import { React, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useNavigate } from "react-router-dom";
import Select from 'react-select';
import 'react-datepicker/dist/react-datepicker.css';
import { v4 as uuidv4 } from 'uuid';
import SendEmail from "./SendEmail.js";
import DatePicker from 'react-datepicker'
import { fetchGridLayout, getHyphenDDMMMYYYYHHMM, getHyphenDDMMYYYYHHMM,saveGridLayout, getHyphenDDMMYYYYHHMMSS, getDDMMMYYYYDefault,getFormattedLocalStorageArray } from '../common/utils';
import GroupIconRenderer from './GroupIconRenderer.js';
import RoutemapTransitAction from './RoutemapTransitAction.js'
import RoutemapenrouteAction from './routemapenroute.js';
import UpdateFTLConsignments from "./updateFTLConsignments.js";
import moment from "moment";
import { Modal } from 'react-bootstrap';
import CustomDialog from './CustomDialog.js';
import CustomDialogForEditLogs from './CustomDialogForEditLogs.js';
import TimelineModal from './TimelineModal.js';
import CustomDialogForDocumentsViewing from './CustomDialogForDocumentsViewing.js';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import SweetAlert from "react-bootstrap-sweetalert";
import Filter from '../../assets/icons/filters.svg'
import redirectURL from "../redirectURL";
import CourierActions from '../layouts/courierActions.js';
import UpdatePTLConsignments from "./updatePTLConsignments.js";
import MainCounters from './mainCounters.js'
import ViewMap from './ViewMap';
import TransitDelay from './TransitDelay';
import EnrouteException from './EnrouteException';
// import Overspeeding from './Overspeeding';
// import NightDriving from './NightDriving';
import LoadingException from './LoadingException';
import UnloadingException from './UnloadingException';
import DrawMap from '../common/drawmap';
import RoutemapAction from './routemapActionComponent.js';
import RouteNightDrivemap from './routenightdrivemap.js';
import NoGPS from './NoGPS.js';
import NoGPSMap from './NoGPSMap.js';
import ForceClose from './forceClose.jsx';
import CancelCourierConsignments from './cancelConsolidatedCourierConsignments.js';
import ConsignmentActions from './ConsignmentActionsComponent';
import ShipmentLegs from "../layouts/shipmentlegs.js";
import onShowTransitDelayIcon from "../layouts/onshowtransitdelay.js";
import onShowNoTrackingIcon from "../layouts/onshownotracking.js";
import onShowstoppagesIcon from "../layouts/onshowstoppages.js";

import CourierShipmentLegs from "../layouts/couriershipmentlegs.js";

import AddDealerConsignments from "./addDealerConsignments.js";
import CourierConsignments from './CourierConsignments';
import BulkForceFileHandler from "../layouts/changebulkuploadhandler";
import FTLConsignments from "./FTLConsignments.js"
import PTLConsignments from "./PTLConsignments.js"
import ConsolidatedCounters from './consolidatedCounters.js';
import CryptoJS from 'crypto-js';
import uploadPOD from '../layouts/uploadPOD.js';
import UpdateConsignments from './updateConsignments.js';
import EditLogsConsignments from './editlogsConsignments.js';
import UploadFTLPod from '../layouts/uploadFTLPod.js';
import { set } from 'react-ga';
import {SubmitBtn} from "../common/utils.js";




var map = ''
function Consignments() {
    const decipher = salt => {
        const textToChars = text => text.split('').map(c => c.charCodeAt(0));
        const applySaltToChar = code => textToChars(salt).reduce((a, b) => a ^ b, code);
        return encoded => encoded.match(/.{1,2}/g)
            .map(hex => parseInt(hex, 16))
            .map(applySaltToChar)
            .map(charCode => String.fromCharCode(charCode))
            .join('');
    }
    const decode = decipher("Z744cRBHYjQTsI6cOlNaUKbuEQF6MiEr")
    const user = useMemo(() => JSON.parse(decode(localStorage.getItem("k"))), []);

    var localStorageRole = (localStorage.getItem("role"));

    let current_defs=[]
    const navigate = useNavigate();
    const agGridRef = useRef(null);
    const gridApi = useRef(null);
    const gridApi2 = useRef(null);
    const gridApiConsignments = useRef(null);
    const columnApiConsignments = useRef(null);
    const gridApiUpdateConsignments = useRef(null);
    const columnApiUpdateConsignments = useRef(null);

    const reloadPage = useRef(false);
    var [rowData, setRowData] = useState([])
    const [columnwithDefs, setColumnWithDefs] = useState([])
    var [filterToggle, setFilterToggle] = useState(false)
    var [key, setKey] = useState('')
    const [gridColumnState, setGridColumnState] = useState([]);
    const [gridColumnState1, setGridColumnState1] = useState([]);
    const [overly, setOverlay] = useState("show-n");
    const [podremarks, setPodRemarks] = useState("");
    const [selectedTab, setSelectedTab] = useState("loading");
    const [transactionData, setTransactionData] = useState();
    const [filterInActive, setFilterInActive] = useState([]);

    const [filterActive, setFilterActive] = useState([]);
    const [filterAll, setFilterAll] = useState([]);
    const [filterForceClose, setFilterForceClose] = useState([]);

    const [activeColumnDefs, setActiveColumnDefs] = useState([]);

    
    const [deliveredColumnDefs, setDeliveredColumnDefs] = useState([]);
    const [allColumnDefs, setAllColumnDefs] = useState([]);
    const [forceCloseColumnDefs, setForceCloseColumnDefs] = useState([]);
    const [filterComplete, setFilterComplete] = useState([]);
    const [finalGridColState, setFinalGridColState] = useState([]);
    const [selectedDoc, setSelectedDoc] = useState(false);
    var [dispatchTime, setDispatchTime] = useState(false);
    var [uploadType, setUploadType] = useState("");
    var [gateOutRow, setGateOutRow] = useState({});
    const [ableRemark, setAbleRemark] = useState(false);
    const [showOthersConsignee, setShowOthersConsignee] = useState([]);
    const [updatelrNo, setUpdateLrNo] = useState('');
    const [showUndelivered, setShowUndelivered] = useState(true);
    const [trackingTypeForDoc, setTrackingTypeForDoc] = useState();
    const [trackingType, setTrackingType] = useState();
    const [selectedViewTab, setSelectedViewTab] = useState('loading'); 
    const [driverNoValidation, setDriverNoValidation] = useState(false);
    const [isEdited, setIsEdited] = useState(false);
    const [transporterValidation, setTransporterValidation] = useState(false);
    const [entityValidation, setEntityValidation] = useState(false);
    const [sourceValidation, setSourceValidation] = useState(false);
    const [dateTypeList, setDateTypeList] = useState([
        { label: "Invoice", value: "Invoice"},
        { label: "Dispatch", value: "Dispatch"}
    ]);


    const [noOfBoxesValidation, setNoOfBoxesValidation] = useState(false);
    const [totalCBMValidation, setTotalCBMValidation] = useState(false);
    const [totalWeightValidation, setTotalWeightValidation] = useState(false);
    const [modeValidation, setModeValidation] = useState(false);
    const [fuelValidation, setFuelValidation] = useState(false);

    const [truckNoValidation, setTruckNoValidation] = useState(false);
    const [invoiceTypeValidation, setInvoiceTypeValidation] = useState(false);
    const [vehicleTypeValidation, setVehicleTypeValidation] = useState(false);
    const [dispacthdateValidation, setDispatchdateValidation] = useState(false);
    const [timelineData, setTimelineData] = useState([]);
    const [showModal, setShowModal] = useState(false);

    const [manualUploadDetails14, setmanualUploadDetails14] = useState({
        dispatch_time:'',
      }); 
      const [shouldReload, setShouldReload] = useState(false);
      var [shipmentId, setShipmentId] = useState("");
      const [error1, setError1] = useState('');
      const [error2, setError2] = useState('');
      const [errorMsg, setErrorMsg] = useState('');
    const [loadshow, setLoadShow] = useState("show-n")
    const [bulkPtlUpdate, setBulkPtlUpdate] = useState(false)
    const [bulkInvoiceError, setBulkInvoiceError] = useState(false)
    const [bulkLRError, setBulkLRError] = useState(false)
    const [bulkLRErrorMsg, setBulkLRErrorMsg] = useState(false)
    const [trackingTypeState, setTrackingTypeState] = useState("")
    const [invoiceTypeCheck, setInvoiceTypeCheck] = useState(false)
    const [bulkUpdateInvoiceError, setBulkUpdateInvoiceError] = useState(false)
    const [bulkInvoiceTypeError, setBulkInvoiceTypeError] = useState(false)
    const [bulkTrackingError, setBulkTrackingError] = useState(false)

    const [bulkError, setBulkError] = useState(false)
    const [bulkTotalWeightError, setBulkTotalWeightError] = useState(false)
    const [bulkDispatchError, setBulkDispatchError] = useState(false)
    const [bulkUpdateExpectedError, setBulkUpdateExpectedError] = useState(false)
    const [bulkUpdateLastEventTimeError, setBulkUpdateLastEventTimeError] = useState(false)
    const [bulkUpdateStatusError, setBulkUpdateStatusError] = useState(false)
    const [bulkUpdateEventError, setBulkUpdateEventError] = useState(false)
    const [bulkUpdateReasonErr, setBulkUpdateReasonErr] = useState(false)
    const [bulkUpdateCurrentLocationErr, setBulkUpdateCurrentLocationErr] = useState(false)
    const [bulkUpdateDispatchError, setBulkUpdateDispatchError] = useState(false)
    const [bulkModeError, setBulkModeError] = useState(false)
    const [bulkMovementError, setBulkMovementError] = useState(false)
    const [bulkPincodeError, setBulkPincodeError] = useState(false)
    const [bulkDestinationError, setBulkDestinationError] = useState(false)
    const [bulkBoxesError, setBulkBoxesError] = useState(false)
    const [bulkSourceError, setBulkSourceError] = useState(false)
    const [sourceCity, setSourceCity] = useState(false)
    const [bulkEntityError, setBulkEntityError] = useState(false)
    const [bulkVehicleNoError, setBulkVehicleNoError] = useState(false)
    const [bulkVehicleTypeError, setBulkVehicleTypeError] = useState(false)
    const [bulkTptError, setBulkTptError] = useState(false)
    const [tptName, setTptName] = useState()
    const [bulkConsigneeError, setBulkConsigneeError] = useState(false)
    const [forcecloseModal, setForcecloseModal] = useState(false);
    const [reasonForceClose, setReasonForceClose] = useState("");
    const [searchConsignee, setSearchConsignee] = useState([{ label: 'All', value: 'all' }]);
    const [movementtype, setMovementtype] = useState({ label: '', value: '' });
    const [searchValue, setSeachValue] = useState('');
    const [selectedBulkSource, setSelectedBulkSource] = useState('');
    const [docRow, setDocRow] = useState();

    const [selectedRows, setSelectedRows] = useState([]);
    const [editDropPoints, setEditDropPoints] = useState([]);
    const [selectedInvoicetoUpdateLr, setSelectInvoicesToUpdate] = useState([])
    const [selectedShipments, setSelectedShipments] = useState([])
    const [consignmentCodeForLRUpdate, setConsignmentCodeForLRUpdate] = useState([])
    const [selectedLRStoUpdateLr, setSelectLRSToUpdate] = useState([])
    const [selectedShipmentUpdate, setSelectShipmentUpdate] = useState([])
    const [selectedTruckUpdate, setSelectTruckUpdate] = useState([])
    const [editLogsData, setEditLogsData] = useState([])
    const [filteredLog, setFilteredLog] = useState([])
    const [editLogsModalOpen, setIsEditLogsModalOpen] = useState(false)


    const [bulkTrackingType, setBulkTrackingType] = useState()
    var [Dselected_row, setDselected_row] = useState({});
    var [isMoreInvoices, setIsMoreInvoices] = useState(false);
    const statusOrderFtl = [
        { label: 'In Transit', value: 'In Transit' },
        { label: 'Near Destination', value: 'Near Destination' },
        { label: 'Reached Destination', value: 'Reached Destination' },
      ];
    const statusOrderPtl =[
        { label: 'In Transit', value: 'In Transit' },
        { label: 'Out For Delivery', value: 'Out For Delivery' },
        { label: 'Arrived At Destination', value: 'Arrived At Destination' }, 
        { label: 'Delivered', value: 'Delivered' }, 
        { label: 'Undelivered', value: 'Undelivered' },
    ]
    const [form2Details, setForm2Details] = useState({
        event_status:statusOrderFtl,
        selectedStatus: { label: 'In Transit', value: 'In Transit' }, // Add a new state variable to store the selected status
        selectedPincode: {label:'', value:''},
        event_location: "",
        remark: "",
        reason_for_delay:"",
        delivered_date:new Date(),
        errorMessage:''
    })
    const [isValid, setIsValid] = useState(true);
    const [uploadPODTracking, setUploadPODTracking] = useState(false);
    const [selectedStatusUpdate, setSelectedStatusUpdate] = useState("");


    const [counterActive, setCounterActive] = useState("Total");
    const [setLrUpdateBtn, setShowLrUpdateBtn] = useState(false);
    // tab states
    const [tabName, setTabName] = useState({ label: "Cancelled", value: "cancelled" });

    // left box fields    
    const [searchType, setSearchType] = useState({ label: "Invoice No", value: "invoice_no" });
    const [searchTrackingType, setSearchTrackingType] = useState({})
    const [searchViewType, setSearchViewType] = useState({ label: "Invoice", value: "Invoice" })
    const [searchPerformance, setSearchPerformance] = useState({})
    const [searchDateType, setSearchDateType] = useState({ label: "Invoice", value: "Invoice"})
    const [filteredInvoices, setFilteredInvoices] = useState([]);
    const [searchInvoice, setSearchInvoice] = useState();
    const [filteredvehicles, setFilteredvehicles] = useState([]);
    const [searchVehicle, setSearchVehicle] = useState({ value: "", label: "" })
    const [filteredLrnos, setFilteredLrnos] = useState([]);
    const [lrNo, setLrNo] = useState()
    const [invoicesUploadList, setInvoiceUploadList] = useState([]);
    const [selectedInvoiceUpload, setSelectedInvoiceUpload]= useState();


    // right box fields
    const [startDate, setStartDate] = useState(new Date(moment.parseZone().subtract(1, "month")));
    const [endDate, setEndDate] = useState(new Date(moment.parseZone()));
    const [consignersList, setConsignersList] = useState([]);
    const [searchConsigner, setSearchConsigner] = useState([]);

    const [filterCities, setFilterCities] = useState([]);
    const [searchCity, setSearchCity] = useState([]);
    const [searchPodStatus,setSearchPodStatus] = useState([]);
    const [filterStates, setFilterStates] = useState([]);
    const [searchState, setSearchStates] = useState([]);
    const [searchEntity, setSearchEntity] = useState([]);
    const [filterTransporters, setFilterTransporters] = useState([]);
    const [error, setError] = useState(null);
    const [errorMsg1, setErrorMsg1] = useState(false);
    const [invoiceValid, setInvoiceValid] = useState(false);
    const [matchedSource, setMatchedSource] = useState(null);
    const [ sourceList, setSourceList] = useState([]);
    const [ originalSourceList, setOriginalSourceList] = useState([]);

    const [ constSourceList, setConstSourceList ] = useState([]);
    const [ sourceRecords, setSourceRecords ] = useState([]);
    const  [ consignees, setConsignees ] = useState([])
    const [ tripConsignees, setTripConsignees ] = useState([])
    const [ dropPointConsignee,setDropPointConsignee ] = useState([]);
    const [validationErrors, setValidationErrors] = useState({});
    const [isValid1,setIsValid1] = useState(false);
    const [showCustomConsigneeInput, setShowCustomConsigneeInput] = useState({});
    const [ entityList, setEntityList] = useState([
        {label:"Adlec", value:"Adlec"},
        {label:"Indoasian", value:"Indoasian"},
        {label:"Legrand", value: "Legrand"},
        {label:"Numeric", value:"Numeric"},
        {label:"Valrack", value:"Valrack"},
        {label:"Netrack", value:"Netrack"},
    ]);
    const [ podStatusList, setPodStatusList] = useState([
        {label:"Available", value:"Available"},
        {label:"Not Available", value:"Not Available"},
       
    ]);
    const [ fuelTypeList, setFuelTypeList] = useState([
        {label:"Diesel", value:"Diesel"},
        {label:"EV", value:"EV"},
        {label:"CNG", value: "CNG"},
        {label:"Rail", value:"Rail"},
        {label:"Air", value:"Air"},
        {label:"Sea", value:"Sea"},
    ]);
    const [ TrackingTypeList, setTrackingTypeList] = useState([
        {label:"FTL", value:"FTL"},
        {label:"PTL", value:"PTL"}
    ]);
    const [ movementType, setMovementType ] = useState([
        { label:"Internal Movement", value:"Internal Movement" },
        { label:"Customer Delivery", value:"Customer Delivery" },
        { label:"Customer Returns", value:"Customer Returns" },
        { label: "Supplier Movement", value: "Supplier Movement" }
    ])
    const [source, setSource] = useState({label:"", value:""})
    const [searchTransporters, setSearchTransporters] = useState([]);



    const [lrNoOption, setLrOptions] = useState([]);
    const [cancelledLrs, setCancelledLrs] = useState([])
    const [invoiceSelected, setInvoiceSelected] = useState([]);


    const [counter, setCounter] = useState({ label: "Consignments", value: "consignments" });
    var [detailCellRendererParams, setdetailCellRendererParams] = useState(null);
    const [basicTitle, setBasicTitle] = useState('');
    const [basicType, setBasicType] = useState('');
    const [maptruckno, setMaptruckno] = useState('');
    const [deptcode, setDeptcode] = useState('');
    const [sliderRouteTranslate, setSliderRouteTranslate] = useState('');
    const [showDiv, setShowDiv] = useState('');
    const [mapinfo, setMapinfo] = useState({});
    const [dealer, setDealer] = useState('');
    const [consignment_code, setConsignment_code] = useState('');
    const [routeTruck, setRouteTruck] = useState({});
    const [leg_no, setLeg_no] = useState(0);
    const [tolls, setTolls] = useState([]);
    const [devation_flag, setDevation_flag] = useState(false);
    const [sliderCreateConsignmentTranslate, setSliderCreateConsignmentTranslate] = useState("show-n")
    var [selected_row, setselected_row] = useState({});
    var [sliderShow, setSliderShow]=useState('');
    
    const [docremarks, setDocRemarks] = useState("");
    const [loadingdocremarks, setLoadingRemarks] = useState("");
    const [unloadingdocremarks, setUnloadingRemarks] = useState("");

    var [customerDocument1, setCustomerDocument1] = useState('');
    var [epodDoc, setEpodDoc] = useState([]);
    var [customerDocument2, setCustomerDocument2] = useState('');
    var [uploadDoc, setUploadDoc] = useState([]);
    var [isSliderDocumentOpen, setSliderDocumentOpen] = useState(false);
    const [documents, setDocuments] = useState([]);
    const [podDocuments, setPodDocuments] = useState([])
    var [short, setShort]= useState(0);
    var [damage, setDamage]= useState(0);
    var [excess, setExcess]= useState(0);
    var [pilferage, setPilferage]= useState(0);
    
    const [manualUploadSlider, setManualUploadSlider] = useState('show-n');
    const [bulkMarkDeliverSlide, setBulkMarkDeliverSlide] = useState('show-n');
    const [shipmentSlider, setShipmentSlider] = useState('show-n');
    const [shipmentCsvContent, setShipmentCsvContent] = useState([]);
    const [shipmentFile, setShipmentFile] = useState('');
    const [bulkSliderShow, setBulkSliderShow] = useState('show-n');
    const [sliderScanShow, setSliderScanShow] = useState('show-n');
    const [sliderSupportShow, setSliderSupportShow] = useState('show-n');
    const [selectedRowNodes, setSelectedRowNodes] = useState([]);
    const [multiplePodDocs, setMultiplePodDocs] = useState([]);
    const [deliveredDate1, setDeliveredDate1] = useState("");
    const [updateRowSlider, setUpdateRowSlider] = useState("");
    var [sliderShow1, setSliderShow1]=useState('')
    var [lRTrackingType, setLRTrackingType]=useState('')

    var [addDealer, setAddDealer] = useState(false);
    
    var [isSliderEmailOpen, setSliderEmailOpen] = useState(false);
    var [isSliderDocumentOpen, setSliderDocumentOpen] = useState(false);
    var [isSliderPODDocumentOpen, setSliderPODDocumentOpen] = useState(false);
    var [viewPodRemark, setViewPodRemark] = useState("");
    var [viewRemark, setViewRemark] = useState("");

    var [email, setEmail] = useState("");    
    var [isSliderEmailOpen, setSliderEmailOpen] = useState(false);
    var [data, setData] = useState([]);
    var [whatsapp_no, setWhatsapp_no] = useState("")
    var [activeForm, setActiveForm] = useState("")
    var [expired_time, setexpired_time] = useState({ label: "7 Days", value: 7 })
    var [orginalDetailsForEdit  ,setOrginalDetailsForEdit] = useState([])
    const [ consignmentUidForTruckLevel ,setConsignmentUidForTruckLevel] = useState("")
    const [ dropPointArr, setDropPointArr] = useState([])
    const [manualTripUploadDetails, setManualTripUploadDetails] = useState([
        // {
        //   id: uuidv4(),
        //   lr_no: '',
        //   consignee_name: "",
        //   invoice_no: "",
        //   no_of_boxes: "",
        //   destination_pincode: "",
        //   destination_city: "",
        //   eway_bill_no: "",
        //   customer_mail_id: "",
        // }
    ]);
    const [showAddForm, setshowAddForm] = useState("");
    const [showAddForm1, setshowAddForm1] = useState("");
    const [showAddForm2, setshowAddForm2] = useState("");
    const [showAddForm3, setshowAddForm3] = useState("");
    const [showBulkUpdateForm, setshowBulkUpdateForm] = useState("");

    var [tabActive, settabActive] = useState('ftl')
    var [processFlowType, SetProcessFlowType] = useState('inbound');
    var [file, setFile] = useState(null)
    var [file1, setFile1] = useState(null)

    var [csvcontent, setcsvcontent] = useState("")
    
    var [vehicleTypeList, setVehicleTypeList] = useState([]);
    var [courierPartnerList, setCourierPartnerList] = useState([]);
    var [courierPartnerList1, setCourierPartnerList1] = useState([]);
    var [tptRecords, settptRecords] = useState([]);
    var [vehicleCapacityList, setVehicleCapacityList] = useState([]);
    const [ errorMessage,setErrorMssge] = useState("");
    const [ enableSourceField,setEnableSourceField] = useState(false)
    const [ enableVehicleType, setEnableVehicelType ] = useState(false)
    const [ enableVehicleType1, setEnableVehicelType1 ] = useState(false)
    const [ enableCourierType, setEnableCourierType] = useState(false)
    const [ enableVehicleCapacity, setEnableVehicleCapacity ] = useState(false)
    const [ enableConsignee, setEnableConsigee] = useState(false);
    const [ validOtherSource, setValidOtherSource] = useState(null)
    const [ validateTruckNo, setValidTruckNo ] = useState(null);
    const [ validOtherConsigneeName, setValidateOtherConsignee ] = useState(null);
    const [ isOtherConsigneeName, setIsOtherConsigneeName ] = useState(null)
    const [validPincode, setValidPincode] = useState(true);
    const [validCity, setValidCity] = useState(true);
    const [validPincode1, setValidPincode1] = useState(true);
    const [invoiceNos, setInvoiceNos] = useState([]);
    const [validCity1, setValidCity1] = useState(true);
    const [ enableEdit, setEnableEdit ] = useState(true);
    const [validVehicleCapacity, setValidVehicleCapacity] = useState(null)
    const [selectedConsignees, setSelectedConsignees] = useState([]);
    const [formData, setFormData] = useState({
        driver_mobile_no:'',
        source:{label:"", value:""},
        truck_no:'',
        truck_seal_no:'',
        other_source:"",
        other_transporter:"",
        other_vehicle_type:"",
        other_consignee_name:"",
        other_vehicle_capacity:"",
        other_destination_pincode:"",
        other_destination_city:"",
        entity:{label:"", value:""},
        vehicle_type:{label:'', value:''},
        courier_partner:{label:'', value:''},
        eway_bill_expiry_date:'',
        vehicle_capacity:'',
        consignee_name:{label:"", value:""},
        movement_type:{label:"", value:""},
        lr_no:'',
        invoice_no:[],
        invoice_no_str:"",
        number_of_boxes:'',
        destination_pincode:'',
        destination_city:'',
        show: false,
        basicType: '',
        basicTitle: '',
        sliderCreateConsignmentTranslate: '',
        loadshow: 'show-n',
        overly: 'show-n',
        disableAddDrop: true,
        disableSubmit: true, 
    });
    const [tabOptions, setTabOptions] = useState([
        { label: "Inactive", value: "inactive" },
        { label: "Active", value: "active" },
        { label: "Completed", value: "completed" },
        { label: "All", value: "all" },
        { label: "Cancelled", value: "cancelled" },
    ])
    const [counterOptions, setCounterOptions] = useState([
        { label: "Consignments", value: "consignments" },
        { label: "Transit Delays", value: "transit_delays" },
        { label: "No GPS Available", value: "no_gps_data" },
        { label: "No GPS Available Lifetime", value: "no_gps_data_lifetime" },
        // { label: "Overspeeding", value: "overspeeding" },
        // { label: "Night Driving", value: "night_driving" },
        { label: "Stoppages", value: "stoppages" },
        { label: "Accidents", value: "accidents" },
        { label: "Trip Deviations", value: "trip_deviations" },
        { label: "Loading Delay", value: "loading_delay" },
        { label: "Unloading Delay", value: "unloading_delay" }
    ]);

    var filterCardStyle1 = { minHeight: "234px" };
    var filterCardStyle2 = { padding: '10px' };
    var mnFilterClass = { marginLeft: "0px", padding: "0px" };
    const [rownode, setRownode] = useState([]);
    const [forceCloseModal, setForceCloseModal] = useState(false);
    const [cancelModal, setCloseCancelModal] = useState(false); 
    const [selectedRecordType , setSelectedRecordType] = useState("")
    const [cancelConsignmentForTrackinType, setCancelConsignmentTrackingType] = useState("")
    const [reasonForCancellation, setReasonForCancellation] = useState("")
    var [mapDetails, setMapDetails] = useState([]);
    const [inactiveTrips, setInactiveTrips] = useState([])
    const [closeTrips, setCloseTrips] = useState([])
    const [activeTrips, setActiveTrips] = useState({
        all: [],
        inTransit: [],
        transit_delay: [],
        no_gps_data: [],
        stoppages: [],
        outForDelivery: [],
        undelivered: [],
        at_source:[],
        dispatched_from_source: [],
        arrived_at_destination:[],
        sim_issues:[]

    })
    const [completedTrips, setCompletedTrips] = useState({
        all: [],
        delivered: [],
        onTime: [],
        delayed: [],
        podPending: [],
        zeroToOneDays:[],
        oneToTwoDays:[],
        threeToFiveDays:[],
        sixToTenDays:[],
        gtTenDays:[]
    })
    const [allTrips, setAllTrips] = useState({
        all: [],
        inTransit: [],        
        transit_delay: [],
        no_gps_data: [],
        stoppages: [],
        disabled: [],
        undelivered: [],
        outForDelivery:[],
        delivered: [],
        podPending: [],
        at_source:[],
        dispatched_from_source: [],
        arrived_at_destination:[],
        sim_issues:[]

    })
    var [rowData1, setrowData1] = useState([]);

    const [modalloadData, setModalLoadData] = useState([])
    const [modalBulkUpdateData, setModalBulkUpdateData] = useState([])
    const [plantData, setPlantData] = useState([])
    const [transporters, setTransporters] = useState([])
    const [dealers, setDealers] = useState([])
    const [previousData, setPreviousData] = useState([])
    const fileRef = useRef()
    const [show, setShow] = useState(false)
    const [invoiceNoList, setInvoiceNoList] = useState([]);
    const [title, setTitle] = useState('')
    const [type, setType] = useState('default')
    const [loader, setLoader] = useState(false)
    var [loadshow1, setloadshow1] = useState('show-n');
    var [truckLocations, setTruckLocations] = useState();

    const [bulkUploadModal, setBulkUploadModal] = useState({
        overly: "show-n",
        bulkPrioritySlide: ""
    })    
    const [showUpdateLrForm, setShowUpdateLrForm] = useState("");
    const [manualUploadDetails, setmanualUploadDetails] = useState({
        lr_no: "",
        invoice_no: "",
    });
    
    var [gateOutSlide, setGateOutSlide] = useState("");
    const [manualInTransitStatusUpdate, setManualInTransitStatusUpdate] = useState(
        {dispatch_time:''}
    )
    const [manualUploadDetails1, setmanualUploadDetails1] = useState({
        lr_no: "",
        invoice_no: selected_row.invoice_no || '',
        consignee_name: "",
        consignee_city: "",
        consignee_state: "",
        consignee_pincode: "",
        total_weight: ""
    }); 
    const [otherSource, setOtherSource] = useState(false);
    const [otherVehicleType , setOtherVehicleType] = useState(false);
    const [otherTransporter , setOtherTransporter] = useState(false);
    const [otherConsignee, setOtherConsignee] = useState(false)
    const [otherDestinationPincode, setOtherDestinationPincode] = useState(false);
    const [sourceOptions, setSourceOptions] = useState([]);
    const [ consigneesForTrip, setConsigneesForTrip ] = useState([])
    const [ consignerCityList, setConsignerCityList ] = useState([])
    const [ entityMasterData, setEntityMasterData ] = useState([])
    const [ vehicleMasterData, setVehicleMasterData ] = useState([])
    const [ tptMasterData, setTptMasterData ] = useState([])
    const [ tptData, setTptData ] = useState([])
    const [ invoiceMasterData, setInvoiceMasterData ] = useState([])
    const [ invoiceSourceSeries, setInvoiceSourceSeries ] = useState([])
    const [ invoiceSourceCategory, setInvoiceSourceCategory ] = useState([])
    const [manualUpdateConsignment, setManualUpdateConsignment] = useState({
        lr_no: "",
        invoice_no: "",
        driver_mobile_no: '',
        source: {label:"", value:""},
        other_source:"",
        other_source_pincode: "",
        truck_no: "",
        truck_seal_no: "",
        entity: {label:"", value:""},
        vehicle_type: {label:"", value:""},
        other_vehicle_type:{label:"", value:""},
        courier_partner:{label:"", value:""},
        other_transporter:{label:"", value:""},
        vehicle_capacity: "",
        other_vehicle_capacity:{label:"", value:""},
        eway_bill_expiry_date:'',
        consignee_name: {label:"", value:""},
        other_consignee_name:{label:"", value:""},
        movement_type:{label:"", value:""},
        no_of_boxes: "",
        destination_pincode: "",
        destination_city:"",
        other_destination_pincode:"",
        other_destination_city:"",
      });  
    const [manualUpdateLRConsignment, setManualUpdateLRConsignment] = useState({
        lr_no: "",
        invoice_no: "",
        driver_mobile_no: '',
        truck_no: "",
        entity: {label:"", value:""},
        vehicle_type: {label:"", value:""},
        fuel_type:{label:"", value:""},
        other_vehicle_type:"",
        courier_partner:{label:"", value:""},
        other_transporter:{label:"", value:""},
        no_of_boxes: "",
        tracking_type:"",
        total_cbm:"",
        total_weight:"",
        dispatch_time:"",
        tracking_type_mutliple: {label:"", value:""},

    });  
    const [openMap, setOpenMap] = useState({
        sliderRouteTranslate: "",
        showDiv: 'show-n',
        mapinfo: [],
        dealer: "",
        lr_no: "",
        maptruckno: "",
        geofence_coordinates: [],
        parking_coordinates: [],
        routeTruck: { "truck_no": '', "startTime": '', "endTime": '' },
        loadshow: 'show-n',
        sidebarSubHeader: "",
        overly: 'show-m',
        rownode: {},
        leg_no: 0,
        tolls: []
    })
    const [countersActive, setCountersActive] = useState({
        consignments: 0,
        transit_delays: 0,
        in_transit: 0,
        no_gps_data: 0,
        stoppages: 0,
        outfordelivery: 0,
        undelivered:0,
        at_source:0,
        dispatched_from_source: 0,
        arrived_at_destination:0,
        sim_issues:0
    })
    const [countersCompleted, setCountersCompleted] = useState({
        consignments: 0,
        delivered: 0,
        delayed: 0,
        onTime: 0,
        podPending: 0,
        zeroToOneDays: 0,
        oneToTwoDays: 0,
        threeToFiveDays: 0,
        sixToTenDays: 0,
        gtTenDays: 0
    })
    const [countersAll, setCountersAll] = useState({
        consignments: 0,
        inTransit: 0,
        transit_delays: 0,
        no_gps_data: 0,
        stoppages: 0,
        disabled: 0,
        undelivered: 0,
        outforDelivery:0,
        delivered: 0,
        podPending: 0,
        at_source:0,
        dispatched_from_source: 0    })
    
    var x = [         
        {
            headerName: "Check",
            field: "checkbox",
            hide: (tabName.value !== "inactive"),
            // colId: "_id",
            width: 40,
            pinned: 'left',
            filter: false, 
            resizable: true,
            checkboxSelection: true
        }       
    ]

    const [pincodesList, setPincodesList] = useState([{ label: "", value: "" }]);
  
    var decodedRoleCase= decode(localStorageRole).toLowerCase()
    var warehouseDisableIcons = decodedRoleCase==="warehouse" && processFlowType==="inbound"

    var locationNameConversion = getFormattedLocalStorageArray("location")
     
    var entityConversion = getFormattedLocalStorageArray("entity")
    
    var stateConversion =  getFormattedLocalStorageArray("state")

     
    var zoneConversion = getFormattedLocalStorageArray("zone")   
    var statusMap={
        0: "At Source",
        1:"Dispatched from Source",
        2: "In Transit",
        3: "Arrived At Destination",
        4: "Out For Delivery",
        5: "Delivered",
        6: "Force Closure",
        7: "Provision",
        8: "Delivered",
        9: "Cancelled",
        10: "Trip Created",
        11: "Undelivered"
    }
  
    
    
    var intransitColDefs =
            [
                {
                    headerName: "Vehicle No" ,
                    field: "truck_no",
                    hide: (tabName.value === "inactive"),
                    width: 150,
                    cellRenderer: '', resizable: true,
                    headerClass: 'bold-header'
                },
                {
                    headerName: "LR No" ,
                    field: "lr_no",
                    hide: (tabName.value === "inactive"),
                    width: 150,
                    cellRenderer: '', resizable: true,
                    headerClass: 'bold-header'
                },
                {
                    headerName: "Invoice No" ,
                    field: "invoice_no",
                    width: 150,
                    cellRenderer: '', resizable: true,
                    headerClass: 'bold-header'
                },  
                // here
                {
                    headerName: "Status",
                    field: "consignment_status",  
                    width: 120,
                    filter: "agSetColumnFilter",
                    resizable: true,                    
                    valueFormatter: (params) => {
                        
                        if (params.data.consignment_status) {
                            return params.data.consignment_status;  
                        }  else {                
                            const status = params.data.status;    
                            return statusMap[status] || "Not Available";  
                        }
                    },
                    headerClass: 'bold-header'
                },                
                {
                    headerName: "Invoice Date",
                    field: "invoice_time",
                    width: 180,
                    cellRenderer: '', resizable: true,
                    comparator: dateComparator,
                    valueGetter: function (params) {
                        if (params.data.invoice_time != '' && params.data.invoice_time != undefined && params.data.invoice_time !== ' ') {
                            return getHyphenDDMMMYYYYHHMM(params.data.invoice_time);
                        }
                        else {
                            return "NA";
                        }
                    },
                    headerClass: 'bold-header'
                },
                {
                    headerName: "Dispatch Date" ,
                    field: "dispatch_date",
                    width: 150,
                    //filter: "agDateColumnFilter",
                    cellRenderer: '', resizable: true,
                    comparator: dateComparator,

                    valueGetter: function (params) {
                        const dispatchDate = params.data.dispatch_date;
                        if (dispatchDate && dispatchDate.trim() !== '' && dispatchDate !== undefined) {
                            // Call date formatting only when the dispatch date is valid
                            const formattedDate = getHyphenDDMMMYYYYHHMM(dispatchDate);
                            // Check if formattedDate is valid, otherwise return "NA"
                            return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                        } else {
                            return "NA";
                        }
                    },
                    headerClass: 'bold-header'
                },
                {
                    headerName: "Customer Name",
                    field: "customer_name",
                    width: 180,
                    filter: "agSetColumnFilter",
                    cellRenderer: '',
                    resizable: true,
                    valueGetter: function (params) {
                        if (params.data.customer_name != "" && params.data.customer_name != "") {
                            return params.data.customer_name
                        }
                    },
                    headerClass: 'bold-header'
                },
                {
                    headerName: "Entity" ,
                    field: "entity",
                    width: 150,
                    cellRenderer: '', resizable: true,
                    headerClass: 'bold-header'
                },               
                {
                    headerName: "Invoice Type" ,
                    field: "invoice_type",
                    width: 150,
                    cellRenderer: '', resizable: true,
                    headerClass: 'bold-header'
                },
                {
                    headerName: "Transporter",
                    field: "transporter_name",
                    width: 180,
                    filter: "agSetColumnFilter",
                    cellRenderer: '',
                    resizable: true,
                    valueGetter: function (params) {
                        if (params.data.truck_no != "" && params.data.truck_no != "") {
                            return (params.data.transporter_name ? capitalizeWords(params.data.transporter_name):"")
                        }
                    },
                    headerClass: 'bold-header'
                },
                {
                    headerName: "Source City" ,
                    field: "consigner_city",
                    width: 150,
                    cellRenderer: '', resizable: true,
                    headerClass: 'bold-header'
                },  
                {
                    headerName: "Source Pincode" ,
                    field: "consigner_pincode",
                    width: 180,
                    cellRenderer: '', resizable: true,
                    headerClass: 'bold-header'
                },
                {
                    headerName: "Source Zone" ,
                    field: "consigner_zone",
                    width: 150,
                    cellRenderer: '', resizable: true,
                    headerClass: 'bold-header'
                },
                {
                    headerName: "Destination City" ,
                    field: "consignee_city",
                    width: 150,
                    cellRenderer: '', resizable: true,
                    headerClass: 'bold-header'
                },
                {
                    headerName: "Destination Pincode" ,
                    field: "consignee_pincode",
                    width: 180,
                    cellRenderer: '', resizable: true,
                    headerClass: 'bold-header'
                },
                {
                    headerName: "Destination State" ,
                    field: "consignee_state",
                    width: 150,
                    cellRenderer: '', resizable: true,
                    headerClass: 'bold-header'
                },
                {
                    headerName: "Total Weight" ,
                    field: "total_weight",
                    width: 150,
                    cellRenderer: '', resizable: true,
                    headerClass: 'bold-header',
                    valueFormatter: (params) => {
                        // Ensure the value is a valid number
                        const value = parseFloat(params.value);
                        return !isNaN(value) ? value.toFixed(2) : ''; // Return empty string if it's not a valid number
                    }
                },
                {
                    headerName: "Total CBM" ,
                    field: "total_cbm",
                    width: 150,
                    cellRenderer: '', resizable: true,
                    headerClass: 'bold-header',
                    valueFormatter: (params) => {
                        // Ensure the value is a valid number
                        const value = parseFloat(params.value);
                        return !isNaN(value) ? value.toFixed(2) : ''; // Return empty string if it's not a valid number
                    }
                },
                {
                    headerName: "Transporter Category" ,
                    field: "tpt_category",
                    width: 190,
                    cellRenderer: '', resizable: true,
                    headerClass: 'bold-header'
                },
                {
                    headerName: "Vehicle Type" ,
                    field: "vehicle_type",
                    width: 150,
                    cellRenderer: '', resizable: true,
                    headerClass: 'bold-header'
                },
                {
                    headerName: "Truck Seal No" ,
                    hide: (tabName.value === "inactive"),
                    field: "truck_seal_no",
                    width: 150,
                    cellRenderer: '', resizable: true,
                    headerClass: 'bold-header'
                },
                {
                    headerName: "ODA",
                    field: "origin_destination_area",
                    width: 150,
                    cellRenderer: '',
                    headerClass: 'bold-header',
                    resizable: true,
                },
            // till here 
                {
                    headerName: "POD Status" ,
                    field: "pod_status",
                    hide: (tabName.value === "inactive"),
                    width: 150,
                    cellRenderer: '', resizable: true,
                    headerClass: 'bold-header'
                }, 
                {
                    headerName: "TAT" ,
                    field: "transit_time",
                    hide: (tabName.value === "inactive"),
                    width: 150,
                    cellRenderer: '', resizable: true,
                    headerClass: 'bold-header'
                },
                {
                    headerName: "Last Data Received On",
                    field: "last_process_on",
                    width: 200,
                    // hide:(tabName.value !== "completed" && tabName.value !== "all"),
                    //filter: "agDateColumnFilter",
                    cellRenderer: '', resizable: true,
                    comparator: dateComparator,

                    valueGetter: function (params) {
                        if (params.data.last_process_on != '' && params.data.last_process_on != undefined && params.data.last_process_on !== ' ') {
                            return getHyphenDDMMMYYYYHHMM(params.data.last_process_on);
                        }
                        else {
                            return "NA";
                        }
                    },
                    headerClass: 'bold-header'
                },  
                {
                    headerName: "Expected ETA" , // estimated delivery data
                    field: "expected_trip_end",
                    width: 150,
                    //filter: "agDateColumnFilter",
                    cellRenderer: '', resizable: true,
                    comparator: dateComparator,
                    hide: (tabName.value === "inactive"),
                    valueGetter: function (params) {
                        const expectedEta = params.data.expected_trip_end;
                        const tripEndMaster = params.data.expected_trip_end_master;
                
                        if (expectedEta && expectedEta.trim() !== '') {
                            return getHyphenDDMMMYYYYHHMM(expectedEta);
                        } else if (tripEndMaster && tripEndMaster.trim() !== '') {
                            return getHyphenDDMMMYYYYHHMM(tripEndMaster);
                        } else {
                            return "NA";
                        }
                    },
                    headerClass: 'bold-header'
                
                },
                {
                    headerName: "Revised Estimated Delivery Date",
                    // field: "modified_date",
                    field: "revised_trip_end",
                    width: 240,
                    hide: (tabName.value === "inactive"),
                    cellRenderer: '', resizable: true,
                    comparator: dateComparator,
                    valueGetter: function (params) {
                        if (params.data.revised_trip_end != '' && params.data.revised_trip_end != undefined && params.data.revised_trip_end !== ' ') {
                            return getHyphenDDMMMYYYYHHMM(params.data.revised_trip_end);
                        }
                        else {
                            return "NA";
                        }
                    },
                    headerClass: 'bold-header'
                },
                {
                    headerName: "Actual Delivery Date",
                    field: "delivery_datetime",
                    width: 180,
                    hide: (tabName.value === "inactive"),
                    cellRenderer: '', resizable: true,
                    comparator: dateComparator,
                    valueGetter: function (params) {
                        if (params.data.delivery_datetime != '' && params.data.delivery_datetime != undefined && params.data.delivery_datetime !== ' ') {
                            return getHyphenDDMMMYYYYHHMM(params.data.delivery_datetime);
                        }
                        else {
                            return "NA";
                        }
                    },
                    headerClass: 'bold-header'
                },
                {
                    headerName: "Performance" ,
                    field: "delivery_performance",
                    width: 180,
                    cellRenderer: '', resizable: true,
                    headerClass: 'bold-header'
                },
                {
                    headerName: "Delay Days",
                    field: "transit_delay_hours",
                    colId: "transit_delay_hours",
                    width: 180,
                    resizable: true,
                    headerClass: 'bold-header',
                    valueFormatter: (params) => {
                        const hours = params.value;
                        if (hours !== undefined && hours !== null) {
                            // Convert hours to days and round to the nearest whole number
                            const days = Math.ceil(hours / 24); // Round up to the nearest whole number
                            return `${days} Days`; // Display in "X Days" format
                        }
                        return ''; // Return empty if no value
                    },
                    filterParams: {
                        values: (params) => {
                            const uniqueDays = new Set();
                
                            try {
                                // Collect unique "Delay Days" values from the filtered rows
                                params.api.forEachNodeAfterFilter((node) => {
                                    if (node.data) {
                                        const hours = node.data.transit_delay_hours;
                                        if (hours !== undefined && hours !== null) {
                                            const days = Math.ceil(hours / 24); // Convert hours to days
                                            uniqueDays.add(`${days} Days`); // Add to the Set
                                        }
                                    }
                                });
                
                                // Pass the unique values to the filter dropdown
                                params.success(Array.from(uniqueDays));
                            } catch (error) {
                                console.error("Error in Delay Days filter:", error);
                                // Pass an empty array if there's an error
                                params.success([]);
                            }
                        },
                        refreshValuesOnOpen: true, // Refresh filter values every time the dropdown is opened
                    },
                    filterValueGetter: (params) => {
                        const hours = params.data?.transit_delay_hours;
                        if (hours !== undefined && hours !== null) {
                            const days = Math.ceil(hours / 24); // Convert hours to days
                            return `${days} Days`; // Return formatted value for filtering
                        }
                        return ''; // Return empty if no value
                    },
                },
                
                // {
                //     headerName: "Delay Days Bucket" ,
                //     field: "delay_days_bucket",
                //     width: 180,
                //     hide: (tabName.value !== 'completed' && tabName.value !== "all"),
                //     cellRenderer: '', resizable: true,
                //     headerClass: 'bold-header'
                // },

                // add below 
                {
                    headerName: "Reason For Delay" ,
                    field: "reason_for_delay",
                    width: 180,
                    hide: (tabName.value !== 'completed' && tabName.value !== "all"),
                    cellRenderer: '', resizable: true,
                    headerClass: 'bold-header'
                },
                // from here
                {
                    headerName: "E-Way Bill No" ,
                    field: "eway_bill_no",
                    width: 150,
                    cellRenderer: '', resizable: true,
                    headerClass: 'bold-header'
                }, 
                {
                    headerName: "Mode" ,
                    field: "shipment_mode",
                    width: 150,
                    cellRenderer: '', resizable: true,
                    headerClass: 'bold-header'
                },   
                {
                    headerName: "Fuel Type" ,
                    field: "fuel_type",
                    width: 150,
                    cellRenderer: '', resizable: true,
                    headerClass: 'bold-header'
                },
                {
                    headerName: "Disabled Time",
                    field: "cancelled_time",
                    hide: (tabName.value === "inactive" && tabName.value === "inactive"),
                    width: 180,
                    //filter: "agDateColumnFilter",
                    cellRenderer: '', resizable: true,
                    comparator: dateComparator,

                    valueGetter: function (params) {
                        if (params.data.cancelled_time != '' && params.data.cancelled_time != undefined && params.data.cancelled_time !== ' ') {
                            return getHyphenDDMMMYYYYHHMM(params.data.cancelled_time);
                        }
                        else {
                            return "NA";
                        }
                    },
                    headerClass: 'bold-header'
                    // hide: (this.state.tnpReturnConsignmentsVisibilty) ? true : hideonlyPRT, // this logic was imported from msil so for hero we are commenting this as of 27-07-2022
                },
                {
                    headerName: "No Of Boxes" ,
                    field: "no_of_boxes",
                    width: 150,
                    cellRenderer: '', resizable: true,
                    headerClass: 'bold-header'
                },
                
    ];
    var forceCloseCodefs = [
      
        {
            headerName: "Tracking Mode" ,
            field: "tracking_type",
            colId: "tracking_type",
            // hide: (tabName.value === "inactive"),
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        // {
        //     headerName: "Update Tracking Status",
        //     field: "update_tracking_status",
        //     width: 190,
        //     pinned: "left",
        //     // hide: (tabName.value !== 'active'),
        //     cellRendererSelector: function (param) {
        //         try {
        //             if (param.data._id != null && param.data._id != undefined) {
        //                 if(param.data.manual_tracking === 1 || param.data.status === 1 || param.data.status === 2){                                
        //                     return {
        //                         component: UpdatePTLConsignments,
        //                         params: {
        //                             onClickActive: updateDeliveredDate
        //                         }
        //                     }
        //                 } else {
        //                 }
        //             }
        //         } catch (err) {
        //             //console.log(err);
        //         }
        //     },
        //     cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" },
        //     headerClass: 'bold-header'
        // },        
        // {
        //     headerName: "Update LR",
        //     field: "update",
        //     width: 100,
        //     pinned: "left",
        //     // hide: tabName.value !== 'inactive',
        //     cellRendererSelector: function (param) {
        //         try {
        //             if (param.data._id != null && param.data._id != undefined) {
        //                 return {
        //                     component: UpdatePTLConsignments,
        //                     params: {
        //                         onClickActive: onClickActive
        //                     }
        //                 }
        //             }
        //         } catch (err) {
        //             //console.log(err);
        //         }
        //     },
        //     cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" },
        //     headerClass: 'bold-header'
        // },
     
        // {
        //     headerName: "LR No" ,
        //     field: "lr_no",
        //     hide: (tabName.value === "inactive"),
        //     width: 150,
        //     cellRenderer: '', resizable: true,
        //     headerClass: 'bold-header'
        // },
        {
            headerName: "Invoice No" ,
            colId: "invoice_no",
            field: "invoice_no",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },         
        {
            headerName: "Invoice Date",
            field: "invoice_time",
            colId: "invoice_time",
            width: 180,
            cellRenderer: '', resizable: true,
            comparator: dateComparator,
            valueGetter: function (params) {
                if (params.data.invoice_time != '' && params.data.invoice_time != undefined && params.data.invoice_time !== ' ') {
                    return getHyphenDDMMMYYYYHHMM(params.data.invoice_time);
                }
                else {
                    return "NA";
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Status",
            field: "status",
            colId: "status",
            valueGetter: (params) => {
                const consignmentStatus = params.data?.consignment_status;
                const status = params.data?.status;
        
                return consignmentStatus || statusMap[status] || status || "Not Available";
            },
        
            // filterParams: {
            //     values: (params) => {
            //         const uniqueValues = new Set();
            //         try {
            //             params.api.forEachNodeAfterFilter((node) => {
            //                 if (node.data) {
            //                     const statusMap = {
            //                         0: "Invoiced",
            //                         1: "At Source",
            //                         2: "In Transit",
            //                         3: "Near Destination",
            //                         4: "Delivered",
            //                         5: "Left Dealer",
            //                         6: "Force Closure",
            //                         7: "Provision",
            //                         8: "Delivered",
            //                     };
        
            //                     let status = statusMap[node.data.status] || node.data.status;
            //                     let consignmentStatus = node.data.consignment_status;
        
            //                     let statusText = consignmentStatus || status || "Not Available";
            //                     uniqueValues.add(statusText);
            //                 }
            //             });
        
            //             params.success(Array.from(uniqueValues));
            //         } catch (error) {
            //             console.error("Error in filterParams.values:", error);
            //             params.success([]);
            //         }
            //     },
            //     refreshValuesOnOpen: false, // ✅ Ensure filter dropdown updates dynamically
            // },
        
            // filterValueGetter: (params) => {
            //     const statusMap = {
            //         0: "Invoiced",
            //         1: "At Source",
            //         2: "In Transit",
            //         3: "Near Destination",
            //         4: "Delivered",
            //         5: "Left Dealer",
            //         6: "Force Closure",
            //         7: "Provision",
            //         8: "Delivered",
            //     };
        
            //     return params.data?.consignment_status || statusMap[params.data?.status] || params.data?.status || "Not Available";
            // }
        },
        {
            headerName: "Creation Time",
            field: "creation_time",
            colId: "creation_time",
            width: 180,
            cellRenderer: '', resizable: true,
            comparator: dateComparator,
            valueGetter: function(params){
                if(params.data.tpt_assigned===0){
                    if(!!params.data.invoice_upload_time){
                        return getHyphenDDMMMYYYYHHMM(params.data.invoice_upload_time)
                    }else{
                        return ""
                    }
                }else if(params.data.tpt_assigned ===1){
                    if(!!params.data.tpt_assigned_at){
                        return getHyphenDDMMMYYYYHHMM(params.data.tpt_assigned_at)
                    }else{
                        return ""
                    }
                }else{
                    return ""
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Consignor Name",
            field: "consigner_name",
            colId: "consigner_name",
            width: 180,
            filter: "agSetColumnFilter",
            cellRenderer: '',
            resizable: true,
            valueGetter: function (params) {
                if (params.data.consigner_name != "" && params.data.consigner_name != "") {
                    return params.data.consigner_name
                }
            },
            headerClass: 'bold-header'
        }, 
        {
            headerName: "Consignee Code",
            field: "consignee_code",
            colId: "consignee_code",
            width: 180,
            filter: "agSetColumnFilter",
            cellRenderer: '',
            resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Consignee Name",
            field: "consignee_name",
            colId: "consignee_name",
            width: 180,
            filter: "agSetColumnFilter",
            cellRenderer: '',
            resizable: true,
            valueGetter: function(params){
                if(params.data.consignee_name !=="" && params.data.consignee_name !==" " && params.data.consignee_name !== undefined && params.data.consignee_name !== null){
                    return capitalizeWords(params.data.consignee_name)
                }else{
                    return ""
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Destination City" ,
            field: "consignee_city",
            colId: "consignee_city",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function(params){
                if(params.data.consignee_city !=="" && params.data.consignee_city !==" " && params.data.consignee_city !== undefined && params.data.consignee_city !== null){
                    return capitalizeWords(params.data.consignee_city)
                }else{
                    return ""
                }
            },
        },
        {
            headerName: "Destination Pincode" ,
            field: "consignee_pincode",
            colId: "consignee_pincode",
            width: 180,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Total Weight",
            field: "total_weight",
            colId: "total_weight",
            width: 150,
            resizable: true,
            headerClass: 'bold-header',
            valueFormatter: (params) => {
                // Ensure the value is a valid number
                const value = parseFloat(params.value);
                return !isNaN(value) ? value.toFixed(2) : ''; // Return empty string if it's not a valid number
            }
          
        },
        {
            headerName: "Total CBM",
            field: "total_cbm",
            colId: "total_cbm",
            width: 150,
            resizable: true,
            headerClass: 'bold-header',
            valueFormatter: (params) => {
                // Ensure the value is a valid number
                const value = parseFloat(params.value);
                return !isNaN(value) ? value.toFixed(2) : ''; // Return empty string if it's not a valid number
            }
          
        },
        {
            headerName: "Entity",
            field: "truck_seal_entity",
            colId: "truck_seal_entity",
            width: 150,
            resizable: true,
            valueGetter: function (params) {
                try {
                 
                    const entity = params.data.truck_seal_entity;
                    if (entity) {
                        return capitalizeWords(entity); // Capitalize words only if a valid value is present
                    }
                    return '';   
                } catch (error) {
                    
                } // Return an empty string for invalid or missing values
            },
            headerClass: 'bold-header',
        },               
        {
            headerName: "Invoice Type" ,
            field: "invoice_type",
            colId: "invoice_type",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Transporter",
            field: "transporter_name",
            colId: "transporter_name",
            width: 180,
            filter: "agSetColumnFilter",
            cellRenderer: '',
            resizable: true,
            valueGetter: function (params) {
                if (params.data.transporter_name != "" && params.data.transporter_name != undefined) {
                    
                    return (params.data.transporter_name ? capitalizeWords(params.data.transporter_name):"")
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Source City" ,
            field: "consigner_city",
            colId: "consigner_city",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function(params){
                if(params.data.consigner_city !=="" && params.data.consigner_city !==" " && params.data.consigner_city !== undefined && params.data.consigner_city !== null){
                    return capitalizeWords(params.data.consigner_city)
                }else{
                    return ""
                }
            },
        },  
        {
            headerName: "Source Pincode" ,
            field: "consigner_pincode",
            colId: "consigner_pincode",
            width: 180,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        
        {
            headerName: "Source Zone" ,
            field: "consigner_zone",
            colId: "consigner_zone",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function(params){
                if(params.data.consigner_zone !=="" && params.data.consigner_zone !==" " && params.data.consigner_zone !== undefined && params.data.consigner_zone !== null){
                    return capitalizeWords(params.data.consigner_zone)
                }else{
                    return ""
                }
            },
        },
      
       
        {
            headerName: "Destination State" ,
            field: "consignee_state",
            colId: "consignee_state",
            width: 180,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function(params){
                if(params.data.consignee_state !=="" && params.data.consignee_state !==" " && params.data.consignee_state !== undefined && params.data.consignee_state !== null){
                    return capitalizeWords(params.data.consignee_state)
                }else{
                    return ""
                }
            },
        },
        {
            headerName: "Destination Zone",
            field: "consignee_zone", // This can be the default field, but will be dynamically overridden by valueGetter
            colId: "consignee_zone",
            colId: "zone",
            width: 180,
            resizable: true,
            headerClass: 'bold-header',
            valueGetter: function(params){
                if(params.data.consignee_zone !=="" && params.data.consignee_zone !==" " && params.data.consignee_zone !== undefined && params.data.consignee_zone !== null){
                    return capitalizeWords(params.data.consignee_zone)
                }else{
                    return ""
                }
            },
            
            // Use valueGetter to dynamically return the correct field based on tracking type
            // valueGetter: (params) => {
            //     if (params.data.tracking_type === "FTL") {
            //         return params.data.consignee_zone; // If tracking is FTL, use consignee_zone
            //     } else if (params.data.tracking_type === "PTL") {
            //         return params.data.zone; // If tracking is PTL, use zone
            //     }
            //     return null; // Return null or empty if neither condition is met
            // }
        },
        {
            headerName: "Cancellation Reason" ,
            field: "reasonForCancellation",
            colId: "reasonForCancellation",
            width: 200,
            resizable: true,
            headerClass: 'bold-header',
            
            // Use valueGetter to dynamically return the correct field based on tracking type
            // valueGetter: (params) => {
            //     if (params.data.tracking_type === "FTL") {
            //         return params.data.consignee_zone; // If tracking is FTL, use consignee_zone
            //     } else if (params.data.tracking_type === "PTL") {
            //         return params.data.zone; // If tracking is PTL, use zone
            //     }
            //     return null; // Return null or empty if neither condition is met
            // }
        },    

       
       
    ]
    
    
    useEffect(() => {
        // Helper function to merge gridColumnState with columnDefs
        const mergeColumnDefs = (gridState, columnDefs) => {
            return gridState.map((header) => {
                const matchingDef = columnDefs.find((def) => def.colId === header.colId);
                return {
                    ...header,
                    ...(matchingDef || {}), // Preserve custom properties like cellRenderer
                };
            });
        };
    
        // Merge gridColumnState with active, delivered, and all columnDefs
    
        const gridColumnStateDefsForceClose = gridColumnState.length > 0 
            ? mergeColumnDefs(gridColumnState,forceCloseCodefs) 
            : forceCloseCodefs;
        setFilterForceClose(gridColumnStateDefsForceClose);
    
    }, [gridColumnState]); // Ensure dependencies are in sync
    var deliveredColDefs = [...intransitColDefs];

    const nogpscols = [
        {
            headerName: "",
            field: "_id",
            cellRendererSelector: function (param) {
                try {
                    if (param.data._id != null && param.data._id != undefined) {
                        return {
                            component: NoGPSMap,
                            params: {
                                onShowNoGPSRouteMap: onShowNoGPSRouteMap
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            width: 50,
            suppressSizeToFit: true,
            cellclassName: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }

            }
        },
        {
            headerName: "Truck No", field: "truck_no", width: 100, resizable: true,
            cellclassName: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }

            }
        },
        {
            headerName: "Last Data Received",
            field: "last_packet_datetime",
            width: 180,
            resizable: true,
            valueGetter: function (params) {
                return getHyphenDDMMMYYYYHHMM(params.data.last_packet_datetime);
            },
            cellclassName: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }

            }
        },
        {
            headerName: "Data Received on",
            field: "packet_received_on",
            width: 180,
            resizable: true,
            valueGetter: function (params) {
                return getHyphenDDMMMYYYYHHMM(params.data.packet_received_on);
            },
            cellclassName: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }

            }
        }
    ]
    const transitdelaycols = [
        {
            headerName: "", field: "_id",
            cellRendererSelector: function (param) {
                try {
                    if (param.data._id != null && param.data._id != undefined) {
                        return {
                            component: RoutemapTransitAction,
                            params: {
                                onShowTransitRouteMap: onShowTransitRouteMap
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            width: 50,
            cellclassName: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }

            }
        },
        {
            headerName: "Truck No", field: "truck_no", width: 100, resizable: true,
            cellclassName: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }
            }
        },
        {
            headerName: "Leg Start Time", field: "leg_start", width: 120, resizable: true,
            valueGetter: function (params) {
                return getHyphenDDMMMYYYYHHMM(params.data.leg_start);
            },
            cellclassName: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }

            }
        },
        {
            headerName: "Leg End Time", field: "leg_end_eta",
            width: 120, resizable: true,
            valueGetter: function (params) {
                return getHyphenDDMMMYYYYHHMM(params.data.leg_end_eta);
            },
            cellclassName: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }
            }
        },
        {
            headerName: "Exp. Leg Distance (KM)",
            field: "leg_expected_distance", width: 140, resizable: true,
            valueGetter: function (params) {
                return Math.round(params.data.leg_expected_distance);
            },
            cellclassName: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }

            }
        },
        {
            headerName: "Actual Leg Distance Covered (KM)",
            field: "actual_leg_distance", width: 140, resizable: true,
            valueGetter: function (params) {
                if (params.data.actual_leg_distance != '' && params.data.actual_leg_distance != undefined) {
                    return Math.round(params.data.actual_leg_distance);
                }
                else {
                    return 0;
                }
            },
            cellclassName: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }

            }
        },
        {
            headerName: "Exp. Distance from Trip Start(KM)",
            field: "expected_distance_start_to_leg", width: 140, resizable: true,
            valueGetter: function (params) {
                if (params.data.expected_distance_start_to_leg != '' && params.data.expected_distance_start_to_leg != undefined) {
                    return Math.round(params.data.expected_distance_start_to_leg);
                }
                else {
                    return 0;
                }

            },
            cellclassName: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }

            }

        },
        {
            headerName: "Actual Distance from Trip Start (KM)",
            field: "actual_distance_traveled_start_to_leg", width: 140, resizable: true,
            valueGetter: function (params) {
                if (params.data.actual_distance_traveled_start_to_leg != '' && params.data.actual_distance_traveled_start_to_leg != undefined) {
                    return Math.round(params.data.actual_distance_traveled_start_to_leg);
                }
                else {
                    return 0;
                }

            },
            cellclassName: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }

            }


        },

        {
            headerName: "Google Distance from Start (KM)",
            field: "actual_start_to_leg_google_distance",
            width: 140,
            resizable: true,
            cellclassName: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }

            }


        },
        {
            headerName: "GPS Data Available",
            field: "no_gps_data",
            width: 140,
            resizable: true,
            valueGetter: function (params) {
                if (params.data.no_gps_data == 1) {
                    return "Not Available";
                }
                if (params.data.no_gps_data == 0) {
                    return "Available";
                }

            },
            cellclassName: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }

            }


        },


        {
            headerName: "Trip Completed",
            field: "trip_completed",
            width: 140,
            resizable: true,
            valueGetter: function (params) {
                if (params.data.trip_completed == 1) {
                    return "Yes";
                }
                if (params.data.trip_completed == 2) {
                    return "";
                }
                if (params.data.trip_completed == 0) {
                    return "";
                }

            },
            cellclassName: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }

            }
        }
    ]
    const stoppagescols = [
        // {
        //     headerName: "",
        //     field: "_id",
        //     cellRendererSelector: function (param) {
        //         try {
        //             if (param.data._id != null && param.data._id != undefined) {
        //                 return {
        //                     component: RoutemapenrouteAction,
        //                     params: {
        //                         onShowEnrouteRouteMap: onShowEnrouteRouteMap
        //                     }
        //                 }
        //             }
        //         } catch (err) {
        //             console.log(err);
        //         }
        //     },
        //     width: 50,
        //     suppressSizeToFit: true,
        // },
        {
            headerName: "Break Start",
            field: "stoppage_start_time",
            width: 150,
            resizable: true,
            valueGetter: function (params) {
                if (params.data.stoppage_start_time != undefined) {
                    return getHyphenDDMMMYYYYHHMM(params.data.stoppage_start_time)
                }
                else {
                    return '';
                }

            }
        },
        {
            headerName: "Break End",
            field: "reset_datetime",
            width: 150,
            resizable: true,
            valueGetter: function (params) {
                if (params.data.reset_datetime != undefined) {
                    return getHyphenDDMMMYYYYHHMM(params.data.reset_datetime)
                }
                else {
                    return '';
                }

            }
        },
        {
            headerName: "Exception Closed On",
            field: "modified_date",
            width: 220,
            resizable: true,
            valueGetter: function (params) {
                if (params.data.exception_closed == 1) {

                    if (params.data.modified_date != undefined) {
                        return getHyphenDDMMMYYYYHHMM(params.data.modified_date)
                    }
                    else {
                        return '';
                    }
                }
                else {
                    return '';
                }

            }
        },
        {
            headerName: "Break Time",
            field: "elaped_time_from_last_moved_seconds",
            width: 180,
            resizable: true,
            valueGetter: function (params) {
                if (params.data.exception_closed == 1) {
                    var sdate = moment.parseZone(params.data.stoppage_start_time).format("x");
                    if (typeof params.data.reset_datetime == 'undefined') {
                        var edate = moment.parseZone().format("x");
                    }
                    else {
                        var edate = moment.parseZone(params.data.reset_datetime).format("x");
                    }
                    var diff = (edate - sdate) / 1000;
                    return secondsToString(diff);
                }
                else {
                    return '';
                }
            }
        }
    ]
    

    deliveredColDefs.splice(16, 0, {
        headerName: "Recent Destination",
        field: "last_location",
        width: 150,
        cellRenderer: '',
        resizable: true,
        headerClass: 'bold-header'
    });

    deliveredColDefs.push({
        headerName: "Delivery Station",
        field: "delivery_station",
        width: 150,
        cellRenderer: '',
        resizable: true,
        headerClass: 'bold-header'
    });

    var allColDefs = [...deliveredColDefs];
    var lrNoOptions = []
    const CounterClick = (ecounter) => {
        
        if (tabName.value == "active") {
          switch (ecounter) {
            case "Total":
                columnApiConsignments.current.setColumnsVisible(
                    [
                      "cancel_order",
                      "map",
                      "shipmentlegs",
                      "Group",
                      "view_document",
                      "sendemail",
                    ],
                    true                  );
                  columnApiConsignments.current.setColumnsVisible(["remarks"], false);
              setCounterActive(ecounter);
              setColumnWithDefs(filterActive);
              setRowData(activeTrips.all);
              break;
            case "In Transit":
                columnApiConsignments.current.setColumnsVisible(
                    [
                      "cancel_order",
                      "map",
                      "shipmentlegs",
                      "Group",
                      "view_document",
                      "sendemail",
                    ],
                    true                  );
                  columnApiConsignments.current.setColumnsVisible(["remarks"], false);
              setCounterActive(ecounter);
              setColumnWithDefs(filterActive);
              setRowData(activeTrips.inTransit);
              lrBasedSegData = activeTrips.inTransit.reduce((acc, cur) => {
                let curLrno = cur.lr_no;
                if (!acc[curLrno]) {
                  acc[curLrno] = new Set();
                }
                acc[curLrno].add(cur.invoice_no);
                return acc;
              }, []);
              lrNoOptions = Object.entries(lrBasedSegData)
                .map(([key, set]) => {
                  return Array.from(set).map((item) => ({
                    value: key,
                    label: item,
                  }));
                })
                .flat()
                .filter(
                  (option) =>
                    option.value && option.label && option.value !== "undefined"
                );
              setLrOptions(lrNoOptions);
              break;
            case "Out For Delivery":
                columnApiConsignments.current.setColumnsVisible(
                    [
                      "cancel_order",
                      "map",
                      "shipmentlegs",
                      "Group",
                      "view_document",
                      "sendemail",
                    ],
                    true                  );
                  columnApiConsignments.current.setColumnsVisible(["remarks"], false);
              setCounterActive(ecounter);
              setColumnWithDefs(filterActive);
              setRowData(activeTrips.outForDelivery);
              break;
         case "Arrived At Destination":
            columnApiConsignments.current.setColumnsVisible(
                [
                  "cancel_order",
                  "map",
                  "shipmentlegs",
                  "Group",
                  "view_document",
                  "sendemail",
                ],
                true                  );
              columnApiConsignments.current.setColumnsVisible(["remarks"], false);
            setCounterActive(ecounter);
            setColumnWithDefs(filterActive);
            setRowData(activeTrips.arrived_at_destination);
            break;
                case "SIM Issues":
                    columnApiConsignments.current.setColumnsVisible(
                        [
                          "cancel_order",
                          "map",
                          "shipmentlegs",
                          "Group",
                          "view_document",
                          "sendemail",
                        ],
                        true                  );
                      columnApiConsignments.current.setColumnsVisible(["remarks"], false);
                    setCounterActive(ecounter);
                    setColumnWithDefs(filterActive);
                    setRowData(activeTrips.sim_issues);
                    break;
            case "Disabled":
                columnApiConsignments.current.setColumnsVisible(
                    [
                      "cancel_order",
                      "map",
                      "shipmentlegs",
                      "Group",
                      "view_document",
                      "sendemail",
                    ],
                    true                  );
                  columnApiConsignments.current.setColumnsVisible(["remarks"], false);
              setCounterActive(ecounter);
              setColumnWithDefs(filterActive);
              setRowData(activeTrips.cancelled);
              break;
            case "Tracking N/A":
                columnApiConsignments.current.setColumnsVisible(
                    [
                      "cancel_order",
                      "map",
                      "shipmentlegs",
                      "Group",
                      "view_document",
                      "sendemail",
                    ],
                    true                  );
                  columnApiConsignments.current.setColumnsVisible(["remarks"], false);
              setCounterActive(ecounter);
              setColumnWithDefs(filterActive);
              setRowData(activeTrips.tracking_na);
              break;
            case "Transit Delays":
                columnApiConsignments.current.setColumnsVisible(
                    [
                      "cancel_order",
                      "map",
                      "shipmentlegs",
                      "Group",
                      "view_document",
                      "sendemail",
                    ],
                    true                  );
                  columnApiConsignments.current.setColumnsVisible(["remarks"], false);
              setCounterActive(ecounter);
              setColumnWithDefs(filterActive);
              setRowData(activeTrips.transit_delay);
              break;
            case "Stoppages":
                columnApiConsignments.current.setColumnsVisible(
                    [
                      "cancel_order",
                      "map",
                      "shipmentlegs",
                      "Group",
                      "view_document",
                      "sendemail",
                    ],
                    true                  );
                  columnApiConsignments.current.setColumnsVisible(["remarks"], false);
              setCounterActive(ecounter);
              setColumnWithDefs(filterActive);
              setRowData(activeTrips.stoppages);
              break;
            case "Dispatched From Source":
                columnApiConsignments.current.setColumnsVisible(
                    [
                      "cancel_order",
                      "map",
                      "shipmentlegs",
                      "Group",
                      "view_document",
                      "sendemail",
                    ],
                    true                  );
                  columnApiConsignments.current.setColumnsVisible(["remarks"], false);
                setCounterActive(ecounter);
                setColumnWithDefs(filterActive);
                setRowData(activeTrips.dispatched_from_source);
                break;    
            case "At Source":
                     columnApiConsignments.current.setColumnsVisible(
                [
                  "cancel_order",
                  "map",
                  "shipmentlegs",
                  "Group",
                  "view_document",
                  "sendemail",
                ],
                true                  );
              columnApiConsignments.current.setColumnsVisible(["remarks"], false);
                    setCounterActive(ecounter);
                    setColumnWithDefs(filterActive);
                    setRowData(activeTrips.at_source);
                break;        
            case "accidents":
              setCounterActive(ecounter);
              setColumnWithDefs([...intransitColDefs]);
              current_defs = [...intransitColDefs];
              setRowData(activeTrips.accidents);
              break;
            case "trip_deviations":
                columnApiConsignments.current.setColumnsVisible(
                    [
                      "cancel_order",
                      "map",
                      "shipmentlegs",
                      "Group",
                      "view_document",
                      "sendemail",
                    ],
                    true                  );
                  columnApiConsignments.current.setColumnsVisible(["remarks"], false);
              setCounterActive(ecounter);
              setColumnWithDefs([...intransitColDefs]);
              current_defs = [...intransitColDefs];
              setRowData(activeTrips.trip_deviations);
              break;
              case "Undelivered":
                columnApiConsignments.current.setColumnsVisible(
                  [
                    "cancel_order",
                    "map",
                    "shipmentlegs",
                    "Group",
                    "view_document",
                    "sendemail",
                  ],
                  true
                );
                columnApiConsignments.current.setColumnsVisible(["remarks"], true);
                setShowUndelivered(false);
                setCounterActive(ecounter);
                setRowData(activeTrips.undelivered);
                break;
            case "Loading Delay":
              setCounterActive(ecounter);
              setColumnWithDefs([...intransitColDefs]);
              setRowData(activeTrips.loading_delay);
              break;
            case "Unloading Delay":
              setCounterActive(ecounter);
              setColumnWithDefs([...intransitColDefs]);
              setRowData(activeTrips.unloading_delay);
              break;
            case "No GPS Available":
              setCounterActive("Tracking N/A");
              setColumnWithDefs(filterActive);
              setRowData(activeTrips.no_gps_data);
              break;
            case "no_gps_data_lifetime":
              setCounterActive(ecounter);
              setColumnWithDefs([...intransitColDefs]);
              setRowData(activeTrips.no_gps_data_lifetime);
              break;
            default:
              break;
          }
        } else if (tabName.value == "completed") {
          columnApiConsignments.current.setColumnsVisible(
            ["cancel_order"],
            false
          );
          switch (ecounter) {
            case "Total":
              columnApiConsignments.current.setColumnsVisible(
                ["upload_pod"],
                false
              );
              columnApiConsignments.current.setColumnsVisible(["Group"], false);
              setCounterActive(ecounter);
              setRowData(completedTrips.all);
              break;
            case "Delivered":
              columnApiConsignments.current.setColumnsVisible(
                ["upload_pod"],
                false
              );
              columnApiConsignments.current.setColumnsVisible(["Group"], false);
              setCounterActive(ecounter);
              setRowData(completedTrips.delivered);
              break;
            case "Delayed":
              columnApiConsignments.current.setColumnsVisible(
                ["upload_pod"],
                false
              );
              columnApiConsignments.current.setColumnsVisible(["Group"], false);
              setCounterActive(ecounter);
              setRowData(completedTrips.delayed);
              break;
            case "On Time":
              columnApiConsignments.current.setColumnsVisible(["Group"], false);
              columnApiConsignments.current.setColumnsVisible(
                ["upload_pod"],
                false
              );
              setCounterActive(ecounter);
              setRowData(completedTrips.onTime);
              break;
            case "POD Pending":
              columnApiConsignments.current.setColumnsVisible(["Group"], false);
              columnApiConsignments.current.setColumnsVisible(
                ["upload_pod"],
                true
              );
              setCounterActive(ecounter);
              setRowData(completedTrips.podPending);
              break;
            case "0-1 Days":
              columnApiConsignments.current.setColumnsVisible(["Group"], false);
              columnApiConsignments.current.setColumnsVisible(
                ["upload_pod"],
                true
              );
              setCounterActive(ecounter);
              setRowData(completedTrips.zeroToOneDays);
              break;
            case "1-2 Days":
              columnApiConsignments.current.setColumnsVisible(["Group"], false);
              columnApiConsignments.current.setColumnsVisible(
                ["upload_pod"],
                true
              );
              setCounterActive(ecounter);
              {
              }
              setRowData(completedTrips.oneToTwoDays);
              break;
            case "3-5 Days":
              columnApiConsignments.current.setColumnsVisible(["Group"], false);
              columnApiConsignments.current.setColumnsVisible(
                ["upload_pod"],
                true
              );
              setCounterActive(ecounter);
              setRowData(completedTrips.threeToFiveDays);
              break;
            case "6-10 Days":
              columnApiConsignments.current.setColumnsVisible(["Group"], false);
              columnApiConsignments.current.setColumnsVisible(
                ["upload_pod"],
                true
              );
              setCounterActive(ecounter);
              setRowData(completedTrips.sixToTenDays);
              break;
            case ">10 Days":
              columnApiConsignments.current.setColumnsVisible(["Group"], false);
              columnApiConsignments.current.setColumnsVisible(
                ["upload_pod"],
                true
              );
              setCounterActive(ecounter);
              setRowData(completedTrips.gtTenDays);
              break;
            default:
              break;
          }
        } else if (tabName.value == "all") {
          switch (ecounter) {
            case "Total":
              columnApiConsignments.current.setColumnsVisible(
                [
                  "cancel_order",
                  "map",
                  "shipmentlegs",
                  "Group",
                  "view_document",
                  "sendemail",
                ],
                true
              );
              columnApiConsignments.current.setColumnsVisible(
                ["remarks"],
                false
              );
              setShowUndelivered(true);
              setCounterActive(ecounter);
              setRowData(allTrips.all);
              break;
            case "At Source":
                columnApiConsignments.current.setColumnsVisible(
                  [
                    "cancel_order",
                    "map",
                    "shipmentlegs",
                    "Group",
                    "view_document",
                    "sendemail",
                  ],
                  true
                );
                columnApiConsignments.current.setColumnsVisible(
                  ["remarks"],
                  false
                );
                setShowUndelivered(true);
                setCounterActive(ecounter);
                setRowData(allTrips.at_source);
                break;
             case "Arrived At Destination":
                columnApiConsignments.current.setColumnsVisible(
                  [
                    "cancel_order",
                    "map",
                    "shipmentlegs",
                    "Group",
                    "view_document",
                    "sendemail",
                  ],
                  true
                );
                columnApiConsignments.current.setColumnsVisible(
                  ["remarks"],
                  false
                );
                setShowUndelivered(true);
                setCounterActive(ecounter);
                setRowData(allTrips.arrived_at_destination);
                break;
                case "SIM Issues":
                    columnApiConsignments.current.setColumnsVisible(
                      [
                        "cancel_order",
                        "map",
                        "shipmentlegs",
                        "Group",
                        "view_document",
                        "sendemail",
                      ],
                      true
                    );
                    columnApiConsignments.current.setColumnsVisible(
                      ["remarks"],
                      false
                    );
                    setShowUndelivered(true);
                    setCounterActive(ecounter);
                    setRowData(allTrips.sim_issues);
                    break;        
            case "Dispatched From Source":
                    columnApiConsignments.current.setColumnsVisible(
                      [
                        "cancel_order",
                        "map",
                        "shipmentlegs",
                        "Group",
                        "view_document",
                        "sendemail",
                      ],
                      true
                    );
                    columnApiConsignments.current.setColumnsVisible(
                      ["remarks"],
                      false
                    );
                    setShowUndelivered(true);
                    setCounterActive(ecounter);
                    setRowData(allTrips.dispatched_from_source);
                    break;
            case "In Transit":
              columnApiConsignments.current.setColumnsVisible(
                [
                  "cancel_order",
                  "map",
                  "shipmentlegs",
                  "Group",
                  "view_document",
                  "sendemail",
                ],
                true
              );
              columnApiConsignments.current.setColumnsVisible(
                ["remarks"],
                false
              );
              setShowUndelivered(true);
              setCounterActive(ecounter);
              setRowData(allTrips.inTransit);
              break;
            case "Delivered":
              columnApiConsignments.current.setColumnsVisible(
                [
                  "cancel_order",
                  "map",
                  "shipmentlegs",
                  "Group",
                  "view_document",
                  "sendemail",
                ],
                true
              );
              columnApiConsignments.current.setColumnsVisible(
                ["remarks"],
                false
              );
              setShowUndelivered(true);
              setCounterActive(ecounter);
              setRowData(allTrips.delivered);
              break;
            case "Tracking N/A":
              columnApiConsignments.current.setColumnsVisible(
                [
                  "cancel_order",
                  "map",
                  "shipmentlegs",
                  "Group",
                  "view_document",
                  "sendemail",
                ],
                true
              );
              columnApiConsignments.current.setColumnsVisible(
                ["remarks"],
                false
              );
              setShowUndelivered(true);
              setCounterActive("Tracking N/A");
              setRowData(allTrips.tracking_na);
              break;
            case "Undelivered":
              columnApiConsignments.current.setColumnsVisible(
                [
                  "cancel_order",
                  "map",
                  "shipmentlegs",
                  "Group",
                  "view_document",
                  "sendemail",
                ],
                true
              );
              columnApiConsignments.current.setColumnsVisible(["remarks"], true);
              setShowUndelivered(false);
              setCounterActive(ecounter);
              setRowData(allTrips.undelivered);
              break;
            case "Disabled":
              columnApiConsignments.current.setColumnsVisible(
                [
                  "cancel_order",
                  "map",
                  "shipmentlegs",
                  "Group",
                  "view_document",
                  "sendemail",
                ],
                false
              );
              columnApiConsignments.current.setColumnsVisible(
                ["remarks"],
                false
              );
              setShowUndelivered(true);
              setCounterActive(ecounter);
              setRowData(allTrips.disabled);
              break;
            case "Transit Delays":
              columnApiConsignments.current.setColumnsVisible(
                [
                  "cancel_order",
                  "map",
                  "shipmentlegs",
                  "Group",
                  "view_document",
                  "sendemail",
                ],
                true
              );
              columnApiConsignments.current.setColumnsVisible(
                ["remarks"],
                false
              );
              setShowUndelivered(true);
              setCounterActive(ecounter);
              setRowData(allTrips.transit_delay);
              break;
            case "Stoppages":
              columnApiConsignments.current.setColumnsVisible(
                [
                  "cancel_order",
                  "map",
                  "shipmentlegs",
                  "Group",
                  "view_document",
                  "sendemail",
                ],
                true
              );
              columnApiConsignments.current.setColumnsVisible(
                ["remarks"],
                false
              );
              setShowUndelivered(true);
              setCounterActive(ecounter);
              setRowData(allTrips.stoppages);
              break;
            case "Out For Delivery":
              columnApiConsignments.current.setColumnsVisible(
                [
                  "cancel_order",
                  "map",
                  "shipmentlegs",
                  "Group",
                  "view_document",
                  "sendemail",
                ],
                true
              );
              columnApiConsignments.current.setColumnsVisible(
                ["remarks"],
                false
              );
              setShowUndelivered(true);
              setCounterActive(ecounter);
              setRowData(allTrips.outForDelivery);
              break;
            case "Delivered":
              columnApiConsignments.current.setColumnsVisible(
                [
                  "cancel_order",
                  "map",
                  "shipmentlegs",
                  "Group",
                  "view_document",
                  "sendemail",
                ],
                true
              );
              columnApiConsignments.current.setColumnsVisible(
                ["remarks"],
                false
              );
              setShowUndelivered(true);
              setCounterActive(ecounter);
              setRowData(allTrips.delivered);
              break;
           
            case "POD Pending":
              columnApiConsignments.current.setColumnsVisible(
                [
                  "cancel_order",
                  "map",
                  "shipmentlegs",
                  "Group",
                  "view_document",
                  "sendemail",
                ],
                true
              );
              columnApiConsignments.current.setColumnsVisible(
                ["remarks"],
                false
              );
              setShowUndelivered(true);
              setCounterActive(ecounter);
              setRowData(allTrips.podPending);
              break;
            case "accidents":
              setCounterActive(ecounter);
              setShowUndelivered(true);
              setRowData(allTrips.accidents);
              break;
            case "trip_deviations":
              setCounterActive(ecounter);
              setShowUndelivered(true);
              setRowData(allTrips.trip_deviations);
              break;
            case "Loading Delay":
              setCounterActive(ecounter);
              setShowUndelivered(true);
              setRowData(allTrips.loading_delay);
              break;
            case "Unloading Delay":
              setCounterActive(ecounter);
              setShowUndelivered(true);
              setRowData(allTrips.unloading_delay);
              break;
            case "No GPS Available":
              setCounterActive("Tracking N/A");
              setShowUndelivered(true);
              setRowData(allTrips.no_gps_data);
              break;
            case "no_gps_data_lifetime":
              setCounterActive(ecounter);
              setShowUndelivered(true);
              setRowData(allTrips.no_gps_data_lifetime);
              break;
            default:
              break;
          }
        } else if (tabName.value == "inactive") {
          columnApiConsignments.current.setColumnsVisible(["identity"], false);
          columnApiConsignments.current.setColumnsVisible(["Group"], false);
          columnApiConsignments.current.setColumnsVisible(
            ["update_tracking_status"],
            false
          );
          setRowData(inactiveTrips);
        }else if (tabName.value == "cancelled") {
            columnApiConsignments.current.setColumnsVisible(["identity"], false);
            columnApiConsignments.current.setColumnsVisible(["Group"], false);
            columnApiConsignments.current.setColumnsVisible(
              ["update_tracking_status"],
              false
            );
            setRowData(closeTrips);
          }
    }
    const validateFormOrder = () => {
        const {
            lr_no, invoice_no, driver_mobile_no, source, truck_no, truck_seal_no, entity,
            vehicle_type, courier_partner, eway_bill_expiry_date, vehicle_capacity,
            consignee_name, movement_type, number_of_boxes, destination_pincode, destination_city
        } = formData;
    
        // Validate fields in order; return true if all fields are filled
        if (!lr_no) return false;
        if (!invoice_no) return false;
        if (!driver_mobile_no) return false;
        if (!source.value) return false;
        if (!truck_no) return false;
        if (!truck_seal_no) return false;
        if (!entity) return false;
        if (!vehicle_type.value) return false;
        if (!courier_partner.value) return false;
        if (!eway_bill_expiry_date) return false;
        if (!vehicle_capacity.value) return false;
        if (!consignee_name) return false;
        if (!movement_type) return false;
        if (!number_of_boxes) return false;
        if (!destination_pincode) return false;
        if (!destination_city) return false;
    
        return true; // All fields are filled
    };
    
const onCloseEmail = () => {
    // Close the slider
    setSliderEmailOpen(false);
    setEmail("")
    setWhatsapp_no("")
    setActiveForm("")
  }
  const handleCloseModal = () => {
    setIsEditLogsModalOpen(false); // Close the modal
    setFilteredLog(null); // Clear filtered log
    setOverlay("show-n")
};
  var onSubmitEmail = async (event) => {
    event.preventDefault(); 
    onCloseEmail();
    // (!email || !validateEmail(email)) 
    if(!activeForm){
        return;
    }
    if (activeForm === 'email') {
        if (!email || !validateEmail(email)) {
            setShow(true); 
            setTitle('Please Enter a Valid Email ID');
            setType('warning');
            setActiveForm("")
            return; // Stop the function if email validation fails
        }
    } else if (activeForm === 'whatsapp') {
        if (!whatsapp_no || !validatePhoneNumber(whatsapp_no)) {
            setShow(true); 
            setTitle('Please Enter a Valid Phone Number');
            setType('warning');
            setActiveForm("")
            return; // Stop the function if phone number validation fails
        }
    }

    setOverlay("show-m");
    await setLoadShow("show-m");

    var current_date = new Date()
    var current_date = new Date(current_date.setHours(current_date.getHours() - 1))


    var gateouttime = moment.parseZone(data.gate_out_time).format('YYYY-MM-DD HH:mm:ss');
    if (data.gate_out_time ==="" || data.gate_out_time === undefined) {
        // if (data.dispatch_date) {
        //     gateouttime = moment.parseZone(data.dispatch_date).format('YYYY-MM-DD HH:mm:ss');
        // }
        if (data.shipment_time) {
            gateouttime = moment.parseZone(data.shipment_time).format('YYYY-MM-DD HH:mm:ss');
        }
    }

    var end_date;
    var edate;
    if(data.hasOwnProperty('status')){
        
        if (data.status == 6) {
            if (data.force_closure_time) {
                let splitT = data.force_closure_time.split('T');
                let yMD = splitT[0];
                let hMS = splitT[1];
                let hms1 = hMS.split('.');
                let finalHms = hms1[0];
                let final_end_date = yMD + ' ' + finalHms;
                end_date = final_end_date;
                edate = final_end_date;
            }
        } else if (data.status == 2 || data.status == 3) {
            end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss');
            edate = getHyphenDDMMYYYYHHMMSS(end_date);
        } else if (data.status == 5) {
            if (data.left_dealer_marked) {
                end_date = data.left_dealer_marked.replace("T", " ").replace("Z", " ").replace(".000", " ").replace(".855", " ").trim();
                edate = getHyphenDDMMYYYYHHMMSS(data.left_dealer_marked);
            }
        } else if (data.status == 4 || data.status == 8) {
            if (data.recent_dealer_reported) {
                end_date = data.recent_dealer_reported.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
                edate = getHyphenDDMMYYYYHHMMSS(data.recent_dealer_reported);
            }
        } else {
            end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss');
            edate = getHyphenDDMMYYYYHHMMSS(end_date);
        }
    
        if (!end_date) {
            end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss');
        }
        
        let encryptedVal = window.btoa(`${data.truck_no},${gateouttime},${end_date},${data.lr_no},${data.consignee_code},${data.consignment_code}`);
        var map_link = "https://legrandgroup.autometrics.in/map/" + encryptedVal;
    
        var event_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss');
        var event_date1 = getHyphenDDMMYYYYHHMMSS(event_date);
    
        if (email && validateEmail(email)){
            // Fetch the current status from the statusMap based on data.status
            let currentStatus = statusMap[data.status] || "Unknown Status";
           
            var dispatchDateFormat;
            if(data.dispatch_date!==""){
                // formatAdjustedDate(data.dispatch_date)
                // var date1 = moment(data.dispatch_date);
                // var adjustedTime1= date1.subtract(5, "hours").subtract(30, 'minutes')
                // var time1 = adjustedTime1.toDate()
                // var timeString = time1.toDateString()
                // const date = new Date(timeString);

                // // Format date as "DD-MM-YYYY HH:mm:ss"
                // const formattedDate = `${date.getDate().toString().padStart(2, '0')}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getFullYear()} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}`;
                dispatchDateFormat=formatAdjustedDate(data.dispatch_date)
                
            }
            const dispatchDateFormatted = data?.dispatch_date ? dispatchDateFormat : "";
            var expectedDateFormat;
            if(data.expected_eta!==""){
                expectedDateFormat=formatAdjustedDate(data.expected_eta)
                
            }
            const expectedDateFormatted = data?.expected_eta ? expectedDateFormat : "";
            
            let reqData = {
                tracking_type: data.tracking_type,
                truck_no: data.truck_no,
                Lr_no: data.lr_no,
                transporter_name: data?.transporter_name ?? "",
                dispatch_date: dispatchDateFormatted,                
                source: data?.consigner_city ?? "",
                destination: data?.consignee_city ?? "",
                current_eta: expectedDateFormatted,
                current_status: currentStatus,
                screen: "consignment",
                email: email,
                map_param: 1,
                map_link: map_link,
                shipment_id: data.shipment_id
            };
    
            var emailLogs = {
                dept_code: localStorage.getItem("dept_code"),
                useremail: decode(localStorage.getItem("email")),
                role: decode(localStorageRole),
                event_date: event_date1,
                screen: "FTL Consignments Email share link ",
                activity: "On sending tracking link to email",
                email_receiver:email
            }
            var combinedParams ={
                reqData,
                emailLogs
            }
        
            redirectURL.post("/consignments/sentemail", combinedParams)
                .then((response) => {
                    setLoadShow("show-m");
                    setOverlay("show-m");
                    try {
                        var records = response.data;
                        if (records.status == "Failure") {
                            setShow(true);
                            setTitle("No Route data available");
                            setType("danger");
                            setOverlay("show-n");
                            setLoadShow("show-n");
                        } else {
                            setShow(true);
                            setTitle("Email Sent Successfully");
                            setType("success");
                            setLoadShow("show-n");
                            setOverlay("show-n");
                        }
                    } catch (e) {
                        console.log("e ", e);
                        setShow(true);
                        setTitle("No Route data available");
                        setType("danger");
                    } finally {
                        setLoadShow("show-n");
                        setOverlay("show-n");
                    }
                });
        }
        if (whatsapp_no && validatePhoneNumber(whatsapp_no)){
            
            
            if (whatsapp_no.length == 10) {
                expired_time = current_date.getTime() + (expired_time.value) * 24 * 60 * 60 * 1000
                let expired_date = moment.parseZone(new Date(expired_time)).format('YYYY-MM-DD HH:mm:ss')
                let expiry_date = await handleEncrypt(expired_date)
     
                // var from_date = moment.parseZone(new Date(current_date)).format('YYYY-MM-DD HH:mm:ss')
                var from_date = moment.parseZone(data.gate_out_time).format('YYYY-MM-DD HH:mm:ss');

                if(data.gate_out_time ==='' || data.gate_out_time === undefined){
                    // var from_date = moment.parseZone(data.dispatch_date).format('YYYY-MM-DD HH:mm:ss');
                    if (data.shipment_time) {
                        from_date = moment.parseZone(data.shipment_time).format('YYYY-MM-DD HH:mm:ss');
                    }
                }
               
                
                // var from_date = await handleEncrypt(from_date)
                var params={
                    shipment_id: data.shipment_id,
                    tracking_type: data.tracking_type
                }
                var updated_time;
                await redirectURL.post("/consignments/fetchLastUpdateTime", params).then((resp)=>{
                    if(resp.data.status==="success"){
                        updated_time= data.updated_time
                    }
                })
     
                // var link = `https://enmovil.io/truckdetails/sharelink/tptlogin/${data.truck_no}/${(from_date)}/${(expiry_date)}`
                let encryptedVal = window.btoa(`${data.truck_no},${gateouttime},${end_date},${data.lr_no},${data.consignee_code},${data.consignment_code}`);
                var link = "https://legrandgroup.autometrics.in/map/" + encryptedVal;                
                // Fetch the current status from the statusMap based on data.status
                const currentStatus = statusMap[data.status] || "Unknown Status";
                var dispatchDateFormat;
            if(data.dispatch_date!==""){
                dispatchDateFormat=formatAdjustedDate(data.dispatch_date)
                
            }
                const dispatchDateFormatted = data?.dispatch_date ? dispatchDateFormat : "";
                var expectedDateFormat;
                if(data.expected_eta!==""){
                    expectedDateFormat=formatAdjustedDate(data.expected_eta)
                    
                }
                const expectedDateFormatted = data?.expected_eta ? expectedDateFormat : "";

                var updateTimeDate;
                if(updated_time!==""){
                    updateTimeDate=formatAdjustedDate(updated_time)
                    
                }
                const updateTimeDateFormatted = updated_time ? updateTimeDate : "";

               

                var eventDateTime;
                if(data.status === 2){
                    eventDateTime=formatAdjustedDate(data.gate_out_time)

                }else if (data.status === 3 || data.status === 4 || data.status === 8) {
                    // Use 'consignment_status' logic
                    eventDateTime=formatAdjustedDate(data.recent_dealer_reported)

                }else  if (data.status === 6) {
                    // Use 'status' logic
                    eventDateTime=formatAdjustedDate(data.force_closure_time)

                }
                const eventTimeDateFormatted = eventDateTime;

                // var message = `Truck Details:
                // Vehicle No: ${data.truck_no}
                // LR.No: ${data.lr_no}
                // Transporter: ${data.transporter_name}
                // Dispatch Date: ${dispatchDateFormatted}
                // Source: ${data.consigner_city}
                // Destination: ${data.consignee_city}
                // Current ETA: ${data.expected_eta}
                // Current Status: ${currentStatus}
                // Tracking Link: ${link}`;
                var message = `Truck Details:\nVehicle No: ${data.truck_no},\nLR.No: ${data.lr_no},\nTransporter: ${data.transporter_name},\nDispatch Date: ${dispatchDateFormatted},\nSource: ${data.consigner_city},\nDestination: ${data.consignee_city},\nCurrent ETA: ${expectedDateFormatted},\nLast Update Date: ${updateTimeDateFormatted},\nCurrent Status: ${currentStatus}, \nEvent Date & Time: ${eventTimeDateFormatted} \nEvent Location: ${data.last_location}, \nTracking Link:`;

                const encodedMessage = encodeURIComponent(message);
                
                // var link1 = <a href="link" target="_blank"></a>
                // var linkHtml = <a href={link} target="_blank">Click here to view the map</a>;


                // Open WhatsApp with the truck details and the map link
                window.open(`https://web.whatsapp.com/send?phone=${whatsapp_no}&text=${encodedMessage}%0A${link}`, '_blank');


                // Open WhatsApp with the truck details and the map link
                // window.open(`https://web.whatsapp.com/send?phone=${whatsapp_no}&text=${encodeURIComponent(link)}`);
               
                // var message = `Truck Details:
                // Vehicle No: ${data.truck_no}
                // LR.No: ${data.lr_no}
                // Transporter: ${data.transporter_name}
                // Dispatch Date: ${dispatchDateFormatted}
                // Source: ${data.consigner_city}
                // Destination: ${data.consignee_city}
                // Current ETA: ${data.expected_eta}
                // Current Status- ${currentStatus}
                // Tracking Link: `;
                // // window.open(`/truckdetails/sharelink/tptlogin/${data.truck_no}/${from_date}/${expiry_date}`)
                // // window.open(`/truckdetails/sharelink/tptlogin/${data.truck_no}`)
                // // window.open(`https://api.whatsapp.com/send?text=${link}` , '_blank')
     
                // window.open(`https://web.whatsapp.com/send?phone=${whatsapp_no}&text=${encodeURIComponent(link)}`)
                
                setShow(true);
                setTitle("Whatsapp Sent Successfully");
                setType("success");
                setLoadShow("show-n");
                setOverlay("show-n")
                setActiveForm("");
                setexpired_time({ label: "7 Day", value: 7 })
                setWhatsapp_no("")
            }
            else {
                setShow(true);
                setTitle("WhatApp Number should be 10 Digits");
                setType("danger");
                setLoadShow("show-n");
                setOverlay("show-n");
               
            }
     
        
        }
    } 
    else{
        let encryptedVal = window.btoa(`${data.truck_no},${gateouttime},${end_date},${data.lr_no},${data.consignee_code},${data.consignment_code}`);

        // let encryptedVal = window.btoa(`${data.truck_no},${data.dispatch_date},${end_date},${data.lr_no},${data.consignee_code},${data.consignment_code}`);
        var map_link = "https://legrandgroup.autometrics.in/map/" + encryptedVal;
    
        var event_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss');
        var event_date1 = getHyphenDDMMYYYYHHMMSS(event_date);
        var dispatchDateFormat;
            if(data.dispatch_date!==""){
                var date1 = moment(data.dispatch_date);
                var adjustedTime1= date1.subtract(5, "hours").subtract(30, 'minutes')
                var time1 = adjustedTime1.toDate()
                var timeString = time1.toDateString()
                const date = new Date(timeString);

                // Format date as "DD-MM-YYYY HH:mm:ss"
                const formattedDate = `${date.getDate().toString().padStart(2, '0')}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getFullYear()} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}`;
                dispatchDateFormat=formattedDate
                
            }
            var expectedDateFormat;
            if(data.expected_eta!==""){
                var date1 = moment(data.expected_eta);
                var adjustedTime1= date1.subtract(5, "hours").subtract(30, 'minutes')
                var time1 = adjustedTime1.toDate()
                var timeString = time1.toDateString()
                const date = new Date(timeString);

                // Format date as "DD-MM-YYYY HH:mm:ss"
                const formattedDate = `${date.getDate().toString().padStart(2, '0')}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getFullYear()} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}`;
                expectedDateFormat=formattedDate
                
            }
    
        if (email && validateEmail(email)){
            const dispatchDateFormatted = data?.dispatch_date ? dispatchDateFormat : "";
            const expectedDateFormatted = data?.expected_eta ? expectedDateFormat : "";

            
            let reqData = {
                tracking_type: data.tracking_type,
                lr_no: data.lr_no,
                truck_no: data.truck_no,
                transporter_name: data?.transporter_name ?? "",
                dispatch_date: dispatchDateFormatted,                
                source: data?.consigner_city ?? "",
                destination: data?.consignee_city ?? "",
                current_eta: expectedDateFormatted,
                current_status: data.consignment_status,
                screen: "consignment",
                email: email,
                shipment_id: data.shipment_id

            };
    
            let emailLogs = {
                dept_code: localStorage.getItem("dept_code"),
                useremail: decode(localStorage.getItem("email")),
                role: decode(localStorageRole),
                event_date: event_date1,
                screen: "PTL Courier Consignments Email share link ",
                activity: "On sending tracking Details to email",
                email_receiver:email
            }
            var combinedParams ={
                reqData,
                emailLogs
            }
        
            redirectURL.post("/consignments/sentemail", combinedParams)
                .then((response) => {
                    setLoadShow("show-m");
                    setOverlay("show-m");
                    try {
                        var records = response.data;
                        if (records.status == "Failure") {
                            setShow(true);
                            setTitle("No Route data available");
                            setType("danger");
                            setOverlay("show-n");
                            setLoadShow("show-n");
                        } else {
                            setShow(true);
                            setTitle("Email Sent Successfully");
                            setType("success");
                            setLoadShow("show-n");
                            setOverlay("show-n");
                        }
                    } catch (e) {
                        console.log("e ", e);
                        setShow(true);
                        setTitle("No Route data available");
                        setType("danger");
                    } finally {
                        setLoadShow("show-n");
                        setOverlay("show-n");
                    }
                });
        }
        if (whatsapp_no && validatePhoneNumber(whatsapp_no)){
            var dispatchDateFormat;
            if(data.dispatch_date!==""){
                var date1 = moment(data.dispatch_date);
                var adjustedTime1= date1.subtract(5, "hours").subtract(30, 'minutes')
                var time1 = adjustedTime1.toDate()
                var timeString = time1.toDateString()
                const date = new Date(timeString);

                // Format date as "DD-MM-YYYY HH:mm:ss"
                const formattedDate = `${date.getDate().toString().padStart(2, '0')}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getFullYear()} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}`;
                dispatchDateFormat=formattedDate
                
            }
            var expectedDateFormat;
            if(data.expected_eta!==""){
                var date1 = moment(data.expected_eta);
                var adjustedTime1= date1.subtract(5, "hours").subtract(30, 'minutes')
                var time1 = adjustedTime1.toDate()
                var timeString = time1.toDateString()
                const date = new Date(timeString);

                // Format date as "DD-MM-YYYY HH:mm:ss"
                const formattedDate = `${date.getDate().toString().padStart(2, '0')}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getFullYear()} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}`;
                expectedDateFormat=formattedDate
                
            }
            
            
            if (whatsapp_no.length == 10) {
                expired_time = current_date.getTime() + (expired_time.value) * 24 * 60 * 60 * 1000
                let expired_date = moment.parseZone(new Date(expired_time)).format('YYYY-MM-DD HH:mm:ss')
                let expiry_date = await handleEncrypt(expired_date)
     
                var from_date = moment.parseZone(new Date(current_date)).format('YYYY-MM-DD HH:mm:ss')
                var from_date = await handleEncrypt(from_date)
                const dispatchDateFormatted = data?.dispatch_date ? dispatchDateFormat: "";
                const expectedDateFormatted = data?.expected_eta ? expectedDateFormat : "";

                var params={
                    shipment_id: data.shipment_id,
                    tracking_type: data.tracking_type
                }
                var updated_time;
                await redirectURL.post("/consignments/fetchLastUpdateTime", params).then((resp)=>{
                    if(resp.data.status==="success"){
                        
                    updated_time=resp.data.updated_time;
                    }
                })
                var updateTimeDate;
                if(updated_time!==""){
                    var date1 = moment(updated_time);
                    var adjustedTime1= date1.subtract(5, "hours").subtract(30, 'minutes')
                    var time1 = adjustedTime1.toDate()
                    var timeString = time1.toDateString()
                    const date = new Date(timeString);
    
                    // Format date as "DD-MM-YYYY HH:mm:ss"
                    const formattedDate = `${date.getDate().toString().padStart(2, '0')}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getFullYear()} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}`;
                    updateTimeDate=formattedDate
                    
                }
                const updateTimeDateFormatted = updated_time ? updateTimeDate : "";

                var eventDateTime;
                if (data.last_event_time) {
                    eventDateTime=formatAdjustedDate(data.last_event_time)

                    // Use 'consignment_status' logic
                }
                



     
                let encryptedVal = window.btoa(`${data.truck_no},${gateouttime},${end_date},${data.lr_no},${data.consignee_code},${data.consignment_code}`);
                var link = "https://legrandgroup.autometrics.in/map/" + encryptedVal;  
                
                
                // Fetch the current status from the statusMap based on data.status
                const currentStatus = data.consignment_status || "Unknown Status";              
                
                // var message = `<p>Courier Track Details:<br>
                // \tLR.No: ${data.lr_no}<br>
                // \tVehicle No: ${data.truck_no}
                // \tTransporter: ${data.transporter_name}<br>
                // \tDispatch Date: ${dispatchDateFormatted}<br>
                // \tSource: ${data.consigner_city}<br>
                // \tDestination: ${data.consignee_city}<br>
                // \tCurrent ETA: ${data.expected_eta}<br>
                // \tCurrent Status- ${data.consignment_status}</p>
                // `;
                var message = `Courier Track Details:\nVehicle No: ${data.truck_no},\nLR.No: ${data.lr_no},\nTransporter: ${data.transporter_name},\nDispatch Date: ${dispatchDateFormatted},\nSource: ${data.consigner_city},\nDestination: ${data.consignee_city},\nCurrent ETA: ${expectedDateFormatted},\nLast Update Date: ${updateTimeDateFormatted},\nCurrent Status: ${currentStatus}, \nEvent Date & Time: ${eventDateTime}, \nEvent Location: ${data.last_location}, \nTracking Link:`;
                // window.open(`/truckdetails/sharelink/tptlogin/${data.truck_no}/${from_date}/${expiry_date}`)
                // window.open(`/truckdetails/sharelink/tptlogin/${data.truck_no}`)
                // window.open(`https://api.whatsapp.com/send?text=${link}` , '_blank')
                const encodedMessage = encodeURIComponent(message);

                // var link1 = <a href="${link}" target="_blank"></a>
                // var linkHtml = <a href={link} target="_blank">Click here to view the map</a>

     
                window.open(`https://web.whatsapp.com/send?phone=${whatsapp_no}&text=${encodedMessage}%0A${link}`, '_blank');
                
                setShow(true);
                setTitle("Whatsapp Sent Successfully");
                setType("success");
                setLoadShow("show-n");
                setOverlay("show-n")
                setActiveForm("");
                setexpired_time({ label: "7 Day", value: 7 })
                setWhatsapp_no("")
            }
            else {
                setShow(true);
                setTitle("WhatApp Number should be 10 Digits");
                setType("danger");
                setLoadShow("show-n");
                setOverlay("show-n");
               
            }
     
        
        }
    }
   
    
}

var changeEmail = (event) => {
    setEmail(event.target.value)
}
var changeWhatsapp = (event) => {
    setWhatsapp_no(event.target.value)
}
var changeExpiredTime = (event) => {
    setexpired_time({label:event.target.value, value:event.target.value})
}

const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
        event.preventDefault();
        onSubmitEmail();
}
} 
const onCloseDocument = () => {
  // Close the slider
  setSelectedViewTab("loading")
  setSliderDocumentOpen(false);
}
const onClosePodDocument = () => {
    setSliderPODDocumentOpen(false)
}
const validatePhoneNumber = (phoneNumber) => {
    
    if (!phoneNumber || phoneNumber === ""){
        return false
    }else{
        const re = /^[0-9]{10}$/; // Adjust the regex pattern according to your requirements
        return re.test(String(phoneNumber));
    }
    
}
const validateEmail = (email) => {
    if (!email || email ===""){
        return false
    }else{
        const re = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
        return re.test(String(email).toLowerCase());
    }
}
const handleEncrypt = (word) => {
    const plaintext = word;
    const key = CryptoJS.enc.Hex.parse('0123456789abcdef0123456789abcdef');
    const iv = CryptoJS.enc.Hex.parse('0102030405060708090a0b0c0d0e0f00');
    const encryptedBytes = CryptoJS.AES.encrypt(plaintext, key, {
        iv: iv
    });
    const encryptedBase64 = encryptedBytes.toString();
    const encryptedText = encodeURIComponent(encryptedBase64);
    return encryptedText;
};
// const uploadDocument = async(event) => {
//     event.preventDefault();
//     if (Array.isArray(rownode) && rownode[0]?.tracking_type === "FTL"){
//         console.log(selectedInvoiceUpload, "selectedInvoiceUpload");
//         const invoiceNos = selectedInvoiceUpload.map(invoice => invoice.value);
//          const params = {
//         invoiceNos: invoiceNos
//     };
//  try {
//         const response = await redirectURL.post("/consignments/getshipmentrowid", params);
//         console.log(response.data, "Row IDs retrieved for selected invoices");
//         const rowIds = response.data.map(item => item._id);       
//          // Handle response data as needed
//     } catch (error) {
//         console.error("Error fetching row IDs:", error);
//     }        
//     }
//     if (podremarks === "") {
//         setShow(true);
//         setType("warning");
//         setTitle("Please enter remarks");
//         setPodRemarks("");
//         // setEpodDoc([]);
//     } 
//     else if (rownode.length > 0) { // for single pod upload
//         console.log(rownode,"rownodeeeee");
//             const rowid = rownode[0]._id;
//             const shipment_id = rownode[0].shipment_id;
//             const tracking_type = rownode[0].tracking_type;
//             const rownodes = rownode;
//             const formData = new FormData();
//             formData.append("shipmentId", shipment_id);
//             formData.append("podDoc", epodDoc);
//             formData.append("podremarks", podremarks);
//             formData.append("rowid", rowid);
//             formData.append("rownodes", JSON.stringify(rownodes));
//             formData.append("damage", damage);
//             formData.append("short", short);
//             formData.append("excess", excess);
//             formData.append("pilferage", pilferage);
//             formData.append("trackingType", tracking_type);
//             console.log(formData,"savingPOD");
//             await redirectURL.post("/savePoddocument", formData, {
//                 headers: {
//                     'content-type': 'multipart/form-data',
//                     'Access-Control-Allow-Origin': "*",
//                     'Access-Control-Allow-Methods': 'POST',
//                     'Access-Control-Allow-Headers': 'Origin, Content-Type'
//                 }
//             })
//                 .then((resp) => {
//                     if (resp.data.status === 'success') {
//                         document.getElementById("formPOD").reset();
//                         // setRowNode([]);
//                         setShow(true);
//                         // setSlider('show-n');
//                         setTitle("Success.");
//                         setType("success");
//                         setPodRemarks("");
//                         setSliderShow("");
//                         setOverlay("show-n");
//                         setEpodDoc([]);

//                         // setLoadshow('show-n');
//                         // window.location.reload();

//                     }
//                 })
//                 .catch((error) => {
//                     console.error("Error uploading document:", error);
//                     // Handle error here, e.g., show a message
//                 });
//         }
    
// };
const uploadDocument = async (event) => {
    event.preventDefault();

    // Validation for podremarks
    // if (podremarks === "") {
    //     setShow(true);
    //     setType("warning");
    //     setTitle("Please enter remarks");
    //     setPodRemarks("");
    //     return;
    // }
    
    // Check if tracking_type is "FTL" and selectedInvoiceUpload is empty
    if (Array.isArray(rownode) && rownode[0]?.tracking_type === "FTL") {
        // if (!selectedInvoiceUpload || selectedInvoiceUpload.length === 0) {
        //     setShow(true);
        //     setType("warning");
        //     setTitle("Please select an LR No");
        //     return;
        // }
        
        // console.log(selectedInvoiceUpload, "selectedInvoiceUpload");
        
        // const invoiceNos = selectedInvoiceUpload.map(invoice => invoice.value);
        // const params = { invoiceNos: invoiceNos };
        const rowid = rownode[0]._id;
        await savePodDocument(rowid);
        
        // try {
        //     const response = await redirectURL.post("/consignments/getshipmentrowid", params);
        //     console.log(response.data, "Row IDs retrieved for selected invoices");
            
        //     const rowIds = response.data.map(item => item._id);

        //     // Handle single or multiple rowIds
        //     if (rowIds.length === 1) {
        //         // Single rowId, proceed with one request
        //         await savePodDocument(rowIds[0]);
        //     } else {
        //         // Multiple rowIds, loop through each one and make a request
        //         for (const rowid of rowIds) {
        //             await savePodDocument(rowid);
        //         }
        //     }
        // } catch (error) {
        //     console.error("Error fetching row IDs:", error);
        // }        
    } else if (rownode.length > 0) {
        // PTL Case: Only one row ID from rownode[0]
        const rowid = rownode[0]._id;
        await savePodDocument(rowid);
    }
};
const isValidProgression = (currentStatus, newStatus) => {

    // Helper function to get the appropriate status value
    const getStatusValue = (status) => {
        return trackingTypeState ? status : status.value;
    };

    if (
        Dselected_row.tracking_type === "FTL" ||
        bulkTrackingType === "FTL" ||
        trackingTypeState === "FTL"
    ) {
        const currentIndex = statusOrderFtl.findIndex(
            (status) => status.value === getStatusValue(currentStatus)
        );
        const newIndex = statusOrderFtl.findIndex(
            (status) => status.value === getStatusValue(newStatus)
        );
        
        return newIndex >= currentIndex; // Ensure progression for FTL
    } else if (
        Dselected_row.tracking_type === "PTL" ||
        bulkTrackingType === "PTL" ||
        trackingTypeState === "PTL"
    ) {
        if (getStatusValue(currentStatus) === "Undelivered") {
            return (
                getStatusValue(newStatus) !== "Undelivered" && // Ensure new status is not "Undelivered"
                statusOrderPtl.some(
                    (status) => status.value === getStatusValue(newStatus)
                ) // Ensure new status exists in PTL status list
            );
        }
        

        const currentIndex = statusOrderPtl.findIndex(
            (status) => status.value === getStatusValue(currentStatus)
        );
        const newIndex = statusOrderPtl.findIndex(
            (status) => status.value === getStatusValue(newStatus)
        );
        // console.log(newIndex >= currentIndex, "index");
        

        return newIndex >= currentIndex; // Ensure progression for PTL
    }

    return false; // Default return for unknown cases
};


const handleStatusChange = (e) => {
    const newStatus = { label: e.value, value: e.value };

    
    // Check if the status selection is valid
    if(selectedStatusUpdate==="Undelivered"){
        setForm2Details(prev => ({
            ...prev,
            selectedStatus: newStatus,
            errorMessage: ''  // Clear error if valid
          }));
    }else{
        if (isValidProgression(form2Details.selectedStatus, newStatus)) {
            
          setForm2Details(prev => ({
            ...prev,
            selectedStatus: newStatus,
            errorMessage: ''  // Clear error if valid
          }));
        } else {
    
          setForm2Details(prev => ({
            ...prev,
            selectedStatus: newStatus,
            errorMessage: 'You cannot select a previous status.'  // Set error if invalid
          }));
        }
    }
    
    
  };


// Helper function to handle the POD document upload

const savePodDocument = async (rowid) => {
    // console.log(Dselected_row, "test54");
    
    const shipment_id = rownode?.[0]?.shipment_id || Dselected_row?.shipment_id;
    const tracking_type = rownode?.[0]?.tracking_type || Dselected_row?.tracking_type;
        // const rownodes = rownode;
    
    const formData = new FormData();
    formData.append("shipmentId", shipment_id);
    formData.append("podDoc", epodDoc);
    formData.append("podremarks", podremarks);
    formData.append("rowid", rowid);
    // formData.append("rownodes", JSON.stringify(rownodes));
    formData.append("damage", damage);
    formData.append("short", short);
    formData.append("excess", excess);
    formData.append("pilferage", pilferage);
    formData.append("trackingType", tracking_type);
    

    try {
        const resp = await redirectURL.post("/savePoddocument", formData, {
            headers: {
                'content-type': 'multipart/form-data',
                'Access-Control-Allow-Origin': "*",
                'Access-Control-Allow-Methods': 'POST',
                'Access-Control-Allow-Headers': 'Origin, Content-Type'
            }
        });

        if (resp.data.status === 'success') {
            document.getElementById("formPOD").reset();
            setShow(true);
            setTitle("Success.");
            setType("success");
            setPodRemarks("");
            setSliderShow("");
            setOverlay("show-n");
            setEpodDoc([]);
        }
    } catch (error) {
        console.error("Error uploading document:", error);
    }
};
const changeHandler1 = (event) => {
    
    const { name, value } = event.target;
    
    // Assuming you're using setFormData for other fields, make sure to handle podremarks separately
    if (name === "podremarks") {
        setPodRemarks(value);  // Update the podremarks state
    }else if (name ==="docremarks"){
        setDocRemarks(value);
    }else if (name==="loadingdocremarks"){
        setLoadingRemarks(value)
    }else if (name==="unloadingdocremarks"){
        setUnloadingRemarks(value)
    }
     else {
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    }
};

var hideSlideBlock = () => {
    // Clear React state for form fields
    setDamage(0); 
    setExcess(0); 
    setPilferage(0); 
    setShort(0); 
    setPodRemarks(""); // This will clear the textarea
    
    // Resetting other states
    setSliderShow(''); 
    setOverlay('show-n'); 
    setManualUploadSlider('show-n'); 
    setBulkMarkDeliverSlide('show-n'); 
    setShipmentSlider('show-n'); 
    setShipmentCsvContent([]); 
    setShipmentFile(''); 
    setBulkSliderShow('show-n'); 
    setSliderScanShow('show-n'); 
    setSliderSupportShow('show-n'); 
    setSelectedRowNodes([]); 
    setLoadShow('show-n'); 
    setMultiplePodDocs([]); 
    setDeliveredDate1(""); 
    setUpdateRowSlider("");

    // Clear the file input field by DOM manipulation (because it's an uncontrolled input)
    document.getElementById("epodDoc").value = ""; 

    // Optionally reset the whole form if needed
    document.getElementById("formPOD").reset();
};


const changeFileHandlerForUploadDoc = (event) => {
    try {
        const files = Array.from(event.target.files);
        if (files && files.length > 0) {
            const validTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/gif', 'image/bmp', 'image/webp'];

            // Check each file type for validity
            const isValidFile = files.every(file => validTypes.includes(file.type));

            if (!isValidFile) {
                alert("Please select only PDF or image files.");
                setCustomerDocument2(null);
                setUploadDoc(null);
                // document.getElementById("customer_document_2").value = ""; // Reset the file input
                document.getElementById("uploadDoc").value = ""; // Reset the file input
                return; // Exit the function
            }
            
            setCustomerDocument2(files);
            setUploadDoc(null);

            setUploadDoc(files);
            setUploadType(event.target.name)
           
        }
    } catch (e) {
        setCustomerDocument2(null);
        setUploadDoc(null);

        const fileInput = document.getElementById("uploadDoc");
        if (fileInput) {
            fileInput.value = "";
        } else {
            console.error("Element with ID 'uploadDoc' not found");
        }

        // document.getElementById("customer_document_2").value = "";
    }
};
const hideSlideBlockForDocument = () => {
    // $("#podDoc").val("")
    setSliderShow1("")
    setOverlay("show-n")
    document.getElementById("uploadDoc").value = "";
    setDocRemarks("")

//    this.setState({
//        delivered_date :""
//    })
    // document.getElementById("formBulkPOD").reset();
    document.getElementById("formDocument").reset();
    // document.getElementById("formBulkSingle").reset();
}
const onClickEmail = (rowNode) => {
    setData(rowNode.data);
    setSliderEmailOpen(true)
}
const onClickCancelActiveCourierConsignemnts = (e) => {
    setCancelConsignmentTrackingType(e.data.tracking_type)
    setCloseCancelModal(true)
    setRownode(e.data)
    setReasonForCancellation("");    

    if(tabName.value !== "inactive"){
        let x = activeTrips.inTransit.filter((e)=> e.tracking_type === "PTL")
        lrBasedSegData = x.reduce((acc, cur)=>{
            let curLrno = cur.lr_no;
            if(!acc[curLrno]){
                acc[curLrno] = new Set();
            }
            acc[curLrno].add(cur.invoice_no);
            return acc;
        }, [])
        lrNoOptions = Object.entries(lrBasedSegData).map(([key, set]) => {
            return Array.from(set).map(item => ({ value: key, label: item }));
        }).flat().filter(option => option.value && option.label && option.value !== "undefined"); 
        const filteredLrOptions = lrNoOptions.filter(m => {
            return m.label !== "undefined" && m.value === e.data.lr_no;
        });
        setLrOptions(filteredLrOptions)
    } else {
        setLrOptions([])
        let x = [{label: e.data.invoice_no, value: e.data.invoice_no}]
        setLrOptions(x)
    }
}
const uploadPODInTracking=()=>{
    // e.preventDefault(); 
    setUploadPODTracking(!uploadPODTracking)
}
// const onCellValueChanged = (params) => {
//     console.log("Updated Value1",params.newValue ); // Check the updated value

//     // This will get the updated value after the user edits the cell
//     const updatedData = params.data;
//     const updatedValue = params.newValue;

//     // Check if it's the correct column (e.g., 'recent_dealer_reported' or 'delivery_datetime')
//     if (params.colDef.field === "recent_dealer_reported" || params.colDef.field === "delivery_datetime") {
//         console.log("Updated Value:", updatedValue); // Check the updated value
//         updatedData[params.colDef.field] = updatedValue

//         // Optionally, you can update any other data or state here
//     }
//     params.api.refreshCells({ rowNodes: [params.node] });
// };

const onClickEditDeliveryDate = (rowdata) => {
    // setreload(true)
    var row = rowdata.data 
    var tracking_type= row.tracking_type;
    var shipment_id = row.shipment_id
    var delivery_date
   if(tracking_type==="FTL"){
    delivery_date= row.recent_dealer_reported_modified
   }else{
    delivery_date= row.delivery_datetime_modified

   }
    var data={'delivery_date': delivery_date,'shipment_id': shipment_id, "tracking_type":tracking_type}

    
    
    var params = {
        data:data
    }
    
    redirectURL.post('/consignments/uploadBulkuploadforDeliverydates',params).then((resp)=>{
        if(resp.data.status=='success'){
            setShow(true)
            setTitle(resp.data.message)
            setType("success")
        }
        else{
            setShow(true)
            setTitle(resp.data.message)
            setType("danger")
        
            
        }
       })
    // redirectURL.post('/consignments/editProductionDate', params).then((resp) => {
    //     if (resp.data.status == 'success') {
    //         setshow(true)
    //         setbasicTitle("Successfully Updated")
    //         setbasicType("success")
    //     }
    // })
}
    
const onShowDocs = (e) => {
    setDocuments([]);
    let params = {};
    setDocRow(e)
    setTrackingType(e.data.tracking_type)
    if(e.data.tracking_type === "FTL"){
        if (selectedViewTab === 'loading') {
            // Send uploaded_loading_document if 'loading' tab is selected
            if (e.data.uploaded_loading_document !== undefined && e.data.uploaded_loading_document !== null) {
              params.uploaded_loading_document = e.data.uploaded_loading_document;
            }
          } else if (selectedViewTab === 'unloading') {
            // Send uploaded_unloading_document if 'unloading' tab is selected
            if (e.data.uploaded_unloading_document !== undefined && e.data.uploaded_unloading_document !== null) {
              params.uploaded_unloading_document = e.data.uploaded_unloading_document;
            }
          }
    } else {
        params.uploaded_document = e.data.uploaded_document;
        params.lr_no = e.data.lr_no
    }
    redirectURL.post("/consignments/downloadUploadDocument", params
    //     , {
    //     headers: {
    //         'Content-Type': 'application/json',
    //         'Authorization': localStorage.getItem("userid")
    //     }
    // }
).then(res => {
    setDocuments(res.data);  
    
    // setViewRemark(e.data.doc_remarks)
    setSliderDocumentOpen(true)
}).catch(error => {
    console.error(error);
});
}
const onShowDocs1 = (tab) => {
    let params = {};
        if (tab === 'loading') {
            // Send uploaded_loading_document if 'loading' tab is selected
            if (docRow.data.uploaded_loading_document !== undefined && docRow.data.uploaded_loading_document !== null) {
              params.uploaded_loading_document = docRow.data.uploaded_loading_document;
            }
          } else if (tab === 'unloading') {
            // Send uploaded_unloading_document if 'unloading' tab is selected
            if (docRow.data.uploaded_unloading_document !== undefined && docRow.data.uploaded_unloading_document !== null) {
              params.uploaded_unloading_document = docRow.data.uploaded_unloading_document;
            }
          }
   
    redirectURL.post("/consignments/downloadUploadDocument", params
    //     , {
    //     headers: {
    //         'Content-Type': 'application/json',
    //         'Authorization': localStorage.getItem("userid")
    //     }
    // }
).then(res => {
    if(res.data ==="No documents provided"){
        setDocuments([])
    }else{
        setDocuments(res.data);  
    }
    
    
    // setViewRemark(e.data.doc_remarks)
    setSliderDocumentOpen(true)
}).catch(error => {
    console.error(error);
});
}
const onShowPodDoc = (e) => {
    setTrackingTypeForDoc(e.data.tracking_type)
    // if (e.data.tracking_type === "FTL") {
    //     let query = {
    //         truck_no: e.data.truck_no,
    //         shipment_id: e.data.shipment_id
    //     };

    //     redirectURL.post('/consignments/getShipmentDetails', query)
    //     .then(resp => {
    //         console.log("resp", resp.data.consignments);
    //         const allPodDocuments = resp.data.consignments.flatMap(consignment => consignment.uploaded_pod_document);
    //         console.log(allPodDocuments, "allPodDocuments");

    //         // Set params only after allPodDocuments is available
    //         let params = { uploaded_document: allPodDocuments };
    //         setPodDocuments([]); // Reset before new data

    //         redirectURL.post("/consignments/downloadUploadDocument", params)
    //         .then(res => {
    //             setPodDocuments(res.data);  
    //             setSliderPODDocumentOpen(true);
    //         })
    //         .catch(error => {
    //             console.error(error);
    //         });
    //     })
    //     .catch((e) => {
    //         console.log(e, "error");
    //     });
    // } else {
        // Handle the PTL case directly since it doesn't require async data
        let params = {
            uploaded_document: e.data.uploaded_pod_document,
            lr_no: e.data.lr_no
        };

        redirectURL.post("/consignments/downloadUploadDocument", params)
        .then(res => {
            
            setPodDocuments(res.data); 
            setViewPodRemark(e.data.podremarks); 
            setSliderPODDocumentOpen(true);
        })
        .catch(error => {
            console.error(error);
        });
    // }
};

useEffect(()=>{
    if(formData.consignee_name.value === "Other"){
        setEnableConsigee(true)
    }else{
        setEnableConsigee(false)
    }
},[formData.consignee_name.value])

useEffect(()=>{
    redirectURL.post("/consignments/getTruckLocations").then(resp=>{
        // console.log(resp.data.trucks_locations, "respp788");
        setTruckLocations(resp.data.trucks_locations);
    })
}, [])

// useEffect(() => {
//     const invoiceNo = formData.invoice_no;
//     // if (validateInput(invoiceNo)) {
//     //     setErrorMssge(""); 
//     // let invoiceLength = invoiceNo.length;
    
        
//         if (invoiceNo.length > 0  && /[\/]/.test(invoiceNo[0])) {
//             const isValid = validateInput(invoiceNo); // Perform validation

//             if (isValid) {
//                 filterSources(invoiceNo); // Call filterSources only if validation passes
//             } else {
//                 setErrorMssge("All invoices should have the same series.");
//             } // Call filterSources if the value contains a slash
//         } 
//     // if (/[\/]/.test(invoiceNo[0])) {

//     //     let invoiceNumber = 
//     //     let source = invoiceNo.split('/')[1];
        
//     //     let filteredSource = sourceList.filter(e => e.value === source);
        
//     //     // filteredSource.push({ label: "Others", value: "Others" });

//     //     // Set the filtered source list
//     //     setSourceList(filteredSource);
//     // // } else {
//     // //     setErrorMssge("Invalid Invoice Number"); 
//     // // }
//     // }
// }, [formData.invoice_no]);
// useEffect(() => {
//     const lastThreeLetters = manualUpdateConsignment.invoice_no;
//     const matchingSource = sourceList.find((item) => item.value.endsWith(lastThreeLetters));

//     if (manualUpdateConsignment.invoice_no !== '') {
//       if (matchingSource) {
//         setManualUpdateConsignment((prev) => ({ ...prev, source: matchingSource }));
//         setSourceOptions([matchingSource, { value: 'Other', label: 'Other' }]);
//       } else {
//         setSourceOptions([{ value: 'Other', label: 'Other' }]);
//       }
//     }
//   }, [manualUpdateConsignment.invoice_no, sourceList]);
    useEffect(()=>{
        if(form2Details.selectedStatus.value === "Undelivered"){
            setAbleRemark(true)
        } else {
            setAbleRemark(false)
        }
    }, [form2Details.selectedStatus])
    useEffect(()=>{
        redirectURL.post("/consignments/getinvoicenos").then(resp=>{
            const records = resp.data.total_invoices;
            const allInvoices = records.flatMap(e => e.invoice_no).filter(invoice => invoice !== undefined).map(invoice => invoice.toLowerCase());

            
            setInvoiceNos(allInvoices)
            
        })
    },[])
    
    // useEffect(() => {
    //     const isFormValid = validateFormOrder();
    
    //     setFormData((prev) => ({
    //         ...prev,
    //         disableAddDrop: !isFormValid,  // Disable if form is invalid
    //         disableSubmit: !isFormValid,   // Disable if form is invalid
    //     }));
    // }, [formData]);
    useEffect(()=>{
        if(decodedRoleCase === "user"){
            SetProcessFlowType('inbound')
        }else {
            SetProcessFlowType('outbound')
        }
        redirectURL.post('/consignments/getVehicleMaster')
        .then(resp => {
            var records = resp.data.vehicleMaster
            var vehicleArr = records.map((e)=> e.vehicle_type);
            var vehicleCapacityArr = records.map((e)=> e.vehicle_capacity);
            var vehicleTypeList=[]
            var vehicleCapacityList=[]
            for (let i of vehicleArr){
                vehicleTypeList.push({label:i, value: i})
            }
            for (let i of vehicleCapacityArr){
                vehicleCapacityList.push({label:i, value: i})
            }
            // vehicleTypeList.push({label:"Other", value:"Other"});
            vehicleCapacityList.push({label:"Others", value:"Others"});
            vehicleTypeList.push({label:"Others", value:"Others"});
            setVehicleTypeList(vehicleTypeList)
            setVehicleCapacityList(vehicleCapacityList)
        }) 
        redirectURL.post('/consignments/getTransportersList')
        .then(resp => {
            var records = resp.data.tptMaster
            var tptNames = records.filter((e)=> e.transporter_type == "FTL").map((e)=> e.transporter_name);
            settptRecords(records)

            var tptNamesList=[]
            for (let i of tptNames){
                tptNamesList.push({label:i, value: i})
            }
            var tptNames1 = records
            .filter(e => e.transporter_name && e.transporter_name !== "") // Filter records with valid transporter_name
            .map(e => e.transporter_name); // Extract only transporter_name
        
            var tptNamesList1=[]
            for (let i of tptNames1){
                tptNamesList1.push({label:i, value: i})
            }
            // tptNamesList.push({label:"Others", value:"Others"});
            setCourierPartnerList(tptNamesList)
            setCourierPartnerList1(tptNamesList1)
        }) 
        redirectURL.post("/consignments/getSourceTypes")
        .then(resp => {
            let records = resp.data.sourceMaster;
            let sourceList=[]
            let sourceSet = new Set();
            for (let i of records){
                if(i.invoice_source !== "Nan"){
                    if(!sourceSet.has(i.invoice_series)){
                        sourceList.push({label:i.invoice_source, value: i.invoice_series})
                        sourceSet.add(i.invoice_series)
                    }
                }
            }
            var arr1 = Array.from(sourceSet)
            sourceList.push({label:"Others", value:"Others"})
            setOriginalSourceList(sourceList)
            
            setSourceList(sourceList)
            setConstSourceList(sourceList)
            setSourceRecords(arr1);
            // setCourierPartnerList(tptNamesList)
        }) 
        redirectURL.post("/consignments/getConsignees")
        .then(resp => {
            let records = resp.data.consigneeMaster;

            // var sources = records.filter((e)=> e.transporter_type == "FTL").map((e)=> e.transporter_name);
            let consigneeList=[]
            let consigneeSet = new Set();
            for (let i of records){
                if(i.consignee_code && i.consignee_name){
                    if(!consigneeSet.has(i.consignee_code)){
                        
                        consigneeList.push({label:i.consignee_name, value: i.consignee_code})
                        consigneeSet.add(i.consignee_code)
                    }
                }
            }
            consigneeList.push({label:"Others", value:"Others"})
            
            
            setConsignees(consigneeList)
            setTripConsignees(consigneeList)
        })
    },[])
    useEffect(() => {
        if ( tabName.value == "active" ) {
            setRowData(activeTrips.all);
            setDateTypeList((prevList) => prevList.filter(item => item.value !== "Delivered"));
        } else if (tabName.value == "completed") {
            setRowData(completedTrips.all)
            setDateTypeList((prevList) => [
                ...prevList,
                { label: "Delivered", value: "Delivered" }
            ]);       
             }
        else if (tabName.value == "all") {
            setRowData(allTrips.all);
        } else if(tabName.value == "inactive"){    
            setRowData(inactive_trips)
            setDateTypeList((prevList) => prevList.filter(item => item.value !== "Delivered"));
        }else{
            setRowData(closeTrips)
            setDateTypeList((prevList) => prevList.filter(item => item.value !== "Delivered"));
        }
        
    }, [tabName.value])
    useEffect(() => {
        if ( tabName.value == "active" ) {
            setRowData(activeTrips.all);
            setDateTypeList((prevList) => prevList.filter(item => item.value !== "Delivered"));
        } else if (tabName.value == "completed") {
            setRowData(completedTrips.all)
            setDateTypeList((prevList) => [
                ...prevList,
                { label: "Delivered", value: "Delivered" }
            ]);       
             }
        else if (tabName.value == "all") {
            setRowData(allTrips.all);
        } else if(tabName.value == "inactive"){    
            setRowData(inactive_trips)
            setDateTypeList((prevList) => prevList.filter(item => item.value !== "Delivered"));
        }else{
            setRowData(closeTrips)
            setDateTypeList((prevList) => prevList.filter(item => item.value !== "Delivered"));
        }
        
    }, [searchViewType.value])
    
    useEffect(()=>{
        setShowLrUpdateBtn(true)
    }, [selectedRows])
    function capitalizeWords(str) {
        return str
          .toLowerCase() // Convert the whole string to lowercase
          .split(' ') // Split by spaces to handle multiple words
          .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize the first letter of each word
          .join(' '); // Join the words back into a single string
      }
    useEffect( () => {
        let key = ''
        redirectURL.post('/details')
            .then((response) => {
                if (response.data.status === 'success') {
                    setKey(response.data.output[0].g_key);
                    key = response.data.output[0].g_key
                    loadScript("https://maps.googleapis.com/maps/api/js?key=" + key + "&libraries=places,drawing&callback=initMap");
                    window.initMap = async () => {
                        var lt = 28.4519751;
                        var ln = 77.0310713;
                        map = new window.google.maps.Map(document.getElementById('map_canvas'), {
                            zoom: 13,
                            center: new window.google.maps.LatLng(lt, ln),
                            mapTypeId: window.google.maps.MapTypeId.ROADMAP,
                        });
                    }
                }
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
            });
            var params1 ={}
            var params ={
                dept_code: "SNDG"
            }
            if(decodedRoleCase === "transporter" && localStorage.getItem("transporter")!=="All"){
                params1.transporter_name = localStorage.getItem("transporter")
                params.transporter_name = localStorage.getItem("transporter")

            }
            if (
                zoneConversion &&
                zoneConversion.length > 0 &&
                !zoneConversion.includes("all")
            ) {            
            params1.consignee_zone = zoneConversion;
            params.consignee_zone =zoneConversion;
    }
    if (
        stateConversion &&
        stateConversion.length > 0 &&
        !stateConversion.includes("all")
    ) {            
                params1.consignee_state = stateConversion;
                params.consignee_state = stateConversion;
    }
    if (
        locationNameConversion &&
        locationNameConversion.length > 0 &&
        !["all numeric shipments", "all sites", "all shipment"].some((item) => locationNameConversion.includes(item))
    ) {            
                params1.consigner_name = locationNameConversion;
                params1.consigner_code = locationNameConversion;
                params.consigner_name = locationNameConversion;
                params.consigner_code = locationNameConversion;
    }

               
        
        if(entityConversion && entityConversion.length > 0 && !["all"].some((item)=> entityConversion.includes(item))){
                    
            params1.truck_seal_entity = entityConversion;
            params.truck_seal_entity = entityConversion
        }                
                     
                redirectURL.post('consignments/getCollectiveConsigner', params1)
        .then((response) => {
            let formattedOptions = response.data.records.map(record => ({
                label: capitalizeWords(record.label),
                value: (record.value)
              }));
            setConsignersList(formattedOptions)
        })
        .catch((error) => {
            console.error('Error fetching data:', error);
        });
       

        redirectURL.post("/consignments/getCombinedConsignmentsNewFilterKeys", params)
        .then((resp) => {
        
            const extractUniqueValues = (items = []) => {
                const uniqueSet = new Set();
                return items
                .map(item => {
                    let id = item._id;
                    // Check if the item is a string before applying toUpperCase
                    if (typeof id === 'string') {
                        return id.toUpperCase();
                    }
                    return id;  // If it's not a string, just return the item as-is
                })
                .filter(value => {
                    if (!uniqueSet.has(value)) {
                        uniqueSet.add(value);
                        return true;
                    }
                    return false;
                })
                .map(value => ({
                    label: capitalizeWords(value),
                    value: capitalizeWords(value)
                  }));

            };
            const extractUniqueValues1 = (items = []) => {
                const uniqueSet = new Set();
                
                return items
                    .filter(item => {
                        const id = item._id;
                        const trackingType = item.tracking_type;
                        
                        // Ensure id and trackingType exist before proceeding
                        if (id && trackingType) {
                            const combinedValue = `${id}:${trackingType}`; // Create a unique combination to avoid duplicates
                            if (!uniqueSet.has(combinedValue)) {
                                uniqueSet.add(combinedValue);
                                return true;
                            }
                        }
                        return false;
                    })
                    .map(item => ({
                        label: item._id,           // label is the invoice_no
                        value: item.tracking_type  // value is the tracking_type
                    }));
            };
            const capitalizeWords = (str) => 
                str.toLowerCase().replace(/\b\w/g, char => char.toUpperCase());
            
            const extractUniqueValues2 = (items = []) => {
                const uniqueSet = new Set();
                return items
                    .map(item => {
                        const label = capitalizeWords(item._id); // Capitalize words for label
                        const value = item._id; // Keep value as is
                        return { label, value };
                    })
                    .filter(item => {
                        if (!uniqueSet.has(item.value)) {
                            uniqueSet.add(item.value);
                            return true;
                        }
                        return false;
                    });
            };

            let transporterSet = new Set();
            var transporters = resp.data.transporters;
            var filterTransporters = [];
            if (transporters != undefined) {
                if (transporters.length > 0) {
                    transporters.map(function (t) {
                        if(!transporterSet.has(t.toUpperCase())){
                            transporterSet.add(t.toUpperCase())
                            filterTransporters.push({
                                label: capitalizeWords(t),
                                value: t,
                            });
                        }                            
                    });
                }
            }
            const filteredVehicles = extractUniqueValues(resp?.data?.vehicles);
            const filteredCities = extractUniqueValues2(resp?.data?.cities);
            const filteredStates = extractUniqueValues(resp?.data?.states);
            // const filteredTransporters = extractUniqueValues(resp?.data?.transporters);
            const filteredInvoices = extractUniqueValues1(resp?.data?.invoices);
            const filteredLrnos = extractUniqueValues1(resp?.data?.lrNos);
        
            setFilterCities(filteredCities);
            setFilterStates(filteredStates);
            setFilterTransporters(filterTransporters);
            setFilteredvehicles(filteredVehicles);
            setFilteredInvoices(filteredInvoices);
            setFilteredLrnos(filteredLrnos);
        
        })        
        .catch(error => {
            console.error("Error fetching data:", error);
        });
            
        fetchGridLayout(user.email, "cancelled_consignments")
            .then(res => {
                if (res.data.status == "success" && Array.isArray(res.data.data[0].columnState) && res.data.data[0].columnState.length > 0) {
                    setGridColumnState(res.data.data[0].columnState)
                }
            })
            // fetchGridLayout(user.email, "invoice_consignments")
            // .then(res => {
            //     if (res.data.status == "success" && Array.isArray(res.data.data[0].columnState) && res.data.data[0].columnState.length > 0) {
            //         setGridColumnState1(res.data.data[0].columnState)
            //     }
            // })
            .catch(err => console.log(err))
    }, [processFlowType,searchViewType.value])
    const defaultColDef = {
        sortable: true,
        filter: true,
        resizable: true,
        pivot: false,
        // cellStyle: { fontSize: '15px' }         
    }
    const columnDef = [
        
        {
            headerName: "LR No",
            field: "lr_no",
            width: 150,
            editable: true, // Allow editing
            resizable: true,
            headerClass: 'bold-header',
        
            // valueSetter: (params) => {
            //     const newValue = params.newValue;
            //     params.data.lr_no = newValue; // Set the edited value directly to the data
            //     return true; // Return true to indicate successful update
            // },
        
            // valueFormatter: (params) => {
            //     return validateLRNo(params.value); // Use validation function to format value
            // },
        
            // cellStyle: (params) => {
            //     const isValid = validateLRNo(params.value) !== "Invalid LR No";
        
            //     // If the LR number is invalid, apply a red background
            //     if (!isValid) {
            //         return { backgroundColor: "#c85f62" }; // Light red background for invalid LR No
            //     }
            //     return null; // Default cell style for valid LR numbers
            // }
        },
        {
            headerName: "Invoice No",
            field: "invoice_no",
            width: 150,
            resizable: true,
            editable: true,
            headerClass: 'bold-header',
            valueGetter:function(params){
                const invoiceValue = params.data.invoice_no;
                if(invoiceValue==="" || invoiceValue===null || invoiceValue===undefined){
                    
                    setBulkInvoiceError(true);
                    return params.data.invoice_no
                }
                else if (!(invoiceValue.includes("/"))) {
                    setInvoiceTypeCheck(true);
                    setBulkInvoiceError(false); // No error for values without slash
                    return params.data.invoice_no; // Return the invoice value as is
                }
                else{
                    setInvoiceTypeCheck(false);
                    return params.data.invoice_no; // Return the invoice value as is
                }
            },
            valueSetter: function (params) {
                const invoiceValue = params.newValue;
            
                // If invoice value is empty
                if (!invoiceValue) {
                    setBulkInvoiceError(true);
                    return ""; // Return empty and show error
                }
            
                // Check if the invoice does NOT have a slash
                if (!(invoiceValue.includes("/"))) {
                    params.data.invoice_no = invoiceValue;
                    setInvoiceTypeCheck(true);
                    setBulkInvoiceError(false); // No error for values without slash
                    return true; // Return the invoice value as is
                }
            
                // If it has a slash, validate the invoice
                const isValid = validateInvoice(invoiceValue, sourceRecords);
            
                if (isValid !== "") {
                    let invoiceNo =  isValid.split("/")[1]
                    setSelectedBulkSource(invoiceNo.toUpperCase())
                    params.data.invoice_no = isValid;
                    setInvoiceTypeCheck(false);

                    setBulkInvoiceError(false); // Validation successful
                    return true; // Return the validated value
                } else {
                    setBulkInvoiceError(true); // Validation failed
                    return false; // Return empty to indicate error
                }
            },
            
            cellStyle: function (params) {
                // Apply red background if value is empty (invalid or failed validation)
                if (!params.value) {
                    return {
                        backgroundColor: "#c85f62", // Light red background for invalid input
                    };
                }
                return null; // Default styling for valid input
            },            

        },
        
        {
            headerName: "Source City",
            field: "source_city",
            editable: true,
            valueGetter: (params)=>{
                if(params.data.source_city===""){
                   
                    setBulkSourceError(true)

                    return ""
                }else{
                    return params.data.source_city
                }
            },
            valueSetter: async (params) => {
                const newValue = params.newValue;
        
                // Check if the value is empty (empty string, null, or undefined)
                if (newValue==="" || newValue.trim() === "") {
                    // Set the value to "Invalid Field Value" and prevent the update
                    params.data.source_city = "";
                    setBulkSourceError(true)
                    return false; // Prevent the empty value from being set
                }

                if(selectedBulkSource!==""){
                    
                    const matchingItem = invoiceSourceSeries.find(e => e.label === selectedBulkSource);
                    
                    if(matchingItem){
                        if((matchingItem.value).toLowerCase() === newValue.toLowerCase()){
                            params.data.source_city = newValue;
                            
                            setSourceCity(newValue)
                            setBulkSourceError(false);
                            return true;
                        }else{
                            params.data.source_city = "";
                            setBulkSourceError(true)
                            return false; 
                        }
                    }
                }
        
                // Fetch consigners from the database
                const newValueLowerCase = newValue.toLowerCase();
                const isValid = consignerCityList.includes(newValueLowerCase);
                
                
        
                // If the consigner is invalid, set "Invalid Field Value" and prevent the update
                if (!isValid) {
                    params.data.source_city = "";
                    setBulkSourceError(true)
                    return false; // Prevent invalid value from being set
                }
        
                // If valid, update the source_city field
                params.data.source_city = newValue;
                setSourceCity(newValue)

                return true; // Return true to indicate successful update
            },
        
            cellStyle: (params) => {
                // Check if the source_city is invalid or empty and apply red background
                if (!params.value || params.value.trim() === "") {
                    return {
                        backgroundColor: "#c85f62" // Light red background for invalid or empty input
                    };
                }
        
                return null; // Default styling for valid input
            }
        },
        
        // {
        //     headerName: "Driver Mobile No",
        //     field: "driver_mobile_no",
        //     editable: true
        // },
        {
            headerName: "Vehicle No",
            field: "truck_no",
            width: 150,
            resizable: true,
            editable: true,
            headerClass: "bold-header",
            valueGetter: function (params) {
                // Return the value if it's not empty
                if (params.data.truck_no && params.data.truck_no.trim() !== "") {
                    setBulkVehicleNoError(false);
                    return params.data.truck_no;
                }else if(params.data.truck_no===""){
                    const tptCategory = tptData.find(e=> e.label.toLowerCase() === (params.data.courier_partner).toLowerCase())
                    if(tptCategory && tptCategory.value?.toLowerCase()==="ptl"){
                        setBulkVehicleNoError(false);
                        return "";
                    }else if(tptCategory && tptCategory.value?.toLowerCase() === "ftl"){
                        setBulkVehicleNoError(true);
                        return "";
                    }
                    
                      
                }

            },
            valueSetter: function (params) {
                const newValue = params.newValue?.trim();
                const tptCategory = tptData.find(e=> e.label.toLowerCase() === (params.data.courier_partner).toLowerCase())

                // Validate only when mode is "FTL"
                if (
                    tptCategory && tptCategory.value?.toLowerCase() === "ftl" &&
                    (!newValue || newValue === "")
                ) {
                    params.data.truck_no = ""; // Empty value for invalid input
                    setBulkVehicleNoError(true);
                    return true; // Trigger UI refresh
                }
        
                // Valid input
                params.data.truck_no = newValue;
                setBulkVehicleNoError(false);
                return true;
            },
            cellStyle: function (params) {
                // Find the tptCategory based on courier_partner
                const tptCategory = tptData.find(
                    (e) => e.label.toLowerCase() === (params.data.courier_partner || "").toLowerCase()
                );
            
                // Check if tptCategory is found and has a valid value
                if (
                    tptCategory &&
                    tptCategory.value?.toLowerCase() === "ftl" &&
                    (!params.value || params.value.trim() === "")
                ) {
                    return { backgroundColor: "#c85f62" }; // Red background
                }
            
                // Default case: no special styling
                return null;
            }
        },
        {
            headerName: "Entity",
            field: "entity",
            width: 150,
            resizable: true,
            editable: true,
            valueGetter: (params)=>{
                if(params.data.entity==="" || !entityMasterData.includes((params.data.entity).toLowerCase())){
                    setBulkEntityError(true);
                    return ""
                }
                return params.data.entity
            },
            valueSetter: async (params) => {
                const newValue = params.newValue;
        
                // Check if the value is empty (empty string, null, or undefined)
                if (!newValue || newValue.trim() === "") {
                    params.data.entity = ""
                    setBulkEntityError(true);
                    return ""; // Prevent the empty value from being set
                }
        
                // Validate the value against the master data
                const isValid = entityMasterData.includes(newValue.toLowerCase());
        
                if (!isValid) {
                    params.data.entity = ""
                    setBulkEntityError(true);
                    return ""; // Prevent invalid value from being set
                }
        
                // If valid, set the value
                params.data.entity = newValue;
                setBulkEntityError(false);
                return "";
            },
            cellStyle: (params) => {
                // Check if the value is empty or not in entityMasterData
                if (
                    params.value==="" || 
                    !entityMasterData.includes(params.value.toLowerCase())
                ) {
                    return {

                        backgroundColor: "#c85f62", // Light red for invalid or empty input
                        // color: "#ffffff", // White text for better visibility
                    };
                }
                return null; // Default styling for valid input
            },
            headerClass: 'bold-header',
        },
        
        {
            headerName: "Vehicle Type" ,
            field: "vehicle_type",
            width: 150,
            cellRenderer: '', resizable: true,
            editable: true,
            valueGetter : (params)=>{
                if(params.data.vehicle_type==="" || !vehicleMasterData.includes((params.data.vehicle_type).toLowerCase())){
                    setBulkVehicleTypeError(true);
                    return ""
                }
                return params.data.vehicle_type
            },
            valueSetter: async (params) => {
                const newValue = params.newValue;
        
                // Check if the value is empty (empty string, null, or undefined)
                if (!newValue || newValue.trim() === "") {
                    params.data.vehicle_type = ""
                    setBulkVehicleTypeError(true);
                    return ""; // Prevent the empty value from being set
                }
        
                // Validate the value against the master data
                const isValid = vehicleMasterData.includes(newValue.toLowerCase());
        
                if (!isValid) {
                    params.data.vehicle_type = ""
                    setBulkVehicleTypeError(true);
                    return ""; // Prevent invalid value from being set
                }
        
                // If valid, set the value
                params.data.vehicle_type = newValue;
                setBulkVehicleTypeError(false);
                return "";
            },
            cellStyle: (params) => {
                // Check if the value is empty or not in entityMasterData
                if (
                    !params.value || 
                    !vehicleMasterData.includes(params.value.toLowerCase())
                ) {
                    return {

                        backgroundColor: "#c85f62", // Light red for invalid or empty input
                        // color: "#ffffff", // White text for better visibility
                    };
                }
                return null; // Default styling for valid input
            },
            headerClass: 'bold-header',
        },
        {
            headerName: "Customer Code",
            field: "customer_code",
            width: 200,
            cellRenderer: '',
            resizable: true,
                headerClass: 'bold-header'
        },
        {
            headerName: "Transporter" ,
            field: "courier_partner",
            width: 150,
            cellRenderer: '', resizable: true,
            editable:true,
            valueGetter: (params)=>{
                if(params.data.courier_partner===""){

                    return ""
                }else if(!tptMasterData.includes(params.data.courier_partner.toLowerCase())){

                    return ""
                }
                else{
                    return params.data.courier_partner
                }
            },
            valueSetter: async (params) => {
                const newValue = params.newValue;
        
                // Check if the value is empty (empty string, null, or undefined)
                if (newValue==="" || newValue.trim() === "") {
                    // Set the value to "Invalid Field Value" and prevent the update
                    params.data.courier_partner = "";
                    return false; // Prevent the empty value from being set
                }
        
                // Fetch consigners from the database
                const newValueLowerCase = newValue.toLowerCase();
                const isValid = tptMasterData.includes(newValueLowerCase);
                
        
                // If the consigner is invalid, set "Invalid Field Value" and prevent the update
                if (!isValid) {
                    params.data.courier_partner = "";
                    return false; // Prevent invalid value from being set
                }
        
                // If valid, update the source_city field
                setTptName(newValue)
                params.data.courier_partner = newValue;

                return true; // Return true to indicate successful update
            },
        
            cellStyle: (params) => {
                // Check if the source_city is invalid or empty and apply red background
                if(!params.data.courier_partner || 
                !tptMasterData.includes(params.data.courier_partner.toLowerCase())){
                    setBulkTptError(true)

                    return {
                        backgroundColor: "#c85f62" // Light red background for invalid or empty input
                    };
                }
                setBulkTptError(false)

                return null; // Default styling for valid input
            },
                headerClass: 'bold-header'
        },
        {
            headerName: "Consignee Name",
            field: "customer_name",
            width: 180,
            filter: "agSetColumnFilter",
            cellRenderer: '',
            resizable: true,
            editable:true,
            valueGetter: function (params) {
                if (params.data.customer_name != "" && params.data.customer_name != "") {
                    setBulkConsigneeError(false)
                    return params.data.customer_name
                }else{
                    setBulkConsigneeError(true)

                    return ""
                }
            },
            cellStyle: function (params) {
                // If the customer_name is empty, apply red background color
                if (params.value === "") {
                    return {
                        backgroundColor: "#c85f62"  // Light red background for empty customer_name
                    };
                }
                return null;  // No special styling if the customer_name is not empty
            },

                headerClass: 'bold-header'
        },
        // {
        //     headerName: "Movement Type",
        //     field: "movement_type",
        //     editable: true,
        //     valueGetter:(params)=>{
        //         if(params.data.movement_type!=""){
        //             return params.data.movement_type
        //         }else{
        //             setBulkMovementError(true)

        //             return ""
        //         }
        //     },
        //     valueSetter: (params)=>{
        //         const newValue = params.newValue;
        //         const validMovementType=["internal movement", "customer delivery", "customer returns"]
                
        //         const newValueLowerCase = newValue?.toLowerCase();
        //         const isValid = validMovementType.includes(newValueLowerCase);
        //         if(isValid){
        //             setBulkMovementError(false)
        //             params.data.movement_type= newValue;
        //             return true;
        //         }else{
        //             // params.api.flashCells({ rowNodes: [params.node], columns: ['movement_type'] }); // Flash the invalid cell
        //             // alert("Invalid Movement Type! Please enter 'Internal Movement' or 'Customer Movement'."); // Optional alert
        //             params.data.movement_type=""
        //             return false;
        //         }
        //     },
        //     cellStyle: (params) => {
              
        //         // If the value is not valid, apply red background
        //         if (params.value ==="") {
        //             return {
        //                 backgroundColor: "#c85f62"  // Light red background for invalid movement_type
        //             };
        //         }
        //         return null; // Default cell style for valid values
        //     }
            
        // },
        {
            headerName: "Number Of Boxes",
            field: "no_of_boxes",
            width: 200,
            resizable: true,
            headerClass: 'bold-header',
            editable:true,
        
            // Add valueSetter for numeric validation
            valueSetter: (params) => {
                const newValue = params.newValue;
        
                // Check if the new value is a valid number
                if (!isNaN(newValue) && newValue !== "" && newValue !== null) {
                    // Set the value if it's a valid number
                    params.data.no_of_boxes = parseFloat(newValue);
                    setBulkBoxesError(false)
                    return ; // Indicate that the value was successfully set
                } else {
                    console.warn("Invalid input: Only numeric values are allowed.");
                    params.data.no_of_boxes = '';
                    setBulkBoxesError(true)

                    return ""; // Prevent invalid values from being set
                }
            },
        
            // Add cellRenderer to display the value
            // cellRenderer: (params) => {
            //     return params.value || 0; // Display 0 if no value is set
            // },
        
            cellStyle: (params) => {
                if(isNaN(params.value)&& params.value!==""){
                    return { backgroundColor: "#c85f62" }
                }
                
            },
        },
        
        {
            headerName: "Destination City" ,
            field: "destination_city",
            width: 150,
            editable:true,

            cellRenderer: '', resizable: true,
                headerClass: 'bold-header',
                valueGetter: (params) => {
                    const destinationCity = params.data.destination_city;
                   
                
                    if (destinationCity !=="") {
                        setBulkDestinationError(false)

                      return destinationCity;
                    } else {
                        setBulkDestinationError(true)

                      return "";
                    }
                  },
                  cellStyle: (params) => {
                    const destinationCity = params.value;
                    // Apply red background if the date format is invalid
                    if (destinationCity === "") {
                      return { "backgroundColor": "#c85f62" };
                    }
                    return null;
                  },
        },
        
        {
            headerName: "Destination Pincode" ,
            field: "destination_pincode",
            width: 180,
            editable:true,

            cellRenderer: '', resizable: true,
                headerClass: 'bold-header',
                valueGetter: (params) => {
                    const destinationPincode = params.data.destination_pincode;
                    
                
                    if (destinationPincode !=="" && /^\d{6}$/.test(destinationPincode)) {
                        setBulkPincodeError(false)
                      return destinationPincode;
                    } else {
                        setBulkPincodeError(true)

                      return "";
                    }
                  },
                  cellStyle: (params) => {
                    const destinationPincode = params.value;
                    // Apply red background if the date format is invalid
                    if (destinationPincode === "") {
                      return { "backgroundColor": "#c85f62" };
                    }
                    return null;
                  },
        },
        {
            headerName: "Invoice Date",
            field: "invoice_date",
            editable: true,
            valueGetter: (params) => {
              const date = params.data.invoice_date;
              // Check if date is in DD-MM-YYYY format
              const datePattern = /^\d{2}-\d{2}-\d{4}$/;
          
              if (date && datePattern.test(date)) {
                return date;
              } else {
                setBulkError(true)

                return "";
              }
            },
            valueSetter: (params) => {
              const newValue = params.newValue;
              const datePattern = /^\d{2}-\d{2}-\d{4}$/;
          
              // Check if the new value follows the DD-MM-YYYY format
              if (newValue && datePattern.test(newValue)) {
                params.data.invoice_date = newValue; // Set the new value if valid
                return true;
              } else {
                return false; // Reject the value if it's in an invalid format
              }
            },
            cellStyle: (params) => {
              const date = params.value;
              // Apply red background if the date format is invalid
              if (date === "") {
                return { "backgroundColor": "#c85f62" };
              }
              return null;
            },
          },
          
       

       
       
          {
            headerName: "Total CBM",
            field: "total_cbm",
            width: 150,
            resizable: true,
            headerClass: 'bold-header',
            editable:true,
            
            // Value Setter for Numeric Validation
            valueSetter: (params) => {
                const newValue = params.newValue;
        
                // Check if the input is a valid float or integer
                if (!isNaN(newValue) && newValue !== "" && newValue !== null) {
                    // Convert the value to a float (to accept decimals)
                    params.data.total_cbm = parseFloat(newValue);
                    return ; // Accept the value
                } else if(isNaN(newValue)) {
                    params.data.total_cbm =""
                    console.warn("Invalid input: Only numeric values (integer or float) are allowed.");
                    return ""; // Reject the value
                }
            },
        
            // Cell Renderer to Display the Value Properly
            
            cellStyle: (params) => {
                if(isNaN(params.value) && params.value!==""){
                    return { backgroundColor: "#c85f62" }
                }
                
            },
        },
        
        {
            headerName: "Total Weight",
            field: "total_weight",
            width: 150,
            resizable: true,
            headerClass: 'bold-header',
            editable: true,
            valueGetter: (params)=>{
                if(params.data.total_weight===""){
                    setBulkTotalWeightError(true)
                    return ""
                }
                return params.data.total_weight
            },
            // Value Setter for Numeric Validation
            valueSetter: (params) => {
                const newValue = params.newValue;
        
                // Check if the new value is a valid number
                if (!isNaN(newValue) && newValue !== "" && newValue !== null) {
                    // Set the value if it's a valid number
                    params.data.total_weight = parseFloat(newValue);
                    setBulkTotalWeightError(false)
                    return ; // Indicate that the value was successfully set
                } else {
                    console.warn("Invalid input: Only numeric values are allowed.");
                    params.data.total_weight = '';
                    setBulkTotalWeightError(true)

                    return ""; // Prevent invalid values from being set
                }
            },
        
            // Cell Renderer to Display the Value Properly
            
            cellStyle: (params) => {
                if((isNaN(params.value) && params.value!=="") || (params.value ==="")){
                    return { backgroundColor: "#c85f62" }
                }
                
            },
        },
        
       
        
       
        {
            headerName: "Dispatch Date",
            field: "dispatch_date",
            editable: true,
            valueGetter: (params) => {
              const date = params.data.dispatch_date;
              // Check if date is empty or in DD-MM-YYYY format
              const datePattern = /^\d{2}-\d{2}-\d{4}$/;
              if (!date || datePattern.test(date)) {
                setBulkDispatchError(false); // Set error state for empty value

                return date || ""; // Return empty string if the date is empty
              } else {
                setBulkDispatchError(true); // Set error state for empty value
                return "Invalid Date Format";
              }
            },
            valueSetter: (params) => {
              const newValue = params.newValue;
              const datePattern = /^\d{2}-\d{2}-\d{4}$/;
          
              // Accept empty value or a valid DD-MM-YYYY formatted date
              if (newValue!=="" && datePattern.test(newValue)) {
                params.data.dispatch_date = newValue || ""; // Allow empty values
                setBulkDispatchError(false)
                return true;
              } else {
                params.data.dispatch_date = ""
                setBulkDispatchError(true)
                return false; // Reject invalid formats
              }
            },
            cellStyle: (params) => {
              const date = params.value;
              const datePattern = /^\d{2}-\d{2}-\d{4}$/;
          
              // Apply red background only if the value is invalid and not empty
              if (date!="" && date == "Invalid Date Format" && !datePattern.test(date)) {
                return { backgroundColor: "#c85f62" };
              }
              return null; // No style if valid or empty
            },
          },
          
          
        {
            headerName: "Mode (Road/Air)",
            field: "shipment_mode",
            width: 190,
            cellRenderer: '',
            resizable: true,
            editable:true,
            valueGetter:(params)=>{
                const modeValue = (params.data.shipment_mode).toLowerCase();
                const validModeType=["air", "road"]
                if(validModeType.includes(modeValue)){
                    setBulkModeError(false)

                    return params.data.shipment_mode
                }else{
                    setBulkModeError(true)

                    return ""
                }
            },
            valueSetter: (params)=>{
                const newValue = params.newValue;
                const validModeType=["air", "road"]
                
                const newValueLowerCase = newValue?.toLowerCase();
                const isValid = validModeType.includes(newValueLowerCase);
                if(isValid){
                    setBulkModeError(false)
                    params.data.shipment_mode= newValue;
                    return true;
                }else{
                    // params.api.flashCells({ rowNodes: [params.node], columns: ['movement_type'] }); // Flash the invalid cell
                    // alert("Invalid Movement Type! Please enter 'Internal Movement' or 'Customer Movement'."); // Optional alert
                    setBulkModeError(true)
                    params.data.shipment_mode=""
                    return false;
                }
            },
            cellStyle: (params) => {
              
                // If the value is not valid, apply red background
                if (params.value ==="") {
                    return {
                        backgroundColor: "#c85f62"  // Light red background for invalid movement_type
                    };
                }
                return null; // Default cell style for valid values
            },
                headerClass: 'bold-header'
        },
        {
            headerName: "E-Way Bill No",
            field: "eway_bill_no",
            width: 150,
            cellRenderer: '',
            resizable: true,
                headerClass: 'bold-header'
        },
       
        {
            headerName: "Customer Mail ID",
            field: "customer_mail_id",
            width: 200,
            cellRenderer: '',
            resizable: true,
                headerClass: 'bold-header'
        },
        {
            headerName: "Tracking Mode (FTL/PTL)",
            field: "mode",
            editable: true,
            width:250,
            valueGetter: function (params) {
                if (params.data.mode !== "" && params.data.mode !== "") {
                    setBulkTrackingError(false)
                    return params.data.mode
                }else{
                    setBulkTrackingError(true)
                    return ""
                }
            },
            valueSetter: (params)=>{
                const newValue = params.newValue;
                if (!newValue || newValue.trim() === "") {
                    params.data.mode = "";
                    setBulkTrackingError(true); // Mark as error
                    return ""; // Prevent update
                }
                params.data.mode = newValue;
                setBulkTrackingError(false); // Valid value
                return true


            },
            cellStyle: function (params) {
                // If the customer_name is empty, apply red background color
                if (params.value === "") {
                    return {
                        backgroundColor: "#c85f62"  // Light red background for empty customer_name
                    };
                }
                return null;  // No special styling if the customer_name is not empty
            },

                headerClass: 'bold-header'
        },
        {
            headerName: "Invoice Type",
            field: "invoice_type",
            editable: true,
            valueGetter: (params) => {
                if (params.data.invoice_no && params.data.invoice_no.includes("/")) {
                    // Return the existing value when invoice_no contains a slash
                    return params.data.invoice_type;
                }else{
                    return "";
                }
                // Return empty value if invoice_no does not contain a slash
            },
            
            valueSetter: async (params) => {
                const newValue = params.newValue;
        
                if (!newValue || newValue.trim() === "") {
                    params.data.invoice_type = "";
                    setBulkInvoiceTypeError(false); // Mark as error
                    return ""; // Prevent update
                }
        
                if (sourceCity !== "") {
                    let matchingItem = invoiceSourceCategory.find(
                        (e) => e.label.toLowerCase() === sourceCity.toLowerCase()
                    );
                    if (matchingItem) {
                        if (matchingItem.value.toLowerCase() === newValue.toLowerCase()) {
                            params.data.invoice_type = newValue;
                            setBulkInvoiceTypeError(false); // Valid value
                            return true; // Update successful
                        } else {
                            params.data.invoice_type = "";
                            setBulkInvoiceTypeError(true); // Invalid value
                            return false; // Prevent update
                        }
                    }
                }
        
                params.data.invoice_type = newValue; // Set the value
                setBulkInvoiceTypeError(false); // Clear error
                return true;
            },
            // cellStyle: (params) => {
            //     if (!params.value && params.data.invoice_no && params.data.invoice_no.includes("/")) {
            //         // Red background for invalid invoice_type when invoice_no has a slash
            //         return { backgroundColor: "#c85f62" };
            //     }
            //     return null; // Default styling
            // }
        },
        
       
         {
            headerName: "Fuel Type",
            field: "fuel_type",
            // cellRenderer: '',
            resizable: true,
            // editable: true,
            // cellStyle: params => {
            //     if (params.data.fuel_type == undefined || params.data.fuel_type == "" ) {
            //         return {
            //             "backgroundColor": '#c85f62'
            //         };
            //     }
            // }
            // valueGetter:(params)=>{
            //     const modeValue = (params.data.shipment_mode).toLowerCase();
            //     const validModeType=["air", "road"]
            //     if(validModeType.includes(modeValue)){
            //         setBulkModeError(false)

            //         return params.data.shipment_mode
            //     }else{
            //         setBulkModeError(true)

            //         return ""
            //     }
            // },
            // valueSetter: (params)=>{
            //     const newValue = params.newValue;
            //     const validModeType=["air", "road"]
                
            //     const newValueLowerCase = newValue?.toLowerCase();
            //     const isValid = validModeType.includes(newValueLowerCase);
            //     if(isValid){
            //         setBulkModeError(false)
            //         params.data.shipment_mode= newValue;
            //         return true;
            //     }else{
            //         // params.api.flashCells({ rowNodes: [params.node], columns: ['movement_type'] }); // Flash the invalid cell
            //         // alert("Invalid Movement Type! Please enter 'Internal Movement' or 'Customer Movement'."); // Optional alert
            //         setBulkModeError(true)
            //         params.data.shipment_mode=""
            //         return false;
            //     }
            // },
            // cellStyle: (params) => {
              
            //     // If the value is not valid, apply red background
            //     if (params.value ==="") {
            //         return {
            //             backgroundColor: "#c85f62"  // Light red background for invalid movement_type
            //         };
            //     }
            //     return null; // Default cell style for valid values
            // },
                headerClass: 'bold-header'

           
        },
        // {
        //     headerName: "Driver Name",
        //     field: "driver_name",
        //     editable: true,
        //     // cellStyle: params => {
        //     //     if (params.data.driver_name == undefined || params.data.driver_name == "" ) {

        //     //         return {
        //     //             "backgroundColor": '#c85f62'
        //     //         };
        //     //     }
        //     // }
        // },
       
        
    ]
   
    const parseDate = (dateString) => {
    
        const [day, month, yearTime] = dateString.split("-");
        const [year, time] = yearTime.split(" ");
        const [hours, minutes] = time.split(":");
    
        const parsedDate = new Date(year, month - 1, day, hours, minutes);
        return parsedDate;
    };
    
    const getHyphenDDMMYYYYHHMM1 = (date) => {
        if (!date) return "";
    
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, "0");
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const year = d.getFullYear();
        const hours = String(d.getHours()).padStart(2, "0");
        const minutes = String(d.getMinutes()).padStart(2, "0");
    
        const formattedDate = `${day}-${month}-${year} ${hours}:${minutes}`;
        return formattedDate;
    };
    
    const isValidDateRange = (eventDate, currentDate) => {
        const fortyEightHoursAgo = new Date(currentDate.getTime() - 48 * 60 * 60 * 1000); // 48 hours ago
        const eightHoursAhead = new Date(currentDate.getTime() + 8 * 60 * 60 * 1000); // 8 hours ahead
        
        return eventDate >= fortyEightHoursAgo && eventDate <= eightHoursAhead;
    };
    const validateAllRows = (api) => {
        const allRows = [];
        api.forEachNode((node) => allRows.push(node.data));
    
        let hasError = false;
    
        for (const row of allRows) {
            const date = row.current_event_date_time;
    
            if (!date) {
                hasError = true;
                console.error("Empty date detected");
                break;
            }
    
            const dateTimePattern = /^\d{2}-\d{2}-\d{4} \d{2}:\d{2}$/;
            if (!dateTimePattern.test(date)) {
                hasError = true;
                console.error("Invalid format detected:", date);
                break;
            }
    
            const eventDate = parseDate(date);
            const currentDate = new Date();
            if (!eventDate || !isValidDateRange(eventDate, currentDate)) {
                hasError = true;
                console.error("Out-of-range date detected:", eventDate);
                break;
            }
        }
    
    
        setBulkUpdateEventError(hasError); // Update global error state
    };
    
    
    const columnBulkUpdateDef = [
        
        {
            headerName: "LR No",
            field: "lr_no",
            width: 150,
            resizable: true,
            headerClass: 'bold-header',
        
            // Validate and retrieve LR No
            valueGetter: (params) => {
                const lrNo = params.data.lr_no;
                // const invoiceNo = params.data.invoice_no;
                const allData = activeTrips.all; // Array of all LR No and Invoice No combinations
        
                // // Check if the LR No is invalid or already associated with another Invoice No
                // const isDuplicate = allData.some(
                //     (item) => item.lr_no === lrNo && item.invoice_no !== invoiceNo
                // );
        
                // if (isDuplicate) {
                //     console.error(
                //         `Error: LR No '${lrNo}' is already associated with a different Invoice No.`
                //     );
                //     // Optionally, return a message or highlight error
                //     setBulkLRError(true)
                //     setBulkLRErrorMsg(`${lrNo} (Invalid Combination)`)
                //     return `${lrNo} (Invalid Combination)`;
                // }

                const matchingData = allData.find((item) => item.lr_no === lrNo);
                if (matchingData) {
                    setTrackingTypeState(matchingData.tracking_type); // Store tracking type in state
                }
        
                // Return the LR No if valid
                // setBulkLRError(false)
                return lrNo || ""; // Default to an empty string if no LR No is provided
            },
        
            // Optional: Style the cell based on the validation result
            // cellStyle: (params) => {
            //     const lrNo = params.data.lr_no;
            //     // const invoiceNo = params.data.invoice_no;
            //     const allData = activeTrips.all;
        
            //     // Check if the combination is valid
            //     const isDuplicate = allData.some(
            //         (item) => item.lr_no === lrNo && item.invoice_no !== invoiceNo
            //     );
        
            //     if (isDuplicate) {
            //         return { backgroundColor: "#c85f62"}; // Red background for invalid combination
            //     }
            //     return null; // Default style for valid data
            // },
        },
        
        // {
        //     headerName: "Invoice No",
        //     field: "invoice_no",
        //     width: 150,
        //     resizable: true,
        //     // editable: true,
        //     headerClass: 'bold-header',
        //     valueGetter:function(params){
        //         const invoiceValue = params.data.invoice_no;
        //        if (invoiceValue && !(invoiceValue.includes("/"))) {
        //             console.log("invoiceIncludes444");
        //             setBulkUpdateInvoiceError(true); // No error for values without slash
        //             return params.data.invoice_no; // Return the invoice value as is
        //         }
        //         else{
        //             setInvoiceTypeCheck(false);
        //             return params.data.invoice_no; // Return the invoice value as is
        //         }
        //     },
            // valueSetter: function (params) {
            //     const invoiceValue = params.newValue;
            
            //     // If invoice value is empty
            //     if (!invoiceValue) {
            //         setBulkInvoiceError(true);
            //         return ""; // Return empty and show error
            //     }
            
            //     // Check if the invoice does NOT have a slash
            //     if (!(invoiceValue.includes("/"))) {
            //         console.log("invoiceIncludes444");
            //         params.data.invoice_no = invoiceValue;
            //         setInvoiceTypeCheck(true);
            //         setBulkInvoiceError(false); // No error for values without slash
            //         return true; // Return the invoice value as is
            //     }
            
            //     // If it has a slash, validate the invoice
            //     const isValid = validateInvoice(invoiceValue, sourceRecords);
            
            //     if (isValid !== "") {
            //         let invoiceNo =  isValid.split("/")[1]
            //         setSelectedBulkSource(invoiceNo.toUpperCase())
            //         console.log(invoiceNo.toUpperCase(),"invoiceIncludes555");
            //         params.data.invoice_no = isValid;
            //         setInvoiceTypeCheck(false);

            //         setBulkInvoiceError(false); // Validation successful
            //         return true; // Return the validated value
            //     } else {
            //         setBulkInvoiceError(true); // Validation failed
            //         return false; // Return empty to indicate error
            //     }
            // },
            
        //     cellStyle: function (params) {
        //         // Apply red background if value is empty (invalid or failed validation)
        //         if (params.value && !((params.value).includes("/"))) {
        //             return {
        //                 backgroundColor: "#c85f62", // Light red background for invalid input
        //             };
        //         }
        //         return null; // Default styling for valid input
        //     },            

        // },
        {
            headerName: "Dispatch Date",
            field: "dispatch_date",
            // editable: true,
            valueGetter: (params) => {
              const date = params.data.dispatch_date;
              // Check if date is empty or in DD-MM-YYYY format
              const datePattern = /^\d{2}-\d{2}-\d{4}$/;
              if (!date || datePattern.test(date)) {
                setBulkUpdateDispatchError(false); // Set error state for empty value

                return date || ""; // Return empty string if the date is empty
              } else if(date ===""){
                setBulkUpdateDispatchError(false); // Set error state for empty value

                return date || ""; 
              }
                else if(date && !(datePattern.test(date))){
                    setBulkUpdateDispatchError(true); // Set error state for empty value
                return "Invalid Date Format";
              }
            },
            // valueSetter: (params) => {
            //   const newValue = params.newValue;
            //   const datePattern = /^\d{2}-\d{2}-\d{4}$/;
          
            //   // Accept empty value or a valid DD-MM-YYYY formatted date
            //   if (!newValue || datePattern.test(newValue)) {
            //     params.data.dispatch_date = newValue || ""; // Allow empty values
            //     return true;
            //   } else {
            //     return false; // Reject invalid formats
            //   }
            // },
            cellStyle: (params) => {
              const date = params.value;
              const datePattern = /^\d{2}-\d{2}-\d{4}$/;
          
              // Apply red background only if the value is invalid and not empty
              if (date!="" && date == "Invalid Date Format" && !datePattern.test(date)) {
                return { backgroundColor: "#c85f62" };
              }
              return null; // No style if valid or empty
            },
          },
        // {
        //     headerName: "Source City",
        //     field: "source_city",
            // editable: true,
            // valueGetter: (params)=>{
            //     if(params.data.source_city===""){
                   
            //         setBulkSourceError(true)

            //         return ""
            //     }else{
            //         return params.data.source_city
            //     }
            // },
            // valueSetter: async (params) => {
            //     const newValue = params.newValue;
        
            //     // Check if the value is empty (empty string, null, or undefined)
            //     if (newValue==="" || newValue.trim() === "") {
            //         // Set the value to "Invalid Field Value" and prevent the update
            //         params.data.source_city = "";
            //         setBulkSourceError(true)
            //         return false; // Prevent the empty value from being set
            //     }

            //     if(selectedBulkSource!==""){
            //         console.log(invoiceSourceSeries, "invoiceSourceSeries");
                    
            //         const matchingItem = invoiceSourceSeries.find(e => e.label === selectedBulkSource);
            //         console.log(matchingItem, "matchingItem999");
                    
            //         if(matchingItem){
            //             if((matchingItem.value).toLowerCase() === newValue.toLowerCase()){
            //                 params.data.source_city = newValue;
            //                 console.log(newValue, "source4545");
                            
            //                 setSourceCity(newValue)
            //                 setBulkSourceError(false);
            //                 return true;
            //             }else{
            //                 params.data.source_city = "";
            //                 setBulkSourceError(true)
            //                 return false; 
            //             }
            //         }
            //     }
        
            //     // Fetch consigners from the database
            //     const newValueLowerCase = newValue.toLowerCase();
            //     const isValid = consignerCityList.includes(newValueLowerCase);
            //     console.log(isValid, "consignerListValiddd");
                
                
        
            //     // If the consigner is invalid, set "Invalid Field Value" and prevent the update
            //     if (!isValid) {
            //         console.log("Invalid Source City!"); // Debugging log for invalid value
            //         params.data.source_city = "";
            //         setBulkSourceError(true)
            //         return false; // Prevent invalid value from being set
            //     }
        
            //     // If valid, update the source_city field
            //     params.data.source_city = newValue;
            //     setSourceCity(newValue)

            //     return true; // Return true to indicate successful update
            // },
        
            // cellStyle: (params) => {
            //     // Check if the source_city is invalid or empty and apply red background
            //     if (!params.value || params.value.trim() === "") {
            //         return {
            //             backgroundColor: "#c85f62" // Light red background for invalid or empty input
            //         };
            //     }
        
            //     return null; // Default styling for valid input
            // }
        // },
        {
            headerName: "Consignee Name",
            field: "customer_name",
            width: 180,
            filter: "agSetColumnFilter",
            cellRenderer: '',
            resizable: true,
            // editable:true,
            // valueGetter: function (params) {
            //     if (params.data.customer_name != "" && params.data.customer_name != "") {
            //         setBulkConsigneeError(false)
            //         return params.data.customer_name
            //     }else{
            //         setBulkConsigneeError(true)

            //         return ""
            //     }
            // },
            // cellStyle: function (params) {
            //     // If the customer_name is empty, apply red background color
            //     if (params.value === "") {
            //         return {
            //             backgroundColor: "#c85f62"  // Light red background for empty customer_name
            //         };
            //     }
            //     return null;  // No special styling if the customer_name is not empty
            // },

                headerClass: 'bold-header'
        },
        {
            headerName: "Destination City" ,
            field: "destination_city",
            width: 150,
            // editable:true,

            cellRenderer: '', resizable: true,
                headerClass: 'bold-header',
                // valueGetter: (params) => {
                //     const destinationCity = params.data.destination_city;
                   
                
                //     if (destinationCity !=="") {
                //         setBulkDestinationError(false)

                //       return destinationCity;
                //     } else {
                //         setBulkDestinationError(true)

                //       return "";
                //     }
                //   },
                //   cellStyle: (params) => {
                //     const destinationCity = params.value;
                //     // Apply red background if the date format is invalid
                //     if (destinationCity === "") {
                //       return { "backgroundColor": "#c85f62" };
                //     }
                //     return null;
                //   },
        },
        {
            headerName: "Expected ETA", // Estimated delivery date
            field: "expected_trip_end",
            width: 150,
            resizable: true,
            comparator: dateComparator,
            valueGetter: (params) => {
                const date = params.data.expected_trip_end;
                // Check if date is empty or in DD-MM-YYYY format
                const datePattern = /^\d{2}-\d{2}-\d{4}$/;
                if (!date || datePattern.test(date)) {
                  setBulkUpdateExpectedError(false); // Set error state for empty value
  
                  return date || ""; // Return empty string if the date is empty
                } else if(date ===""){
                  setBulkUpdateExpectedError(false); // Set error state for empty value
  
                  return date || ""; 
                }
                  else if(date && !(datePattern.test(date))){
                  setBulkUpdateExpectedError(true); // Set error state for empty value
                  return "Invalid Date Format";
                }
              },
              // valueSetter: (params) => {
              //   const newValue = params.newValue;
              //   const datePattern = /^\d{2}-\d{2}-\d{4}$/;
            
              //   // Accept empty value or a valid DD-MM-YYYY formatted date
              //   if (!newValue || datePattern.test(newValue)) {
              //     params.data.dispatch_date = newValue || ""; // Allow empty values
              //     return true;
              //   } else {
              //     return false; // Reject invalid formats
              //   }
              // },
              cellStyle: (params) => {
                const date = params.value;
                const datePattern = /^\d{2}-\d{2}-\d{4}$/;
            
                // Apply red background only if the value is invalid and not empty
                if (date!="" && date == "Invalid Date Format" && !datePattern.test(date)) {
                  return { backgroundColor: "#c85f62" };
                }
                return null; // No style if valid or empty
              },
            headerClass: 'bold-header'

        },
        {
            headerName: "Status",
            field: "status",
            // editable: true,
            // cellStyle: params => {
            //     if (params.data.status == undefined || params.data.status == "" ) {

            //         return {
            //             "backgroundColor": '#c85f62'
            //         };
            //         // return ""

            //     }
            // }
        },
        {
            headerName: "Event Location",
            field: "last_location",
            // editable: true,
            // cellStyle: params => {
            //     if (params.data.last_location == undefined || params.data.last_location == "" ) {

            //         return {
            //             "backgroundColor": '#c85f62'
            //         };
            //         // return ""
            //     }
            // }
        },
        {
            headerName: "Event Date & Time", // Estimated delivery date
            field: "event_date_time",
            width: 150,
            resizable: true,
            comparator: dateComparator,
            // valueGetter: (params) => {
            //     const date = params.data.event_date_time;
            //     // Check if date is empty or in DD-MM-YYYY format
            //     const datePattern = /^\d{2}-\d{2}-\d{4}$/;
            //     if (!date || datePattern.test(date)) {
            //       setBulkUpdateLastEventTimeError(false); // Set error state for empty value
  
            //       return date || ""; // Return empty string if the date is empty
            //     } else if(date ===""){
            //         setBulkUpdateLastEventTimeError(false); // Set error state for empty value
  
            //       return date || ""; 
            //     }
            //       else if(date && !(datePattern.test(date))){
            //         setBulkUpdateLastEventTimeError(true); // Set error state for empty value
            //       return "Invalid Date Format";
            //     }
            //   },
              // valueSetter: (params) => {
              //   const newValue = params.newValue;
              //   const datePattern = /^\d{2}-\d{2}-\d{4}$/;
            
              //   // Accept empty value or a valid DD-MM-YYYY formatted date
              //   if (!newValue || datePattern.test(newValue)) {
              //     params.data.dispatch_date = newValue || ""; // Allow empty values
              //     return true;
              //   } else {
              //     return false; // Reject invalid formats
              //   }
              // },
            //   cellStyle: (params) => {
            //     const date = params.value;
            //     const datePattern = /^\d{2}-\d{2}-\d{4}$/;
            
            //     // Apply red background only if the value is invalid and not empty
            //     if (date!="" && date == "Invalid Date Format" && !datePattern.test(date)) {
            //       return { backgroundColor: "#c85f62" };
            //     }
            //     return null; // No style if valid or empty
            //   },
            headerClass: 'bold-header'

        },
        {
    headerName: "Current Status",
    field: "current_status",
    editable: true,
    valueGetter: (params) => {
        const currentStatus = params.data.current_status;

        // Check for validity
        if (isValidProgression(params.data.status, currentStatus)) {
            setBulkUpdateStatusError(false);
            return currentStatus; // Valid value
        } else if (!currentStatus) {
            // Empty or null value
            setBulkUpdateStatusError(true);
            return ""; // Show empty value
        } else {
            // Invalid value
            setBulkUpdateStatusError(true);
            return ""; // Show empty value for invalid status
        }
        return params.data.current_status
    },
    valueSetter: (params) => {
        const newValue = params.newValue;

        // Validate the new value
        if (isValidProgression(params.data.status, newValue)) {
            params.data.current_status = newValue; // Update the value
            return ""; // Indicate successful update
        } else {
            params.data.current_status = ""; // Reset to empty if invalid
            return ""; // Indicate failed update
        }

        params.data.current_status = newValue;
        return ""
    },
    cellStyle: (params) => {
        const currentStatus = params.data.current_status;

        // Highlight invalid or empty values
        if (!currentStatus || !isValidProgression(params.data.status, currentStatus)) {
            setBulkUpdateStatusError(true);

            return { backgroundColor: "#c85f62"}; // Red background for invalid
        }else{
            setBulkUpdateStatusError(false);
        }
        return null; // Default style for valid values
    },
}
,
        {
            headerName: "Current Location",
            field: "current_location",
            editable: true,
            valueGetter: (params)=>{
                if(params.data.current_location===""){
                    setBulkUpdateCurrentLocationErr(true)
                    return ""
                }
                return params.data.current_location
            },
            valueSetter: (params) => {
                const newValue = params.newValue // Trim the new value
                if (newValue==="") {
                    // If the new value is empty or undefined
                    console.error("Current Location cannot be empty.");
                    params.data.current_location = ""; // Reset to an empty string
                    return ""; // Indicate failed update
                }

                // Update the value if valid

                params.data.current_location = newValue;
                return ""; // Indicate successful update
            },
            cellStyle: (params) => {
        // Highlight cells with empty or undefined `current_location`
        if (!params.data.current_location) {
            setBulkUpdateCurrentLocationErr(true)

            return {
                
                backgroundColor: '#c85f62', // Red background for invalid or empty cells
                // color: 'white', // Optional: White text for contrast
            };

        }else{
            setBulkUpdateCurrentLocationErr(false)
        }
        return null; // Default styling for valid cells
    },
}
,
{
    headerName: "Current Event Date & Time",
    field: "current_event_date_time",
    colId:"current_event_date_time",
    width: 150,
    resizable: true,
    editable: true,
    comparator: dateComparator, // Custom date comparator for sorting
    cellEditor: DateEditor,

    // Retrieve and validate the date and time value
    valueGetter: (params) => {
        const date = params.data.current_event_date_time;
    
        // Call validateAllRows to ensure all rows are checked
        validateAllRows(params.api);
    
        // Regex pattern for DD-MM-YYYY HH:mm format
        const dateTimePattern = /^\d{2}-\d{2}-\d{4} \d{2}:\d{2}$/;
    
        if (date && dateTimePattern.test(date)) {
            const currentDate = new Date();
            const eventDate = parseDate(date);
    
    
            // Check if the date is within the valid range
            if (isValidDateRange(eventDate, currentDate)) {
                return (date); // Return formatted date
            } else {
                return ""; // Out-of-range date
            }
        } else if (date) {
            console.error("ValueGetter - Invalid Date Format:", date);
        }
    
        // Default case: return an empty string for invalid or missing dates
        return "";
    },
    

    // Validate and update the date and time value
    valueSetter: (params) => {
        const newValue = getHyphenDDMMYYYYHHMM1(params.newValue?.trim());


        const dateTimePattern = /^\d{2}-\d{2}-\d{4} \d{2}:\d{2}$/;

        if (newValue && dateTimePattern.test(newValue)) {
            const currentDate = new Date();
            const eventDate = parseDate(newValue);


            if (isValidDateRange(eventDate, currentDate)) {
                params.data.current_event_date_time = newValue;
                validateAllRows(params.api);
                return true;
            } else {
                params.data.current_event_date_time = "";
                validateAllRows(params.api);
                return false;
            }
        } else {
            params.data.current_event_date_time = "";
            validateAllRows(params.api);
            return false;
        }
    },

    // Apply conditional styling based on validity
    cellStyle: (params) => {
        const date = params.data.current_event_date_time;
        const dateTimePattern = /^\d{2}-\d{2}-\d{4} \d{2}:\d{2}$/;

        if (date && dateTimePattern.test(date)) {
            const currentDate = new Date();
            const eventDate = parseDate(date);

            if (!isValidDateRange(eventDate, currentDate)) {
                return { backgroundColor: "#c85f62" }; // Highlight invalid cells
            }
        } else if (date==="" || date) {
            return { backgroundColor: "#c85f62" }; // Highlight cells with invalid format
        }

        return null; // Default style for valid cells
    },

    headerClass: 'bold-header',
}
        ,
        {
            headerName: "Reason for delay",
            field: "reason_for_delay",
            editable: true,

            // Value Getter to check and return the reason
            valueGetter: (params) => {
                const reason = params.data.reason_for_delay;
                const eventDateTime = params.data.current_event_date_time;
                const expectedETA = params.data.expected_eta;

                if (eventDateTime && expectedETA) {
                    const eventDate = parseDate(eventDateTime);
                    const expectedDate = parseDate(expectedETA);

                    // Check if event_date_time is greater than expected_eta
                    if (eventDate > expectedDate && (!reason || reason.trim() === "")) {
                        setBulkUpdateReasonErr(true)
                        console.error("Reason for delay is mandatory if Event Date and Time exceeds Expected ETA.");
                        return ""; // Return empty if mandatory and not provided
                    }
                }
                setBulkUpdateReasonErr(false)
                return reason || ""; // Return reason or empty if valid
            },

            // Value Setter to validate and update the reason
            valueSetter: (params) => {
                const newValue = params.newValue?.trim();
                const eventDateTime = params.data.current_event_date_time;
                const expectedETA = params.data.expected_eta;

                if (eventDateTime && expectedETA) {
                    const eventDate = parseDate(eventDateTime);
                    const expectedDate = parseDate(expectedETA);

                    // Validate only if Event Date > Expected ETA
                    if (eventDate > expectedDate) {
                        if (!newValue || newValue === "") {
                            setBulkUpdateReasonErr(true)

                            console.error("Reason for delay is mandatory if Event Date and Time exceeds Expected ETA.");
                            params.data.reason_for_delay = ""; // Reset to empty if invalid
                            return false; // Indicate failed update
                        }
                    }
                }

                // Update the value if valid
                setBulkUpdateReasonErr(false)

                params.data.reason_for_delay = newValue;
                return true; // Indicate successful update
            },

            // Conditional cell styling
            cellStyle: (params) => {
                const reason = params.data.reason_for_delay;
                const eventDateTime = params.data.current_event_date_time;
                const expectedETA = params.data.expected_eta;

                if (eventDateTime && expectedETA) {
                    const eventDate = parseDate(eventDateTime);
                    const expectedDate = parseDate(expectedETA);

                    // Highlight if Event Date > Expected ETA and reason is missing
                    if (eventDate > expectedDate && (!reason || reason.trim() === "")) {
                        return {
                            backgroundColor: "#c85f62", // Red background for mandatory field
                            color: "white",
                        };
                    }
                }

                return null; // Default style for valid values
            },

            headerClass: 'bold-header',
        }
        ,


    ]


    var inactiveColDefs = [];




    const onClickShowRoute = (rownode) => {
        setLoader(true)
        setOverlay("show-m")
        setLoadShow("show-m")
        let e = rownode.data
        var s_date;
        if (e.gate_out_time !== "" && e.gate_out_time !== undefined) {
            s_date = moment.parseZone(e.gate_out_time).format('YYYY-MM-DD HH:mm:ss');
        } else {
            s_date = moment.parseZone(e.shipment_time).format('YYYY-MM-DD HH:mm:ss');
        }

        var gateouttime = moment.parseZone(e.gate_out_time).format('YYYY-MM-DD HH:mm:ss');
        var edate = '';
        var end_date;
        if (e.status <= 2) {
            end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss')
            edate = getHyphenDDMMMYYYYHHMM(end_date);
        }
        else if ((e.status == 3 || e.status == 4)) {
            if (e.recent_dealer_reported) {
                end_date = e.recent_dealer_reported.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
                edate = getHyphenDDMMMYYYYHHMM(e.recent_dealer_reported);
            }
        }
        else if (e.status == 5) {
            if (e.tvp_gate_in) {
                end_date = e.tvp_gate_in.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
                edate = getHyphenDDMMMYYYYHHMM(e.tvp_gate_in);
            }
            else if (e.left_dealer_marked) {
                end_date = e.left_dealer_marked.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
                edate = getHyphenDDMMMYYYYHHMM(e.left_dealer_marked);
            }
        }
        else if (e.status == 6) {
            if (e.tvp_gate_in) {
                end_date = e.tvp_gate_in.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
                edate = getHyphenDDMMMYYYYHHMM(e.tvp_gate_in);
            } else if (e.force_closure_time) {
                end_date = getHyphenDDMMMYYYYHHMM(e.force_closure_time);
            }
        }
        else {
            end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss')
            edate = getHyphenDDMMMYYYYHHMM(end_date);
        }
        if ((e.transit_time) > 0) {
            var seconddate = new Date(new Date(e.gate_out_time).getTime() + ((e.transit_time + 1) * 24 * 60 * 60 * 1000));
        }
        else {
            var seconddate = new Date(new Date(e.gate_out_time).getTime() + 2 * 24 * 60 * 60 * 1000);
        }

        var sdate = seconddate.getFullYear() + "-" + (seconddate.getMonth() + 1) + "-" + seconddate.getDate() + " " + seconddate.getHours() + ":" + seconddate.getMinutes() + ":" + seconddate.getSeconds();

        if (!end_date) {
            // When end date is unavailable then current date is considered as end date.
            end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss');
        }
        var reqData = {
            truck_no: e.truck_no,
            gate_out_time: s_date,
            seconddate: end_date,
            screen: "consignment",
            consignment_code: e.consignment_code
        }
        // if (e.consignee_code !== undefined) reqData.consignee_code = e.consignee_code
        if (e.consignment_code !== undefined) reqData.consignment_code = e.consignment_code
        redirectURL.post('/consignments/maproutes', reqData, {
            headers: {
                'content-type': 'application/json'
            }
        })
            .then((response) => {
                var records = response.data;
                
                
                // this.setState({
                //     loadshow: 'show-m'
                // });
                try {
                    if (records.coords.length == 0) {
                        setShow(true);
                        setTitle("No Tracking data available")
                        setType("danger")
                    }
                    else {
                        if (records != '') {
                            var sdate = e.gate_out_time;
                            if (e.invoice_time) {
                                var sdate = e.invoice_time;
                            }
                            else {
                                if (e.gate_in_time) {
                                    var sdate = e.gate_in_time;
                                }
                                else {
                                    if (e.gate_out_time) {
                                        var sdate = e.gate_out_time;
                                    }
                                }
                            }
                            var edate = '';
                            if (e.status <= 4) {
                                end_date = moment.parseZone().format('DD/MM/YYYY HH:mm:ss')
                                edate = getHyphenDDMMMYYYYHHMM(end_date);
                            }
                            else if (e.status == 5) {
                                if (e.left_dealer_marked) {
                                    edate = getHyphenDDMMMYYYYHHMM(e.left_dealer_marked);
                                }
                                else {
                                    end_date = moment.parseZone().format('DD/MM/YYYY HH:mm:ss')
                                    edate = getHyphenDDMMMYYYYHHMM(end_date);
                                }
                            }
                            if (e.deviation_flag == 1) {
                                let consignee_city;
                                consignee_city = e.consignee_city
                                var params = {
                                    "base_route_id": e.base_route_id,
                                    "consigner_code": e.consigner_code,
                                    "consignee_city": consignee_city
                                }
                                redirectURL.post("/consignments/getDeviationRouteBaseRoute",
                                    params).then((resp) => {
                                        var baseRouteCoords = eval(resp.data.route_coords);
                                        setOpenMap({
                                            overly: "show-m",
                                            sliderRouteTranslate: "slider-translate-60p",
                                            mapinfo: records,
                                            dealer: e.consignee_code,
                                            lr_no: "LR No. : " + e.lr_no,
                                            maptruckno: e.truck_no,
                                            routeTruck: { "truck_no": e.truck_no, "startTime": sdate, "endTime": end_date },
                                            loadshow: 'show-n',
                                            sidebarSubHeader: "Consignment Information",
                                            rownode: e,
                                            leg_no: 0,
                                            tolls: records.tolls,
                                            baseRouteCoords: baseRouteCoords
                                        })
                                    })
                                setLoadShow("show-n")
                            }
                            else {
                                var params =
                                {
                                    consignee_code: e.consignee_code,
                                    dept_code: e.dept_code
                                }
                                redirectURL.post('/consignments/geofencedata', params).then((response) => {
                                    var records1 = response.data.records;
                                    let parkingGeodata = []
                                    if (response.data.parkingGeofence[0] !== undefined) parkingGeodata = response.data.parkingGeofence[0]
                                    var geofence_coords = []
                                    if (records1.length) {
                                        geofence_coords = records1[0].geofence_coordinates;
                                    }
                                    setOpenMap({
                                        sliderRouteTranslate: "slider-translate-60p",
                                        showDiv: 'show-m',
                                        mapinfo: records,
                                        dealer: e.consignee_code,
                                        lr_no: "LR No. : " + e.lr_no,
                                        maptruckno: e.truck_no,
                                        geofence_coordinates: geofence_coords,
                                        parking_coordinates: parkingGeodata,
                                        routeTruck: { "truck_no": e.truck_no, "startTime": sdate, "endTime": end_date },
                                        loadshow: 'show-n',
                                        sidebarSubHeader: "Consignment Information",
                                        overly: 'show-m',
                                        rownode: e,
                                        leg_no: 0,
                                        tolls: records.tolls
                                    })
                                    setLoadShow("show-n")
                                })
                            }
                        }
                    }
                }
                catch (e) {

                    setShow(true)
                    setTitle("No Tracking data available")
                    setType("danger")
                    setLoadShow("show-n")
                    setOverlay("show-n")
                }

            })
            .catch(function (error) {
                console.log(error);
            });
        setLoader(false)
    }
    
const handleEwayDate = (date) => {
    if (!date) return; // Ensure a valid date is passed
    // Save the raw Date object for DatePicker
    setFormData(prev => ({ ...prev, eway_bill_expiry_date: date }));
    setManualUpdateConsignment(prev => ({...prev, eway_bill_expiry_date: date}))
};
    const closeCancelModal = (e) => {
        setCloseCancelModal(false)
        setReasonForCancellation('')
        setRownode([])
    }
    const closeforceCloseModal = (e) => {
        setForceCloseModal(false)
        setReasonForCancellation('')
        setRownode([])
    }
    const cancelForceCloseFormCloseHandler = (e) => {
        e.preventDefault();
        let invoices_list = invoiceNoList.map((e)=> e.label)
        let reqData = {
            truck_no: rownode.truck_no,
            invoices_selected: invoices_list,
            reasonForCancellation: reasonForCancellation
        }
        redirectURL.post("/consignments/updateFtlConsignmentCancellation", reqData)
            .then(async (response) => {
                if (response.data.status == 'success') {
                    setShow(true)
                    setTitle(response.data.message)
                    setType("success")
                    closeCancelModal();
                    setRownode([]);
                    setLrOptions([]);
                    setReasonForCancellation("");
                    setshowAddForm3('')
                    // window.location.reload();
                }
                else {
                    setShow(true)
                    setTitle(response.data.message)
                    setType("danger")                    
                    closeCancelModal();
                }
            })
            .catch(function (e) {
                console.log("Error ", e)
            })
    }
    const cancelFormCloseHandler = (e) => {
        e.preventDefault();
        let invoices_list = lrNoOption.map((e)=> e.label)
        let reqData = {
            truck_no: rownode.truck_no,
            lrNo: rownode.lr_no,
            invoices_selected: invoices_list,
            reasonForCancellation: reasonForCancellation,
            trackingType: cancelConsignmentForTrackinType
        }
        redirectURL.post("/consignments/updateConsignmentCancellation", reqData)
            .then(async (response) => {
                if (response.data.status == 'success') {
                    setShow(true)
                    setTitle(response.data.message)
                    setType("success")
                    closeCancelModal();
                    setRownode([]);
                    setLrOptions([]);
                    setReasonForCancellation("");
                    window.location.reload();
                }
                else {
                    setShow(true)
                    setTitle(response.data.message)
                    setType("danger")                    
                    closeCancelModal();
                }
            })
            .catch(function (e) {
                console.log("Error ", e)
            })
    }
    // const   onShowCourierTrack = async (params, consignmentStatus) => {
    //         // if (googleAnalytics.page.enableGA) {
    //         // 	let pageTitle = this.state.pageTitle;
    //         // 	// let eventOptions = {
    //         // 	// 	"category": pageTitle,
    //         // 	// 	"action": this.state.eventGridAction,
    //         // 	// 	"label": googleAnalytics.page.action.trackCourier,
    //         // 	// }
    //         // 	// googleAnalytics.logEvent(eventOptions);
    //         // }
    
    //         redirectURL.post('/consignments/trackcourier',{consignment_code :params.data.consignment_code} )
    //         .then(resp => {
    //             if (resp.data.consignments?.length > 0) {
    //                 params.node.setExpanded(!params.node.expanded)
    //                 const columnDefs =  [
                                
    //                     {
    //                         headerName: "Transit Date",
    //                         field: "transitdatetime",
    //                         valueGetter: function(params) {
    //                             let transitDateTime = params.data.transitdatetime;
                        
    //                             if (!transitDateTime) {
    //                                 return '';
    //                             }
                        
    //                             let momentDate;
                        
    //                             // Parse ISO format and check other formats as well
    //                             if (moment(transitDateTime, moment.ISO_8601, true).isValid()) {
    //                                 momentDate = moment(transitDateTime).utc();  // Use UTC here
    //                             }
    //                             else if (moment(transitDateTime, "DD-MM-YYYY HH:mm:ss", true).isValid()) {
    //                                 momentDate = moment(transitDateTime, "DD-MM-YYYY HH:mm:ss").utc();
    //                             } 
    //                             else if (moment(transitDateTime, "DD-MMM-YYYY HH:mm", true).isValid()) {
    //                                 momentDate = moment(transitDateTime, "DD-MMM-YYYY HH:mm").utc();
    //                             } 
    //                             else if (params.data.transitdatetimeseconds) {
    //                                 momentDate = moment.utc(parseInt(params.data.transitdatetimeseconds));  // Use UTC here for epoch time
    //                             }
                        
    //                             // If the moment object is not valid, return the original string
    //                             if (!momentDate) {
    //                                 return transitDateTime;
    //                             }
                        
    //                             // Format as DD-MM-YYYY HH:mm in UTC
    //                             return momentDate.format("DD-MM-YYYY HH:mm");
    //                         },
                        
    //                         filter: true,
    //                         resizable: true
    //                     },
                        
    //                     { 
    //                         headerName: "Location",
    //                         field: "intransit_location", 
    //                         filter:true,
    //                         resizable:true 
    //                     },
    //                     { 
    //                         headerName: "Status",
    //                         field: "intransit_status", 
    //                         filter:true ,
    //                         resizable:true
    //                     },
    //                     {
    //                         headerName: "Force Closure Reason",
    //                         field: "force_closure_reason",
    //                         width: 160,
    //                         hide:consignmentStatus!=="Cancelled",
    //                         filter: "agSetColumnFilter",
    //                         cellRenderer: '', resizable: true
    //                     },
    //                 ];
    //                 columnDefs.forEach(e => {
    //                     e.cellClass = function (params) {
    //                         if (params.data && params.data.hasOwnProperty(`${e.field}_modified`) && params.data[`${e.field}_modified`] === 1) {
    //                             return "bgColorDangerDark"; // Apply your custom CSS class here
    //                         } else {
    //                             return null;
    //                         }
    //                     };
    //                 });
    //                 setdetailCellRendererParams({
    //                     detailGridOptions: {
    //                         columnDefs: columnDefs,
    //                         defaultColDef: {
    //                             flex: 3,
    //                         },
    //                     },
    //                     getDetailRowData: (params) => {
    //                         // params.successCallback(resp.data);
    //                         params.successCallback(resp.data.consignments);
    //                     },
    //                 })
    //             }})
    //     }
   
    
        const onClickUploadPOD = async(rownode) => {
        // for FTL POD Upload
            if (rownode.data.tracking_type ==='FTL'){
                var params = {
                    truck_no: rownode.data.truck_no,
                    shipment_id: rownode.data.shipment_id
                }
                await redirectURL.post('consignments/gettruckrecord', params).then
                (resp => {
                    var data= resp.data;
                    let truck_level_invoice = rownode.data.invoice_no;
                    // let invoicesList = data
                    // .filter(e => e.is_submitted_pod !== 1) // Filter out invoices with is_submitted_pod === 1
                    // .map(e => ({ label: e.invoice_no, value: e.invoice_no }));                    
                    // console.log(invoicesList, "invoicesList123");
                    // setInvoiceUploadList(invoicesList)

                    let LRList = data
                    .filter(e => e.is_submitted_pod !== 1) // Filter out invoices with is_submitted_pod === 1
                    .map(e => e.lr_no) // Get only the lr_no values
                    .filter((value, index, self) => self.indexOf(value) === index); 
                    setInvoiceUploadList(LRList)
                    
                })
            }
            
            setSliderShow("slider-translate-30p")
            setOverlay("show-m")
            setRownode([rownode.data])
    
        }
      
        const onClickShowShipmentLegs = async (params, status) => {
            
            let query = {
                truck_no: params.data.truck_no,
                shipment_id: params.data.shipment_id
            }
            redirectURL.post('/consignments/getShipmentDetails', query)
            .then(resp => {
                if (resp.data.consignments?.length > 0) {
                    params.node.setExpanded(!params.node.expanded)
                    const columnDefs = [
                        // {
                        //     headerName: "",
                        //     field: "legs_map",
                        //     colId: "legs_map",
                        //     width: 40,
                        //     pinned: 'left',
                        //     cellRenderer:function(params){
                        //         var htmloption = '<i className="icofont icofont-map-pins f25" style="padding:0 9px"></i>';
                        //         return htmloption;
                        //     } ,
                        //     filter: false, resizable: true
        
                        // },
                        {
                            headerName: "Invoice No",
                            field: "invoice_no",
                            width: 150,
                            resizable:true,

                            // cellclassName: function (params) {
                            // 	if (params.data.transit_delay == 1) {
                            // 		return 'lightred';
                            // 	}
                            // 	else {
                            // 		return '';
                            // 	}

                            // }
                        },
                        
                        // {
                        //     headerName: "Consignment",
                        //     field: "consignment_code",
                        //     width: 140,
                        //     // cellclassName: function (params) {
                        //     // 	if (params.data.transit_delay == 1) {
                        //     // 		return 'lightred';
                        //     // 	}
                        //     // 	else {
                        //     // 		return '';
                        //     // 	}

                        //     // }
                        // },
                        
                        {
                            headerName: "Original ETA",
                            field: "expected_eta",
                            width: 150,
                            resizable:true,

                            valueGetter: function (params) {
                                return getHyphenDDMMMYYYYHHMM(params.data.expected_trip_end)
                            },
                            cellclassName: function (params) {
                                if (params.data.transit_delay == 1) {
                                    return 'lightred';
                                }
                                else {
                                    return '';
                                }
                            },

                        },
                        {
                            headerName: "Revised ETA",
                            field: "revised_eta",
                            width: 150,
                            resizable:true,

                            valueGetter: function (params) {
                                return getHyphenDDMMMYYYYHHMM(params.data.revised_trip_end)
                            },
                            cellclassName: function (params) {
                                if (params.data.transit_delay == 1) {
                                    return 'lightred';
                                }
                                else {
                                    return '';
                                }

                            }
                        },
                        
                        {
                            headerName: "Status",
                            field: "status",
                            width: 140,
                            resizable:true,

                            // cellclassName: function (params) {
                            // 	if (params.data.transit_delay == 1) {
                            // 		return 'lightred';
                            // 	}
                            // 	else {
                            // 		return '';
                            // 	}

                            // },
                            

                            valueGetter: function (params) {
                                if (params.data.status == 1) {
                                    return "At Source"
                                }
                                else if (params.data.status == 2) {
                                    return "In Transit"
                                }
                                else if (params.data.status == 3) {
                                    return "Near Destination"
                                }
                                else if (params.data.status == 4) {
                                    return "Reached Destination"
                                }

                                else if (params.data.status == 5) {
                                    return "Left Destination"
                                }
                                else if (params.data.status == 6) {
                                    return "Force Closed"
                                }
                                else if (params.data.status == 8) {
                                    return "Delivered"
                                }else if(params.data.status == 9){
                                    return "Cancelled"
                                }
                                else {
                                    return ""
                                }

                            }
                        },
                        // {
                        //     headerName: "Zone",
                        //     field: "zone",
                        //     width: 100,
                        //     // cellclassName: function (params) {
                        //     // 	if (params.data.transit_delay == 1) {
                        //     // 		return 'lightred';
                        //     // 	}
                        //     // 	else {
                        //     // 		return '';
                        //     // 	}

                        //     // }
                        // },
                        
                        // {
                        //     headerName: "Dealer Code",
                        //     field: "consignee_code",
                        //     width: 140,
                            // cellclassName: function (params) {
                            // 	if (params.data.transit_delay == 1) {
                            // 		return 'lightred';
                            // 	}
                            // 	else {
                            // 		return '';
                            // 	}

                            // }
                        // },
                        {
                            headerName: "Destination City",
                            field: "consignee_city",
                            width: 150,
                            resizable: true,
                            // cellclassName: function (params) {
                            // 	if (params.data.transit_delay == 1) {
                            // 		return 'lightred';
                            // 	}
                            // 	else {
                            // 		return '';
                            // 	}

                            // }
                        },

                        {
                            headerName: "Consignee Name",
                            field: "customer_name",
                            width: 200,
                            resizable: true,
                            // cellclassName: function (params) {
                            // 	if (params.data.transit_delay == 1) {
                            // 		return 'lightred';
                            // 	}
                            // 	else {
                            // 		return '';
                            // 	}

                            // }
                        },
                        {
                            headerName: "Trip Distance (KM)",
                            field: "distance_in_km",
                            width: 100,
                            resizable: true,
                            valueGetter: params =>{
                                if(params.data.distance_in_km>0){
                                    return params.data.distance_in_km
                                }else{
                                    return 0
                                }
                            }
                            ,
                            // cellclassName: function (params) {
                            // 	if (params.data.transit_delay == 1) {
                            // 		return 'lightred';
                            // 	}
                            // 	else {
                            // 		return '';
                            // 	}

                            // }
                        },
                        {
                            headerName: "Distance from Dealer (KM)",
                            field: "distance_from_dealer_location",
                            width: 220,
                            resizable:true,

                            valueGetter: function (params) {
                                if (params.data.distance_from_dealer_location != '' && params.data.distance_from_dealer_location != null) {
                                    return params.data.distance_from_dealer_location;
                                }
                                else {
                                    return "";
                                }
                            },
                            // cellclassName: function (params) {
                            // 	if (params.data.transit_delay == 1) {
                            // 		return 'lightred';
                            // 	}
                            // 	else {
                            // 		return '';
                            // 	}

                            // }
                        },
                        // {
                        //     headerName: "Reached Destination At",
                        //     field: "recent_dealer_reported",
                        //     width: 180,


                        //     //cellRenderer:'dateFormater',
                        //     valueGetter: function (params) {
                        //         if (params.data.status == 4 || params.data.status == 5) {
                        //             return getHyphenDDMMMYYYYHHMM(params.data.recent_dealer_reported);
                        //         }
                        //         else {
                        //             return "";
                        //         }

                        //     },
                        //     resizable: true,

                        // },
                        // {
                        //     headerName: "Left Destination At",
                        //     field: "left_dealer_marked",
                        //     width: 150,
                        //     //filter: "agDateColumnFilter",
                        //     //cellRenderer:'dateFormater',
                        //     valueGetter: function (params) {
                        //         if (params.data.status == 5) {
                        //             return getHyphenDDMMMYYYYHHMM(params.data.left_dealer_marked);
                        //         }
                        //         else {
                        //             return "";
                        //         }

                        //     },
                        //     resizable: true,

                        // },
                        {
                            headerName: "Transit Time (Days)",
                            field: "transit_time",
                            width: 170,
                            filter: "agSetColumnFilter",
                            cellRenderer: '', resizable: true
                        },
                        {
                            headerName: "Transit Delay Hours",
                            field: "transit_delay_hours",
                            width: 180,
                            filter: "agSetColumnFilter",
                            cellRenderer: '', resizable: true
                        },
                        // {
                        //     headerName: "Upload POD",
                        //     field: "upload_pod",
                        //     width: 200,
                        //     filter: false,
                        //     hide:tabName.value !=='completed',
                        //     cellRendererSelector: function (param) {
                        //         try {
                        //             return {
                        //                 component: uploadPOD,
                        //                 params: {
                        //                     onClickUploadPOD: onClickUploadPOD,
                        //                     isSubmittedPOD: param.data.is_submitted_pod
                        //                 }
                        //             }
                        //         } catch (err) {
                        //             console.log(err);
                        //         }
                        //     }
                            // cellRenderer: (params) => {
                            //     const handleClick = (e) => {
                            //         e.stopPropagation();
                            //         onClickUploadPOD(params);  
                            //     };
                            //     console.log(params,"disballelee");
                            //     return (
                            //         <button
                            //             onClick={handleClick}
                            //             // className="btn btn-info"
                            //             // style={{
                            //             //     padding: "8px 10px",
                            //             //     fontSize: "13px",
                            //             //     margin: "0",
                            //             //     display: "flex",           
                            //             //     alignItems: "center",      
                            //             //     justifyContent: "center",  
                            //             //     height: "100%",            
                            //             //     boxSizing: "border-box"    
                            //             // }}
                            //             style={{border:"none"}}
                            //             title="Upload POD"
                            //             disabled={params.data.epod_uploaded === 1}
                            //         >
                            //             <i
                            //                 className="icofont icofont-upload-alt f15"
                            //                 style={{
                            //                     fontSize: "15px",
                            //                     color: "#3a3fa6",
                            //                     lineHeight: "1",       
                            //                 }}
                            //             ></i>
                            //         </button>
                            //     );
                            // }
                            
                            // },
                            {
                                headerName: "Force Closure Reason",
                                field: "force_closure_reason",
                                width: 160,
                                hide:status!==6,
                                filter: "agSetColumnFilter",
                                cellRenderer: '', resizable: true
                            },
                            // {
                            //     headerName: "Upload POD",
                            //     field: "upload_pod",
                            //     width: 200,
                            //     filter: false,
                            //     hide:tabName.value !=='all',
                            //     cellRendererSelector: function (param) {
                            //         try {
                            //             // console.log(param,"subbbbblegggg");
                            //             return {
                            //                 component: UploadFTLPod,
                            //                 params: {
                            //                     onClickUploadPOD: onClickUploadPOD,
                            //                 }
                            //             }
                            //         } catch (err) {
                            //             console.log(err);
                            //         }
                            //     }
                                // cellRenderer: (params) => {
                                //     const handleClick = (e) => {
                                //         e.stopPropagation();
                                //         onClickUploadPOD(params);  
                                //     };
                                //     console.log(params,"disballelee");
                                //     return (
                                //         <button
                                //             onClick={handleClick}
                                //             // className="btn btn-info"
                                //             // style={{
                                //             //     padding: "8px 10px",
                                //             //     fontSize: "13px",
                                //             //     margin: "0",
                                //             //     display: "flex",           
                                //             //     alignItems: "center",      
                                //             //     justifyContent: "center",  
                                //             //     height: "100%",            
                                //             //     boxSizing: "border-box"    
                                //             // }}
                                //             style={{border:"none"}}
                                //             title="Upload POD"
                                //             disabled={params.data.epod_uploaded === 1}
                                //         >
                                //             <i
                                //                 className="icofont icofont-upload-alt f15"
                                //                 style={{
                                //                     fontSize: "15px",
                                //                     color: "#3a3fa6",
                                //                     lineHeight: "1",       
                                //                 }}
                                //             ></i>
                                //         </button>
                                //     );
                                // }
                                
                                // },
                               
                                
                            
                    ];
                    columnDefs.forEach(e => {
                        e.cellClass = function (params) {
                            if (params.data && params.data.hasOwnProperty(`${e.field}_modified`) && params.data[`${e.field}_modified`] === 1) {
                                return "bgColorDangerDark"; // Apply your custom CSS class here
                            } else {
                                return null;
                            }
                        };
                    });
                    setdetailCellRendererParams({
                        detailGridOptions: {
                            columnDefs: columnDefs
                            // defaultColDef: {
                            //     flex: 3,
                            // },
                        },
                        getDetailRowData: (params) => {
                            // params.successCallback(resp.data);
                            params.successCallback(resp.data.consignments);
                        },
                    })
                // }
            // })
            // .catch(err => {
            //     console.log(err);
            // })
        }})}
        const onClickShowCourierShipmentLegs = async (params, status) => {
            
            let query = {
                // truck_no: params.data.truck_no,
                shipment_id: params.data.shipment_id
            }
            redirectURL.post('/consignments/getCourierShipmentDetails', query)
            .then(resp => {
                if (resp.data.courier_consignments?.length > 0) {
                    params.node.setExpanded(!params.node.expanded)
                    const columnDefs = [
                        // {
                        //     headerName: "",
                        //     field: "legs_map",
                        //     colId: "legs_map",
                        //     width: 40,
                        //     pinned: 'left',
                        //     cellRenderer:function(params){
                        //         var htmloption = '<i className="icofont icofont-map-pins f25" style="padding:0 9px"></i>';
                        //         return htmloption;
                        //     } ,
                        //     filter: false, resizable: true
        
                        // },
                        {
                            headerName: "Invoice No",
                            field: "invoice_no",
                            width: 150,
                            // cellclassName: function (params) {
                            // 	if (params.data.transit_delay == 1) {
                            // 		return 'lightred';
                            // 	}
                            // 	else {
                            // 		return '';
                            // 	}

                            // }
                        },
                        
                        // {
                        //     headerName: "Consignment",
                        //     field: "consignment_code",
                        //     width: 140,
                        //     // cellclassName: function (params) {
                        //     // 	if (params.data.transit_delay == 1) {
                        //     // 		return 'lightred';
                        //     // 	}
                        //     // 	else {
                        //     // 		return '';
                        //     // 	}

                        //     // }
                        // },
                        
                        {
                            headerName: "Original ETA",
                            field: "expected_eta",
                            width: 150,
                            valueGetter: function (params) {
                                return getHyphenDDMMMYYYYHHMM(params.data.expected_trip_end)
                            },
                            cellclassName: function (params) {
                                if (params.data.transit_delay == 1) {
                                    return 'lightred';
                                }
                                else {
                                    return '';
                                }
                            },

                        },
                        {
                            headerName: "Revised ETA",
                            field: "revised_eta",
                            width: 150,
                            valueGetter: function (params) {
                                return getHyphenDDMMMYYYYHHMM(params.data.revised_trip_end)
                            },
                            cellclassName: function (params) {
                                if (params.data.transit_delay == 1) {
                                    return 'lightred';
                                }
                                else {
                                    return '';
                                }

                            }
                        },
                        
                        {
                            headerName: "Status",
                            field: "consignment_status",
                            width: 140,
                            resizable:true
                            // cfellclassName: function (params) {
                            // 	if (params.data.transit_delay == 1) {
                            // 		return 'lightred';
                            // 	}
                            // 	else {
                            // 		return '';
                            // 	}

                            // },
                            

                           
                        },
                        // {
                        //     headerName: "Zone",
                        //     field: "zone",
                        //     width: 100,
                        //     // cellclassName: function (params) {
                        //     // 	if (params.data.transit_delay == 1) {
                        //     // 		return 'lightred';
                        //     // 	}
                        //     // 	else {
                        //     // 		return '';
                        //     // 	}

                        //     // }
                        // },
                        
                        // {
                        //     headerName: "Dealer Code",
                        //     field: "consignee_code",
                        //     width: 140,
                            // cellclassName: function (params) {
                            // 	if (params.data.transit_delay == 1) {
                            // 		return 'lightred';
                            // 	}
                            // 	else {
                            // 		return '';
                            // 	}

                            // }
                        // },
                        {
                            headerName: "Destination City",
                            field: "consignee_city",
                            width: 150,
                            resizable: true,
                            // cellclassName: function (params) {
                            // 	if (params.data.transit_delay == 1) {
                            // 		return 'lightred';
                            // 	}
                            // 	else {
                            // 		return '';
                            // 	}

                            // }
                        },

                        {
                            headerName: "Consignee Name",
                            field: "customer_name",
                            width: 200,
                            resizable: true,
                            // cellclassName: function (params) {
                            // 	if (params.data.transit_delay == 1) {
                            // 		return 'lightred';
                            // 	}
                            // 	else {
                            // 		return '';
                            // 	}

                            // }
                        },
                        // {
                        //     headerName: "Trip Distance (KM)",
                        //     field: "distance_in_km",
                        //     width: 100,
                        //     resizable: true,
                        //     valueGetter: params =>{
                        //         if(params.data.distance_in_km>0){
                        //             return params.data.distance_in_km
                        //         }else{
                        //             return 0
                        //         }
                        //     }
                        //     ,
                            // cellclassName: function (params) {
                            // 	if (params.data.transit_delay == 1) {
                            // 		return 'lightred';
                            // 	}
                            // 	else {
                            // 		return '';
                            // 	}

                            // }
                        // },
                        // {
                        //     headerName: "Distance from Dealer (KM)",
                        //     field: "distance_from_dealer_location",
                        //     width: 200,
                        //     valueGetter: function (params) {
                        //         if (params.data.distance_from_dealer_location != '' && params.data.distance_from_dealer_location != null) {
                        //             return params.data.distance_from_dealer_location;
                        //         }
                        //         else {
                        //             return "";
                        //         }
                        //     },
                            // cellclassName: function (params) {
                            // 	if (params.data.transit_delay == 1) {
                            // 		return 'lightred';
                            // 	}
                            // 	else {
                            // 		return '';
                            // 	}

                            // }
                        // },
                        // {
                        //     headerName: "Reached Destination At",
                        //     field: "recent_dealer_reported",
                        //     width: 180,
                        //     resizable: true,

                        // },
                        // {
                        //     headerName: "Left Destination At",
                        //     field: "left_dealer_marked",
                        //     width: 150,
                        //     //filter: "agDateColumnFilter",
                        //     //cellRenderer:'dateFormater',
                        //     valueGetter: function (params) {
                        //         if (params.data.status == 5) {
                        //             return getHyphenDDMMMYYYYHHMM(params.data.left_dealer_marked);
                        //         }
                        //         else {
                        //             return "";
                        //         }

                        //     },
                        //     resizable: true,

                        // },
                        {
                            headerName: "Transit Time (Days)",
                            field: "transit_time",
                            width: 170,
                            filter: "agSetColumnFilter",
                            cellRenderer: '', resizable: true
                        },
                        {
                            headerName: "Transit Delay Hours",
                            field: "transit_delay_hours",
                            width: 180,
                            filter: "agSetColumnFilter",
                            cellRenderer: '', resizable: true
                        },
                        // {
                        //     headerName: "Upload POD",
                        //     field: "upload_pod",
                        //     width: 200,
                        //     filter: false,
                        //     hide:tabName.value !=='completed',
                        //     cellRendererSelector: function (param) {
                        //         try {
                        //             return {
                        //                 component: uploadPOD,
                        //                 params: {
                        //                     onClickUploadPOD: onClickUploadPOD,
                        //                     isSubmittedPOD: param.data.is_submitted_pod
                        //                 }
                        //             }
                        //         } catch (err) {
                        //             console.log(err);
                        //         }
                        //     }
                            // cellRenderer: (params) => {
                            //     const handleClick = (e) => {
                            //         e.stopPropagation();
                            //         onClickUploadPOD(params);  
                            //     };
                            //     console.log(params,"disballelee");
                            //     return (
                            //         <button
                            //             onClick={handleClick}
                            //             // className="btn btn-info"
                            //             // style={{
                            //             //     padding: "8px 10px",
                            //             //     fontSize: "13px",
                            //             //     margin: "0",
                            //             //     display: "flex",           
                            //             //     alignItems: "center",      
                            //             //     justifyContent: "center",  
                            //             //     height: "100%",            
                            //             //     boxSizing: "border-box"    
                            //             // }}
                            //             style={{border:"none"}}
                            //             title="Upload POD"
                            //             disabled={params.data.epod_uploaded === 1}
                            //         >
                            //             <i
                            //                 className="icofont icofont-upload-alt f15"
                            //                 style={{
                            //                     fontSize: "15px",
                            //                     color: "#3a3fa6",
                            //                     lineHeight: "1",       
                            //                 }}
                            //             ></i>
                            //         </button>
                            //     );
                            // }
                            
                            // },
                            // {
                            //     headerName: "Force Closure Reason",
                            //     field: "force_closure_reason",
                            //     width: 160,
                            //     hide:status!==6,
                            //     filter: "agSetColumnFilter",
                            //     cellRenderer: '', resizable: true
                            // },
                            // {
                            //     headerName: "Upload POD",
                            //     field: "upload_pod",
                            //     width: 200,
                            //     filter: false,
                            //     hide:tabName.value !=='all',
                            //     cellRendererSelector: function (param) {
                            //         try {
                            //             // console.log(param,"subbbbblegggg");
                            //             return {
                            //                 component: UploadFTLPod,
                            //                 params: {
                            //                     onClickUploadPOD: onClickUploadPOD,
                            //                 }
                            //             }
                            //         } catch (err) {
                            //             console.log(err);
                            //         }
                            //     }
                                // cellRenderer: (params) => {
                                //     const handleClick = (e) => {
                                //         e.stopPropagation();
                                //         onClickUploadPOD(params);  
                                //     };
                                //     console.log(params,"disballelee");
                                //     return (
                                //         <button
                                //             onClick={handleClick}
                                //             // className="btn btn-info"
                                //             // style={{
                                //             //     padding: "8px 10px",
                                //             //     fontSize: "13px",
                                //             //     margin: "0",
                                //             //     display: "flex",           
                                //             //     alignItems: "center",      
                                //             //     justifyContent: "center",  
                                //             //     height: "100%",            
                                //             //     boxSizing: "border-box"    
                                //             // }}
                                //             style={{border:"none"}}
                                //             title="Upload POD"
                                //             disabled={params.data.epod_uploaded === 1}
                                //         >
                                //             <i
                                //                 className="icofont icofont-upload-alt f15"
                                //                 style={{
                                //                     fontSize: "15px",
                                //                     color: "#3a3fa6",
                                //                     lineHeight: "1",       
                                //                 }}
                                //             ></i>
                                //         </button>
                                //     );
                                // }
                                
                                // },
                               
                                
                            
                    ];
                    columnDefs.forEach(e => {
                        e.cellClass = function (params) {
                            if (params.data && params.data.hasOwnProperty(`${e.field}_modified`) && params.data[`${e.field}_modified`] === 1) {
                                return "bgColorDangerDark"; // Apply your custom CSS class here
                            } else {
                                return null;
                            }
                        };
                    });
                    setdetailCellRendererParams({
                        detailGridOptions: {
                            columnDefs: columnDefs
                            // defaultColDef: {
                            //     flex: 3,
                            // },
                        },
                        getDetailRowData: (params) => {
                            // params.successCallback(resp.data);
                            params.successCallback(resp.data.courier_consignments);
                        },
                    })
                // }
            // })
            // .catch(err => {
            //     console.log(err);
            // })
        }})}
        const changeFileHandlerForPod = (event) => {
            try {

                const files = event.target.files;
                
        
                if (files && files.length > 0) {
                    const file = files[0];
                    const fileType = file.type;
        
                    // Define the allowed MIME types (PDF and images)
                    const validTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/gif', 'image/bmp', 'image/webp'];
        
                    // Check if the file type is valid
                    if (!validTypes.includes(fileType)) {
                        alert("Please select a valid PDF or image file.");
                        setCustomerDocument1(null);
                        setEpodDoc(null);
                        document.getElementById("epodDoc").value = ""; // Clear the input
                        return; // Exit the function
                    }
        
                    // If the file is valid, proceed to set the document
                    setCustomerDocument1(files);
                    setEpodDoc(files[0]);
        
                    // Optional: If you want to add a size limit
                    // if (file.size <= 102400) {
                    //     setCustomerDocument1(files);
                    //     setEpodDoc(file);
                    // } else {
                    //     setShow(true);
                    //     setBasicTitle("File size exceeds 100KB");
                    //     setBasicType("info");
                    //     setCustomerDocument1(null);
                    //     document.getElementById("customer_lr_doc").value = "";
                    // }
                }
            } catch (e) {
                setCustomerDocument1(null);
                const fileInput = document.getElementById("customer_document_1");
                if (fileInput) {
                    fileInput.value = "";
                } else {
                    console.error("Element with ID 'customer_document_1' not found");
                }
        
                // document.getElementById("customer_document_1").value = "";
            }
        };                  
        const onCloseSliderDiv = () => {
                        // Clear the state for all inputs to reset their values
                        setDamage(0);            // Reset damage input
                        setExcess(0);            // Reset excess input
                        setPilferage(0);         // Reset pilferage input
                        setShort(0);             // Reset short input
                        setPodRemarks("");       // Reset remarks textarea
                    
                        // Clear file input fields via DOM manipulation as they are uncontrolled components
                        if (document.getElementById("epodDoc")) {
                            document.getElementById("epodDoc").value = "";
                        }
                        if (document.getElementById("File")) {
                            document.getElementById("File").value = "";
                        }
                        if (document.getElementById("podDoc")) {
                            document.getElementById("podDoc").value = "";
                        }
                    
                        // Reset other states related to the UI
                        setSliderShow(''); 
                        setOverlay('show-n'); 
                        setManualUploadSlider('show-n');
                        setBulkMarkDeliverSlide('show-n');
                        setShipmentSlider('show-n');
                        setShipmentCsvContent([]); 
                        setShipmentFile(''); 
                        setBulkSliderShow('show-n');
                        setSliderScanShow('show-n');
                        setSliderSupportShow('show-n');
                        setSelectedRowNodes([]); 
                        setLoadShow('show-n'); 
                        setMultiplePodDocs([]); 
                        setDeliveredDate1(""); 
                        setUpdateRowSlider("");
};
                    

const onCloseSliderDiv1 = () => {
    setSliderShow1('');
    setOverlay('show-n');
    setDocRemarks("")
    setSelectedTab("loading")
    document.getElementById("uploadDoc").value = "";
    document.getElementById("File").value = "";
    setLoadShow('show-n');
    setPodRemarks("");
};
const onShowUploadDoc = (rownode) => {
    if(rownode.data.status ===4){
        setSelectedDoc(true)
    }
    setSliderShow1("slider-translate-30p")
    setOverlay("show-m")
    setRownode([rownode.data])

}

const onShowTransitData = (params) => {
    let query = {
        truck_no: params.data.truck_no,
        consignment_code: params.data.consignment_code,
        consignee_code: params.data.consignee_code
    }
    redirectURL.post('/consignments/transitdelay', query)
        .then(resp => {
            if (resp.data?.length > 0) {
                params.node.setExpanded(!params.node.expanded)
                setdetailCellRendererParams({
                    detailGridOptions: {
                        columnDefs: transitdelaycols,
                        defaultColDef: {
                        },
                    },
                    getDetailRowData: (params) => {
                        params.successCallback(resp.data);
                    },
                })
            }
        })
        .catch(err => {
            console.log(err);
        })
}
const onShowStoppagesData = (params) => {
    
    let query = {
        truck_no: params.data.truck_no,
        consignment_code: params.data.consignment_code
    }
    redirectURL.post('/consignments/enroutes', query)
        .then(resp => {
            if (resp.data?.length > 0) {
                params.node.setExpanded(!params.node.expanded)
                setdetailCellRendererParams({
                    detailGridOptions: {
                        columnDefs: stoppagescols,
                        defaultColDef: {
                            flex: 1,
                        },
                    },
                    getDetailRowData: (params) => {
                        params.successCallback(resp.data);
                    },
                })
            }
        })
        .catch(err => {
            console.log(err);
        })
}
const onShowNoGPSData = (params) => {
    params.node.setExpanded(!params.node.expanded)
    setdetailCellRendererParams({
        detailGridOptions: {
            columnDefs: nogpscols,
            defaultColDef: {
                flex: 1,
            },
        },
        getDetailRowData: (params) => {
            let nogpsrecords = []
            redirectURL.post('/consignments/nogpsdata', {
                consignment_code: params.data.consignment_code,
                truck_no: params.data.truck_no
            })
                .then(async (response) => {
                    nogpsrecords = response.data;
                    params.successCallback(nogpsrecords);

                });
        },
    })
}
const uploaddocSubmission=async(rownode)=>{
    if (rownode.length > 0) { 
        const rowid = rownode[0]._id;
        const rownodes = rownode;
        const formData = new FormData();
        uploadDoc?.forEach((file) => {
            formData.append("uploadDocs", file);
        });      
        if (uploadType ==="loading"){
            formData.append("loadingdocremarks", loadingdocremarks);
        }else if(uploadType ==="unloading"){
            formData.append("unloadingdocremarks", unloadingdocremarks);
        }else{
            formData.append("docremarks", docremarks);
        }
             
        formData.append("rowid", rowid);
        formData.append("rownodes", JSON.stringify(rownodes));
        formData.append("tracking_type", rownode[0].tracking_type)

        await redirectURL.post("/saveuploaddocument", formData, {
            headers: {
                'content-type': 'multipart/form-data',
                'Access-Control-Allow-Origin': "*",
                'Access-Control-Allow-Methods': 'POST',
                'Access-Control-Allow-Headers': 'Origin, Content-Type'
            }
        })
            .then((resp) => {
                if (resp.data.status === 'success') {
                    document.getElementById("formDocument").reset();
                    // setRowNode([]);
                    setShow(true);
                    setUploadDoc([]);
                    // setSlider('show-n');
                    setTitle("Success.");
                    setType("success");
                    setDocRemarks("");
                    setSliderShow1("");
                    setOverlay("show-n");
                    // setLoadshow('show-n');
                // window.location.reload();
                }
            })
            .catch((error) => {
                console.error("Error uploading document:", error);
                // Handle error here, e.g., show a message
            });
    }
}


const uploadDocument1 = async(event) => {
    event.preventDefault();
    if(rownode[0].tracking_type === 'FTL'){
        if (selectedTab === "loading" ? (loadingdocremarks === "") : (unloadingdocremarks === "")) {
            setShow(true);
            setType("warning");
            setTitle("Please enter remarks");
            setDocRemarks("");
            // setUploadDoc([]);
        }else{
            uploaddocSubmission(rownode)
        }

    }else{
        if (docremarks === "") {
            setShow(true);
            setType("warning");
            setTitle("Please enter remarks");
            setDocRemarks("");
            // setUploadDoc([]);
        } else{
            uploaddocSubmission(rownode)
        }
    }
    
    
};
    const onClickActive = (e) => {
       
        setOrginalDetailsForEdit(e.data)
        var reqDetail = {
            consignment_code: e.data.shipment_id,
            lr_no: e.data.lr_no,
            tracking_type: e.data.tracking_type
        }
        if((e.data.tracking_type).toLowerCase() ==="ptl"){
            reqDetail = {
                consignment_code: e.data.consignment_code,
                lr_no: e.data.lr_no,
                tracking_type: e.data.tracking_type
            }
           
        }
        let selectedSource = sourceList.filter((k)=> k.label.toLowerCase() === e.data.consigner_city.toLowerCase())
        // let selectedSource = e.data.source_city
        redirectURL.post("/consignments/getDropPointDetailsForShipment", reqDetail)
        .then((response) => {
            if (response.data.status == 'Success') {
                
                
                setConsignmentUidForTruckLevel(response.data.data[0].consignment_uid)
                let drpPoint = response.data.data.slice(1)
                let selectedKeys = drpPoint.map(item => ({
                    consignee_name: item.consignee_name,
                    lr_no: item.lr_no,
                    invoice_no: item.invoice_no,
                    consignee_pincode: item.consignee_pincode,
                    consignee_city: item.consignee_city,
                    consignment_uid: item?.consignment_uid??""
                }));
                setDropPointArr(selectedKeys)
                const newCvArray = response.data.data.map((item) => {
                    return {
                      lr_no: item.lr_no,
                      invoice_no: item.invoice_no,
                      consignee_name: item.consignee_name ? item.consignee_name : "",
                      no_of_boxes: "",
                      destination_pincode: item.consignee_pincode ?? "",
                      destination_city: item.consignee_city ?? "",
                      eway_bill_no: "",
                      customer_mail_id: "",
                      other_consignee_name: item.other_consignee ?? "",
                      other_consignee_pincode: item.other_consignee_pincode ?? "",
                      other_consignee_city: item.other_consignee_city ?? "",
                      consignment_uid: item.consignment_uid?? "",
                    };
                  }).filter(item => item !== null);
                  if (newCvArray.length === 0) {
                    console.log("newCvArray is empty or not populated as expected.");
                } else {
                    console.log(newCvArray, "newCvArray contents:");
                }
                  console.log(newCvArray, "newCvArray");
                  
                    let x = newCvArray.splice(0,1)

                    setManualTripUploadDetails(newCvArray);
                    // setEditDropPoints(x)
            }
            else {
                console.log("error fro dropoint");
            }
        })
        .catch(function (e) {
            console.log("Error ", e)
        })  
        let consignee_details_arr = [
            
        ]
        setselected_row(e.data);
        // Nneeded
        setmanualUploadDetails1((prev) => ({
                ...prev,
                invoice_no: e.data.invoice_no,
                consignee_name: e.data.customer_name,
                consignee_city: e.data.consignee_city,
                consignee_state: e.data.consignee_state,
                consignee_pincode: e.data.consignee_pincode,
                total_weight: e.data.total_weight
            }
        ))
        setmanualUploadDetails((prev) => ({
                ...prev,
                invoice_no: e.data.invoice_no,
                lr_no: e.data.lr_no}
        ))
        setShipmentId(e.data.shipment_id)
        setManualUpdateConsignment((prev) => {
            // const isOtherConsignee = !e.data.consignee_name || e.data.consignee_name.trim() === '';
        
            return {
                ...prev,
                lr_no: e.data.lr_no,
                invoice_no: e.data.invoice_no,
                driver_mobile_no: e.data.driver_mobile_no,
                truck_no: e.data.truck_no,
                truck_seal_no: e.data.truck_seal_no,
                entity: { label: e.data.truck_seal_entity, value: e.data.truck_seal_entity },
                vehicle_type: { label: e.data.truck_type, value: e.data.truck_type },
                courier_partner: { label: e.data.transporter_name, value: e.data.transporter_name },
                vehicle_capacity: e.data.vehicle_capacity,
                eway_bill_expiry_date: e.data.eway_bill_expiry_date,
                no_of_boxes: e.data.no_of_boxes,
                movement_type: { label: e.data.movement_type, value: e.data.movement_type },
                // consignee_name: isOtherConsignee ? '' : { label: e.data.consignee_name, value: e.data.consignee_name },
                consignee_name: { label: e.data.customer_name, value: e.data.customer_name },
                destination_pincode: e.data.consignee_pincode,
                destination_city: e.data.consignee_city,
                other_consignee_name: e.data.other_consignee ,
                other_destination_pincode: e.data.other_consignee_pincode ,
                other_destination_city:  e.data.other_consignee_city,
                other_transporter: "",
                other_vehicle_capacity: "",
                other_source: "",
                source: {label:e.data.consigner_city, value:e.data.consigner_city},
                other_vehicle_type: "",
            };
        });
        let intialConsignmentConsigneeDetails = [];
        // if (e.data.consignee_name && e.data.consignee_name.value === "Other") {
        //     intialConsignmentConsigneeDetails.push({
        //       consignee_name: e.data.other_consignee_name,
        //       destination_city: e.data.other_destination_city,
        //       destination_pincode: e.data.other_destination_pincode
        //     });
        // } else {
            intialConsignmentConsigneeDetails.push({
              consignee_name: e.data.consignee_name,
              destination_city: e.data.consignee_city,
              destination_pincode: e.data.consignee_pincode
            });
        // }
        


        setConsigneesForTrip(intialConsignmentConsigneeDetails);

        if(e.data.tracking_type === "FTL"){
            setshowAddForm3('slider-translate-30p');
        } else {
            // setshowAddForm("slider-translate-30p");
            setshowAddForm3('slider-translate-30p');
        }
        setOverlay("show-m");
    };
    const onClickEditLogs = (e) => {
       
        // setOrginalDetailsForEdit(e.data)
        var params = {
            shipment_id: e.data.shipment_id,
        }
       
        // let selectedSource = e.data.source_city
        redirectURL.post("/consignments/getEditLogsData", params)
        .then((response) => {
            if (response.data.status == 'Success') {
                setEditLogsData(response.data.edit_logs_data); // Store all logs
                setFilteredLog(response.data.edit_logs_data[0]); // Default to first log
                setIsEditLogsModalOpen(true);
                
            }
        })
        .catch(function (e) {
            console.log("Error ", e)
        })  
      

        // if(e.data.tracking_type === "FTL"){
        //     setshowAddForm3('slider-translate-30p');
        // } else {
        //     // setshowAddForm("slider-translate-30p");
        //     setshowAddForm3('slider-translate-30p');
        // }
        setOverlay("show-m");
    };
    
    const updateLrs = () => {
               
        var isValid = selectedRows.every(row=> row.tracking_type === selectedRows[0].tracking_type);
        var isValid1 = selectedRows.every(row=> row.transporter_name === selectedRows[0].transporter_name);
        var isValid2 = selectedRows.every(row=> row.truck_no === selectedRows[0].truck_no);
        var trackingTypeLR = selectedRows[0].tracking_type;
        var data = selectedRows[0];
        setLRTrackingType(trackingTypeLR)
        var timeString;
        if (data.dispatch_date && moment(data.dispatch_date, moment.ISO_8601, true).isValid()) {
            var date1 = moment(data.dispatch_date);
            var adjustedTime1 = date1.subtract(5, "hours").subtract(30, "minutes");
            var time1 = adjustedTime1.toDate();
            var timeString = time1.toDateString();
        
        } 
        const date = new Date(timeString);
        
        // const date = moment(data.dispatch_date).utcOffset("+05:30");
        // console.log("test",moment(data.dispatch_date).format("YYYY-MM-DD HH:mm:ss"), new Date(moment(data.dispatch_date).format("YYYY-MM-DD HH:mm:ss")))

      
        setManualUpdateLRConsignment((prev)=> {
            
            return {
            ...prev,
            driver_mobile_no: data.driver_mobile_no,
            truck_no: data.truck_no,
            entity: {label: data.truck_seal_entity, value: data.truck_seal_entity },
            fuel_type:{label:data.fuel_type, value:data.fuel_type},
            vehicle_type: {label:data.truck_type, value:data.truck_type},
            courier_partner:{label:data.transporter_name, value:data.transporter_name},
            no_of_boxes:data.no_of_boxes ,
            tracking_type:data.tracking_type,
            total_cbm:data.total_cbm,
            total_weight:data.total_weight,
            dispatch_time:time1,
            tracking_type_mutliple: {label:"", value:""},

        }
    }
    )
        

        if(!isValid){
            setShow(true)
            setTitle("Please select the same tracking mode consignments")
            setType("danger")

        }
        if(!isValid1){
            setShow(true)
            setTitle("Please select the same transporter consignments")
            setType("danger")

        }
        if(!isValid2){
            setShow(true)
            setTitle("Please select the same truck no consignments")
            setType("danger")

        }

        else{
            const x = selectedRows.map((e)=> ({label:e.invoice_no, value: e.invoice_no}))

            const y = selectedRows.flatMap((e)=> (e.consignment_code))
            const z = selectedRows.map((e)=> ({label:e.shipment_id, value:e.shipment_id}))
            
            
            
            var transporterName = selectedRows.every(row => {
                return row.transporter_name === "" || typeof row.transporter_name === 'undefined';
            });  
            
            setTransporterValidation(transporterName);
            var entity = selectedRows.every(row => row.truck_seal_entity === "" || typeof row.truck_seal_entity === "undefined");
            setEntityValidation(entity);

            var noOfBoxes = selectedRows.every(row => row.no_of_boxes === "" || typeof row.no_of_boxes === "undefined");
            setNoOfBoxesValidation(noOfBoxes);

            var totalCBM = selectedRows.every(row => row.total_cbm === "" || typeof row.total_cbm === "undefined");
            setTotalCBMValidation(totalCBM);

            var totalWeight = selectedRows.every(row => row.total_weight === "" || typeof row.total_weight === "undefined");
            setTotalWeightValidation(totalWeight);

            var dispatchDate = selectedRows.every(row => row.dispatch_date === "" || typeof row.dispatch_date === "undefined");
            setDispatchdateValidation(dispatchDate);

            var mode = selectedRows.every(row => row.shipment_mode === "" || typeof row.shipment_mode === "undefined");
            setModeValidation(mode);

            var multipleModes = selectedRows.every(row => (row.shipment_mode).length>0);
            setModeValidation(mode);

            var fuelType = selectedRows.every(row => row.fuel_type === "" || typeof row.fuel_type === "undefined");
            setFuelValidation(fuelType);


            var invoiceType = selectedRows.every(row => row.invoice_type === "" || typeof row.invoice_type === "undefined");
            setInvoiceTypeValidation(invoiceType);

            var driverNoValidation = selectedRows.every(row => row.driver_mobile_no === "" || typeof row.driver_mobile_no === "undefined");
            setDriverNoValidation(driverNoValidation);

            var truckNo = selectedRows.every(row => row.truck_no === "" || typeof row.truck_no === "undefined");
            setTruckNoValidation(truckNo);

            var vehicleType = selectedRows.every(row => row.truck_type === "" || typeof row.truck_type === "undefined");
            setVehicleTypeValidation(vehicleType);
            ;




            
            setShowUpdateLrForm('slider-translate-30p');
            setOverlay('show-m'); 
    
            setConsignmentCodeForLRUpdate(y)
            setSelectedShipments(z)
            
            setSelectInvoicesToUpdate(x);
        }

       
    }
    const onClickHideAll = () => {
        setshowAddForm2("")
        // setManualInTransitStatusUpdate.dispatch_time("")
        setOpenMap({
            sliderRouteTranslate: "",
            showDiv: 'show-n',
            mapinfo: [],
            dealer: "",
            lr_no: "",
            maptruckno: "",
            geofence_coordinates: [],
            parking_coordinates: [],
            routeTruck: { "truck_no": '', "startTime": '', "endTime": '' },
            loadshow: 'show-n',
            sidebarSubHeader: "",
            overly: 'show-m',
            rownode: {},
            leg_no: 0,
            tolls: []
        })
        setDselected_row({})        
        document.getElementById("uploadDoc").value = "";
        // document.getElementById("File").value = "";
        setSliderShow1("")
        setSliderShow("");
        setDocRemarks("")
        setshowAddForm2("");
        setInvoiceValid(false)
        setForm2Details({
            event_status: statusOrderPtl,
            selectedStatus: {value: 'In Transit', label: 'In Transit'},
            selectedPincode: {value: '', label: ''},
            event_location: "",
            remark: "",
            reason_for_delay:"",
            delivered_date:'',
            errorMessage:''
        })
        setshowAddForm("")
        setshowAddForm3("")
        setErrorMssge("");
        setEnableSourceField(false);
        
        setShowUpdateLrForm("")
        setSliderCreateConsignmentTranslate("")
        setBulkUploadModal({
            overly: "show-n",
            bulkPrioritySlide: ""
        })
        setOverlay("show-n")
        setLoadShow("show-n")
        setSliderCreateConsignmentTranslate("")
        setManualTripUploadDetails([])
        setManualUpdateConsignment({
            driver_number: '',
            source: "",
            truck_no: "",
            truck_seal_no: "",
            vehicle_type: "",
            courier_partner:"",
            vehicle_capacity: "",
            consignee_name: "",
            lr_no: "",
            invoice_no: "",
            no_of_boxes: "",
            destination_pincode: "",
            destination_city:""
          })
        document.getElementById("epodDoc").value = "";
        setDamage("")
        setExcess("")
        setPilferage("")
        setShort("")
        setPodRemarks("")
        document.getElementById("formPOD").reset();
        setFormData({
            driver_mobile_no:'',
            source:'',
            truck_no:'',
            truck_seal_no:'',
            entity:'',
            vehicle_type:{label:'', value:''},
            courier_partner:{label:'', value:''},
            eway_bill_expiry_date:'',
            vehicle_capacity:'',
            consignee_name:'',
            movement_type:'',
            lr_no:'',
            invoice_no:[],
            invoice_no_str:"",

            number_of_boxes:'',
            destination_pincode:'',
            destination_city:'',
            show: false,
            basicType: '',
            basicTitle: '',
            sliderCreateConsignmentTranslate: '',
            loadshow: 'show-n',
            overly: 'show-n',
        })
    }
    const closeForceCloseModal = (e) => {
        setForcecloseModal(false)
        setReasonForceClose('')
        setRownode([])
    }

    const onShowForceCloseModal = (e) => {
        setForcecloseModal(true)
        setRownode(e)
        setReasonForceClose('')
        setReasonForCancellation("");
        let query = {
            truck_no: e.truck_no,
            shipment_id: e.shipment_id,
        }
        redirectURL.post('/consignments/getShipmentDetails', query)
        .then(resp => {
            if (resp.data.consignments?.length > 0) {
                var records = resp.data.consignments

            const invoiceNos =    records.map(each => ({
                    label:each.invoice_no,
                    value: each.invoice_no
            }))
            
            setInvoiceNoList(invoiceNos)
            }})
        
        const filteredLrOptions = lrNoOptions.filter(m => {
            return m.label !== "undefined" && m.value === e.data.lr_no;
        });
        setLrOptions(filteredLrOptions)
    }

    const saveGrid = async (e) => {
        let coloumnState = columnApiConsignments.current.getColumnState()
        let temp;
        temp = await saveGridLayout(user.email, "cancelled_consignments", coloumnState)

        
        if (temp.data.status == "success") {
            setShow(true)
            setTitle("Save grid successfully updated")
            setType("success")
            reloadPage.current = true
        }
        else {
            setShow(true)
            setTitle("Failed to update grid")
            setType("danger")
        }
    }

    const resetGrid = async (e) => {
        let coloumnState = []
        let temp;
        temp = await saveGridLayout(user.email, "cancelled_consignments", coloumnState)

             
        if (temp.data.status == "success") {
            setShow(true)
            setTitle("Reset grid successfully updated")
            setType("success")
            reloadPage.current = true
        }
        else {
            setShow(true)
            setTitle("Failed to update grid")
            setType("danger")
        }
    }
    
    // deselect all rows
    const deselectAllRows = () => {
        if (agGridRef.current && agGridRef.current.api) {
            agGridRef.current.api.deselectAll();
        }
    };

    const onClickHideLrUpdateForm = () => {
        setShowUpdateLrForm("");
        setOverlay("show-n");
        setSelectedRows([]);
        setSelectInvoicesToUpdate([]);
        deselectAllRows();
        setShowLrUpdateBtn(false);
        setUpdateLrNo("")
        setError1("")
        setManualUpdateLRConsignment({
            lr_no: "",
            invoice_no: "",
            driver_mobile_no: '',
            truck_no: "",
            entity: {label:"", value:""},
            fuel_type:{label:"", value:""},
            vehicle_type: {label:"", value:""},
            other_vehicle_type:"",
            courier_partner:{label:"", value:""},
            other_transporter:{label:"", value:""},
            no_of_boxes: "",
            tracking_type:"",
            total_cbm:"",
            total_weight:"",
            dispatch_time:"",
            tracking_type_mutliple: {label:"", value:""},

        })
    }
    
    const cancelUpdateLrNo = () => {
        setShowUpdateLrForm("");
        setOverlay("show-n");
        setSelectedRows([]);
        setSelectInvoicesToUpdate([]);
        deselectAllRows();
        setShowLrUpdateBtn(false);
        setUpdateLrNo("")
    }
    const viewTypeChange=(e)=>{
        
        setSearchViewType(e)

        setTimeout(async () => {

            if(e.value==="LR"){
                
                await columnApiConsignments.current.applyColumnState({
                
                    state: gridColumnState,
                    applyOrder: true,
                })
            }else{
                await columnApiConsignments.current.applyColumnState({
                
                    state: gridColumnState1,
                    applyOrder: true,
                })
            }
            
        }, 1500);
    }
    
    const onSubmitLrUpdateForm = (e) => {
        e.preventDefault()
        deselectAllRows();
        const extractedInvoices = selectedInvoicetoUpdateLr.map(e => e.value)
        const extractedShipmentIds = selectedShipments.map(e=> e.value)
        
        var lrNoUpdate =showAddForm === "slider-translate-30p"? manualUploadDetails.lr_no :updatelrNo.trim();
        var data = {
            invoice_no: showAddForm === "slider-translate-30p"? [manualUploadDetails.invoice_no] :extractedInvoices,
            shipment_id: extractedShipmentIds.length> 0 ? extractedShipmentIds:""
            // consignment_code: consignmentCodeForLRUpdate
        }
        // data.invoice_no = JSON.stringify(data.invoice_no);
        // data.shipment_id = JSON.stringify(data.shipment_id);
        var fieldsCheck=true;
        var fieldsCheck1=true;
        
        const mandatoryCheck1 =  updatelrNo !=="" && extractedInvoices.length>0 && manualUpdateLRConsignment.courier_partner?.value !=="" && 
        manualUpdateLRConsignment.tracking_type !=="" && manualUpdateLRConsignment.dispatch_time !=="" && manualUpdateLRConsignment.fuel_type?.value !==""

            
            
        var mandatoryCheck= false;
        if(mandatoryCheck1){
            
            if( manualUpdateLRConsignment.tracking_type==="FTL" && manualUpdateLRConsignment.truck_no){
                mandatoryCheck= true
            }else if(manualUpdateLRConsignment.tracking_type==="PTL"){

                mandatoryCheck= true
            }
        }else{
            mandatoryCheck= false
        }
        if(transporterValidation){
            if(
                (manualUpdateLRConsignment.courier_partner.value==="") 
                && ((driverNoValidation && manualUpdateLRConsignment.driver_mobile_no !=="") || (fuelValidation && manualUpdateLRConsignment.fuel_type ==="") || (truckNoValidation && manualUpdateLRConsignment.truck_no !=="") || (entityValidation && manualUpdateLRConsignment.entity.value !=="") || (vehicleTypeValidation && manualUpdateLRConsignment.vehicle_type.value !=="") || (noOfBoxesValidation && manualUpdateLRConsignment.no_of_boxes !=="") ) ){
                fieldsCheck=false;
                fieldsCheck1=false;

            }else if(lrNoUpdate!==""){
                if(manualUpdateLRConsignment.courier_partner.value ===""){

                    fieldsCheck=false;
                }else{
                    
                    fieldsCheck=true;
                }
            }else if (lrNoUpdate ==="" && ((driverNoValidation && manualUpdateLRConsignment.driver_mobile_no ==="") || (fuelValidation && manualUpdateLRConsignment.fuel_type ==="") || (truckNoValidation && manualUpdateLRConsignment.truck_no ==="") || (entityValidation && manualUpdateLRConsignment.entity.value ==="") || (vehicleTypeValidation && manualUpdateLRConsignment.vehicle_type.value ==="") || (noOfBoxesValidation && manualUpdateLRConsignment.no_of_boxes ==="") )){
                fieldsCheck=true;
            }else if((driverNoValidation && manualUpdateLRConsignment.driver_mobile_no ==="") || (truckNoValidation && manualUpdateLRConsignment.truck_no ==="") || (fuelValidation && manualUpdateLRConsignment.fuel_type ==="") || (entityValidation && manualUpdateLRConsignment.entity.value ==="") || (vehicleTypeValidation && manualUpdateLRConsignment.vehicle_type.value ==="") || (noOfBoxesValidation && manualUpdateLRConsignment.no_of_boxes ==="")){
                fieldsCheck=false;
                fieldsCheck1=false;
            }
        }
        // const invoice_time1 = moment(selectedRows[0].invoice_time);  // Parse the date from your data source
        // const adjustedTime = invoice_time1.subtract(5, 'hours').subtract(30, 'minutes');
        // const invoice_time= adjustedTime.toDate()

        // const selectedDate = new Date(manualUpdateLRConsignment?.dispatch_time);  // The date you're passing to the function
    
        // // Log for debugging
        // console.log(selectedDate, invoice_time, "selectedDate and invoice_time");
    
        // // Check if the selected date is the same day as the invoice date
        // const isSameDay = selectedDate.toDateString() === invoice_time.toDateString();
        
        // var dispatchTime;
        // if (isSameDay) {
        //     // If the selected date is the same day, ensure the time is greater than or equal to the invoice time
        //     if (selectedDate >= invoice_time) {
        //         // If selected date and time is greater than or equal to invoice time
        //         dispatchTime=manualInTransitStatusUpdate.dispatch_time
        //     } else {
        //         // If selected time is earlier than invoice time
        //         setShow(true);
        //         setTitle("Dispatch time should be greater than or equal to invoice time");
        //         setType("danger");
        //     }
        // } else if (selectedDate > invoice_time) {
        //     // If the selected date is later than the invoice date, it's valid
        //     dispatchTime=manualInTransitStatusUpdate.dispatch_time

        // } else {
        //     // If the selected date is earlier than the invoice date, it's invalid
        //     setShow(true);
        //     setTitle("Dispatch date should be greater than invoice date");
        //     setType("danger");
        //     return;
        // }        
        
        
        var updateData={
            lr_no: showAddForm === "slider-translate-30p"? manualUploadDetails.lr_no :updatelrNo.trim(),

            driver_mobile_no: manualUpdateLRConsignment?.driver_mobile_no || '',
            truck_no: manualUpdateLRConsignment?.truck_no || "",
            entity: manualUpdateLRConsignment?.entity.value || {label: "", value: ""},
            vehicle_type: manualUpdateLRConsignment?.vehicle_type.value || {label: "", value: ""},
            // other_vehicle_type: manualUpdateLRConsignment?.other_vehicle_type || "",
            transporter_name: manualUpdateLRConsignment?.courier_partner.value || {label: "", value: ""},
            fuel_type:manualUpdateLRConsignment?.fuel_type.value || {label:"", value:""},
            // other_transporter: manualUpdateLRConsignment?.other_transporter || {label: "", value: ""},
            no_of_boxes: manualUpdateLRConsignment?.no_of_boxes || "",
            tracking_type: Array.isArray(manualUpdateLRConsignment?.tracking_type) 
            ? manualUpdateLRConsignment?.tracking_type_mutliple.value 
            : manualUpdateLRConsignment?.tracking_type,
            // total_cbm: manualUpdateLRConsignment?.total_cbm || "",
            // total_weight: manualUpdateLRConsignment?.total_weight || "",
            dispatch_time: manualUpdateLRConsignment?.dispatch_time || ""
        }
        if(updateData.vehicle_type === "Others"){
            updateData.vehicle_type = manualUpdateLRConsignment.other_vehicle_type
        }

        

        var tracking_type1 = tptRecords.filter(e=> e.transporter_name===updateData.transporter_name).map(e=> e.transporter_type)
        updateData.tracking_type= tracking_type1[0]
        


        Object.keys(updateData).forEach(key => {
            if (updateData[key] && (typeof updateData[key] === 'object' ? updateData[key].value !== "" : updateData[key] !== "")) {
                data[key] = updateData[key];
            }
        }) 

        
        
        if(mandatoryCheck){
            // if(fieldsCheck){
                // if(showAddForm === "slider-translate-30p" || ((invoiceSelected && invoiceSelected.value!=''))){
                    redirectURL.post('/consignments/updateLRno', data).then((resp) => {
                        if (resp.data.status == 'Success') {
                            setTitle("Data has been successfully updated!");
                            setShow(true)
                            if(selectedRows.length>1){
                                setTitle(`Data has been successfully updated!`);
                            } else {
                                setTitle("Data has been successfully updated!");
                            }
                            
                            setType("success");
                            setLoadShow('show-n');
                            setOverlay('show-n');
                            setShowUpdateLrForm('');
                            deselectAllRows();
                            setUpdateLrNo('');
                            setSelectInvoicesToUpdate([]);
                            setError1("");
                            setManualUpdateLRConsignment({
                                lr_no: "",
                                invoice_no: "",
                                driver_mobile_no: '',
                                truck_no: "",
                                entity: {label:"", value:""},
                                vehicle_type: {label:"", value:""},
                                fuel_type:{label:"", value:""},
                                other_vehicle_type:"",
                                courier_partner:{label:"", value:""},
                                other_transporter:{label:"", value:""},
                                no_of_boxes: "",
                                tracking_type:"",
                                tracking_type_mutliple: {label:"", value:""},
                                total_cbm:"",
                                total_weight:"",
                                dispatch_time:""
                            })
                            
                            // window.location.reload();
                        }
                        else{
                            setShow(true)
                            setTitle("Please Upload Valid Details")
                            setType("danger")
                            setLoadShow('show-n')
                            setOverlay('show-n');
                            // setShowUpdateLrForm('');
                            // deselectAllRows();
                            // setUpdateLrNo('');
                            // setSelectInvoicesToUpdate([]);
                        }
                    })
                // }
                // else if(!invoiceSelected){
                //     setShow(true)
                //     setTitle("Please Selected Invoice")
                //     setType("danger")
                //     setLoadShow('show-n')
                //     setOverlay('show-n')
                // } 
                // else {
                //     setShow(true)
                //     setTitle("Please Enter Lr'no")
                //     setType("danger")
                //     setLoadShow('show-n')
                //     setOverlay('show-n')
                // }
            // }else{
            //     if(fieldsCheck1){
            //         setTitle("Please select transporter as LR No provided");
            //     }else{
            //         setTitle("Please select transporter first as relevant fields are provided");
            //     }
            //     setShow(true);
            //     setType("danger")
            // }
        }else{
            setShow(true)
            setTitle("Please fill all the mandatory field's")
            setType("danger")
            setLoadShow('show-n')
            setOverlay('show-n')
        }
        
       
        
       
        
        // setShowUpdateLrForm('');
        // deselectAllRows();
        // setUpdateLrNo('');
        // setSelectInvoicesToUpdate([]);
    }  
    
    
    function onSelectionChanged(params) {
        setTimeout(async () => {

            if(searchViewType.value ==="LR"){

                await columnApiConsignments.current.applyColumnState({
                    state: gridColumnState,
                    applyOrder: true,
                })           
             }else{
                await columnApiConsignments.current.applyColumnState({
                    state: gridColumnState1,
                    applyOrder: true,
                })
             }
           
        }, 1500);
        const selectedNodes = params.api.getSelectedNodes();
        const selectedData = selectedNodes.map(node => node.data);
        setSelectedRows(selectedData);
    };
    const formForceCloseHandler = (e) => {
        e.preventDefault()
        var consignemnt = rownode;
        var consignment_code = consignemnt.consignment_code;
        var truck_no = consignemnt.truck_no;
        var dept_code = "SNDG";
        var email = user?.email;
        var username = user?.username;
        var reqdata = {
            truck_no: rownode.data.truck_no,
            shipment_ids: JSON.stringify([rownode.data.shipment_id]),
            username: username,
            user_email: email,
            reasonforceclose: reasonForceClose,
        }
        if(reqdata.reasonforceclose.trim()===""){
            setShow(true)
            setTitle("Please Enter The Reason")
            setType("danger")
        } else {
            redirectURL.post("/consignments/updateConsignmentForceClose", reqdata)
                .then((response) => {
                    if (response.data.status == 'Success') {
                        setShow(true)
                        setTitle("Successfully Force Closed the consignment")
                        setType("success")
                        closeForceCloseModal()
                        reloadPage.current = true
                    }
                    else {
                        setShow(true)
                        setTitle("Failed to Force Close")
                        setType("danger")
                    }
                })
                .catch(function (e) {
                    console.log("Error ", e)
                })
        }

    }

    const handleStartDateChange = (date) => {
        if (endDate && date > endDate) {
            setShow(true)
            setTitle("To Date should be greater than From Date")
            setType("danger")
        } else {
            setStartDate(date)
        }
    };
    // async onClickShowShipmentLegs(params) {
	// 	console.log("params", params)
	// 	if (params != 0) {
	// 		var transitedelaydata = [];

	// 		await this.setState({

	// 			detailCellRendererParams: {
	// 				suppressRefresh: true,
	// 				detailGridOptions: {
	// 					headerHeight: 50,
	// 					columnDefs: [
	// 						{
	// 							headerName: "",
	// 							field: "legs_map",
	// 							colId: "legs_map",
	// 							width: 40,
	// 							pinned: 'left',
	// 							cellRenderer:function(params){
	// 								var htmloption = '<i class="icofont icofont-map-pins f25" style="padding:0 9px"></i>';
	// 								return htmloption;
	// 							} ,
	// 							filter: false, resizable: true
			
	// 						},
	// 						{
	// 							headerName: "Invoice No",
	// 							field: "invoice_no",
	// 							width: 140,
	// 							// cellClass: function (params) {
	// 							// 	if (params.data.transit_delay == 1) {
	// 							// 		return 'lightred';
	// 							// 	}
	// 							// 	else {
	// 							// 		return '';
	// 							// 	}

	// 							// }
	// 						},
	// 						{
	// 							headerName: "Consignment",
	// 							field: "consignment_code",
	// 							width: 140,
	// 							// cellClass: function (params) {
	// 							// 	if (params.data.transit_delay == 1) {
	// 							// 		return 'lightred';
	// 							// 	}
	// 							// 	else {
	// 							// 		return '';
	// 							// 	}

	// 							// }
	// 						},
	// 						{
	// 							headerName: "Original ETA",
	// 							field: "expected_eta",
	// 							width: 140,
	// 							valueGetter: function (params) {
	// 								return getHyphenDDMMMYYYYHHMM(params.data.expected_trip_end)
	// 							},
	// 							cellClass: function (params) {
	// 								if (params.data.transit_delay == 1) {
	// 									return 'lightred';
	// 								}
	// 								else {
	// 									return '';
	// 								}
	// 							},

	// 						},
	// 						{
	// 							headerName: "Revised ETA",
	// 							field: "revised_eta",
	// 							width: 140,
	// 							valueGetter: function (params) {
	// 								return getHyphenDDMMMYYYYHHMM(params.data.revised_trip_end)
	// 							},
	// 							cellClass: function (params) {
	// 								if (params.data.transit_delay == 1) {
	// 									return 'lightred';
	// 								}
	// 								else {
	// 									return '';
	// 								}

	// 							}
	// 						},
							
	// 						{
	// 							headerName: "Status",
	// 							field: "status",
	// 							width: 140,
	// 							// cellClass: function (params) {
	// 							// 	if (params.data.transit_delay == 1) {
	// 							// 		return 'lightred';
	// 							// 	}
	// 							// 	else {
	// 							// 		return '';
	// 							// 	}

	// 							// },
								

	// 							valueGetter: function (params) {
	// 								//console.log("GPS ", params.data.gps_data_available);
	// 								if (params.data.status == 1) {
	// 									return "Inside Plant"
	// 								}
	// 								else if (params.data.status == 2) {
	// 									return "In Transit"
	// 								}
	// 								else if (params.data.status == 3) {
	// 									return "Near Destination"
	// 								}
	// 								else if (params.data.status == 4) {
	// 									return "Reached Destination"
	// 								}

	// 								else if (params.data.status == 5) {
	// 									return "Left Destination"
	// 								}
	// 								else if (params.data.status == 6) {
	// 									return "Force Closed"
	// 								}
	// 								else if (params.data.status == 8) {
	// 									return "Crossdock"
	// 								}else if(params.data.status == 9){
	// 									return "Trip Completed"
	// 								}
	// 								else {
	// 									return ""
	// 								}

	// 							}
	// 						},
	// 						{
	// 							headerName: "Zone",
	// 							field: "zone",
	// 							width: 100,
	// 							// cellClass: function (params) {
	// 							// 	if (params.data.transit_delay == 1) {
	// 							// 		return 'lightred';
	// 							// 	}
	// 							// 	else {
	// 							// 		return '';
	// 							// 	}

	// 							// }
	// 						},
							
	// 						{
	// 							headerName: "Dealer Code",
	// 							field: "consignee_code",
	// 							width: 100,
	// 							// cellClass: function (params) {
	// 							// 	if (params.data.transit_delay == 1) {
	// 							// 		return 'lightred';
	// 							// 	}
	// 							// 	else {
	// 							// 		return '';
	// 							// 	}

	// 							// }
	// 						},
	// 						{
	// 							headerName: "Dealer City",
	// 							field: "consignee_city",
	// 							width: 120,
	// 							resizable: true,
	// 							// cellClass: function (params) {
	// 							// 	if (params.data.transit_delay == 1) {
	// 							// 		return 'lightred';
	// 							// 	}
	// 							// 	else {
	// 							// 		return '';
	// 							// 	}

	// 							// }
	// 						},

	// 						{
	// 							headerName: "Dealer Name",
	// 							field: "consignee_name",
	// 							width: 120,
	// 							resizable: true,
	// 							// cellClass: function (params) {
	// 							// 	if (params.data.transit_delay == 1) {
	// 							// 		return 'lightred';
	// 							// 	}
	// 							// 	else {
	// 							// 		return '';
	// 							// 	}

	// 							// }
	// 						},
	// 						{
	// 							headerName: "Trip Distance (KM)",
	// 							field: "distance_in_km",
	// 							width: 120,
	// 							resizable: true,
	// 							valueGetter: params =>{
	// 								if(params.data.distance_in_km>0){
	// 									return params.data.distance_in_km
	// 								}else{
	// 									return 0
	// 								}
	// 							}
	// 							,
	// 							// cellClass: function (params) {
	// 							// 	if (params.data.transit_delay == 1) {
	// 							// 		return 'lightred';
	// 							// 	}
	// 							// 	else {
	// 							// 		return '';
	// 							// 	}

	// 							// }
	// 						},
	// 						{
	// 							headerName: "Distance from Dealer (KM)",
	// 							field: "distance_from_dealer_location",
	// 							width: 160,
	// 							valueGetter: function (params) {
	// 								if (params.data.distance_from_dealer_location != '' && params.data.distance_from_dealer_location != null) {
	// 									return params.data.distance_from_dealer_location;
	// 								}
	// 								else {
	// 									return "";
	// 								}
	// 							},
	// 							// cellClass: function (params) {
	// 							// 	if (params.data.transit_delay == 1) {
	// 							// 		return 'lightred';
	// 							// 	}
	// 							// 	else {
	// 							// 		return '';
	// 							// 	}

	// 							// }
	// 						},
	// 						{
	// 							headerName: "Reached Destination At",
	// 							field: "first_dealer_reported",
	// 							width: 180,


	// 							//cellRenderer:'dateFormater',
	// 							valueGetter: function (params) {
	// 								if (params.data.status == 4 || params.data.status == 5 || params.data.status == 3) {
	// 									return getHyphenDDMMMYYYYHHMM(params.data.recent_dealer_reported);
	// 								}
	// 								else {
	// 									return "";
	// 								}

	// 							},
	// 							resizable: true,

	// 						},
	// 						{
	// 							headerName: "Left Destination At",
	// 							field: "left_dealer_marked",
	// 							width: 180,
	// 							//filter: "agDateColumnFilter",
	// 							//cellRenderer:'dateFormater',
	// 							valueGetter: function (params) {
	// 								if (params.data.status == 5) {
	// 									return getHyphenDDMMMYYYYHHMM(params.data.left_dealer_marked);
	// 								}
	// 								else {
	// 									return "";
	// 								}

	// 							},
	// 							resizable: true,

	// 						},
	// 						{
	// 							headerName: "Transit Time (Days)",
	// 							field: "transit_time",
	// 							width: 200,
	// 							filter: "agSetColumnFilter",
	// 							cellRenderer: '', resizable: true
	// 						},
							
	// 					],
	// 					overlayNoRowsTemplate: 'No rows to show',
	// 					onCellClicked:(leg_params) =>{
	// 						if(leg_params.colDef.field =="legs_map"){
	// 							if(leg_params.data.status==8){
	// 								this.setState({
	// 									show: true,
	// 									basicTitle: 'No Route data available',
	// 									basicType: "danger",
	// 									loadshow: 'show-n'
	// 								});
	// 							}else{
								
	// 								var leg_params = leg_params.data
	// 								this.setState({
	// 									loadshow: 'show-m',
	// 									maptruckno: leg_params.truck_no
	// 								});
							
	// 								// If gateouttime is current time - It shows "No Route data available"
	// 								if (leg_params.invoice_time) {
	// 									var gateouttime = moment.parseZone(leg_params.invoice_time).format('YYYY-MM-DD HH:mm:ss');
	// 								}
	// 								else {
	// 									if (leg_params.gate_in_time) {
	// 										var gateouttime = moment.parseZone(leg_params.gate_in_time).format('YYYY-MM-DD HH:mm:ss');
	// 									}
	// 									else {
	// 										if (leg_params.gate_out_time) {
	// 											var gateouttime = moment.parseZone(leg_params.gate_out_time).format('YYYY-MM-DD HH:mm:ss');
	// 										}
	// 									}
	// 								}
							
	// 								var edate = '';
	// 								var end_date;
	// 								if (leg_params.status <= 2) {
	// 									end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss')
	// 									edate = getHyphenYYYYMMDDHHMMSS(end_date);
	// 								}
	// 								else if (leg_params.status == 3 || leg_params.status == 4) {
	// 									if (leg_params.recent_dealer_reported) {
	// 										edate = getHyphenYYYYMMDDHHMMSS(leg_params.recent_dealer_reported);
	// 										end_date = getHyphenYYYYMMDDHHMMSS(leg_params.recent_dealer_reported);
	// 									}
	// 								}
	// 								else if (leg_params.status == 5) {
	// 									if (leg_params.left_dealer_marked) {
	// 										edate = getHyphenYYYYMMDDHHMMSS(leg_params.left_dealer_marked);
	// 										end_date =  getHyphenYYYYMMDDHHMMSS(leg_params.left_dealer_marked);
	// 									}
	// 								}
	// 								else if (leg_params.status == 6) {
	// 									if (leg_params.force_closure_time) {
	// 										let splitT = leg_params.force_closure_time.split('T')
	// 										let yMD = splitT[0]
	// 										let hMS = splitT[1]
	// 										let hms1 = hMS.split('.')
	// 										let finalHms = hms1[0]
	// 										let final_end_date = yMD + ' ' + finalHms
	// 										end_date = final_end_date;
	// 										edate = final_end_date
	// 									}
	// 								}
	// 								else {
	// 									end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss')
	// 									edate = getHyphenYYYYMMDDHHMMSS(end_date);
	// 								}							
	// 								if ((leg_params.transit_time) > 0) {
	// 									var seconddate = new Date(new Date(leg_params.gate_out_time).getTime() + ((leg_params.transit_time + 1) * 24 * 60 * 60 * 1000));
	// 								}
	// 								else {
	// 									var seconddate = new Date(new Date(leg_params.gate_out_time).getTime() + 2 * 24 * 60 * 60 * 1000);
	// 								}
							
	// 								var sdate = seconddate.getFullYear() + "-" + (seconddate.getMonth() + 1) + "-" + seconddate.getDate() + " " + seconddate.getHours() + ":" + seconddate.getMinutes() + ":" + seconddate.getSeconds();
							
	// 								if (!end_date) {
	// 									// When end date is unavailable then current date is considered as end date.
	// 									end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss');
	// 								}
	// 								var reqData = {
	// 									truck_no: leg_params.truck_no,
	// 									consignment_code: leg_params.invoice_no,
	// 									consignee_code: leg_params.consignee_code,
	// 									gate_out_time: gateouttime,
	// 									seconddate: end_date,
	// 									screen: "consignment"
	// 								}
	// 								if (["2", "3", "4"].includes(leg_params.status)) reqData.mapMode = 2
							
	// 								redirectURL.post('/consignments/maproutes', reqData, {
	// 									headers: {
	// 										'content-type': 'application/json'
	// 									}
	// 								})
	// 									.then((response) => {
	// 										var records = response.data;
	// 										console.log(records,"record3535")
	// 										this.setState({
	// 											loadshow: 'show-m'
	// 										});
	// 										try {
	// 											if (records.coords.length == 0 || records.status == "failure") {
	// 												this.setState({
	// 													show: true,
	// 													basicTitle: 'No Route data available',
	// 													basicType: "danger",
	// 													loadshow: 'show-n'
	// 												});
	// 											}
	// 											else {
	// 												if (records != '') {
	// 													var sdate = leg_params.gate_out_time;
	// 													if (leg_params.invoice_time) {
	// 														var sdate = leg_params.invoice_time;
	// 													}
	// 													else {
	// 														if (leg_params.gate_in_time) {
	// 															var sdate = leg_params.gate_in_time;
	// 														}
	// 														else {
	// 															if (leg_params.gate_out_time) {
	// 																var sdate = leg_params.gate_out_time;
	// 															}
	// 														}
	// 													}
							
							
	// 													var edate = '';
	// 													var end_date = ""
	// 													console.log(leg_params.recent_dealer_reported , "recent_dealer_reported")
	// 													if (leg_params.status < 4) {
	// 														end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss')
	// 														edate = getHyphenDDMMYYYYHHMMSS(end_date);
							
	// 													}
	// 													else if (leg_params.status == 4 ) {
	// 														console.log("end_time", leg_params)
	// 														edate = getHyphenDDMMYYYYHHMMSS(leg_params.end_time);
	// 														end_date = leg_params.recent_dealer_reported
	// 													}
	// 													else if (leg_params.status == 5) {
	// 														if (leg_params.left_dealer_marked) {
	// 															edate = getHyphenDDMMYYYYHHMMSS(leg_params.left_dealer_marked);
	// 															end_date = leg_params.left_dealer_marked
							
	// 														}
	// 														else {
	// 															end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss')
	// 															edate = getHyphenDDMMYYYYHHMMSS(end_date);
	// 														}
	// 													}
	// 													if (leg_params.deviation_flag == 1 && this.state.deptcode == "LOG-PRT") {
	// 														var params = {
	// 															"base_route_id": leg_params.base_route_id
	// 														}
	// 														redirectURL.post("/consignments/getLiveRouteDeviationBaseRoute",
	// 															params).then((resp) => {
	// 																this.setState({
	// 																	sliderRouteTranslate: "slider-translate-60p",
	// 																	showDiv: 'show-m',
	// 																	mapinfo: records,
	// 																	dealer: leg_params.consignee_code,
	// 																	consignment_code: "Truck No : " + leg_params.truck_no,
	// 																	maptruckno: leg_params.truck_no,
	// 																	routeTruck: { "truck_no": leg_params.truck_no, "startTime": sdate, "endTime": end_date },
	// 																	loadshow: 'show-n',
	// 																	sidebarSubHeader: "Consignment Information",
	// 																	overly: 'show-m',
	// 																	rownode: leg_params,
	// 																	leg_no: 0,
	// 																	tolls: records.tolls,
	// 																	baseRouteCoords: resp.data.alteredHeroPRTBaseRoute,
	// 																	devation_flag: true
	// 																});
	// 																this.onShowGoogleRoute(leg_params.invoice_no, leg_params.consignee_code, 0, leg_params.truck_no)
	// 																this.renderMap();
	// 															})
	// 													}
	// 													else {
	// 														this.setState({
	// 															sliderRouteTranslate: "slider-translate-60p",
	// 															showDiv: 'show-m',
	// 															mapinfo: records,
	// 															dealer: leg_params.consignee_code,
	// 															consignment_code: "Invoice No : " + leg_params.invoice_no,
	// 															maptruckno: leg_params.truck_no,
	// 															routeTruck: { "truck_no": leg_params.truck_no, "startTime": sdate, "endTime": end_date },
	// 															loadshow: 'show-n',
	// 															sidebarSubHeader: "Consignment Information",
	// 															overly: 'show-m',
	// 															rownode: leg_params,
	// 															leg_no: 0,
	// 															tolls: records.tolls
	// 														});
	// 														this.onShowGoogleRoute(leg_params.invoice_no, leg_params.consignee_code, 0, leg_params.truck_no)
	// 														this.renderMap();
	// 													}
	// 												}
	// 											}
	// 										}
	// 										catch (e) {
	// 											this.setState({
	// 												show: true,
	// 												basicTitle: 'No Route data available',
	// 												basicType: "danger",
	// 												loadshow: 'show-n'
	// 											});
	// 										}
							
	// 									})
	// 									.catch(function (error) {
	// 										console.log(error);
	// 									});
	// 							}
	// 						}
	// 					}
	// 				},
	// 				getDetailRowData: function (params) {
	// 					console.log("Step 4 ", transitedelaydata)
	// 					console.log("Step 4 ", params)
	// 					redirectURL.post('/consignments/getShipmentDetails', {
	// 						shipment_id: params.data.shipment_id
	// 					})
	// 						.then(async (response) => {
	// 							console.log(response.data , "srinu")
	// 							params.successCallback(response.data || []);
	// 							//console.log("Step 2 ",response.data)

	// 						});

	// 				}
	// 			}
	// 		});

	// 		//if( params.column.colId == 'transit_delay' || params.column.colId == 'transit_delay_1' ||   params.column.colId == 'no_gps_data' || params.column.colId == 'no_gps_data_1')
	// 		if (params.column.colDef.field == 'shipmentlegs') {
	// 			params.node.setExpanded(!params.node.expanded);
	// 			//console.log("expanded ",params.node.expanded)
	// 			if (params.node.expanded == false) {
	// 				transitedelaydata = []
	// 			}
	// 		}
	// 		else {

	// 			params.node.setExpanded(false);
	// 		}
	// 		//console.log("detailCellRendererParams ", this.state.detailCellRendererParams);

	// 	}

	// }
// })};
    // const handleCellClick = (leg_params) => {
    //     setLoadshow('show-m');
    //     setMaptruckno(leg_params.data.truck_no);

    //     let gateouttime = getGateOutTime(leg_params.data);

    //     let end_date = getEndDate(leg_params.data);
    //     let edate = getHyphenYYYYMMDDHHMMSS(end_date);

    //     let sdate = getSecondDate(leg_params.data);

    //     if (!end_date) {
    //         end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss');
    //         edate = getHyphenYYYYMMDDHHMMSS(end_date);
    //     }

    //     const reqData = {
    //         truck_no: leg_params.data.truck_no,
    //         consignment_code: leg_params.data.invoice_no,
    //         consignee_code: leg_params.data.consignee_code,
    //         gate_out_time: gateouttime,
    //         seconddate: end_date,
    //         screen: "consignment"
    //     };

    //     if (["2", "3", "4"].includes(leg_params.data.status)) reqData.mapMode = 2;

    //     redirectURL.post('/consignments/maproutes', reqData, {
    //         headers: {
    //             'content-type': 'application/json'
    //         }
    //     })
    //         .then(response => handleRouteResponse(response, leg_params.data))
    //         .catch(error => console.error(error));
    // };

    const handleEndDateChange = (date) => {
        if (startDate && date < startDate) {
            setShow(true)
            setTitle("To Date should be greater than From Date")
            setType("danger")
        } else {
            setEndDate(date)
        }
    };

    const onShowCourierTrack = async (params) => {
        try {
            const response = await redirectURL.post('/consignments/trackcourier', { consignment_code: params.data.consignment_code });
            if (response.data.consignments?.length > 0) {
                setTimelineData(response.data.consignments);
                setShowModal(true); // Show modal on success
            }
        } catch (error) {
            console.error("Error fetching consignment data: ", error);
        }
    };

    const onCloseModal = () => {
        setShowModal(false); // Close the modal
    };


    const onShowTransitRouteMap = (rownode) => {
        var d = new Date(rownode.leg_start);
        var r = new Date(rownode.leg_end_eta);
        var fintance = rownode.leg_start.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
        var eintance = rownode.leg_end_eta.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
        var params = {
            truck_no: rownode.truck_no,
            consignment_code: rownode.consignment_code,
            consignee_code: rownode.consignee_code,
            first_instance: fintance,
            recent_instance: eintance,
            screen: "consignment"
        }
        redirectURL.post('/consignments/nightdriveroutes', params)
            .then((response) => {
                if (response.data.coords.length == 0) {
                    setShow(true)
                    setTitle("No Tracking data available")
                    setType("danger")
                }
                else {
                    var sdate = '';
                    var edate = '';

                    if (rownode.leg_start != '' && rownode.leg_start != undefined) {
                        sdate = rownode.leg_start;
                    }
                    if (rownode.leg_end_eta != '' && rownode.leg_end_eta != undefined) {
                        edate = getHyphenDDMMMYYYYHHMM(rownode.leg_end_eta)
                    }
                    setOpenMap({
                        overly: "show-m",
                        sliderRouteTranslate: "slider-translate-60p",
                        mapinfo: response.data,
                        dealer: rownode.consignee_code,
                        // consignment_code: "Vehicle No. : " + rownode.truck_no,
                        lr_no: "LR No. : "+ rownode.lr_no,
                        maptruckno: rownode.truck_no,
                        routeTruck: { "truck_no": rownode.truck_no, "startTime": sdate, "endTime": edate },
                        loadshow: 'show-n',
                        sidebarSubHeader: "Consignment Leg Information",
                        overly: 'show-m',
                        rownode: rownode,
                        leg_no: rownode.leg_no,
                        tolls: response.data.tolls,
                        defTransitCoords: rownode.consignee_coordinates,
                    })
                }
            })
            .catch(function (error) {
                console.log(error);
            });

    }
    const onShowEnrouteRouteMap = (rownode) => {
        var fintance = rownode.stoppage_start_time.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
        if (rownode.reset_datetime) {
            var eintance = rownode.reset_datetime.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
        }
        else {
            var eintance = moment.parseZone().format('YYYY-MM-DD HH:mm:ss');
        }
        var params = {
            truck_no: rownode.truck_no,
            first_instance: fintance,
            recent_instance: eintance,
            screen: "consignment"
        }
        redirectURL.post('/consignments/nightdriveroutes', params)
            .then((response) => {
                let records = response.data
                if (response.data.coords.length == 0) {
                    setShow(true)
                    setTitle("No GPS data available")
                    setType("danger")
                }
                else {
                    var sdate = '';
                    var edate = '';
                    if (rownode.leg_start != '' && rownode.leg_start != undefined) {
                        sdate = rownode.leg_start;
                    }
                    if (rownode.leg_end_eta != '' && rownode.leg_end_eta != undefined) {
                        edate = getHyphenDDMMMYYYYHHMM(rownode.leg_end_eta)
                    }
                    if (response.data.route_details.start_time != "" && response.data.route_details.start_time != undefined) {
                        sdate = records.route_details.start_time;
                    }
                    if (response.data.route_details.end_time != "" && response.data.route_details.end_time != undefined) {
                        edate = records.route_details.end_time;
                    }
                    setOpenMap({
                        overly: "show-m",
                        sliderRouteTranslate: "slider-translate-60p",
                        mapinfo: response.data,
                        dealer: rownode.consignee_code,
                        // consignment_code: "Vehicle No. : " + rownode.truck_no,
                        lr_no: "LR No. : "+ rownode.lr_no,
                        maptruckno: rownode.truck_no,
                        routeTruck: { "truck_no": rownode.truck_no, "startTime": sdate, "endTime": edate },
                        loadshow: 'show-n',
                        sidebarSubHeader: "Consignment Leg Information",
                        overly: 'show-m',
                        rownode: rownode,
                        leg_no: rownode.leg_no,
                        tolls: response.data.tolls,
                        defTransitCoords: rownode.consignee_coordinates,
                    })
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    }
    const onShowNightDriveRouteMap = (rownode) => {
        var fintance = rownode.first_instance.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
        var eintance = rownode.recent_instance.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
        var params = {
            truck_no: rownode.truck_no,
            first_instance: fintance,
            recent_instance: eintance,
            screen: "consignment"
        }
        redirectURL.post('/consignments/nightdriveroutes', params)
            .then((response) => {
                if (response.data.coords.length == 0) {
                    setShow(true)
                    setTitle("No GPS data available")
                    setType("danger")
                }
                else {
                    setOpenMap({
                        overly: "show-m",
                        sliderRouteTranslate: "slider-translate-60p",
                        mapinfo: response.data,
                        // consignment_code: rownode.truck_no,
                        lr_no: "LR No. : "+ rownode.lr_no,
                        defTransitCoords: { "lat": rownode.first_lat, "lng": rownode.first_lng },
                        maptruckno: rownode.truck_no,
                        routeTruck: {
                            "truck_no": rownode.truck_no, "startTime": response.data['route_details']['start_time'],
                            "endTime": response.data['route_details']['end_time']
                        },
                        loadshow: 'show-n',
                        tolls: response.data.tolls
                    })
                }
            })
            .catch(function (error) {
                console.log(error);
            });

    }
    const onShowRouteMap = (rownode) => {
        var d = new Date(rownode.first_instance);
        var r = new Date(rownode.recent_instance);
        var finstance = rownode.first_instance.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
        var rinstance = rownode.recent_instance.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
        var params = {
            truck_no: rownode.truck_no,
            consignment_code: rownode.consignment_code,
            consignee_code: rownode.consignee_code,
            first_instance: finstance,
            recent_instance: rinstance,
            screen: "consignment"
        }
        redirectURL.post('/consignments/overspeedgpsroutes', params)
            .then((response) => {
                setOpenMap({
                    overly: "show-m",
                    sliderRouteTranslate: "slider-translate-60p",
                    mapinfo: response.data,
                    dealer: rownode.consignee_code,
                    // consignment_code: "Vehicle No. : " + rownode.truck_no,
                    lr_no: "LR No. : "+ rownode.lr_no,
                    maptruckno: rownode.truck_no,
                    routeTruck: { "truck_no": rownode.truck_no, "startTime": finstance, "endTime": rinstance },
                    loadshow: 'show-n',
                    sidebarSubHeader: "Consignment Leg Information",
                    overly: 'show-m',
                    rownode: rownode,
                    leg_no: rownode.leg_no,
                    tolls: response.data.tolls,
                    defTransitCoords: rownode.consignee_coordinates,
                })
            })
            .catch(function (error) {
                console.log(error);
            });
    }
    const onShowNoGPSRouteMap = (rownode) => {
        var fintance = rownode.last_packet_datetime.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
        var eintance = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
        eintance = eintance.replace("T", " ").replace("Z", " ").replace(".000", " ").trim()
        if ((rownode.hasOwnProperty("exception_closed") && rownode.exception_closed == 1) || rownode.hasOwnProperty("packet_received_on"))
            eintance = rownode.packet_received_on.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
        var params = {
            truck_no: rownode.truck_no,
            consignment_code: rownode.consignment_code,
            first_instance: fintance,
            recent_instance: eintance,
            screen: "consignment"
        }
        redirectURL.post('/consignments/nightdriveroutes', params)
            .then((response) => {
                if (response.data.coords.length == 0) {
                    setShow(true)
                    setTitle("No GPS data available")
                    setType("danger")
                }
                else {
                    var sdate = '';
                    var edate = '';
                    if (rownode.leg_start != '' && rownode.leg_start != undefined) {
                        sdate = rownode.leg_start;
                    }
                    if (rownode.leg_end_eta != '' && rownode.leg_end_eta != undefined) {
                        edate = getHyphenDDMMMYYYYHHMM(rownode.leg_end_eta)
                    }
                    setOpenMap({
                        overly: "show-m",
                        sliderRouteTranslate: "slider-translate-60p",
                        mapinfo: response.data,
                        dealer: rownode.consignee_code,
                        // consignment_code: "Vehicle No. : " + rownode.truck_no,
                        lr_no: "LR No. : "+ rownode.lr_no,
                        maptruckno: rownode.truck_no,
                        routeTruck: { "truck_no": rownode.truck_no, "startTime": sdate, "endTime": edate },
                        loadshow: 'show-n',
                        sidebarSubHeader: "Consignment Leg Information",
                        overly: 'show-m',
                        rownode: rownode,
                        leg_no: rownode.leg_no,
                        tolls: response.data.tolls,
                        defTransitCoords: rownode.consignee_coordinates,
                    })
                }
            })
            .catch(function (error) {
                console.log(error);
            });


    }
    const onClickOpenBulkUploadModal = (e) => {
        setOverlay("show-m")
        setBulkUploadModal({
            overly: "show-m",
            bulkPrioritySlide: "slider-translate-84p"
        })
    }
    const closeBulkUploadModal = () => {
        setFile(null); 

        setBulkUploadModal({
            overly: "show-n",
            bulkPrioritySlide: ""
        })
        setOverlay("show-n")
        setModalLoadData([])
    }
    const onClickHideManualUpload2 = () => {
        setshowAddForm2("");
        setUploadPODTracking(false)

        setOverlay("show-n");        
        setManualInTransitStatusUpdate((prev)=>({
            ...prev,
            dispatch_time: ""
        }))
        setForm2Details({
            event_status: statusOrderPtl,
            selectedStatus: {value: 'In Transit', label: 'In Transit'},
            selectedPincode: {value: '', label: ''},
            event_location: "",
            remark: "",
            reason_for_delay:"",
            delivered_date:'',
            errorMessage:''
        })
      };
      const onClickHideManualUpload4 = () => {
        setshowBulkUpdateForm("");
        setUploadPODTracking(false)

        setFile1(null); 

        
        setOverlay("show-n")
        setModalBulkUpdateData([])      
        // setManualInTransitStatusUpdate((prev)=>({
        //     ...prev,
        //     dispatch_time: ""
        // }))
        // setForm2Details({
        //     event_status: statusOrderPtl,
        //     selectedStatus: {value: 'In Transit', label: 'In Transit'},
        //     selectedPincode: {value: '', label: ''},
        //     event_location: "",
        //     remark: "",
        //     delivered_date:'',
        //     errorMessage:''
        // })
      };
    const closeMapModal = () => {
        setOverlay("show-n")
        setOpenMap({
            sliderRouteTranslate: "",
            showDiv: 'show-n',
            mapinfo: [],
            dealer: "",
            lr_no: "",
            maptruckno: "",
            geofence_coordinates: [],
            parking_coordinates: [],
            routeTruck: { "truck_no": '', "startTime": '', "endTime": '' },
            loadshow: 'show-n',
            sidebarSubHeader: "",
            overly: 'show-m',
            rownode: {},
            leg_no: 0,
            tolls: []
        })
        setMapDetails()
    }
    var lrBasedSegData = [];
    

    useEffect(() => {
        if ((gridColumnState.length > 0 || gridColumnState1.length > 0) && columnApiConsignments.current) {
            console.log("test22")
            // columnApiConsignments.current.applyColumnState({
            //     state: gridColumnState,
            //     applyOrder: true,
            // })
            setTimeout(async () => {
    
                if(searchViewType.value ==="LR"){
    
                    await columnApiConsignments.current.applyColumnState({
                        state: gridColumnState,
                        applyOrder: true,
                    })           
                 }else{
                    await columnApiConsignments.current.applyColumnState({
                        state: gridColumnState1,
                        applyOrder: true,
                    })
                 }
               
            }, 1500);
          
        }
    }, [gridColumnState,gridColumnState1, columnApiConsignments])
    const invalidFileData = async(e) => {
        let params ={
            transaction_id: transactionData
        }
        await redirectURL.post("consignments/getInvalidConsignments", params)
            .then(resp => {
                console.log("ressss", resp);
                
                // setModalLoadData(resp)
            })
            .catch(err => console.log(err))
    };

    const changeFileHandler = (e) => {
        const selectedFile = e.target.files[0];
    
        // Check if a file is selected
        if (!selectedFile) {
            // Reset state if no file is selected
            setFile(null);
            setModalLoadData([]);
            return; // Exit early
        }
        setShow(false);
        setTitle('');
        setType('');
    
        setFile(selectedFile);
        setLoader(true);
    
        // e.target.value = null;
        const formData = new FormData();
        formData.append("fileUpload", selectedFile);
    
        redirectURL.post("/readExcel", formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Access-Control-Allow-Origin': "*",
                'Access-Control-Allow-Methods': 'POST',
                'Access-Control-Allow-Headers': 'Origin, Content-Type'
            }
        })
        .then((response) => {
            if (response.data.status === "success") {
                if (response.data.data.length > 0) {
                    const loadedData = response.data.data;

                    // var errorMessages ="";
                    // var row=[];
                    // const lrMap = new Map();

                    // loadedData.forEach((record,index) => {
                    //     const {lr_no, courier_partner} = record;

                    //     if (lr_no && lr_no.trim() !== "") {
                    //     if(lrMap.has(lr_no)){
                    //         const existingTpt = lrMap.get(lr_no);

                    //         // if (existingTpt !== courier_partner || existingTruckNo !== truck_no){
                    //         if(existingTpt !=  courier_partner){
                    //             // errorMessages.push(`LR No ${lr_no} has different transporters at record ${index + 1} and previous records.`);  
                    //             // errorMessages = "Same LR No has been assigned with different transporters or truck numbers.";
                    //             console.log(existingTpt, lr_no, lrMap, "lrmap99");
                                
                    //             errorMessages="Same LR No has assigned with different transporters. ";  
                    //             // row.push(`${index+1}`)
                    //          }
                    //     }else{
                    //         // lrMap.set(lr_no, { existingTpt: courier_partner, existingTruckNo: truck_no });
                    //         lrMap.set(lr_no, courier_partner)
                    //     }
                    // }
                    // })
                    // if(errorMessages !==""){
                    //     // const msg="Please check this rows "+row+" in excel"
                    //     const msg ="Please check in uploaded excel"
                    //     setShow(true);
                    // setTitle(errorMessages+msg);
                    // setType("danger");
                    // setModalLoadData([]);
                    // }
                    // else{
                        setModalLoadData(response.data.data);
                    // }
                } else {
                    setModalLoadData([]);
                }
            } else {
                // Handle non-success response
                setShow(true);
                setTitle(response.data.message);
                setType("danger");
                setModalLoadData([]);
            }
        })
        .catch(error => {
            console.error("Error uploading file:", error);
            setShow(true);
            setTitle("File upload failed");
            setType("danger");
            setModalLoadData([]);
        })
        .finally(() => {
            setLoader(false); // Ensure the loader is hidden after processing
        });
    };

    const changeBulkStatusFileHandler = (e) => {
        const selectedFile = e.target.files[0];
    
        // Check if a file is selected
        if (!selectedFile) {
            // Reset state if no file is selected
            setFile1(null);
            setModalBulkUpdateData([]);
            return; // Exit early
        }
        setShow(false);
        setTitle('');
        setType('');
    
        setFile1(selectedFile);
        setLoader(true);
        const formData = new FormData();
        formData.append("fileUpload", selectedFile);
    
        redirectURL.post("/readBulkStatusExcel", formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Access-Control-Allow-Origin': "*",
                'Access-Control-Allow-Methods': 'POST',
                'Access-Control-Allow-Headers': 'Origin, Content-Type'
            }
        })
        .then((response) => {
            if (response.data.status === "success") {
                if (response.data.data.length > 0) {
                    
                   
                    // setShow(true);
                    // setTitle(response.data.message);
                    // setType("Success");
                    setModalBulkUpdateData(response.data.data);
                }else{
                        setModalBulkUpdateData([]);
                    }
            } else {
                // Handle non-success response
                setShow(true);
                setTitle(response.data.message);
                setType("danger");
                setModalBulkUpdateData([]);

            }
        })
        .catch(error => {
            console.error("Error uploading file:", error);
            setShow(true);
            setTitle("File upload failed");
            setType("danger");
            setModalBulkUpdateData([]);

        })
        .finally(() => {
            setLoader(false); // Ensure the loader is hidden after processing
        });
    }
    




    useEffect(()=>{
        loadConsignmentsData();
    },[])
    useEffect(()=>{
        loadConsignmentsData();
    },[processFlowType])
    useEffect(()=>{
        loadConsignmentsData();
    },[tabName, searchViewType])
    
    const loadConsignmentsData = async () => {
        let params = {}
        
        if(decodedRoleCase === "transporter" &&  localStorage.getItem("transporter")!=="All"){
            params.transporter_name = localStorage.getItem("transporter")
        }
        if (
            zoneConversion &&
            zoneConversion.length > 0 &&
            !zoneConversion.includes("all")
        ) {            
        params.consignee_zone = zoneConversion;
    }
        if (
            stateConversion &&
            stateConversion.length > 0 &&
            !stateConversion.includes("all")
        ) {            
                    params.consignee_state = stateConversion;
        }
        if (
            locationNameConversion &&
            locationNameConversion.length > 0 &&
            !["all numeric shipments", "all sites", "all shipment"].some((item) => locationNameConversion.includes(item))
    ) {            
            params.consigner_name = locationNameConversion;
            params.consigner_code = locationNameConversion;
}
    if(entityConversion && entityConversion.length > 0 && !["all"].some((item)=> entityConversion.includes(item))){
                        
        params.truck_seal_entity = entityConversion
    }

          

        
        await redirectURL.post("consignments/getCancelledRecords", params)
            .then(resp => {
                fragmentData(resp)
            })
            .catch(err => console.log(err))
    }
    let inactive_trips = [];
    const fragmentData = async(resp) => {
        if (resp.data.status == "success") {

            var active_trips =[];
            var completed_trips;
            var all_trips;
                var active_tripsar = resp.data.cancelled_details
                setRowData(active_tripsar)

                // if(active_tripsar.length > 0)
                //     {
                //         active_tripsar.map((itm) => {
                //             if(itm.transit_delay_hours !== "" && itm.transit_delay_hours !== undefined && itm.transit_delay_hours !== null)
                //             {
                //                 var hrs  = itm.transit_delay_hours
                //                 if (hrs !== undefined && hrs !== null) {
                //                     // Convert hours to days and round to the nearest whole number
                //                     var days = Math.ceil(hrs / 24); // Round up to the nearest whole number
                //                     itm["transit_delay_days"] =days;
                //                 }
                //                 else{
                //                     itm["transit_delay_days"] =0;
                //                 }
                //                 active_trips.push(itm);
                //             }
                //         })
                //     }
                //     setRowData(active_trips)
        }
    }
    
    // firstboxfunction
    const getTruckConsignments = async (e) => {
        setLoader(true)
        setOverlay("show-m")
        e.preventDefault();
        
        const tracking_type1 = filteredInvoices.find(record => record.label === searchInvoice)?.value;
        const tracking_type2 = filteredLrnos.find(record => record.label === lrNo)?.value;

        
        let params = {}
        if(searchType && searchType.value === "truck_no"){
            params.truck_no = searchVehicle.value;
            params.tabType = tabName.value;
        } else if( searchType && searchType.value === "lr_no"){
            params.lr_no = lrNo;
            params.tabType = tabName.value;
            params.tracking_type = tracking_type2;
        } else {
            params.invoice_no =searchInvoice ? searchInvoice.toUpperCase():""
            params.tabType = tabName.value;
            // params.tracking_type = tracking_type1;
        }
        if(decodedRoleCase === "transporter" && localStorage.getItem("transporter")!=="All"){
            params.transporter_name = [localStorage.getItem("transporter")]
        } 
        if (
            zoneConversion &&
            zoneConversion.length > 0 &&
            !zoneConversion.includes("all")
        ) {            
            params.consignee_zone = zoneConversion;
}
        if (
            stateConversion &&
            stateConversion.length > 0 &&
            !stateConversion.includes("all")
        ) {            
            params.consignee_state = stateConversion;
        }
      
        if (
            locationNameConversion &&
            locationNameConversion.length > 0 &&
            !["all numeric shipments", "all sites", "all shipment"].some((item) => locationNameConversion.includes(item))
    ) {            
            params.consigner_name = locationNameConversion;
            params.consigner_code = locationNameConversion;
    }
        if(entityConversion && entityConversion.length > 0 && !["all"].some((item)=> entityConversion.includes(item))){
                            
            params.truck_seal_entity = entityConversion
        }

        
        await redirectURL.post("consignments/filterCombinedConsignments", params)
            .then(resp => {                 
                if(resp.data.totalConsignments.length > 0 || resp.data.consignments.length > 0){
                    fragmentData(resp)
                    setSearchVehicle({value:"", label:""})
                    setOverlay("show-n")
                }else {
                    setCountersActive({
                        consignments: 0,
                        inTransit: 0,
                        transit_delays: 0,
                        stoppages: 0,
                        no_gps_data: 0,
                        outfordelivery: 0,
                        at_source:0,
                        dispatched_from_source:0,
                        arrived_at_destination:0,
                        sim_issues:0
                    })
                    setCountersCompleted({
                        consignments:0,
                        // delivered: completed_delivered.length,
                        onTime: 0,
                        delayed: 0,
                        podPending: 0,
                        zeroToOneDays: 0,
                        oneToTwoDays: 0,
                        threeToFiveDays: 0,
                        sixToTenDays: 0,
                        gtTenDays: 0
                    })
                    setCountersAll({
                        consignments:0,
                        inTransit: 0,
                        transit_delays: 0,
                        no_gps_data: 0,
                        stoppages: 0,
                        disabled: 0,
                        undelivered: 0,
                        delivered: 0,
                        outfordelivery:0,
                        podPending: 0,
                        at_source:0,
                        dispatched_from_source:0,
                        arrived_at_destination:0,
                        sim_issues:0


        
                    })
                    // setShow(true)
                    // setTitle("No Records Found")
                    // setType("danger")
                    setRowData([])
                    setOverlay("show-n")
                }
            })
            .catch(err => console.log(err))
    }
    let role = decode(localStorageRole)
    const handleDocTab=(e)=>{
        setSelectedTab(e)
    }
   
    const saveConsignments = async (e) => {
        
        e.preventDefault();
        // console.log("bullllllk999999",bulkError,bulkInvoiceError,bulkTptError,bulkBoxesError,bulkVehicleNoError,bulkEntityError,bulkTrackingError,bulkSourceError,bulkVehicleTypeError,bulkInvoiceTypeError,bulkConsigneeError,bulkDestinationError,bulkDispatchError,bulkTotalWeightError,bulkModeError,bulkMovementError,bulkPincodeError);


        setLoader(true)
        if (gridApi.current) {
            gridApi.current.stopEditing();
            const gridRowData = [];
            gridApi.current.forEachNode((node) => {
                // if (node.data.plant_code == "" || node.data.fo_number == "" || node.data.order_number == "" || node.data.invoice_date == "" || node.data.transporter_code == "" || node.data.dealer_code == "" || node.data.quantity == "" || node.data.execution_date == "" || node.data.expected_date == "" || node.data.expected_return_to_plant_date == "" || node.data.plant_code == undefined || node.data.fo_number == undefined || node.data.order_number == undefined || node.data.invoice_date == undefined || node.data.transporter_code == undefined || node.data.dealer_code == undefined || node.data.quantity == undefined || node.data.execution_date == undefined || node.data.expected_date == undefined || node.data.expected_return_to_plant_date == undefined) {
                //     setShow(true)
                //     setTitle("Please fill the required fields")
                //     setType("danger")
                //     gridApi.current.refreshCells()
                //     return
                // }
                // else if (!plantData.some(e => e.consigner_code == node.data.plant_code)) {
                //     setShow(true)
                //     setTitle("Please give a valid Plant Code")
                //     setType("danger")
                //     gridApi.current.refreshCells()
                //     return
                // }
                // else if ((!moment(node.data.invoice_date, "YYYY-MM-DD HH:mm:ss", true).isValid())) {
                //     setShow(true)
                //     setTitle("Please give a valid Invoice Date (YYYY-MM-DD HH:mm:ss)")
                //     setType("danger")
                //     gridApi.current.refreshCells()
                //     return
                // }
                // else if (!transporters.some(e => e.transporter_code == node.data.transporter_code)) {
                //     setShow(true)
                //     setTitle("Please give a valid Plant Code")
                //     setType("danger")
                //     gridApi.current.refreshCells()
                //     return
                // }
                // else if (!dealers.some(e => e.consignee_code == node.data.dealer_code)) {
                //     setShow(true)
                //     setTitle("Please give a valid Dealer Code")
                //     setType("danger")
                //     gridApi.current.refreshCells()
                //     return
                // }
                // else if (isNaN(node.data.quantity)) {
                //     setShow(true)
                //     setTitle("Please give a valid quantity")
                //     setType("danger")
                //     gridApi.current.refreshCells()
                //     return
                // }
                // else if (!moment(node.data.execution_date, "YYYY-MM-DD HH:mm:ss", true).isValid()) {
                //     setShow(true)
                //     setTitle("Please give a valid Execution Date (YYYY-MM-DD HH:mm:ss)")
                //     setType("danger")
                //     gridApi.current.refreshCells()
                //     return
                // }
                // else if (!moment(node.data.expected_date, "YYYY-MM-DD HH:mm:ss", true).isValid()) {
                //     setShow(true)
                //     setTitle("Please give a valid Expected Date (YYYY-MM-DD HH:mm:ss)")
                //     setType("danger")
                //     gridApi.current.refreshCells()
                //     return
                // }
                // else if (!moment(node.data.expected_return_to_plant_date, "YYYY-MM-DD HH:mm:ss").isValid()) {
                //     setShow(true)
                //     setTitle("Please give a valid Expected Return to Plant Date (YYYY-MM-DD HH:mm:ss)")
                //     setType("danger")
                //     gridApi.current.refreshCells()
                //     return
                // }
                // else if (previousData.some(e => ((e.order_number == node.data.order_number) && (e.fo_number == node.data.fo_number)))) {
                //     setShow(true)
                //     setTitle("Order number and FO number combination already exist for previous consignments")
                //     setType("danger")
                //     gridApi.current.refreshCells()
                //     return
                // }
                // else
                    gridRowData.push(node.data)
            })

            if (gridRowData.length > 0) {
                

    if(!bulkError && !bulkInvoiceError && !bulkTptError && !bulkBoxesError && !bulkVehicleNoError && !bulkEntityError && !bulkTrackingError &&  !bulkSourceError && !bulkVehicleTypeError && !bulkInvoiceTypeError && !bulkConsigneeError && !bulkDestinationError && !bulkDispatchError && !bulkTotalWeightError && !bulkModeError && !bulkMovementError && !bulkPincodeError){
                    await redirectURL.post("/bulkUploadConsignments", { consignments: gridRowData, email: "" })
                    .then(response => {
                        
                        if (response.data.status == "Success" && (!response.data.transaction_id || response.data.transaction_id === null) && (response.data.message !=="Valid records will be updated successfully, and invalid records with remarks will be sent via email.")) {

                            setShow(true)
                            setTitle(response.data.message)
                            setType("success")
                            setLoader(false)
                            setBulkUploadModal(false)
                            setModalLoadData([])
                            setOverlay("show-n")
                            setFile(null); 
                            loadConsignmentsData()
                            // window.location.reload()

                        }else if(response.data.message =="Valid records will be updated successfully, and invalid records with remarks will be sent via email."){
                            setShow(true)
                            setTitle(response.data.message);
                            setType("warning")
                            setLoader(false)
                        }
                        else if(response.data.transactionId){
                            setTransactionData(response.data.transaction_id)
                            setShow(true)
                            setTitle("This consignment creation has some invalid data");
                            setType("warning")
                            setLoader(false)
                        }
                        else {
                            setShow(true)
                            setTitle(response.data.message)
                            setType("danger")
                            setLoader(false)
                        }
                    })
                    .catch(err => console.log(err))
            }else{
                    setShow(true)
                    setTitle("Please upload mandatory fields")
                    setType("danger")
                    setLoader(false)
            }
                }
                
                
        }
    }
    const uploadFormHandler = async (e) => {
        e.preventDefault();
        setLoader(true)
        
        if (gridApiUpdateConsignments.current) {
            gridApiUpdateConsignments.current.stopEditing();
            const gridRowData = [];
            gridApiUpdateConsignments.current.forEachNode((node) => {
                    gridRowData.push(node.data)
            })
            if (gridRowData.length > 0) {
                if(bulkLRError){
                    setShow(true)
                    setTitle(bulkLRErrorMsg)
                    setType("danger")
                    setLoader(false)
                }
            
                if(!bulkLRError && !bulkUpdateInvoiceError && !bulkUpdateDispatchError && !bulkUpdateExpectedError && !bulkUpdateLastEventTimeError && !bulkUpdateStatusError && !bulkUpdateCurrentLocationErr && !bulkUpdateEventError && !bulkUpdateReasonErr){
                    await redirectURL.post("/bulkUploadStatusConsignments", { consignments: gridRowData, email: "" })
                    .then(response => {
                        
                        if (response.data.status == "Success") {
                            setShow(true)
                            setTitle(response.data.message)
                            setType("success")
                            setLoader(false)
                            setModalBulkUpdateData([])
                            setOverlay("show-n")
                            setFile1(null); 
                            loadConsignmentsData()
                            setShowBulkUpdateForm("")
                            // window.location.reload()

                        }
                        else {
                            setShow(true)
                            setTitle(response.data.message)
                            setType("danger")
                            setLoader(false)
                        }
                    })
                    .catch(err => console.log(err))
                }else{
                    setShow(true)
                    setTitle("Please upload mandatory fields")
                    setType("danger")
                    setLoader(false)
                }
            }
                }
                
                
    }
    
    const onClickDeliveredSubmit = (e)=>{
        e.preventDefault();
        setOverlay("show-m")
        setLoadShow('show-m')
        const formData = new FormData();
        
        if(form2Details.errorMessage!==""){
            setLoadShow('show-n')
                setShow(true);
                setType("warning");
                setTitle("Please select status properly.");
                return;
        }

        if(uploadPODTracking){
            // if (podremarks === "") {
            //     setLoadShow('show-n')
            //     setShow(true);
            //     setType("warning");
            //     setTitle("Please enter remarks");
            //     setPodRemarks("");
            //     return;
            // }
         
                const rowid = Dselected_row._id;
                savePodDocument(rowid);
                const shipment_id = rownode?.[0]?.shipment_id || Dselected_row?.shipment_id;
                const tracking_type = rownode?.[0]?.tracking_type || Dselected_row?.tracking_type;
                    // const rownodes = rownode;
                
                formData.append("shipmentId", shipment_id);
                formData.append("podDoc", epodDoc);
                formData.append("podremarks", podremarks);
                formData.append("rowid", rowid);
                // formData.append("rownodes", JSON.stringify(rownodes));
                formData.append("damage", damage);
                formData.append("short", short);
                formData.append("excess", excess);
                formData.append("pilferage", pilferage);
                formData.append("trackingType", tracking_type);
                

                
                
        }
        

        
        const extractedLRs = selectedLRStoUpdateLr.map(e => e.value)
        var lrList  = extractedLRs.length>0;


        setLoadShow('show-m')


        const formattedDate = moment(form2Details.delivered_date).format("YYYY-MM-DD HH:mm:ss");

        
        let updatedDeliveredData = {
            // Conditionally include consignee_pincode based on isMoreInvoice
           
            tracking_type: bulkPtlUpdate? bulkTrackingType: selectedRecordType,
            lr_no: lrList ? extractedLRs : Dselected_row.lr_no,
            consignment_status: form2Details.selectedStatus.value,
            delivery_station: form2Details.event_location,
            delivery_datetime: formattedDate,
            ...(bulkPtlUpdate ? {truck_no:selectedTruckUpdate,shipment_id: selectedShipmentUpdate} : { truck_no: Dselected_row.truck_no ,
                shipment_id:  Dselected_row.shipment_id,
            ...(isMoreInvoices
                ? { consignee_pincode: form2Details.selectedPincode.value }
                : { consignee_pincode: Dselected_row.consignee_pincode }),    
            invoice_no: Dselected_row.invoice_no,

                
            }) 
        };
       
        
        if(ableRemark){
            updatedDeliveredData.remarks = form2Details.remark
        };
        if(form2Details.reason_for_delay !==""){
            updatedDeliveredData.reason_for_delay = form2Details.reason_for_delay
        }

        let combinedParams={
            updatedDeliveredData, formData
        }
        // console.log("combinedParamsooo", combinedParams);
        

        
        
        redirectURL.post('/consignments/updateDeliveryDetails', combinedParams).then((resp) => {
            
            if (resp.data.status == 'success') {
                setTitle(resp.data.message);
                setShow(true)                
                setType("success");
                setLoadShow('show-n');
                setOverlay('show-n');
                setshowAddForm2('');
                setIsMoreInvoices(false);

                setUploadPODTracking(false)
                setForm2Details({
                    event_status:statusOrderFtl,
                    selectedStatus: {value: 'In Transit', label: 'In Transit'},
                    selectedPincode: {value: '', label: ''},
                    event_location: "",
                    remark: "",
                    reason_for_delay:'',
                    delivered_date:'',
                    errorMessage:''
                })
                setDselected_row({})
                setBulkPtlUpdate(false)
                document.getElementById("formPOD").reset();
                setPodRemarks("");
                setSliderShow("");
                setOverlay("show-n");
                setEpodDoc([]);
                // window.location.reload();    
            }
            else if (resp.data.status =="Failure"){
                
                setShow(true)
                // setTitle("Please upload valid details")
                setTitle(resp.data.message)
                setType("danger")
                setLoadShow('show-n')
                setOverlay('show-n');
                // deselectAllRows();
                // setshowAddForm2('');
                // setForm2Details({
                //     event_status: [
                //         { label: 'Delivered', value: 'Delivered' }, 
                //         { label: 'In Transit', value: 'In Transit' },
                //         { label: 'Out For Delivery', value: 'Out For Delivery' },
                //         { label: 'Arrived At Destination', value: 'Arrived At Destination' },                    
                //         { label: 'Undelivered', value: 'Undelivered' },
                //     ],
                //     selectedStatus: {value: 'In Transit', label: 'In Transit'},
                //     selectedPincode: {value: '', label: ''},
                //     event_location: "",
                //     remark: "",
                //     delivered_date:'',
                // })
                // setDselected_row({})
            } else{
                
                setShow(true)
                setTitle(resp.data.message)
                setType("danger")
                setLoadShow('show-n')
                setOverlay('show-n');
                deselectAllRows();
                setshowAddForm2('');
                setForm2Details({
                    event_status:statusOrderPtl,
                    selectedStatus: {value: 'In Transit', label: 'In Transit'},
                    selectedPincode: {value: '', label: ''},
                    event_location: "",
                    remark: "",
                    reason_for_delay:"",
                    delivered_date:'',
                    errorMessage:''
                })
                setDselected_row({})
            }
        })
    }
    const changeHandleDate1 = (date) => {
        setForm2Details((prev) => ({
        ...prev,
        delivered_date: date,
        }))
    
    };
    const onConfirm = () => {
        setShow(false);
        setLoader(false)
        // if (reloadPage.current) {
        //     window.location.reload()
        // }
        if (type === 'success'){
            window.location.reload()
        }

    };
    
    const updateDeliveredDate = async(e) => {
        setDselected_row(e.data);   
        setSelectedRecordType(e.data.tracking_type)
        // const x = selectedRows.map((e)=> ({label:e.lr_no, value: e.lr_no}))
        
        setSelectLRSToUpdate([{label:e.data.lr_no, value:e.data.lr_no}]);
        setShipmentId(e.data.shipment_id)
        setshowAddForm2("slider-translate-30p");
        setOverlay("show-m");
        setForm2Details((prev) => ({
            ...prev,
            selectedStatus: { label: e.data.consignment_status, value: e.data.consignment_status }, // Set the selected status from e.data
        }));        
        var params ={
            truck_no: e.data.truck_no
        }
        await redirectURL.post("consignments/getPincodes", params)
        .then(resp => {
            if (e.data.tracking_type === 'FTL'){
                if(resp.data.length> 0){
                    setIsMoreInvoices(true)
                    var data = resp.data;
                    
                    const uniquePincodesSet = new Set();

                    const updatedPincodesList = data
                        .map(e => e.consignee_pincode) // Extract only the pincode
                        .filter(pincode => {
                            // Only keep unique values
                            if (!uniquePincodesSet.has(pincode)) {
                                uniquePincodesSet.add(pincode);
                                return true; // Include this pincode in the result
                            }
                            return false; // Skip if it's a duplicate
                        })
                        .map(pincode => ({
                            label: pincode,
                            value: pincode
                        }));
                
                    setPincodesList(updatedPincodesList);
                } else {
                    setShow(true)
                    setTitle("No Records Found")
                    setType("danger")
                }          
              }
        })
        .catch(err => console.log(err))
        if(e.data.tracking_type === "PTL"){
            setSelectedStatusUpdate(e.data.consignment_status)
            const updatedStatusOrderPtl = e.data.consignment_status === "Undelivered"
            ? statusOrderPtl.filter(status => status.value !== "In Transit")
            : statusOrderPtl;
            setForm2Details((prev) => ({
                ...prev,
                event_status: updatedStatusOrderPtl,
                selectedStatus: {label:e.data.consignment_status, value: e.data.consignment_status}, // Add a new state variable to store the selected status
                selectedPincode: {label:'', value:''},
                event_location: "",
                remark: "",
                reason_for_delay:"",
                delivered_date:new Date(),
                errorMessage:''
            }))
        } else {

            setForm2Details((prev) => ({
                ...prev,
                event_status: statusOrderFtl,
                selectedStatus: "", // Add a new state variable to store the selected status
                selectedPincode: {label:'', value:''},
                event_location: "",
                remark: "",
                reason_for_delay:"",
                delivered_date:new Date(),
                errorMessage:''
            }))
            switch (e.data.status) {
                case 1:
                    setSelectedStatusUpdate("At Source")

                    setForm2Details((prev) => ({
                        ...prev,
                        selectedStatus: { value: "At Source", label: "At Source" }
                    }));
                    break;
                case 2:
                    setSelectedStatusUpdate("In Transit")

                    setForm2Details((prev) => ({
                        ...prev,
                        selectedStatus: { value: "In Transit", label: "In Transit" }
                    }));
                    break;
                case 3:
                    setSelectedStatusUpdate("Near Destination")

                    setForm2Details((prev) => ({
                        ...prev,
                        selectedStatus: { value: "Near Destination", label: "Near Destination" }
                    }));
                    break;
                case 4:
                    setSelectedStatusUpdate("Reached Destination")

                    setForm2Details((prev) => ({
                        ...prev,
                        selectedStatus: { value: "Reached Destination", label: "Reached Destination" }
                    }));
                    break;
                default:
                    // Optionally handle unexpected status values
                    console.warn(`Unknown status: ${e.data.status}`);
                    break;
            }
        }
      };
      const updateBulkPTLStatus = async() => {
        const x = selectedRows.map((e)=> ({label:e.lr_no, value: e.lr_no}))
        const y =selectedRows.map((e)=> (e.truck_no))
        const z =selectedRows.map((e)=> (e.shipment_id))


        var isValid = selectedRows.every(row=> row.tracking_type === selectedRows[0].tracking_type);
        if(!isValid){
            setShow(true)
            setTitle("Please select the same tracking mode consignments")
            setType("danger")
            return "";
        }
        var tracking_type = selectedRows[0].tracking_type;

        setBulkTrackingType(tracking_type)

      

        // setForm2Details((prev) => ({
        //     ...prev,
        //     selectedStatus: { label: e.data.consignment_status, value: e.data.consignment_status }, // Set the selected status from e.data
        // })); 
        // if(tracking_type === "PTL"){
        //     var isValid1 = selectedRows.every(row=> row.consignment_status === selectedRows[0].consignment_status);
        //     if(!isValid1){
        //         setShow(true)
        //         setTitle("Please select the same status consignment")
        //         setType("danger")
        //         return "";
        //     }


        //     setSelectedStatusUpdate(selectedRows[0].consignment_status)
        //     setSelectLRSToUpdate(x);
        //     setSelectShipmentUpdate(z);
        //     setSelectTruckUpdate(y);


        //     setForm2Details((prev) => ({
        //         ...prev,
        //         event_status: statusOrderPtl,
        //         selectedStatus: {label:selectedRows[0].consignment_status, value: selectedRows[0].consignment_status}, // Add a new state variable to store the selected status
        //         selectedPincode: {label:'', value:''},
        //         event_location: "",
        //         remark: "",
        //         delivered_date:new Date(),
        //         errorMessage:''
        //     }))
        // } else {
        //     var isValid1 = selectedRows.every(row=> row.status === selectedRows[0].status);
        //     if(!isValid1){
        //         setShow(true)
        //         setTitle("Please select the same status consignment")
        //         setType("danger")
        //         return "";

        //     }
        //     setSelectLRSToUpdate(x);
        //     setSelectShipmentUpdate(z);
        //     setSelectTruckUpdate(y);
            
        //     setForm2Details((prev) => ({
        //         ...prev,
        //         event_status: statusOrderFtl,
        //         selectedStatus: "", // Add a new state variable to store the selected status
        //         selectedPincode: {label:'', value:''},
        //         event_location: "",
        //         remark: "",
        //         delivered_date:new Date(),
        //         errorMessage:''
        //     }))
        //     switch (selectedRows[0].status) {
        //         case 1:
        //             setSelectedStatusUpdate("At Source")

        //             setForm2Details((prev) => ({
        //                 ...prev,
        //                 selectedStatus: { value: "At Source", label: "At Source" }
        //             }));
        //             break;
        //         case 2:
        //             setSelectedStatusUpdate("In Transit")

        //             setForm2Details((prev) => ({
        //                 ...prev,
        //                 selectedStatus: { value: "In Transit", label: "In Transit" }
        //             }));
        //             break;
        //         case 3:
        //             setSelectedStatusUpdate("Near Destination")

        //             setForm2Details((prev) => ({
        //                 ...prev,
        //                 selectedStatus: { value: "Near Destination", label: "Near Destination" }
        //             }));
        //             break;
        //         case 4:
        //             setSelectedStatusUpdate("Reached Destination")

        //             setForm2Details((prev) => ({
        //                 ...prev,
        //                 selectedStatus: { value: "Reached Destination", label: "Reached Destination" }
        //             }));
        //             break;
        //         default:
        //             // Optionally handle unexpected status values
        //             console.warn(`Unknown status: ${selectedRows[0].status}`);
        //             break;
        //     }
        // }    
        
        // setBulkPtlUpdate(true)
        // setShipmentId(e.data.shipment_id)
        // setshowAddForm2("slider-translate-30p");
        setshowBulkUpdateForm("slider-translate-84p")
        setOverlay("show-m");
      
            
     
           
      };  
    const onClickActive1 = (e) => {
    setselected_row(e.data);
    setshowAddForm1("slider-translate-30p");
    setOverlay("show-m");
    };
    const resetFilters = () => {
        setSeachValue("");
        setLrNo("");
        setSearchInvoice("");
        setSearchVehicle({ value:"", label:"" });
        loadConsignmentsData()
    }
    const resetFilters1 = () => {
        setSearchConsigner([]);
        setSearchTransporters([]);
        setSearchStates([]);
        setSearchEntity([]);
        setSearchCity([]);
        setSearchPodStatus([]);
        setSearchTrackingType({})
        setSearchPerformance({})
        setSearchDateType({ label: "Invoice", value: "Invoice"})
        setStartDate('');
        setEndDate('');
        loadConsignmentsData()
    }
    // secondboxfunction
    const onGetConsignments = async (event) => {
        // if (startDate && (!endDate || endDate === "NaN-NaN-NaN")) {
        //     setError("End date is required when a start date is provided.");
        //     setShow(true);
        //     setTitle
        //     return; // Prevent the function from proceeding
        // }
        

        
        let query = {}
        if (searchCity && searchCity.length > 0) {
            query["consignee_city"] = searchCity.map((city) => city.value);
        }
        if (searchPodStatus && searchPodStatus.length > 0) {
            query["pod_status"] = searchPodStatus.map((status) => status.value);
        }

        if (startDate == '' || startDate == "NaN-NaN-NaN") {
            var sDate = "";
        }
        else {
            query["date_type"] =searchDateType.value
            query["sdate"] = moment.parseZone(new Date(startDate)).format("YYYY-MM-DD")
        }

        if (endDate == '' || endDate == "NaN-NaN-NaN") {
            var eDate = "";
        }
        else {
            query["edate"] = moment.parseZone(new Date(endDate)).format("YYYY-MM-DD")
        }

        // if (searchConsigner == null || searchConsigner[0]?.value == '' || (searchConsigner.length == 1 && searchConsigner[0]?.value == 'all') ) {
        // }
        // else {
        //     query["consigner_code"] = searchConsigner.map(e => e.value)
        // }
        if (searchConsigner && searchConsigner.length > 0) {
            query["consigner_code"] = searchConsigner.map((e) => e.value);
        }
        if (searchState && searchState.length > 0) {
            query["consignee_state"] = searchState.map((state) => state.value);
        }
        if (searchEntity && searchEntity.length > 0) {
            query["truck_seal_entity"] = searchEntity.map((entity) => entity.value);
        }
        if (searchTransporters && searchTransporters.length > 0) {
            query["transporter_name"] = searchTransporters.map((tpt) => tpt.value);
        }

        if (searchPerformance.value!=="") {
            query["ontime_status"] = searchPerformance.value
        }

       
       
        
        query.tabType = tabName.value;
       
            query.tracking_type = searchTrackingType.value
        if(decodedRoleCase === "transporter" && localStorage.getItem("transporter")!=="All"){
            query.transporter_name = [localStorage.getItem("transporter")]
        }
        if (
            zoneConversion &&
            zoneConversion.length > 0 &&
            !zoneConversion.includes("all")
        ) {            
            query.consignee_zone = zoneConversion;
}
        if (
            stateConversion &&
            stateConversion.length > 0 &&
            !stateConversion.includes("all")
        ) {            
            query.consignee_state = stateConversion;
        }
        if (
            locationNameConversion &&
            locationNameConversion.length > 0 &&
            !["all numeric shipments", "all sites", "all shipment"].some((item) => locationNameConversion.includes(item))
    ) {            
            query.consigner_name = locationNameConversion;
            query.consigner_code = locationNameConversion;
}
if(entityConversion && entityConversion.length > 0 && !["all"].some((item)=> entityConversion.includes(item))){
                    
    query.truck_seal_entity = entityConversion
}       

        await redirectURL.post("consignments/filterCombinedConsignments", query)
        .then(resp => {
            if(resp.data.totalConsignments.length> 0 || resp.data.consignments.length > 0){
                fragmentData(resp)
            } else {
                setCountersActive({
                    consignments: 0,
                    inTransit: 0,
                    transit_delays: 0,
                    stoppages: 0,
                    no_gps_data: 0,
                    outfordelivery: 0,
                    at_source:0,
                    dispatched_from_source:0,
                    arrived_at_destination:0
                })
                setCountersCompleted({
                    consignments:0,
                    // delivered: completed_delivered.length,
                    onTime: 0,
                    delayed: 0,
                    podPending: 0,
                    zeroToOneDays: 0,
                    oneToTwoDays: 0,
                    threeToFiveDays: 0,
                    sixToTenDays: 0,
                    gtTenDays: 0
                })
                setCountersAll({
                    consignments:0,
                    inTransit: 0,
                    transit_delays: 0,
                    no_gps_data: 0,
                    stoppages: 0,
                    disabled: 0,
                    undelivered: 0,
                    delivered: 0,
                    outfordelivery:0,
                    podPending: 0,
                    at_source:0,
                    dispatched_from_source:0,
                    arrived_at_destination:0
    
                })
    
                // setShow(true)
                // setTitle("No Records Found")
                // setType("danger")
                setRowData([])

            }
        })
        .catch(err => console.log(err))
    }
    const onClickShowForm=()=> {
        setOverlay("show-m")
        setErrorMssge("")
        setSliderCreateConsignmentTranslate("slider-translate-30p")
	}
    const changeHandler = (event) => {
        const { name, value } = event.target;
        if (name === "driver_mobile_num" || name === "transit_days") {
            if (value !== "" && value !== undefined) {
                if (value > 0) {
                    setFormData(prevState => ({
                        ...prevState,
                        [name]: value.replace(/\D/g, '')
                    }));
                }
            } else {
                setFormData(prevState => ({
                    ...prevState,
                    [name]: value.replace(/\D/g, '')
                }));
            }
        } else {
            setFormData(prevState => ({
                ...prevState,
                [name]: value
            }));
        }
    };
    // const onClickHideAll=()=> {
	// 	var uploadfilebulk = $("#uploadfile").val(null)
	// 	this.setState({
	// 		loadshow: 'show-n',
	// 		overly: 'show-n',
	// 		slideuploadeway: '',
	// 		sliderRouteTranslate: '',
	// 		sliderSegmentTranslate: "",
	// 		tabsliderTranslate: '',
	// 		sliderTranslatesidebar: '',
	// 		sliderForceCloseTranslate: '',
	// 		sliderChangeDriverDetails:'',
	// 		sliderCommentTranslate: "",
	// 		bulkPrioritySlide: "",
	// 		sliderCreateConsignmentTranslate: "",
	// 		sliderRso:"",
	// 		sliderSimConsent:"",
	// 		uploadfilebulk:uploadfilebulk
	// 	});

	// }
    const onGridReady = useCallback((params) => {
        gridApi.current = params.api;
        gridApi2.current = params.columnApi;
    }, [tabName]);
    const onGridReadyBulkUpdate = useCallback((params) => {
        gridApiUpdateConsignments.current = params.api;
        // gridApiUpdateConsignments.current = params.columnApi;
    }, [tabName]);


    function getExportableColumnKeys(columnDefs) {
        // Filter out the columns that contain custom renderers for icons or buttons
        return columnDefs.filter(col => !col.cellRenderer && !col.cellRendererSelector)
                         .map(col => col.field);
    }
    var exportParams={}
    
    if(tabName.value === "active"){
        if(searchViewType.value ==="LR"){
            exportParams.columnKeys=["tracking_type","sim_consent_status","lr_no", "invoice_no", "truck_no","status", "invoice_time", "dispatch_date","consignee_code", "consginee_name", "truck_seal_entity", "invoice_type", "transporter_name", "consigner_city", "consigner_pincode",  "consigner_zone", "consignee_city", "consignee_pincode", "consignee_state",  "consignee_zone", "driver_mobile_no", "movement_type", "total_weight", "total_cbm", "tpt_category", "truck_type", "truck_seal_no", "origin_destination_area", "transit_time", "last_location", "event_date_time","last_process_on", "expected_trip_end", "revised_trip_end", "ontime_status", "transit_delay_days", "delay_days_bucket", "eway_bill_no",  "shipment_mode", "fuel_type", "no_of_boxes" ]
        }else{
            exportParams.columnKeys=["tracking_type","sim_consent_status","lr_no","invoice_no","truck_no","status","reason_for_delay","invoice_time","dispatch_date","consignee_code","consignee_name","truck_seal_entity","invoice_type","transporter_name","consigner_city","consigner_pincode","consigner_zone","consignee_city","consignee_pincode","consignee_state","consignee_zone","driver_mobile_no","movement_type","total_weight","total_cbm","tpt_category","truck_type","truck_seal_no","origin_destination_area","transit_time", "last_location", "event_date_time","last_process_on","expected_trip_end","revised_trip_end","recent_dealer_reported","ontime_status", "transit_delay_days","delay_days_bucket","delivery_performance","eway_bill_no","shipment_mode",
                "fuel_type","no_of_boxes","remarks" ]        
        }
    }
    else if (tabName.value ==="completed"){
        if(searchViewType.value ==="LR"){
            exportParams.columnKeys=["tracking_type","sim_consent_status","truck_no","lr_no","invoice_no","status","invoice_time","dispatch_date","consignee_code","consignee_name","truck_seal_entity","invoice_type","transporter_name","consigner_city","consigner_pincode","consigner_zone","consignee_city","consignee_pincode","consignee_state","consignee_zone","last_location","delivery_station","driver_mobile_no","movement_type","total_weight","total_cbm","tpt_category","truck_type","truck_seal_no","origin_destination_area","pod_status","transit_time", "last_location", "event_date_time","last_process_on","expected_trip_end","revised_trip_end","recent_dealer_reported","ontime_status","transit_delay_days","delay_days_bucket","eway_bill_no","shipment_mode","fuel_type","no_of_boxes" ]
        }else{
            exportParams.columnKeys=["tracking_type","sim_consent_status","lr_no","invoice_no","truck_no","status","reason_for_delay","invoice_time","dispatch_date","consignee_code","consignee_name","truck_seal_entity","invoice_type","transporter_name","consigner_city","consigner_pincode","consigner_zone","consignee_city","consignee_pincode","consignee_state","consignee_zone","driver_mobile_no","movement_type","total_weight","total_cbm","tpt_category","truck_type","truck_seal_no","origin_destination_area","transit_time", "last_location", "event_date_time","last_process_on","expected_trip_end","revised_trip_end","recent_dealer_reported","ontime_status","transit_delay_days","delay_days_bucket","eway_bill_no","shipment_mode",
                "fuel_type","no_of_boxes","remarks" ]        
        }
    }else if(tabName.value ==="all"){
        if(searchViewType.value ==="LR"){
            exportParams.columnKeys=["tracking_type","sim_consent_status","lr_no","invoice_no","truck_no","status","reason_for_delay","invoice_time","dispatch_date","consignee_code","consignee_name","truck_seal_entity","invoice_type","transporter_name","consigner_city","consigner_pincode","consigner_zone","consignee_city","consignee_pincode","consignee_state","consignee_zone","driver_mobile_no","movement_type","total_weight","total_cbm","tpt_category","truck_type","truck_seal_no","origin_destination_area","transit_time", "last_location", "event_date_time","last_process_on","expected_trip_end","revised_trip_end","recent_dealer_reported","ontime_status","transit_delay_days","delay_days_bucket","eway_bill_no","shipment_mode",
                "fuel_type","no_of_boxes","remarks" ]        
        }else{
            // exportParams.columnKeys=["invoice_no","lr_no","tracking_type","expected_eta","revised_eta","status","consignee_city","customer_name","distance_in_km","distance_from_dealer_location","recent_dealer_reported","transit_time","transit_delay_hours" ]
            exportParams.columnKeys=["tracking_type","sim_consent_status","lr_no","invoice_no","truck_no","status","reason_for_delay","invoice_time","dispatch_date","consignee_code","consignee_name","truck_seal_entity","invoice_type","transporter_name","consigner_city","consigner_pincode","consigner_zone","consignee_city","consignee_pincode","consignee_state","consignee_zone","driver_mobile_no","movement_type","total_weight","total_cbm","tpt_category","truck_type","truck_seal_no","origin_destination_area","transit_time", "last_location", "event_date_time","last_process_on","expected_trip_end","revised_trip_end","recent_dealer_reported","ontime_status","transit_delay_days","delay_days_bucket","eway_bill_no","shipment_mode",
                "fuel_type","no_of_boxes","remarks" ]        

        }
      
    }else if(tabName.value ==="force_close"){
        if(searchViewType.value ==="LR"){
            exportParams.columnKeys=["tracking_type","sim_consent_status","lr_no","invoice_no","truck_no","status","reason_for_delay","invoice_time","dispatch_date","consigner_name","consignee_code","consignee_name","truck_seal_entity","invoice_type","transporter_name","consigner_city","consigner_pincode","consigner_zone","consignee_city","consignee_pincode","consignee_state","consignee_zone","driver_mobile_no","movement_type","total_weight","total_cbm","tpt_category","truck_type","truck_seal_no","origin_destination_area","transit_time", "last_location", "event_date_time","last_process_on","expected_trip_end","revised_trip_end","recent_dealer_reported","ontime_status","transit_delay_days","delay_days_bucket","eway_bill_no","shipment_mode",
                "fuel_type","no_of_boxes","remarks" ]        
        }else{
            exportParams.columnKeys=["tracking_type","sim_consent_status","lr_no","invoice_no","truck_no","status","reason_for_delay","invoice_time","dispatch_date","consigner_name","consignee_code","consignee_name","truck_seal_entity","invoice_type","transporter_name","consigner_city","consigner_pincode","consigner_zone","consignee_city","consignee_pincode","consignee_state","consignee_zone","driver_mobile_no","movement_type","total_weight","total_cbm","tpt_category","truck_type","truck_seal_no","origin_destination_area","transit_time", "last_location", "event_date_time","last_process_on","expected_trip_end","revised_trip_end","recent_dealer_reported","ontime_status","transit_delay_days","delay_days_bucket","eway_bill_no","shipment_mode",
                "fuel_type","no_of_boxes","remarks" ]        
        }
      
    }
    else if(tabName.value ==="cancelled"){
        exportParams.columnKeys = ["tracking_type","invoice_no","invoice_time","truck_no","status","creation_time","consigner_name","consignee_code","consignee_name","consignee_city","consignee_pincode","total_weight","total_cbm","truck_seal_entity","invoice_type", "transporter_name","consigner_city","consigner_pincode","consigner_zone","consignee_state","consignee_zone", "reasonForCancellation"]
    }
    else if(tabName.value ==="inactive"){
        exportParams.columnKeys = ["tracking_type","sim_consent_status","invoice_no","truck_no","status","invoice_time","consignee_code","consignee_name","truck_seal_entity","invoice_type","transporter_name","consigner_city","consigner_pincode","consigner_zone","consignee_city","consignee_pincode","consignee_state","consignee_zone","total_weight","total_cbm","tpt_category","truck_type","origin_destination_area","eway_bill_no","shipment_mode","fuel_type","no_of_boxes"]
    }
    var updateExportParams ={}
    if(tabName.value === "active"){
        updateExportParams.columnKeys=["lr_no", "dispatch_date", "consginee_name", "consignee_city", "expected_trip_end", "status","last_location","event_date_time", "current_status", "current_location", "current_event_date_time", "reason_for_delay"]
    }

    const getFormattedStatus=(row)=>{

        if(row.status !== undefined){
            return statusMap[row.status] || "Not Available";
        }

        if(row.consignment_status !== undefined){
            return row.consignment_status || "Not Available"
        }

        return "Not Available";
    }
    
    const updateColDefs = (gridApi, additionalCols, selectedRows) => {
        const currentColDefs = gridApi.getColumnDefs();
    
        // Update or filter columns based on selected rows
        const updatedColumnDefs = selectedRows.length > 0
            ? [...currentColDefs, ...additionalCols] // Add additional columns
            : currentColDefs.filter(col => !["last_location", "current_status", "current_location", "event_date_time", "reason_for_delay"].includes(col.field)); // Remove columns
    
        // Set updated column definitions
        gridApi.setColumnDefs(updatedColumnDefs);
    };
   
    const onExportClick =()=>{
        const selectedRows = gridApiConsignments.current.getSelectedRows();

        const additionalColsForUpdate=[
            // {
            //     headerName: "Event Location",
            //     field: "last_location",
            //     width: 150,
            //     resizable: true,
            //     headerClass: 'bold-header',
            // },
            {
                headerName: "Current Status",
                field: "current_status",
                width: 150,
                resizable: true,
                headerClass: 'bold-header',
            },
            {
                headerName: "Current Location",
                field: "current_location",
                width: 150,
                resizable: true,
                headerClass: 'bold-header',
            },
            {
                headerName: "Current Event Date & Time",
                field: "current_event_date_time",
                width: 150,
                resizable: true,
                headerClass: 'bold-header',
            },
            {
                headerName: "Reason for delay",
                field: "reason_for_delay",
                width: 150,
                resizable: true,
                headerClass: 'bold-header',
            }
        ]

        updateColDefs(gridApiConsignments.current, additionalColsForUpdate, selectedRows);


        setTimeout(() => {
            const exportData = selectedRows.length > 0 ? selectedRows : rowData;
            const params = selectedRows.length > 0 ? updateExportParams : exportParams;
    
            const formattedData = exportData.map(row => ({
                ...row,
                status: getFormattedStatus(row),
                last_location: "",
                current_status: "",
                current_location: "",
                event_date_time: "",
                reason_for_delay: "",
            }));
    
            gridApiConsignments.current.setRowData(formattedData);
            gridApiConsignments.current.exportDataAsExcel(params);
        }, 0);
    }
    const onGridReadyConsignments = useCallback((params) => {
        gridApiConsignments.current = params.api;
        columnApiConsignments.current = params.columnApi;
    
        if (
            tabName.value === "completed" ||
            counterActive === "Undelivered" ||
            counterActive === "Stoppages" ||
            counterActive === "Tracking N/A" ||
            counterActive === "Disabled"
        ) {
            columnApiConsignments.current.setColumnsVisible(["cancel_order"], false);
        }
        // const exportParams = {
        //     columnKeys:["tracking_type","lr_no", "invoice_no", "truck_no","consignment_status", "reason_for_delay", "invoice_time", "dispatch_date", "consginee_name", "truck_seal_entity", "invoice_type", "transporter_name", "consigner_city", "consigner_pincode",  "consigner_zone", "consignee_city", "consignee_pincode", "consignee_state",  "consignee_zone", "driver_mobile_no", "movement_type", "total_weight", "total_cbm", "tpt_category", "truck_type", "truck_seal_no", "origin_destination_area", "transit_time", "last_process_on", "expected_trip_end", "revised_trip_end", "delivery_performance", "eway_bill_no",  "shipment_mode", "fuel_type", "no_of_boxes" ]
        // };
        
        // gridApiConsignments.current.exportDataAsExcel(exportParams);
        
        
        // const exportParams = {
        //     columnKeys: params.api
        //         .getAllColumns()  // Get all columns
        //         .slice(2)  // Exclude the first column (index 0)
        //         .map(col => col.getColId())  // Map columns to their field (colId)
        // };
        // // // Replace default Excel export behavior with the custom one
        // params.api.gridOptionsWrapper.gridOptions.getContextMenuItems = () => {
        //     console.log("Default Context Menu Items:", defaultItems); // Debug default items
        //     const customMenu = [
        //         // ...defaultItems, // Retain default items
        //         {
        //             name: "Export to Excel",
        //             action: () => {
        //                 console.log("Export to Excel triggered"); // Debug when action is triggered
        //                 gridApiConsignments.current.exportDataAsExcel(exportParams);
        //             },
        //         },
        //     ];
        //     console.log("Custom Menu Items:", customMenu); // Debug custom menu
        //     return customMenu; // Return modified menu
        // };
        
        }, [tabName, counterActive]);

    const onClickHideManualUpload = () => {
        setshowAddForm("");
        setOverlay("show-n");
        setmanualUploadDetails((prev) => ({
          ...prev,
          lr_no: "",
          lr_status: {label:"",value:''},
        }));
        setmanualUploadDetails1((prev)=> ({
            ...prev,
            lr_no: "",
            invoice_no: selected_row.invoice_no || '',
            consignee_name: "",
            consignee_city: "",
            consignee_state: "",
            consignee_pincode: "",
            total_weight: ""
        }))
    };
    const onCloseUpdateDetails= () => {
        setManualInTransitStatusUpdate({dispatch_time:""})
        // setManualInTransitStatusUpdate.dispatch_time("")
        setOpenMap({
            sliderRouteTranslate: "",
            showDiv: 'show-n',
            mapinfo: [],
            dealer: "",
            lr_no: "",
            maptruckno: "",
            geofence_coordinates: [],
            parking_coordinates: [],
            routeTruck: { "truck_no": '', "startTime": '', "endTime": '' },
            loadshow: 'show-n',
            sidebarSubHeader: "",
            overly: 'show-m',
            rownode: {},
            leg_no: 0,
            tolls: []
        })
        setDselected_row({})        
        document.getElementById("uploadDoc").value = "";
        // document.getElementById("File").value = "";
        setSliderShow1("")
        setSliderShow("");
        setDocRemarks("")
        setshowAddForm2("")
        setForm2Details({
            event_status:statusOrderPtl,
            selectedStatus: {value: 'In Transit', label: 'In Transit'},
            selectedPincode: {value: '', label: ''},
            event_location: "",
            remark: "",
            reason_for_delay:"",
            delivered_date:'',
            errorMessage:''
        })
        setshowAddForm("")
        setshowAddForm3("")
        setErrorMssge("");
        setEnableSourceField(false);
        
        setShowUpdateLrForm("")
        setSliderCreateConsignmentTranslate("")
        setBulkUploadModal({
            overly: "show-n",
            bulkPrioritySlide: ""
        })
        setOverlay("show-n")
        setLoadShow("show-n")
        setSliderCreateConsignmentTranslate("")
        setManualTripUploadDetails([])
        setManualUpdateConsignment({
            driver_number: '',
            source: "",
            truck_no: "",
            truck_seal_no: "",
            vehicle_type: "",
            courier_partner:"",
            vehicle_capacity: "",
            consignee_name: "",
            lr_no: "",
            invoice_no: "",
            no_of_boxes: "",
            destination_pincode: "",
            destination_city:""
          })
        document.getElementById("epodDoc").value = "";
        setDamage("")
        setExcess("")
        setPilferage("")
        setShort("")
        setPodRemarks("")
        document.getElementById("formPOD").reset();
        setFormData({
            driver_mobile_no:'',
            source:'',
            truck_no:'',
            truck_seal_no:'',
            entity:'',
            vehicle_type:{label:'', value:''},
            courier_partner:{label:'', value:''},
            eway_bill_expiry_date:'',
            // vehicle_capacity:{label:'', value:''},
            vehicle_capacity:'',
            consignee_name:'',
            movement_type:'',
            lr_no:'',
            invoice_no:[],
            invoice_no_str:"",

            number_of_boxes:'',
            destination_pincode:'',
            destination_city:'',
            show: false,
            basicType: '',
            basicTitle: '',
            sliderCreateConsignmentTranslate: '',
            loadshow: 'show-n',
            overly: 'show-n',
        })
    }
const onClickGateOutUpdate = (e)=>{
    e.preventDefault();
    setGateOutSlide("slide95")
    setOverlay("show-m")
    setGateOutRow(e.data)
}

const handleDispatchClick = (e) => {
    e.stopPropagation(); // Prevent the row from being selected
    // setselected_row(e.data);
    // setshowAddForm("slide30");
    
    setDispatchTime(!dispatchTime)// Call the provided function
};
// const changeHandleDate = (date) => {
//     // Ensure both 'date' and 'invoice_time' are Date objects
//     const invoice_time = new Date(Dselected_row.invoice_time);  // Invoice time from your data source
//     const selectedDate = new Date(date);  // The date you're passing to the function

//     // Reset time to midnight for both dates (ignoring time part)
//     invoice_time.setHours(0, 0, 0, 0);  // Set time to midnight for invoice time
//     selectedDate.setHours(0, 0, 0, 0);  // Set time to midnight for selected date

//     // Extract year, month, and day from both dates
//     const invoiceYear = invoice_time.getFullYear();
//     const invoiceMonth = invoice_time.getMonth(); // Months are zero-indexed, so January is 0
//     const invoiceDate = invoice_time.getDate();

//     const selectedYear = selectedDate.getFullYear();
//     const selectedMonth = selectedDate.getMonth();
//     const selectedDay = selectedDate.getDate();

//     console.log(selectedYear, selectedMonth, selectedDay, "selectedDate");
//     console.log(invoiceYear, invoiceMonth, invoiceDate, "invoiceTime");

//     // Compare the date parts (year, month, and day)
//     if (
//         selectedYear >= invoiceYear || 
//         (selectedYear === invoiceYear && selectedMonth >= invoiceMonth) || 
//         (selectedYear === invoiceYear && selectedMonth === invoiceMonth && selectedDay >= invoiceDate)
//     ) {
//         setManualInTransitStatusUpdate((prev) => ({
//             ...prev,
//             dispatch_time: selectedDate,
//         }));
//     } else {
//         setShow(true);
//         setTitle("Dispatch date should be greater than invoice date");
//         setType("danger");
//     }
// };
const changeHandleDate = (date) => {

    setManualInTransitStatusUpdate((prev) => ({
        ...prev,
        dispatch_time: date,
        }))};
        
const changeHandleDate2 = (date) => {
    
    setManualUpdateLRConsignment((prev) => ({
                ...prev,
                dispatch_time: date,
}))};



const hideGateoutSubmit = ()=>{
    setGateOutSlide("");
    setOverlay("show-n");

}
    const onClickHideManualUpload1 = () => {
        setshowAddForm("");
        showAddForm1("")
        setOverlay("show-n");
        setmanualUploadDetails1((prev) => ({
          ...prev,
          invoice_no:'',
          lr_no: "",
        }));
      };
    const onsubmitdata = (e) => {
        e.preventDefault()
        var data = {
            invoice_no: manualUploadDetails1.invoice_no,
            consignee_name: manualUploadDetails1.consignee_name,
            consignee_city:manualUploadDetails1.consignee_city,
            consignee_state: manualUploadDetails1.consignee_state,
            consignee_pincode:manualUploadDetails1.consignee_pincode,
            total_weight:manualUploadDetails1.total_weight
        }
        redirectURL.post('/consignments/updatePTLConsignments', data).then((resp) => {
            if (resp.data.message == 'success') {
                setShow(true)
                setTitle("PTL Consignments has been successfully updated!")
                setType("success")
                setLoadShow('show-n')
                setOverlay('show-n')
                setshowAddForm('')
                loadConsignmentsData()
                setmanualUploadDetails1({
                    lr_no: "",
                    invoice_no: selected_row.invoice_no || '',
                    consigner_name: "",
                    consignee_city: "",
                    consignee_state: "",
                    consignee_pincode: "",
                    total_weight: ""
                })
                // window.location.reload();
            }
            else{
                setShow(true)
                setTitle("Please Upload Valid Details")
                setType("danger")
                setLoadShow('show-n')
                setOverlay('show-n')
                setmanualUploadDetails1({
                    lr_no: "",
                    invoice_no: selected_row.invoice_no || '',
                    consigner_name: "",
                    consignee_city: "",
                    consignee_state: "",
                    consignee_pincode: "",
                    total_weight: ""
                })
            }
        })
        setmanualUploadDetails((prev) => ({
            ...prev,
            lr_no: "",
            lr_status: {label:"",value:''},
            location: "",
            arrival_time: "",
            invoice_no: "",
          }));

    } 
    const updateDispatchTime = (dispatch_time) => {
        // Prepare the data to be sent in the POST request
        const data = {
            dispatch_time: moment.parseZone(dispatch_time).utcOffset("+05:30")._d,  // Convert the dispatch time to the desired timezone
            shipment_id: Dselected_row.shipment_id,
            truck_no: Dselected_row.truck_no,
            tracking_type: Dselected_row.tracking_type
        };
    
        // Send the request to the backend
        redirectURL.post('/consignments/updatedispatchtime', data)
            .then((resp) => {
                if (resp.data.message === 'success') {
                    // Success Response
                    setShow(true);
                    setTitle("Dispatch time has been successfully updated!");
                    setType("success");
                    setLoadShow('show-n');
                    setOverlay('show-n');
                    setshowAddForm1('');
                    setshowAddForm2('');
                    // Optionally reload the page or trigger any necessary UI updates
                    // window.location.reload();
                    // props.onRequest('2');
                    // setreloadcheck(true);
                } else {
                    // Failure Response
                    setShow(true);
                    setTitle("Please Upload Valid Details");
                    setType("danger");
                    setLoadShow('show-n');
                    setOverlay('show-n');
                }
            })
            .catch((error) => {
                // Handle any network or server errors
                setShow(true);
                setTitle("An error occurred while updating dispatch time.");
                setType("danger");
                setLoadShow('show-n');
                setOverlay('show-n');
                console.error('Error updating dispatch time:', error);
            });
    };
    
    const onsubmitdata1 = async(e) => {
        setGateOutSlide("")


        e.preventDefault()
        
        const invoice_time1 = moment(Dselected_row.invoice_time);  // Parse the date from your data source
        const adjustedTime = invoice_time1.subtract(5, 'hours').subtract(30, 'minutes');
        const invoice_time= adjustedTime.toDate()

        const selectedDate = new Date(manualInTransitStatusUpdate.dispatch_time);  // The date you're passing to the function
    
        // Log for debugging
    
        // Check if the selected date is the same day as the invoice date
        const isSameDay = selectedDate.toDateString() === invoice_time.toDateString();
        
    
        if (isSameDay) {
            // If the selected date is the same day, ensure the time is greater than or equal to the invoice time
            if (selectedDate >= invoice_time) {
                // If selected date and time is greater than or equal to invoice time
                updateDispatchTime(manualInTransitStatusUpdate.dispatch_time)
            } else {
                // If selected time is earlier than invoice time
                setShow(true);
                setTitle("Dispatch time should be greater than or equal to invoice time");
                setType("danger");
            }
        } else if (selectedDate > invoice_time) {
            // If the selected date is later than the invoice date, it's valid
            updateDispatchTime(manualInTransitStatusUpdate.dispatch_time)

        } else {
            // If the selected date is earlier than the invoice date, it's invalid
            setShow(true);
            setTitle("Dispatch date should be greater than invoice date");
            setType("danger");
        }        
      
        // }
        // else{
        //     setshow(true)
        //     setbasicTitle("Please Select Transporter")
        //     setbasicType("danger")
        //     setloadshow('show-n')
        //     setoverly('show-n')
        // }
        // setmanualUploadDetails14((prev) => ({
        //     ...prev,
        //     dispatch_time: "",
          
        //   }));

    } 
    const handleRemoveDropPoint = (id) => {        
        setManualTripUploadDetails((prevDetails) => prevDetails.filter(point => point.id !== id));
        setSelectedConsignees((prevSelected) => {
            const removedConsignee = manualTripUploadDetails.find(point => point.id === id)?.consignee_name;
            return prevSelected.filter(name => name !== removedConsignee);
        });
    };
    
    const handleConsigneeChange = (pointId, consigneeName) => {
        setManualTripUploadDetails((prevDetails) =>
            prevDetails.map((point) => {
                if (point.id === pointId) {
                    const updatedPoint = { ...point, consignee_name: consigneeName };
                    if (consigneeName === "Others") {
                        updatedPoint.destination_pincode = "";
                        updatedPoint.destination_city = "";
                        setShowCustomConsigneeInput((prev) => ({
                            ...prev,
                            [pointId]: true, 
                        }));
                    } else {
                        setShowCustomConsigneeInput((prev) => ({
                            ...prev,
                            [pointId]: false, 
                        }));
                    }
    
                    return updatedPoint;
                }
                return point;
            })
        );
    };
    
    const setShowCustomConsigneeInputFun = (pointId, isVisible) => {
        setShowCustomConsigneeInput(prev => ({
            ...prev,
            [pointId]: isVisible,
        }));
    };
    const fetchDestinationDetails = async (consigneeCode, pointId) => {
        try {
    
            const response = await redirectURL.post('/consignments/getDestinationDetails', { consignee_code: consigneeCode });
            const data = response.data.consigneeDetails[0]; 
            if (data) {
                setManualTripUploadDetails(prevDetails =>
                    prevDetails.map(point =>
                        point.id === pointId
                            ? {
                                  ...point,
                                  destination_pincode: data.consignee_pincode, 
                                  destination_city: data.consignee_city, 
                              }
                            : point
                    )
                );
            }
        } catch (error) {
            console.error("Error fetching destination details:", error);
        }
    };
    const handleInputChange = (id, field, value) => {
        const invoiceNumberPattern = /^\d+\/[A-Za-z]{3}$/;
    
        // Handle validation for invoice number
        if (field === 'invoice_no') {
            const invoicePattern = /^[A-Za-z0-9]+\/.*/;

            if(invoicePattern.test(value)){

                    const lowerCase = value.toLowerCase();
                    
                    var isValid = invoiceNos.includes(lowerCase);
                        if(isValid){
                        setShow(true);
                        setTitle("Please select unique invoice no")
                        setType("danger")
                        return;
                }
                const invoiceSeries = value.split("/")[1].toLowerCase();
                const selectedSource = (formData.source.value).toLowerCase();
                
                // if(selectedSource === invoiceSeries){
                //     setValidationErrors((prev) => ({
                //         ...prev,
                //         [id]: {
                //             ...prev[id],
                //             invoice_no: '',
                //         },
                //     }));
                //     setIsValid1(false)
                // }else{
                //     setValidationErrors((prev) => ({
                //         ...prev,
                //         [id]: {
                //             ...prev[id],
                //             invoice_no: 'Invalid Invoice number',
                //         },
                //     }));
                //     setIsValid1(true)
                // }
                
            }else if(!(invoicePattern.test(value))){
                setValidationErrors((prev) => ({
                    ...prev,
                    [id]: {
                        ...prev[id],
                        invoice_no: '',
                    },
                }));
                // setIsValid1(true)

            }else{
                setValidationErrors((prev) => ({
                    ...prev,
                    [id]: {
                        ...prev[id],
                        invoice_no: 'Invalid Invoice number',
                    },
                }));
                setIsValid1(true)
            }
            // const invoiceValue = value.split("/")
            // if (!validateInput(value)) {
            //     console.log("Invalid invoice");
    
            //     // Set validation error for invoice_no
            //     setValidationErrors((prev) => ({
            //         ...prev,
            //         [id]: {
            //             ...prev[id],
            //             invoice_no: 'Invalid Invoice number',
            //         },
            //     }));
            // } else {
            //     // Clear validation error if valid
            //     setValidationErrors((prev) => ({
            //         ...prev,
            //         [id]: {
            //             ...prev[id],
            //             invoice_no: '',
            //         },
            //     }));
            // }
        }
    
        // Update manualTripUploadDetails
        setManualTripUploadDetails((prevDetails) =>
            prevDetails.map((point, idx) => {
                if (idx === id) {
                    const updatedPoint = { ...point, [field]: value };
    
                    // Check if consignee_name is "Others" and toggle visibility for the specific index
                    if (field === 'consignee_name') {
                        const isOthersSelected = value === "Others";
    
                        setShowOthersConsignee((prevVisibility) => {
                            const updatedVisibility = [...prevVisibility];
                            updatedVisibility[id] = isOthersSelected; // Set true for this index if "Others" is selected
                            return updatedVisibility;
                        });
    
                        // Initialize fields for "Others" if consignee_name is "Others"
                        if (isOthersSelected) {
                            updatedPoint.other_consignee_name = "";
                            updatedPoint.other_consignee_pincode = "";
                            updatedPoint.other_consignee_city = "";
                        } else {
                            // Clear "other" fields if "Others" is not selected
                            delete updatedPoint.other_consignee_name;
                            delete updatedPoint.other_consignee_pincode;
                            delete updatedPoint.other_consignee_city;
                        }
                    }
    
                    return updatedPoint;
                }
                return point;
            })
        );
    };
    
    const handleDriverNumberChange = (e) => {
        const { name, value } = e.target;
      
        // Allow only numeric input
        const numericValue = value.replace(/\D/g, '').slice(0, 10);
      
        // Validate the input length and content
        if (numericValue.length < 10) {
          setError1('Mobile number must be 10 digits long');
        } else if (numericValue.length > 10) {
          setError1('Mobile number cannot exceed 10 digits');
        } else if (!/^[6-9]\d{9}$/.test(numericValue)) {
          setError1('Mobile number must start with a digit between 6 and 9 and be 10 digits long');
        } else {
          setError1(''); // Clear error if the number is valid
        }
      
        // Update the state with the new value (allow only 10 digits max)
        if (numericValue.length <= 10) {
          if (name === 'driver_number_update') {
            setManualUpdateConsignment((prev) => ({ ...prev, driver_number: numericValue }));
          } else if (name === 'driver_mobile_no') {
            setFormData((prev) => ({ ...prev, driver_mobile_no: numericValue }));
          }
        }
      };
      function validateInput(input) {
        // const regex = /^\d+$/;

        // const lowerCase = input.toLowerCase();

        for (let i of input){
            const lowerCase = i.toLowerCase();
            
            var isValid = invoiceNos.includes(lowerCase);
                if(isValid){
                setShow(true);
                setTitle("Please select unique invoice no")
                setType("danger")
                return;
        }
    }
        
        
      
        var lenofinvoice = input.length;
        
       
        var invoiceArr = input[0]
        var inputSpliting = invoiceArr.split('/');
        var invoiceSeries = inputSpliting[1];

        
        if(lenofinvoice>=1){

            for (let i=0 ;i<lenofinvoice;i++){
                const currentInvoice = input[i]
                if (!currentInvoice.includes('/')) {
                    // setShow(true)
                    // setTitle("All invoice's should have invoice series")
                    // setType("danger")   
                    // setSourceList([])
                    // setFormData((prev) => ({
                    //     ...prev,
                    //     source: { label: "", value: "" }  // Reset source in formData
                    // }));
                    // return false;                 

                }
                const currentSeries = currentInvoice.split('/')[1];

                if(currentSeries !== invoiceSeries){
                    
                    setShow(true)
                    setTitle("All invoice's should be same series")
                    setType("danger")   
                    // setSourceList([])
                    setFormData((prev) => ({
                        ...prev,
                        source: { label: "", value: ""}
                    }));
                    return false;                 
                }else{
                    // setSourceList(originalSourceList)
                    setInvoiceValid(false)
                }
            }
        }

        if (invoiceSeries=== null || invoiceSeries===undefined || invoiceSeries===" "){
            setSourceList(originalSourceList);
            return true
        }

        var arr2 = Array.from(sourceRecords)

        
        const source = arr2.includes(invoiceSeries.toUpperCase())
        var filteredSource = sourceList.filter(e=> e.value===invoiceSeries.toUpperCase())
        filteredSource.push({label:"Others", value:"Others"})
        setSourceList(filteredSource)
        setFormData((prev) => ({
            ...prev,
            source: { label: filteredSource[0].label, value: filteredSource[0].value}
        }));
        
        // var isValidInvoice = regex.test(inputSpliting[0]) && source;
        var isValidInvoice = source;
        
        return isValidInvoice;
      }
      const validateSource = () => {
        if(formData.source.value==="Other"){
            setEnableSourceField(true)
        } else {
            setFormData(prev =>({...prev, other_source:""}))
            setEnableSourceField(false)
        }
      }
      const enableOtherField = (e) => {
        if(e === "vehicleType"){
            if(formData.vehicle_type.value === "Others"){
                setEnableVehicelType(true)
            } else {
                setFormData(prev =>({...prev, other_vehicle_type:"",other_vehicle_capacity:""}))
                setEnableVehicelType(false)
            }
        }
        else if(e === "transporter"){
            if(formData.courier_partner.value === "Others"){
                setEnableCourierType(true)
            } else {
                setFormData(prev =>({...prev, other_transporter:""}))
                setEnableCourierType(false)
            }
        } 
        // else if(e === "vehicleCapacity"){
        //     if(formData.vehicle_capacity.value === "Others"){
        //         setEnableVehicleCapacity(true)
        //     } else {
        //         setFormData(prev =>({...prev, other_vehicle_capacity:""}))
        //         setEnableVehicleCapacity(false)
        //     }
        // } 
        else if(e === "consigneeName"){
            if(formData.consignee_name.value === "Others"){
                setEnableConsigee(true)
            } else {
                setFormData(prev =>({...prev, other_consignee_name:""}))
                setEnableConsigee(false)
                let droppointconsigneelist = consignees.filter(e => e.value !== formData.consignee_name.value)
                setDropPointConsignee(droppointconsigneelist)
            }
        }
      }
      const validateOption = (fieldType) => {
        switch(fieldType){        
            case "vehicleType":
                enableOtherField("vehicleType");
                break;
            case "transporter":
                enableOtherField("transporter");
                break;            
            case "vehicleCapacity":
                enableOtherField("vehicleCapacity");
                break;
            case "consigneeName":
                enableOtherField("consigneeName");
                break;
            case "dropConsigneeName":
                enableOtherField("dropConsigneeName");
                break;
            default:
                break;

        }
      }
      const fetchVehicleDetails = (x,y) => {
        let data = {
            vehicle_type: y,
        }
        redirectURL.post('/consignments/fetchVehicleDetails', data).then((resp) => {
            
        
            setFormData(prev => ({...prev, vehicle_capacity:resp.data.vehicleDetails[0].vehicle_capacity}))
        })
      }
      const fetchVehicleDetails1 = (x,y) => {
        let data = {
            vehicle_type: y,
        }
        redirectURL.post('/consignments/fetchVehicleDetails', data).then((resp) => {
            
        
            setManualUpdateConsignment(prev => ({...prev, vehicle_capacity:resp.data.vehicleDetails[0].vehicle_capacity}))
        })
      }
      const fetchConsigneeDetails = (x,y) => {
        let data = {
            consignee_name: y,
            consignee_code: x
        }
        redirectURL.post('/consignments/fetchConsigneeDetails', data).then((resp) => {
        
            setFormData(prev => ({...prev, destination_pincode:resp.data.consigneeDetails[0].consignee_pincode,  destination_city:resp.data.consigneeDetails[0].consignee_city}))
        })
      }
      useEffect(() => {
        const fetchData = async () => {
            try {
                // Fetch consigner city list
                const factoryResponse = await redirectURL.post('/consignments/allFactoryNames', {});
                const consignerArr = factoryResponse.data;
                const consignerCityList1 = consignerArr.map(e => e.consigner_city.toLowerCase());
                setConsignerCityList(consignerCityList1);
    
                // Fetch entity data
                const entityResponse = await redirectURL.post('/consignments/allEntityData', {});
                const entityArr = entityResponse.data;
                const entityData = entityArr.map(e => e.entity.toLowerCase());
                setEntityMasterData(entityData);

                const vehicleResponse = await redirectURL.post('/consignments/allVehicleData', {});
                const vehicleArr = vehicleResponse.data;
                const vehicleData = vehicleArr.map(e => e.vehicle_type.toLowerCase());
                setVehicleMasterData(vehicleData);

                 const tptResponse = await redirectURL.post('/consignments/transportersbydept', {});
                const tptArr = tptResponse.data;
                const tptData1 = tptArr.map(e => e.transporter_name.toLowerCase());
                const tptNamenCategory = tptArr.map(e=> ({label:e.transporter_name, value:e.transporter_type}))

                setTptData(tptNamenCategory)
                setTptMasterData(tptData1);

                const invoiceResponse = await redirectURL.post('/invoicelist', {});
                
                const invoiceArr = invoiceResponse.data.records;
                const invoiceData = invoiceArr.map(e => e.invoice_category?.toLowerCase() || "");
                const invoiceSeriesSource = invoiceArr.map(e=> ({label:e.invoice_series, value:e.invoice_source}))
                const invoiceSourceCategory = invoiceArr.map(e=> ({label:e.invoice_source, value:e.invoice_category}))
                setInvoiceSourceSeries(invoiceSeriesSource)
                setInvoiceSourceCategory(invoiceSourceCategory)
                setInvoiceMasterData(invoiceData);
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };
    
        fetchData();
    }, []);
    
      const fetchConsigneeDetails2 = (x,y) => {
        let data = {
            consignee_name: x,
            consignee_code: y
        }
        
        redirectURL.post('/consignments/fetchConsigneeDetails', data).then((resp) => {
            
        
            setManualUpdateConsignment(prev => ({...prev, destination_pincode:resp.data.consigneeDetails[0].consignee_pincode,  destination_city:resp.data.consigneeDetails[0].consignee_city}))
        })
      }
      const fetchConsigneeDetails1 = (index, consigneeCode, consigneeName) => {
        let data = {
            consignee_name: consigneeName,
            consignee_code: consigneeCode
        };
    
        redirectURL.post('/consignments/fetchConsigneeDetails', data).then((resp) => {
            const { consignee_pincode, consignee_city } = resp.data.consigneeDetails[0];
    
            // Update only the specific index in ManualTripUploadDetails
            setManualTripUploadDetails((prevDetails) =>
                prevDetails.map((point, idx) => {
                    if (idx === index) {
                        // Only update destination_pincode and destination_city for the specific index
                        return {
                            ...point,
                            destination_pincode: consignee_pincode,
                            destination_city: consignee_city,
                        };
                    }
                    return point;
                })
            );
        }).catch((error) => {
            console.error("Error fetching consignee details:", error);
        });
    };
    
      const fetchConsigneeDetailsForDropPoints = (x,y) => {
        let data = {
            consignee_name: x,
            consignee_code: y
        }
        redirectURL.post('/consignments/fetchConsigneeDetails', data).then((resp) => {
        
            setManualTripUploadDetails(prev => ({...prev, destination_pincode:resp.data.consigneeDetails[0].consignee_pincode,  destination_city:resp.data.consigneeDetails[0].consignee_city}))
        })
      }
      const checkConsignee = () => {
        if(formData.consignee_name.value !==""){
            setEnableEdit(false)
            setShow(true)
            setTitle("Select Consignee Name")
            setType("danger")
        } else {
            setEnableEdit(true)
        }
      }
      const validateTruckNoFun = (value) => {
        // Define the regex for the truck number format SN12TR2345
        const regex = /^[A-Z]{2}\d{2}[A-Z]{2}\d{4}$/;
        
        // Check if the input matches the regex pattern
        const isValid = regex.test(value);
        
        setValidTruckNo(isValid);
    };
      // Function that checks validation based on the field name
      const checkOtherConsigneeName = (fieldName, value) => {
        const pincodeRegex = /^[0-9]+$/;
        const cityRegex = /^[a-zA-Z\s]+$/;
    
        if (fieldName === "other_destination_city") {
            setValidCity(cityRegex.test(value));
        } else if (fieldName === "other_destination_pincode") {
            setValidPincode(pincodeRegex.test(value));
        } else if (fieldName === "other_consignee_pincode1") {
            setValidPincode1(pincodeRegex.test(value));
        } else if (fieldName === "other_consignee_city1") {
            setValidCity1(cityRegex.test(value));
        }

        if (formData.other_consignee_name !== "") {
            setIsOtherConsigneeName(false);
        }
    };

  

    const validateOtherConsignee = () => {
        const nameRegex = /^[a-zA-Z\s]+$/;;
        setValidateOtherConsignee(nameRegex.test(formData.other_consignee_name));
        if (nameRegex.test(formData.other_consignee_name)) {
            setIsOtherConsigneeName(true);
            setValidateOtherConsignee(true);
        } else {
            setValidateOtherConsignee(false);
        }
    };
      const validateVehicleCapacity = () => {
        const regex = /^[0-9]+$/;
        setValidVehicleCapacity(regex.test(formData.other_vehicle_capacity))

      }
      
    const filterSources = (invoiceNo) => {
        
        if (validateInput(invoiceNo)) {
            setErrorMssge("");    
            let invoiceNumber = invoiceNo[0]  
            let source = invoiceNumber.split('/')[1];  
            let filteredSource = sourceList.filter(e => {
                return e.value === source;
            });   
            // filteredSource.push({ label: "Others", value: "Others" });
            setSourceList(filteredSource); 
        } else {
            setErrorMssge("Invalid Invoice Number"); 
            setEnableSourceField(false); 
        }
    };
    const filterSources1 = (invoiceNo) => {
        if (validateInput(invoiceNo)) {
            setErrorMssge("");      
            // let source = invoiceNo.split('/')[1];  
            // let filteredSource = constSourceList.filter(e => {
            //     return e.value === source;
            // });   
            // filteredSource.push({ label: "Others", value: "Others" });
            // setSourceList(filteredSource); 
        } else {
            setErrorMssge("Invalid Invoice Number"); 
            // setEnableSourceField(false); 
        }
    };
    
      const handleInvoiceChange = (e) => {
        const value = e.target.value;

    
        const invoiceArray = value.split(',').map((item) => item.trim()).filter(Boolean);
        setFormData(prev => ({...prev, invoice_no_str: value, invoice_no: invoiceArray}));
        // if (invoiceArray.length > 0 && /[\/]/.test(invoiceArray[0])) {
        //     filterSources(invoiceArray);  // Call filterSources if the value contains a slash
        // } 
        // const isValid = validateInput(invoiceArray);
        // setIsValid(isValid);  
     };
     const handleLRChange = (e) => {
        const value = e.target.value;
        const name = e.target.name;

        // Validate for alphanumeric characters
        if (/^[a-zA-Z0-9]*$/.test(value)) {
            if(name === "lr_no"){
                setmanualUploadDetails((prev) => ({ ...prev, lr_no: value }));
            }
            if(name==="lr_no2"){
                setUpdateLrNo(value)
            }
            setErrorMsg("");

             // Clear the error message if input is valid
        } else {
            setErrorMsg("Only alphanumeric characters are allowed.");
        }
    };
    const validateOtherSource = (source) => {
        const regex = /^[a-zA-Z]+$/;  // Only letters allowed
        const isValid = regex.test(source);
        setValidOtherSource(isValid);
    };
    const handleVehicleCapacityChange = (e) => {
        const value = e.target.value;
        setFormData(prev => ({...prev, other_vehicle_capacity: value}));
        validateVehicleCapacity(value);  // Validate in real-time on change
    };
    const handleTruckNoChange = (e) => {
        const {name, value} = e.target
        const value1 = value.toUpperCase();
        if(name=="truck_no"){
            setFormData(prev => ({...prev, truck_no: value1}));
        }else if(name=="lr_truck_no"){
            setManualUpdateLRConsignment(prev => ({...prev, truck_no: value1}));
        }

        validateTruckNoFun(value1);  
    };
    const handleOtherSourceChange = (e) => {
        const value = e.target.value;
        setFormData(prev => ({...prev, other_source: value}));
        validateOtherSource(value);  
    };
      const saveConsignmentData = async (event) => {
        event.preventDefault();
        let specialCharcters = 0;
        const { driver_mobile_no, source, truck_no, truck_seal_no, entity, vehicle_type, vehicle_capacity,courier_partner,eway_bill_expiry_date, consignee_name, movement_type, lr_no, invoice_no, number_of_boxes, destination_pincode, destination_city, other_source,
            other_transporter,
            other_vehicle_type,
            other_consignee_name,
            other_vehicle_capacity,
            other_destination_pincode, other_destination_city } = formData;
        let add_consignment_params = {}
        if (specialCharcters === 0) {
            let fieldsChk = 0;
            const isGeneralFieldsFilled = driver_mobile_no && !invoiceValid && source.value && truck_no && entity.value && vehicle_type.value 
            && courier_partner.value && movement_type.value && invoice_no && vehicle_capacity;
        
        // Check if consignee-related mandatory fields are filled based on the consignee selection
        const isConsigneeFilled = (consignee_name.value !== 'Others' && destination_city && destination_pincode) 
            || (consignee_name.value === 'Others' && other_consignee_name && other_destination_city && other_destination_pincode);
        
        if (isGeneralFieldsFilled && isConsigneeFilled) {
            fieldsChk = 1;
        }
            if(other_source){
                fieldsChk = 1;
            }
            if (fieldsChk === 1) {
                

                add_consignment_params = {
                    driver_mobile_no, 
                    source: source.label ? source.label: "",
                    truck_no,
                    truck_seal_no,
                    entity: entity.value ? entity.value : "", 
                    vehicle_type: vehicle_type.value, 
                    courier_partner: courier_partner.value.toUpperCase(), 
                    eway_bill_expiry_date: eway_bill_expiry_date ? formatDateForSubmission(eway_bill_expiry_date) : "",                    
                    vehicle_capacity: vehicle_capacity.value,
                    movement_type: movement_type.value, 
                    lr_no, 
                    // invoice_no: `${invoice_no}`, 
                    invoice_no:invoice_no,
                    no_of_boxes: number_of_boxes
                };
               
                if(consignee_name.value === "Others"){
                    add_consignment_params.consignee_name = formData.other_consignee_name
                    add_consignment_params.destination_pincode = formData.other_destination_pincode
                    add_consignment_params.destination_city = formData.other_destination_city
                }
                if(consignee_name.value !=="Others"){
                    add_consignment_params.consignee_name = formData.consignee_name.label;
                    add_consignment_params.destination_pincode = formData.destination_pincode;
                    add_consignment_params.destination_city = formData.destination_city;
                }
                if(add_consignment_params.vehicle_type === "Others"){
                    add_consignment_params.vehicle_type = formData.other_vehicle_type
                }
                if(add_consignment_params.vehicle_capacity === "Others"){
                    add_consignment_params.vehicle_capacity = formData.other_vehicle_capacity
                }
                if(add_consignment_params.courier_partner === "Others"){
                    add_consignment_params.courier_partner = formData.other_transporter.toUpperCase()
                }
                if(other_source){
                    if(validOtherSource){
                        add_consignment_params.source = other_source;
                    }
                }
                
                if (manualTripUploadDetails.length >= 1){
                    add_consignment_params.add_dealer=1
                }

                const manualDropPoints = manualTripUploadDetails.map((point) => ({
                    consignee_name: point.consignee_name === "Others" ? point.other_consignee_name : point.consignee_name,
                    customer_mail_id: point.customer_mail_id,
                    destination_city: point.consignee_name === "Others" ? point.other_consignee_city : point.destination_city,
                    destination_pincode: point.consignee_name === "Others" ? point.other_consignee_pincode : point.destination_pincode,
                    invoice_no: point.invoice_no,
                    lr_no: formData.lr_no,  // assuming lr_no is consistent across all points
                    no_of_boxes: point.no_of_boxes,
                    id: point.id
                }));
                const combinedParams = {
                    add_consignment_params,            // First set of params for updating the collection
                    manualTripUploadDetails :  manualDropPoints  // Second set of params to be sent to the backend API
                };
                try { 
                    const response = await redirectURL.post('/consignments/saveConsignmentData', combinedParams);
                  
                    // Check if the response is successful
                    if (response.data.status.toLowerCase() === 'success') {
                      setShow(true);
                      setTitle('Successfully created consignment');
                      setType('success');
                      setLoadShow('show-n');
                      setOverlay('show-n');
                      setSliderCreateConsignmentTranslate('');
                      setInvoiceValid(false)
                  
                      // Clear form data
                      setFormData({
                        ...formData,
                        driver_mobile_no: '',
                        source: { label: "", value: "" },
                        truck_no: '',
                        truck_seal_no: '',
                        entity: '',
                        vehicle_type: { label: '', value: '' },
                        courier_partner: { label: '', value: '' },
                        eway_bill_expiry_date: '',
                        vehicle_capacity:'',
                        consignee_name: { label: "", value: "" },
                        movement_type: { label: "", value: "" },
                        lr_no: '',
                        invoice_no: [],
                        invoice_no_str:"",

                        number_of_boxes: '',
                        destination_pincode: '',
                        destination_city: '',
                      });
                      
                      // Clear manual trip upload details
                      setManualTripUploadDetails([]);
                    //   window.location.reload();
                    } else if (response.data.status.toLowerCase() === 'fail') {
                      // Show error message returned from backend
                      setShow(true);
                      setTitle(response.data.message); // Display the error message from the backend
                      setType("danger");
                    } else {
                      setShow(true);
                      setTitle(response.data.message === 'Consignment Code Already Exists' ? 
                        'Consignment Code Already Exists' : 'Failed to create consignment');
                      setType('danger');
                      setSliderCreateConsignmentTranslate('');
                      setFormData({
                        ...formData,
                        driver_mobile_no: '',
                        source: '',
                        truck_no: '',
                        truck_seal_no: '',
                        entity: '',
                        vehicle_type: { label: '', value: '' },
                        courier_partner: { label: '', value: '' },
                        eway_bill_expiry_date: '',
                        vehicle_capacity: '',
                        consignee_name: '',
                        movement_type: '',
                        lr_no: '',
                        invoice_no: [],
                        invoice_no_str:"",

                        number_of_boxes: '',
                        destination_pincode: '',
                        destination_city: '',
                      });
                      setManualTripUploadDetails([]);
                    }
                  } catch (error) {
                    // Handle any network or unexpected errors
                  
                    setShow(true);
                    setTitle("An unexpected error occurred. Please try again.");
                    setType("danger");
                  }
                  
            } else {
                setShow(true)
                setTitle('Please fill mandatory fields')
                setType('danger')               
            }
        } else {
            setShow(true)
            setTitle('Special characters are not allowed')
            setType('danger')
           
        }
    };
      const onClickHideManualUpload3 = () => {
        setManualUpdateConsignment((prev) => ({
            ...prev,
            driver_number: '',
            source: "",
            truck_no: "",
            truck_seal_no: "",
            vehicle_type: "",
            courier_partner:"",
            vehicle_capacity: "",
            consignee_name: "",
            lr_no: "",
            invoice_no: "",
            destination_pincode: "",
            destination_city:""
        }))
        setManualTripUploadDetails([])
        setshowAddForm3("");
        setOverlay("show-n");
        setselected_row({});
      }
    const validatePincode = (pincode) => {
    // Make an API call to a pincode validation service or use a local database
    // For this example, we'll assume a simple validation where pincode should be 6 digits
    const isValid = /^\d{6}$/.test(pincode);
    return isValid;
    };
    const keysToInclude = ["consignee_name", "lr_no", "invoice_no", "consignee_pincode", "consignee_city", "consignment_uid"];
    
    const extractChangedFields = (originalDetails, updatedParams) => {
        const editDetails = {};
        
        for (const key in updatedParams) {
            if (originalDetails.hasOwnProperty(key)) {  
                if (Array.isArray(updatedParams[key])) {
                    if (JSON.stringify(updatedParams[key]) !== JSON.stringify(originalDetails[key])) {
                        editDetails[key] = updatedParams[key];
                    }
                } else if (typeof updatedParams[key] === 'object' && updatedParams[key] !== null) {
                    if (JSON.stringify(updatedParams[key]) !== JSON.stringify(originalDetails[key])) {
                        editDetails[key] = updatedParams[key];
                    }
                } else {
                    if (updatedParams[key] !== originalDetails[key]) {
                        editDetails[key] = updatedParams[key];
                    }
                }
            }
        }    
        return editDetails;
    };
    const compareAndExtractChanges = (originalEditData, compareParams) => {
        const updatedFields = {};
      
        // Compare the fields that exist in both originalEditData and compareParams
        for (const key in compareParams) {
          if (compareParams.hasOwnProperty(key)) {
            // Get the original value
            let originalValue = originalEditData[key];
      
            // If the original value is an array with one element, convert it to a string for comparison
            if (Array.isArray(originalValue) && originalValue.length === 1) {
              originalValue = originalValue[0];
            }
      
            // Compare only if the key exists in originalEditData and values are different
            if (originalEditData.hasOwnProperty(key) && originalValue !== compareParams[key]) {
              updatedFields[key] = compareParams[key]; // Store only the changed field
            }
          }
        }
      
        // Return only the changed fields, or an empty object if no changes were found
        return Object.keys(updatedFields).length > 0 ? updatedFields : {};
      };
      
      
      
      const extractChangedFields1 = (originalDetails, updatedParams) => {
        const changedDetails = [];
    
        for (let i = 0; i < originalDetails.length; i++) {
            const originalItem = originalDetails[i];
            const updatedItem = { ...updatedParams[i] };
    
            // Use `other_consignee_*` fields if available, otherwise use default fields
            updatedItem.consignee_name = updatedItem.other_consignee_name && updatedItem.other_consignee_name !== ""
                ? updatedItem.other_consignee_name
                : (updatedItem.consignee_name && typeof updatedItem.consignee_name === 'object'
                    ? updatedItem.consignee_name.label
                    : updatedItem.consignee_name);
    
            updatedItem.destination_city = updatedItem.other_consignee_city && updatedItem.other_consignee_city !== ""
                ? updatedItem.other_consignee_city
                : updatedItem.destination_city;
    
            updatedItem.destination_pincode = updatedItem.other_consignee_pincode && updatedItem.other_consignee_pincode !== ""
                ? updatedItem.other_consignee_pincode
                : updatedItem.destination_pincode;
    
            let hasChanges = false;
    
            for (const key in originalItem) {
                if (originalItem.hasOwnProperty(key) && updatedItem.hasOwnProperty(key)) {
                    if (originalItem[key] !== updatedItem[key]) {
                        hasChanges = true;
                        break;
                    }
                }
            }
    
            // If there are changes, rename keys, remove other_ fields, and push the updated record
            if (hasChanges) {
                const newItem = { ...updatedItem };
    
                // Rename keys for the backend if they exist in updatedItem
                if ('destination_pincode' in newItem) {
                    newItem.consignee_pincode = newItem.destination_pincode;
                    delete newItem.destination_pincode;
                }
    
                if ('destination_city' in newItem) {
                    newItem.consignee_city = newItem.destination_city;
                    delete newItem.destination_city;
                }
    
                // Remove `other_` fields from the newItem
                delete newItem.other_consignee_name;
                delete newItem.other_consignee_pincode;
                delete newItem.other_consignee_city;
    
                changedDetails.push(newItem); // Push the modified updated record
            }
        }
    
        return changedDetails;
    };
    
    
    
      
    // trip edit submit
    const onClickUpdateConsignment = async(e) => {
        e.preventDefault()
        
        
        var update_params = {
            driver_mobile_no: manualUpdateConsignment.driver_mobile_no,
            // source: manualUpdateConsignment.source?.value??"",
            truck_no: manualUpdateConsignment.truck_no,
            truck_seal_no: manualUpdateConsignment.truck_seal_no,
            truck_seal_entity: manualUpdateConsignment.entity.value,
            truck_type: manualUpdateConsignment.other_vehicle_type?.value && manualUpdateConsignment.other_vehicle_type.value !== ""
            ? manualUpdateConsignment.other_vehicle_type.value
            : manualUpdateConsignment.vehicle_type.value || "",           
            
            transporter_name: manualUpdateConsignment.other_transporter?.value && manualUpdateConsignment.other_transporter.value !== ""
            ? manualUpdateConsignment.other_transporter.value.toUpperCase()
            : manualUpdateConsignment.courier_partner.value.toUpperCase(),

            vehicle_capacity: manualUpdateConsignment.other_vehicle_capacity?.value && manualUpdateConsignment.other_vehicle_capacity.value !== ""
            ? manualUpdateConsignment.other_vehicle_capacity.value
            : manualUpdateConsignment.vehicle_capacity,    

            // consignee_name: manualUpdateConsignment.other_consignee_name && manualUpdateConsignment.other_consignee_name!== ""
            // ? manualUpdateConsignment.other_consignee_name
            // : manualUpdateConsignment.consignee_name.label,  
            customer_name: manualUpdateConsignment.other_consignee_name && manualUpdateConsignment.other_consignee_name!== ""
            ? manualUpdateConsignment.other_consignee_name
            : manualUpdateConsignment.consignee_name.label,           
            
            no_of_boxes: manualUpdateConsignment.no_of_boxes,
            lr_no: manualUpdateConsignment.lr_no,
            invoice_no: manualUpdateConsignment.invoice_no,
            shipment_id:shipmentId,
            movement_type: manualUpdateConsignment.movement_type.value,
            eway_bill_expiry_date: manualUpdateConsignment.eway_bill_expiry_date,
            // consignee_pincode: manualUpdateConsignment.destination_pincode[0],
            consignee_pincode: manualUpdateConsignment.other_destination_pincode && manualUpdateConsignment.other_destination_pincode !== ""
            ? manualUpdateConsignment.other_destination_pincode
            : manualUpdateConsignment.destination_pincode,

            consignee_city: manualUpdateConsignment.other_destination_city && manualUpdateConsignment.other_destination_city !== ""
        ? manualUpdateConsignment.other_destination_city
        : manualUpdateConsignment.destination_city,        } 

        //  from here add consignments add droppoint details
        if (manualTripUploadDetails.length>=1){
            update_params.add_dealer=1
        }

        
        const transformedTripDetails = manualTripUploadDetails.map((detail) => {
            return {
                ...detail,
                consignee_name: detail.consignee_name && typeof detail.consignee_name === 'object' && detail.consignee_name.label
                    ? detail.consignee_name.label
                    : detail.consignee_name, // Use label if it's an object, otherwise keep it as is
            };
        });
        const combinedParams = {
            update_params,            // First set of params for updating the collection
            manualTripUploadDetails: transformedTripDetails
                };
        const shipment_id = orginalDetailsForEdit.shipment_id;
        const tracking_type = orginalDetailsForEdit.tracking_type;

        
        
        
       const editDetails = compareAndExtractChanges(orginalDetailsForEdit, combinedParams.update_params);
       
      
       if(editDetails!== undefined && editDetails !== null){

        editDetails.consignment_uid = consignmentUidForTruckLevel;
    }
    //    console.log(editDetails, "editDetailssss9999");
       
       
       const update_data = extractChangedFields1(dropPointArr,combinedParams.manualTripUploadDetails )
    //    const result = combinedParams.manualTripUploadDetails.reduce((acc, manualDetail) => {
    //     // Find the matching dropPoint in dropPointArr based on lr_no
    //     console.log(manualDetail, "manualDetail122");
        
    //     const dropPoint = dropPointArr.find(dp => {
    //         console.log(dp, "dpp");  // Log the current dp object being evaluated
    //         return dp.lr_no === manualDetail.lr_no;  // Return the comparison result
    //     });
    
    //     if (dropPoint) {
    //         const changedDetails = { consignment_uid: dropPoint.consignment_uid }; // Start with consignment_uid only
    
    //         // Compare each field and add to changedDetails if it's different
    //         if (manualDetail.lr_no !== dropPoint.lr_no) {
    //             changedDetails.lr_no = manualDetail.lr_no;
    //         }
    //         if (manualDetail.invoice_no !== dropPoint.invoice_no) {
    //             changedDetails.invoice_no = manualDetail.invoice_no;
    //         }
    //         if (manualDetail.consignee_name !== dropPoint.consignee_name) {
    //             changedDetails.consignee_name = manualDetail.consignee_name;
    //         }
    //         if (manualDetail.destination_pincode !== dropPoint.destination_pincode) {
    //             changedDetails.consignee_pincode = manualDetail.destination_pincode;
    //         }
    //         if (manualDetail.destination_city !== dropPoint.destination_city) {
    //             changedDetails.consignee_city = manualDetail.destination_city;
    //         }
    
    //         // Only push changedDetails if there are changes other than consignment_uid
    //         if (Object.keys(changedDetails).length > 1) {
    //             acc.push(changedDetails);
    //         }
        
    
    //     }
    
    //         return acc;
    //     }, []);
        // truck_level_change
        // droppoint level changes
        let editTripDetails = {
            shipment_id,
            tracking_type,
            editDetails,
            update_data
        }
        
        redirectURL.post('/consignments/updateTripDetails', editTripDetails).then((resp) => {
            if (resp.data.status == 'success') {
                setshowAddForm1('')
                setshowAddForm2('')
                setshowAddForm3('')
                setManualTripUploadDetails([])
                setManualUpdateConsignment(
                    {
                        driver_number: '',
                        source: "",
                        truck_no: "",
                        truck_seal_no: "",
                        vehicle_type: "",
                        courier_partner:"",
                        vehicle_capacity: "",
                        consignee_name: "",
                        lr_no: "",
                        invoice_no: "",
                        no_of_boxes: "",
                        destination_pincode: "",
                        destination_city:""
                      }
                )
                setShow(true)
                setTitle("The consignment details have been successfully updated!")
                setType("success")
                setLoadShow('show-n')
                setOverlay('show-n')
              
                // window.location.reload();
            }
            else{
                setShow(true)
                setTitle("Please Upload Valid Details")
                setType("danger")
                setLoadShow('show-n')
                setOverlay('show-n')
            }
        })
        // setManualUpdateConsignment((prev) => ({
        //     ...prev,
        //     driver_number: "",
        //     source: "",
        //     truck_no: "",
        //     truck_seal_no: "",
        //     vehicle_type: "",
        //     courier_partner:"",
        //     vehicle_capacity: "",
        //     consignee_name: "",
        //     lr_no: "",
        //     no_of_boxes:"",
        //     invoice_no: "",
        //     destination_pincode: "",
        //     destination_city:""
        //   }));
        // setManualTripUploadDetails([])

    } 
    const getSourceList = () => {
        if (manualUpdateConsignment.other_source !== "") {
          return [{ value: "Others", label: "Others" }];
        } else {
          const lastThreeLetters = manualUpdateConsignment.invoice_no.slice(-3);
          const matchingSource = sourceList.find((item) => item.value.endsWith(lastThreeLetters));
          if (matchingSource) {
            setManualUpdateConsignment((prev) => ({ ...prev, source: matchingSource }));
            return [matchingSource, { value: "Others", label: "Others" }];
          } else {
            return [{ value: "Others", label: "Others" }];
          }
        }
      };
    const isFormValid = () => {
        return (
          formData.invoice_no !== '' &&  formData.movement_type.value !== '' &&
          formData.driver_mobile_no !== '' && formData.source.value !== "" &&
          (formData.source.value === 'Others' ? !!formData.other_source : true) &&
          formData.truck_no !== '' &&
          formData.entity.value !== '' &&
          (formData.vehicle_type.value === 'Others' ? !!formData.other_vehicle_type : true) &&
          (formData.courier_partner.value === 'Others' ? !!formData.other_transporter : true) &&
          (formData.vehicle_capacity.value === 'Others' ? !!formData.vehicle_capacity : true) &&
          formData.consignee_name.value !== '' &&
          (formData.consignee_name.value === "Others" ? 
            (formData.other_consignee_name !== '' && 
             formData.other_destination_pincode !== '' && 
             formData.other_destination_city !== '') 
            : 
            (formData.destination_pincode !== '' && 
             formData.destination_city !== '')) &&
          formData.movement_type.value !== '' 
          
        );
    };
    const isManualTripUploadDetailsValid = () => {
        if (manualTripUploadDetails.length === 0) return true;
    
        // Get the most recent block
        const recentBlock = manualTripUploadDetails[manualTripUploadDetails.length - 1];
        const isOtherConsignee = recentBlock.consignee_name.length > 0 && recentBlock.consignee_name === 'Other';
        
        return (
            recentBlock.invoice_no !== '' &&  // Check if invoice_no is not empty
            recentBlock.consignee_name.length > 0 &&  // Check if there is at least one consignee name
            (!isOtherConsignee ||  // If the consignee is 'Other'
                (recentBlock.other_consignee_name !== '' &&  // Check if other_consignee_name is filled
                recentBlock.other_consignee_city !== '' &&  // Check if other_consignee_city is filled
                recentBlock.other_consignee_pincode !== ''))  // Check if other_consignee_pincode is filled
        );
    };
    const handleButtonClick = (e) => {
        e.stopPropagation();
    
        // Initialize an object to store validation errors for each drop point
        let errors = {};
    
        // manualTripUploadDetails.forEach((point, index) => {
        //     const currentErrors = {};
        //     // Check if required fields are filled
        //     if (!point.invoice_no) currentErrors.invoice_no = "Invoice No is required.";
        //     if (!point.consignee_name) currentErrors.consignee_name = "Consignee Name is required.";
        //     if (!point.destination_pincode) currentErrors.destination_pincode = "Destination Pincode is required.";
        //     if (!point.destination_city) currentErrors.destination_city = "Destination City is required.";
    
        //     if (Object.keys(currentErrors).length > 0) {
        //         errors[point.id] = currentErrors; // Add errors for the current drop point
        //     }
        // });
    
        // // If there are errors, update the validation state and do not add a new drop point
        // if (Object.keys(errors).length > 0) {
        //     setValidationErrors(errors);
        //     setShow(true);
        //     setTitle("Please fill all required details in each drop point.");
        //     setType("danger");
        //     return;
        // }
    
        // If no errors, proceed to add a new drop point
        const newTripDetail = {
            id: uuidv4(),
            lr_no: '',
            consignee_name: "",
            invoice_no: "",
            no_of_boxes: "",
            destination_pincode: "",
            destination_city: "",
            eway_bill_no: "",
            customer_mail_id: "",
            other_consignee_name: "",
            other_consignee_pincode:"",
            other_consignee_city: ""
        }        
        setManualTripUploadDetails((prevDetails) => [
            ...prevDetails,
            newTripDetail
        ])    
        setValidationErrors({});
    };

const onTabChange =(selectedtab)=>{
    setSelectedViewTab(selectedtab);
    onShowDocs1(selectedtab);
}
    
const formatDateForSubmission = (date) => {
        // Check if the input is a valid Date object
        if (!(date instanceof Date)) {
            // Try to convert it to a Date object if possible
            date = new Date(date);
        }
    
        // If the date is still invalid, handle the error
        if (isNaN(date.getTime())) {
            throw new Error("Invalid date format");
        }
    
    const pad = (num) => num.toString().padStart(2, '0');
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
};
    
    var filterClassName = "form-group col-xl-12 col-lg-12";
    return (
        <div>
            <SweetAlert
                show={show}
                title={<span style={{ fontSize: "1rem" }}>{title}</span>}
                onConfirm={onConfirm}
                confirmBtnBsStyle={type}
                confirmBtnCssClass="sweetButton"
                customClass='sweetWidth'
                type={type}>
            </SweetAlert>
            <Modal
                onHide={closeForceCloseModal}
                dialogClassName="my-modal"
                show={forcecloseModal}
                centered>
                <Modal.Header>
                    <Modal.Title>Force Close</Modal.Title>
                    <div className="btn-box d-flex gap-3">
                        <button type="button" className="btn btn-sm btn-icon btn-outline-primary" data-bs-dismiss="modal" aria-label="Close" onClick={closeForceCloseModal}>
                            <i className="fa fa-times"></i>
                        </button>
                    </div>
                </Modal.Header>
                <Modal.Body className="view-task">
                    <div>
                        <form onSubmit={formForceCloseHandler}>
                            <div className="col-xl-12 col-lg-12">
                                <label className="custom-label">
                                    Reason
                                </label>
                                <label style={{ color: "#EB1D54", fontSize: "13px", fontFamily: "Inter" }}>*</label>
                                <textarea
                                    type="text"
                                    value={reasonForceClose}
                                    onChange={e => setReasonForceClose(e.target.value)}
                                    autoComplete="off"
                                    className="form-control"
                                    required
                                />
                            </div>
                            <div style={{ paddingTop: "2rem", display: "flex", justifyContent: "flex-end", marginRight:"17px" }}>
                                <button type='submit' className='primary-button'>Submit</button>
                            </div>
                        </form>
                    </div>
                </Modal.Body>
            </Modal>
            
            <Modal
                onHide={closeCancelModal}
                dialogClassName="my-modal"
                show={cancelModal}
                centered>
                <Modal.Header>
                    <Modal.Title>{tabName.value !=="inactive"? 'Disable Shipment' : "Delete Invoice"}</Modal.Title>
                    <div className="btn-box d-flex gap-3">
                        <button type="button" className="btn btn-sm btn-icon btn-outline-primary" data-bs-dismiss="modal" aria-label="Close" onClick={closeCancelModal}>
                            <i className="fa fa-times"></i>
                        </button>
                    </div>
                </Modal.Header>
                <Modal.Body className="view-task">
                    <div>
                        <form onSubmit={cancelFormCloseHandler}>
                            {tabName.value !== "inactive" && 
                                <div className='col-xl-12 col-lg-12' style={{marginBottom:"20px"}}>
                                    <label className="reason">LR No</label>
                                    <input type="text" name="reason" autoComplete="off" class="form-control" id="lrno" value={rownode.lr_no} />                                
                                </div>                          
                            } 
                            <div className='col-xl-12 col-lg-12' style={{marginBottom:"20px"}}>
                                <label>Selected Invoices </label>
                                <Select 
                                    closeMenuOnSelect={false}
                                    value={lrNoOption}
                                    isMulti={tabName.value !== "inactive"}
                                    className="border-radius-0"
                                    isDisabled={tabName.value === "inactive"}                                    
                                    isSearchable={tabName.value !== "inactive"}
                                    style={{ borderRadius: "0px" }}
                                    readOnly={tabName.value === "inactive"}
                                    required 
                                />
                            </div>
                            <div className="col-xl-12 col-lg-12" style={{marginBottom:"20px"}}>
                                <label style={{ color: "#EB1D54", fontSize: "13px", fontFamily: "Inter" }}>*</label>
                                <label className="custom-label">
                                    Reason For Withdrawal
                                </label>
                                <textarea
                                    type="text"
                                    value={reasonForCancellation}
                                    onChange={e => setReasonForCancellation(e.target.value)}
                                    autoComplete="off"
                                    className="form-control"
                                    required
                                />
                            </div>
                            <div style={{ paddingTop: "2rem", display: "flex", justifyContent: "flex-end", marginRight:"17px" }}>
                                <button type='submit' className='primary-button'>Submit</button>
                            </div>
                        </form>
                    </div>
                </Modal.Body>
            </Modal>
            <CustomDialog
                isOpen={isSliderEmailOpen}
                onClose={onCloseEmail}
                onSubmitEmail={onSubmitEmail}
                email={email}
                changeEmail={changeEmail}
                whatsapp_no={whatsapp_no}
                changeWhatsapp={changeWhatsapp}
                expired_time={expired_time}
                changeExpiredTime={changeExpiredTime}
                handleKeyDown={handleKeyDown}
                setActiveForm={setActiveForm}
                activeForm={activeForm}
            /> 
             <CustomDialogForEditLogs
            isOpen={editLogsModalOpen}
            onClose={handleCloseModal}
            editLogsData={editLogsData}
            filteredLog={filteredLog}
            setFilteredLog={setFilteredLog}
        />
             <TimelineModal showModal={showModal} onClose={onCloseModal} timelineData={timelineData} />
            <CustomDialogForDocumentsViewing
                isOpen={isSliderDocumentOpen}
                onClose={onCloseDocument}
                documents={documents}
                trackingType={trackingType}
                onTabChange ={onTabChange}
                // PodRemark={viewRemark}
            /> 
            <CustomDialogForDocumentsViewing
                isOpen={isSliderPODDocumentOpen}
                onClose={onClosePodDocument}
                documents={podDocuments}
                PodRemark={viewPodRemark}
                pod={true}
            />
           
            <Modal
                onHide={closeforceCloseModal}
                dialogClassName="my-modal"
                show={forceCloseModal}
                centered>
                <Modal.Header>
                    <Modal.Title>Disable Shipment</Modal.Title>
                    <div className="btn-box d-flex gap-3">
                        <button type="button" className="btn btn-sm btn-icon btn-outline-primary" data-bs-dismiss="modal" aria-label="Close" onClick={closeforceCloseModal}>
                            <i className="fa fa-times"></i>
                        </button>
                    </div>
                </Modal.Header>
                <Modal.Body className="view-task">
                    <div>
                        <form onSubmit={cancelForceCloseFormCloseHandler}>
                            <div className='col-xl-12 col-lg-12' style={{marginBottom:"20px"}}>
                                <label className="reason">Vehicle No</label>
                                <input type="text" name="reason" autoComplete="off" class="form-control" id="lrno" value={rownode.truck_no} />                                
                            </div>
                            <div className='col-xl-12 col-lg-12' style={{marginBottom:"20px"}}>
                                <label>Selected Invoices </label>
                                <Select 
                                    closeMenuOnSelect={false}
                                    value={invoiceNoList}
                                    isMulti={true}
                                    className="border-radius-0"
                                    style={{ borderRadius: "0px" }}
                                    required 
                                />
                            </div>
                            <div className="col-xl-12 col-lg-12" style={{marginBottom:"20px"}}>
                                <label style={{ color: "#EB1D54", fontSize: "13px", fontFamily: "Inter" }}>*</label>
                                <label className="custom-label">
                                    Reason For Withdrawel
                                </label>
                                <textarea
                                    type="text"
                                    value={reasonForCancellation}
                                    onChange={e => setReasonForCancellation(e.target.value)}
                                    autoComplete="off"
                                    className="form-control"
                                    required
                                />
                            </div>
                            <div style={{ paddingTop: "2rem", display: "flex", justifyContent: "flex-end" }}>
                                <button type='submit' className='primary-button'>Submit</button>
                            </div>
                        </form>
                    </div>
                </Modal.Body>
        </Modal>

            <div className={"slide-r " + (sliderShow)}>
                    <div className="slide-r-title">
                        <h4 className="slide-r-title">Upload POD
                            <span
                                  className="float-right closebtn"
                                  style={{ marginRight: "10px" }}
                                  onClick={onCloseSliderDiv}          
                                        >
                                 X
                            </span>
                        </h4>
                    </div>
                    

                    <div className="col-sm-12">
                        <div className="slide-r-body">
                            <form className="theme-form" method="POST" id="formPOD" enctype="multipart/form-data" onSubmit={uploadDocument}>
                                <div className="row p-20p">
                                {Array.isArray(rownode) && rownode[0]?.tracking_type === "FTL" && (
                                            <div className="form-group col-sm-12 mb-20p">
                                                {/* <label>Select Invoice<span style={{ color: 'red' }}>*</span></label>
                                                
                                                <Select
                                                    isMulti // Enable multi-select
                                                    closeMenuOnSelect={false} // Keeps dropdown open for multiple selections
                                                    placeholder="Select invoices..."
                                                    value={selectedInvoiceUpload} 
                                                    onChange={(selectedOptions) => setSelectedInvoiceUpload(selectedOptions || [])}
                                                    style={{ borderRadius: "0px" }}
                                                    styles={{
                                                        control: (provided, state) => ({
                                                            ...provided,
                                                            fontSize: "0.8rem",
                                                            color: "#6e707e",
                                                            width: "100%"
                                                        }),
                                                        singleValue: (provided, state) => ({
                                                            ...provided,
                                                            fontSize: "0.9rem",
                                                        }),
                                                    }}
                                                    options={invoicesUploadList}
                                                    // required
                                                /> */}
                                                <label className="f16">LR No.
                                                    {/* <span style={{ color: 'red' }}>*</span> */}
                                                    </label>
                                                
                                                {/* <Select
                                                    isMulti // Enable multi-select
                                                    closeMenuOnSelect={false} // Keeps dropdown open for multiple selections
                                                    placeholder="Select LR No's..."
                                                    value={selectedInvoiceUpload} 
                                                    onChange={(selectedOptions) => setSelectedInvoiceUpload(selectedOptions || [])}
                                                    style={{ borderRadius: "0px" }}
                                                    styles={{
                                                        control: (provided, state) => ({
                                                            ...provided,
                                                            fontSize: "0.8rem",
                                                            color: "#6e707e",
                                                            width: "100%"
                                                        }),
                                                        singleValue: (provided, state) => ({
                                                            ...provided,
                                                            fontSize: "0.9rem",
                                                        }),
                                                    }}
                                                    // options={invoicesUploadList}
                                                    
                                                    // required
                                                /> */}
                                                     <input
                                                        type="text"
                                                        id="selectedLr"
                                                        className="border-radius-0"
                                                        readOnly // Makes the input non-editable

                                                        style={{
                                                            borderRadius: '5px',
                                                            fontSize: '13px',
                                                            padding: '8px',
                                                            width: '100%',
                                                            border: "2px solid lightgrey",
                                                        }}
                                                        value={invoicesUploadList}
                                                        
                                                    />
                                            </div>
                                        )}
                                    <div className="form-group col-sm-12">
                                        <label className="f16">Upload POD Document<span style={{color:'red'}}>*</span></label>
                                        
                                        <input type="file" name="epodDoc" id="epodDoc" className="form-control" accept=".pdf, image/*" onChange={changeFileHandlerForPod} required />
                                    </div>
                                   


                                    <div className="form-group2 col-sm-6">
                                        <label className="f16">
                                            Damage
                                        </label><br />
                                        <input type='number' value={damage}  onChange={(e) => {
                                            // Allow only numbers 0 and above
                                            const value = e.target.value;
                                            if (value >= 0) {
                                                setDamage(value);
                                            }
                                        }}
                                        className="form-control custom-input"  />
                                     </div>
                                     <div className="form-group2 col-sm-6">
                                        <label className="f16">
                                            Excess
                                        </label><br />
                                        <input type='number' value={excess} onChange={(e) => {
                                            // Allow only numbers 0 and above
                                            const value = e.target.value;
                                            if (value >= 0) {
                                                setExcess(value);
                                            }
                                        }}
                                        className="form-control custom-input"  />
                                     </div>
                                     <div className="form-group2 col-sm-6">
                                        <label className="f16">
                                            Pilferage
                                        </label><br />
                                        <input type='number' value={pilferage} onChange={(e) => {
                                            // Allow only numbers 0 and above
                                            const value = e.target.value;
                                            if (value >= 0) {
                                                setPilferage(value);
                                            }
                                        }} 
                                        className="form-control custom-input" />
                                     </div>
                                    <div className="form-group2 col-sm-6">
                                        <label className="f16">
                                            Short
                                        </label><br />
                                        <input type='number' value={short} onChange={(e) => {
                                            // Allow only numbers 0 and above
                                            const value = e.target.value;
                                            if (value >= 0) {
                                                setShort(value);
                                            }
                                        }} 
                                        className="form-control custom-input" />
                                     </div>
                                    <div className="form-group col-sm-12 mb-20p">
                                        <label className="f16">Remarks</label>
                                        <textarea name="podremarks" id="podremarks" rows="3" value={podremarks} onChange={changeHandler1} className="form-control" ></textarea>
                                    </div> 
                                    
                                    <div className="form-group col-sm-12 mb-20p text-center">
                                        <button type="submit" className="btn btn-success" style={{marginRight:"10px"}}>Upload</button>
                                        <button type="button" className="btn btn-default" onClick={hideSlideBlock}>Cancel</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-sm-12'>
                        <h5 className='title-heading mb-10p' style={{marginTop:"-18px", fontWeight:"bold"}}>
                        <i className="icofont icofont-vehicle-delivery-van cus-i "></i>Cancelled Invoices
                        </h5>
                        <div style={{ marginRight: "-6px", marginTop:"-31px" }}>

                        {((tabName.value === "active" || tabName.value === "inactive") &&(decodedRoleCase === "admin" ))? (
                            <>
                            <button
                                title="Bulk Upload"
                                onClick={onClickOpenBulkUploadModal}
                                className={"float-right btn btn-warning mr-2"}
                                type="button"
                                style={{fontSize:"13px"}}
                            >
                                <i className="fa fa-upload"></i>&nbsp;&nbsp;&nbsp;Upload Consignments
                            </button>
                            {((decodedRoleCase === "admin" ))?
                            (<button type="button" className="btn btn-warning float-right" onClick={onClickShowForm} style={{ marginRight: "10px", fontSize:'13px' }}>Add Consignment</button>):""
                            }
                            
                            </>
                        ):""}
                          {(tabName.value !=="inactive" && tabName.value !== "cancelled") && 
                                    <>
                                        <div className="col-xl-2 col-lg-2 float-right" style={{marginTop:"-30px"}}>
                                            <label style={{fontSize:"12px", fontWeight:"700"}}>Select View Type  </label>
                                            <Select
                                                className="border-radius-0"
                                                isMulti={false}
                                                id="selectedView"
                                                value={searchViewType}
                                                styles={{
                                                    option: (styles) => ({ ...styles, fontSize: '13px' }),
                                                    singleValue: (styles) => ({ ...styles, fontSize: '13px' }),
                                                    width:"100%"
                                                }}
                                                onChange={(e)=>viewTypeChange(e)}
                                                style={{ borderRadius: "0px", fontSize:"13px" }}
                                                options={[
                                                    { label: "Invoice", value: "Invoice"},
                                                    { label: "LR", value: "LR"}
                                                ]}
                                                required />
                                         </div> 
                                         </>}
                       {/* <i className="icofont icofont-search filter-styling" style={{border:"1px solid #ccc", color:"#ccc",boxShadow: "0 0 5px rgba(0, 0, 0, 0.2)" , background:"#fff"}} onClick={() => setFilterToggle(prev => !prev)}></i> */}
                        </div>
                    </div>
                </div>
                      
            <>     
                
              

                <div className={filterToggle ? "filter-in" : "filter-out"}>
                    {
                        // filterToggle && (localStorage.getItem("role").toLowerCase() === "admin") ?  
                        filterToggle ?  
                    <div className={filterToggle ? "row d-flex" : "row d-flex"}>
                        <div className={"col-xl-4 col-lg-4 d-flex flex-column"}>
                            <div className="card" style={filterCardStyle1}>
                                <div className="row card-body" style={{ padding: "10px 30px" }}>
                                    <form className="row" onSubmit={getTruckConsignments}>
                                        <div className={filterClassName}>
                                            <label style={{fontSize:"13px", fontWeight:"700"}}>Select Type  </label>
                                            <Select
                                                className="border-radius-0"
                                                isMulti={false}
                                                id="selectedFilter"
                                                value={searchType}
                                                styles={{
                                                    option: (styles) => ({ ...styles, fontSize: '13px' }),
                                                    singleValue: (styles) => ({ ...styles, fontSize: '13px' }),
                                                }}
                                                onChange={e => setSearchType(e)}
                                                style={{ borderRadius: "0px", fontSize:"13px" }}
                                                options={
                                                    tabName.value === "inactive" 
                                                    ? [
                                                        // { label: "Vehicle", value: "truck_no" },
                                                        { label: "Invoice No", value: "invoice_no" }
                                                      ] 
                                                    : [
                                                        // { label: "Vehicle", value: "truck_no" },
                                                        { label: "LR No", value: "lr_no" },
                                                        { label: "Invoice No", value: "invoice_no" }
                                                      ]
                                                }
                                                required />
                                        </div>
                                        {searchType.value === "truck_no" ?                                             
                                            <div className={filterClassName}>
                                                {/* <label className="reason">Vehicle No</label>
                                                <input type="text" name="reason" autoComplete="off" class="form-control" id="inputTruckConsignment" value={searchValue} onChange={e => setSeachValue(e.target.value)} /> */}

                                                <label style={{fontSize:"13px", fontWeight:"700"}}>Vehicle No</label>
                                                <Select
                                                    className="border-radius-0"
                                                    isMulti={false}
                                                    id="selectedVehicle"
                                                    styles={{
                                                        option: (styles) => ({ ...styles, fontSize: '13px' }),
                                                        singleValue: (styles) => ({ ...styles, fontSize: '13px' }),
                                                    }}
                                                    style={{ borderRadius: "0px", fontSize:"13px" }}
                                                    value={searchVehicle}
                                                    onChange={e => setSearchVehicle(e)}
                                                    options={filteredvehicles}
                                                />
                                            </div>
                                        : ""}
                                        {searchType.value === "invoice_no" ?
                                            <div className={filterClassName}>
                                                <label style={{fontSize:"13px", fontWeight:"700"}}>Invoice No</label>
                                                {/* <Select
                                                    className="border-radius-0"
                                                    isMulti={false}
                                                    id="selectedInvoice"
                                                    styles={{
                                                        option: (styles) => ({ ...styles, fontSize: '13px' }),
                                                        singleValue: (styles) => ({ ...styles, fontSize: '13px' }),
                                                    }}
                                                    style={{ borderRadius: "0px", fontSize:"13px" }}
                                                    value={searchInvoice}
                                                    onChange={e => setSearchInvoice(e)}
                                                    options={filteredInvoices}
                                                /> */}
                                                <input
                                                    type="text"
                                                    id="selectedInvoice"
                                                    className="border-radius-0"
                                                    style={{
                                                        borderRadius: '5px',
                                                        fontSize: '13px',
                                                        padding: '8px', // Adjust padding to make it look more like the <Select /> component
                                                        width: '100%',
                                                        border:"2px solid lightgrey",
                                                        // outline: 'none', // Remove default outline  
                                                    }}
                                                    value={searchInvoice}
                                                    onChange={(e) => setSearchInvoice(e.target.value)}
                                                    // pattern="\d+/[a-zA-Z]{3}"
                                                    // onInvalid={(e) => {
                                                    // e.target.setCustomValidity("Invalid invoice no format. Please enter 6 digits/ABC format.");
                                                    // }}
                                                    // onInput={(e) => {
                                                    // e.target.setCustomValidity("");
                                                    // }}
                                                    autoComplete='off'
                                                    // placeholder="Enter invoice"
                                                />
                                            </div>                                        
                                        : ""}
                                        {searchType.value === "lr_no" ?  
                                            (tabName.value !== "inactive" ?                                      
                                                <div className={filterClassName}>
                                                    <label style={{fontSize:"13px", fontWeight:"700"}}>LR No</label>
                                                    {/* <Select
                                                        className="border-radius-0"
                                                        isMulti={false}
                                                        id="selectedLr"
                                                        styles={{
                                                            option: (styles) => ({ ...styles, fontSize: '13px' }),
                                                            singleValue: (styles) => ({ ...styles, fontSize: '13px' }),
                                                        }}
                                                        style={{ borderRadius: "0px", fontSize:"13px" }}
                                                        value={lrNo}
                                                        onChange={e => setLrNo(e)}
                                                        options={filteredLrnos}
                                                    /> */}
                                                   <input
                                                        type="text"
                                                        id="selectedLr"
                                                        className="border-radius-0"
                                                        style={{
                                                            borderRadius: '5px',
                                                            fontSize: '13px',
                                                            padding: '8px',
                                                            width: '100%',
                                                            border: "2px solid lightgrey",
                                                        }}
                                                        value={lrNo}
                                                        onChange={(e) => setLrNo(e.target.value)}

                                                        autoComplete='off'
                                                    />


                                                </div>                                                
                                            :
                                            ""
                                            ) 
                                        : ""}
                                        <div className='col-xl-12 col-lg-12'></div>
                                        <div className="form-group col-xl-2 col-lg-2" style={{ textAlign: "left" }}>
                                            <button type="submit" className="btn btn-success">Submit</button>
                                        </div>
                                        <div className="form-group col-xl-2 col-lg-2" style={{ textAlign: "left" }}>
                                            <button type="button" onClick={resetFilters} className="btn btn-default">Reset</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div className={"col-xl-8 col-lg-8 d-flex flex-column"}>
                            <div className="card" style={filterCardStyle1}>
                                <div className="row card-body" style={filterCardStyle2}>
                                    <div className="row col-xl-12 col-lg-12" style={mnFilterClass}>
                                        <div className="form-group col-xl-4 col-lg-4">
                                            <label style={{fontSize:"13px", fontWeight:"700"}}>Select Origin </label>
                                            <Select placeholder={"All"} closeMenuOnSelect={false}
                                                value={searchConsigner}
                                                isMulti={true}
                                                className="border-radius-0"
                                                styles={{
                                                    option: (styles) => ({ ...styles, fontSize: '13px' }),
                                                    singleValue: (styles) => ({ ...styles, fontSize: '13px' }),
                                                }}
                                                onChange={e => setSearchConsigner(e)}
                                                style={{ borderRadius: "0px", fontSize:"13px" }}
                                                options={consignersList}
                                                required />

                                        </div>
                                        {((tabName.value ==="inactive") || (decodedRoleCase !== "user" && decodedRoleCase !== "admin" )) ? 
                                           <>
                                           <div className="col-xl-4 col-lg-4 form-group" style={{padding:"0px"}}>

                                           <div className="col-xl-12 col-lg-12"><label style={{fontSize:"13px", fontWeight:"700"}}>Select Date Type</label></div>
                                                   <div className="col-xl-12 col-lg-12">
                                           <Select
                                               className="border-radius-0"
                                               isMulti={false}
                                               id="selectedFilter"
                                               value={searchDateType}
                                               styles={{
                                                   option: (styles) => ({ ...styles, fontSize: '13px' }),
                                                   singleValue: (styles) => ({ ...styles, fontSize: '13px' }),
                                                   width:"100%"
                                               }}
                                               onChange={e => setSearchDateType(e)}
                                               style={{ borderRadius: "0px", fontSize:"13px" }}
                                              
                                               options={dateTypeList}
                                               required />
                                       </div>
                                       </div>
                                               <div className="col-xl-2 col-lg-2 form-group" style={{padding:"0px"}}>
                                                   <div className="col-xl-12 col-lg-12"><label style={{fontSize:"13px", fontWeight:"700"}}>{`${searchDateType.value} From Date`}</label></div>
                                                   <div className="col-xl-12 col-lg-12">
                                                       <DatePicker
                                                           selected={startDate}
                                                           onChange={handleStartDateChange}
                                                           name="startDate"
                                                           className="datepicker-custom1"
                                                           style={{fontSize:"13px"}}
                                                           onKeyDown={(e) => e.preventDefault()}
                                                           dateFormat="dd-MM-yyyy"
                                                       />
                                                   </div>
                                               </div>
                                               <div className="col-xl-2 col-lg-2 form-group" style={{padding: "0px"}}>
                                                   <div className="col-xl-12 col-lg-12"> <label style={{fontSize:"13px", fontWeight:"700"}}>{`${searchDateType.value} To Date`}</label></div>
                                                   <div className="col-xl-12 col-lg-12">
                                                       <DatePicker
                                                           selected={endDate}
                                                           onChange={handleEndDateChange}
                                                           name="endDate"
                                                           className="datepicker-custom1"
                                                           style={{fontSize:"13px"}}
                                                           onKeyDown={(e) => e.preventDefault()}
                                                           dateFormat="dd-MM-yyyy"
                                                       />
                                                   </div>
                                               </div>
                                           </>
                                        :
                                            <>
                                            <div className="col-xl-2 col-lg-2 form-group" style={{padding:"0px"}}>

                                            <div className="col-xl-12 col-lg-12"><label style={{fontSize:"13px", fontWeight:"700"}}>Select Date Type</label></div>
                                                    <div className="col-xl-12 col-lg-12">
                                            <Select
                                                className="border-radius-0"
                                                isMulti={false}
                                                id="selectedFilter"
                                                value={searchDateType}
                                                styles={{
                                                    option: (styles) => ({ ...styles, fontSize: '13px' }),
                                                    singleValue: (styles) => ({ ...styles, fontSize: '13px' }),
                                                    width:"100%"
                                                }}
                                                onChange={e => setSearchDateType(e)}
                                                style={{ borderRadius: "0px", fontSize:"13px" }}
                                                options={dateTypeList}

                                                required />
                                        </div>
                                        </div>
                                                <div className="col-xl-2 col-lg-2 form-group" style={{padding:"0px"}}>
                                                    <div className="col-xl-12 col-lg-12"><label style={{fontSize:"13px", fontWeight:"700"}}>{`${searchDateType.value} From Date`}</label></div>
                                                    <div className="col-xl-12 col-lg-12">
                                                        <DatePicker
                                                            selected={startDate}
                                                            onChange={handleStartDateChange}
                                                            name="startDate"
                                                            className="datepicker-custom1"
                                                            style={{fontSize:"13px"}}
                                                            onKeyDown={(e) => e.preventDefault()}
                                                            dateFormat="dd-MM-yyyy"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-xl-2 col-lg-2 form-group" style={{padding: "0px"}}>
                                                    <div className="col-xl-12 col-lg-12"> <label style={{fontSize:"13px", fontWeight:"700"}}>{`${searchDateType.value} To Date`}</label></div>
                                                    <div className="col-xl-12 col-lg-12">
                                                        <DatePicker
                                                            selected={endDate}
                                                            onChange={handleEndDateChange}
                                                            name="endDate"
                                                            className="datepicker-custom1"
                                                            style={{fontSize:"13px"}}
                                                            onKeyDown={(e) => e.preventDefault()}
                                                            dateFormat="dd-MM-yyyy"
                                                        />
                                                    </div>
                                                </div>
                                            </>
                                        }
                                        {/* {tabName.value !== "inactive" ? 
                                                    
                                                    
                                        : ""} */}
                                        
                                        {((tabName.value !=="inactive" )  && (decodedRoleCase === "user" || decodedRoleCase === "admin" ))? 
                                            (<div className="col-xl-2 col-lg-2 form-group">
                                            <label style={{fontSize:"13px", fontWeight:"700"}}>Select Tracking Type  </label>
                                            <Select
                                                className="border-radius-0"
                                                isMulti={false}
                                                id="selectedFilter"
                                                value={searchTrackingType}
                                                styles={{
                                                    option: (styles) => ({ ...styles, fontSize: '13px' }),
                                                    singleValue: (styles) => ({ ...styles, fontSize: '13px' }),
                                                    width:"100%"
                                                }}
                                                onChange={e => setSearchTrackingType(e)}
                                                style={{ borderRadius: "0px", fontSize:"13px" }}
                                                options={[
                                                    { label: "PTL", value: "PTL"},
                                                    { label: "FTL", value: "FTL"}
                                                ]}
                                                isDisabled={tabName.value === "inactive"}
                                                required />
                                        </div>)
                                        : ""}
                                        
                                    </div>
                                    <div className="row col-xl-12 col-lg-12" style={{ marginLeft: "0px", padding: "0px" }}>
                                        {(tabName.value==="completed" || tabName.value==="all")&& 
                                        <div className="form-group col-xl-2 col-lg-2">
                                            <label style={{fontSize:"13px", fontWeight:"700"}}>Destination City</label>
                                            <Select
                                                className="border-radius-0"
                                                isMulti={true}
                                                id="selectedCity"
                                                styles={{
                                                    option: (styles) => ({ ...styles, fontSize: '13px' }),
                                                    singleValue: (styles) => ({ ...styles, fontSize: '13px' }),
                                                }}
                                                style={{ borderRadius: "0px", fontSize:"13px" }}
                                                value={searchCity}
                                                onChange={e => setSearchCity(e)}
                                                options={filterCities}
                                            />
                                        </div>
                                         
                                      }
                                        {(tabName.value==="active" || tabName.value==="inactive") && 
                                        <div className="form-group col-xl-4 col-lg-4">
                                            <label style={{fontSize:"13px", fontWeight:"700"}}>Destination City</label>
                                            <Select
                                                className="border-radius-0"
                                                isMulti={true}
                                                id="selectedCity"
                                                styles={{
                                                    option: (styles) => ({ ...styles, fontSize: '13px' }),
                                                    singleValue: (styles) => ({ ...styles, fontSize: '13px' }),
                                                }}
                                                style={{ borderRadius: "0px", fontSize:"13px" }}
                                                value={searchCity}
                                                onChange={e => setSearchCity(e)}
                                                options={filterCities}
                                            />
                                        </div>}
                                        <div className="form-group col-xl-2 col-lg-2">
                                            <label style={{fontSize:"13px", fontWeight:"700"}}>Destination State</label>
                                            <Select
                                                className="border-radius-0"
                                                isMulti={true}
                                                id="selectedState"
                                                styles={{
                                                    option: (styles) => ({ ...styles, fontSize: '13px' }),
                                                    singleValue: (styles) => ({ ...styles, fontSize: '13px' }),
                                                }}
                                                style={{ borderRadius: "0px", fontSize:"13px" }}
                                                value={searchState}
                                                onChange={e => setSearchStates(e)}
                                                options={filterStates}
                                            />
                                        </div>
                                        {(tabName.value==="completed" || tabName.value==="all") &&  <div className="form-group col-xl-2 col-lg-2">
                                          <label style={{fontSize:"13px", fontWeight:"700"}}>Select POD Status</label>
                                          <Select
                                              className="border-radius-0"
                                              isMulti={true}
                                              id="selectedPOD"
                                              styles={{
                                                  option: (styles) => ({ ...styles, fontSize: '13px' }),
                                                  singleValue: (styles) => ({ ...styles, fontSize: '13px' }),
                                              }}
                                              style={{ borderRadius: "0px", fontSize:"13px" }}
                                              value={searchPodStatus}
                                              onChange={e => setSearchPodStatus(e)}
                                              options={podStatusList}
                                          />
                                      </div>}
                                       
                                        <div className="form-group col-xl-2 col-lg-2">
                                            <label style={{fontSize:"13px", fontWeight:"700"}}>Entity</label>
                                            {/* <Select
                                        isMulti={true}
                                        id="selectedEntity"
                                        styles={{
                                            control: (styles) => ({
                                            ...styles,
                                            width: "200px", // Increase the width of the select container
                                            display: "flex", // Flex to align content properly
                                            }),
                                            valueContainer: (styles) => ({
                                            ...styles,
                                            maxWidth: "380px", // Set max width for the selected values
                                            overflowX: "auto", // Enable horizontal scrolling
                                            whiteSpace: "nowrap", // Prevent wrapping of the selected values
                                            }),
                                            menu: (styles) => ({
                                            ...styles,
                                            fontSize: "13px", // Maintain consistent font size in the dropdown options
                                            }),
                                            multiValue: (styles) => ({
                                            ...styles,
                                            fontSize: "13px", // Ensure consistent font size for selected chips
                                            margin: "2px 4px", // Add space between chips
                                            }),
                                            multiValueLabel: (styles) => ({
                                            ...styles,
                                            fontSize: "13px", // Font size for the text inside chips
                                            }),
                                            multiValueRemove: (styles) => ({
                                            ...styles,
                                            cursor: "pointer", // Make the remove button clickable
                                            }),
                                        }}
                                        value={searchEntity}
                                        onChange={(e) => setSearchEntity(e)}
                                        options={entityList}
                                        /> */}
                                        <Select
                                                className="border-radius-0"
                                                isMulti={true}
                                                id="selectedEntity"
                                                styles={{
                                                    option: (styles) => ({ ...styles, fontSize: '13px' }),
                                                    singleValue: (styles) => ({ ...styles, fontSize: '13px' }),
                                                }}
                                                style={{ borderRadius: "0px", fontSize:"13px" }}
                                                value={searchEntity}
                                                onChange={e => setSearchEntity(e)}
                                                options={entityList}
                                            />

                                        </div>
                                        {(decodedRoleCase === "user" || decodedRoleCase === "admin") && 
                            (tabName.value === "inactive" ? (
                                <div className="form-group col-xl-4 col-lg-4">
                                    <label style={{ fontSize: "13px", fontWeight: "700" }}>Transporter</label>
                                    <Select
                                        className="border-radius-0"
                                        isMulti={true}
                                        id="selectedTransporter"
                                        styles={{
                                            option: (styles) => ({ ...styles, fontSize: "13px" }),
                                            singleValue: (styles) => ({ ...styles, fontSize: "13px" }),
                                        }}
                                        style={{ borderRadius: "0px", fontSize: "13px" }}
                                        value={searchTransporters}
                                        onChange={(e) => setSearchTransporters(e)}
                                        options={filterTransporters}
                                    />
                                </div>
                            ) : (
                                <>
                                <div className="form-group col-xl-2 col-lg-2">
                                    <label style={{ fontSize: "13px", fontWeight: "700" }}>Transporter</label>
                                    <Select
                                        className="border-radius-0"
                                        isMulti={true}
                                        id="selectedTransporter"
                                        styles={{
                                            option: (styles) => ({ ...styles, fontSize: "13px" }),
                                            singleValue: (styles) => ({ ...styles, fontSize: "13px" }),
                                        }}
                                        style={{ borderRadius: "0px", fontSize: "13px" }}
                                        value={searchTransporters}
                                        onChange={(e) => setSearchTransporters(e)}
                                        options={filterTransporters}
                                    />
                                </div>
                                <div className="col-xl-2 col-lg-2 form-group">
                                            <label style={{fontSize:"13px", fontWeight:"700"}}>Select Performance</label>
                                            <Select
                                                className="border-radius-0"
                                                isMulti={false}
                                                id="selectedFilter"
                                                value={searchPerformance}
                                                styles={{
                                                    option: (styles) => ({ ...styles, fontSize: '13px' }),
                                                    singleValue: (styles) => ({ ...styles, fontSize: '13px' }),
                                                    width:"100%"
                                                }}
                                                onChange={e => setSearchPerformance(e)}
                                                style={{ borderRadius: "0px", fontSize:"13px" }}
                                                options={[
                                                    { label: "Ontime", value: "Ontime"},
                                                    { label: "Delay", value: "Delay"}
                                                ]}
                                                required />
                                        </div>
                             </>
                            ))
}

                                    </div>

                                    <div className="form-group col-xl-2 col-lg-2" style={{ textAlign: "left", maxWidth:"77px" }}>
                                        <button type="button" className="btn btn-success" onClick={onGetConsignments}>Submit</button>
                                    </div>
                                    <div className="form-group col-xl-2 col-lg-2" style={{ textAlign: "left" }}>
                                        <button type="button" onClick={resetFilters1} className="btn btn-default">Reset</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                        : <>
                        
                        </>
                    }
                </div>
                { (tabName.value !== "inactive" && tabName.value !== "cancelled") &&
                    (<div className={""}>
                        <ConsolidatedCounters setCounter={CounterClick} data={tabName.value == "active" ? countersActive : (tabName.value == "completed" ? countersCompleted : (tabName.value == "all" ? countersAll : ""))} tabName={tabName}/>
                    </div>)
                }
                <div className="row">
                    <div className="col-xl-12 col-lg-12">
                        <div className="card mt-3">
                            <div className="card-header" style={{borderBottom:"#ccc", borderBottom: "1px solid rgb(233 227 227)"}}>
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                    {/* Left side content */}
                                    <h4 style={{ fontWeight: "600", fontSize: "18px" }}>
                                        {( tabName?.value === "inactive" || tabName?.value === "cancelled") ? "":<>
                                                                                <i className="icofont icofont-vehicle-delivery-van cus-i"></i>
                                                                                <span>
                                                                                {`${tabName?.value === "completed" ? "Delivered" : tabName?.label}`} 
                                                                                {(tabName?.value === "inactive" || tabName?.value === "cancelled") ? "" : ` - ${counterActive}`}
                                                                                </span>
                                                                                </>
                                        }
                                    </h4>

                                    {/* Right side content */}
                                 
                                                                   
                        {/* <i className="icofont icofont-search filter-styling" style={{border:"1px solid #ccc", color:"#ccc",boxShadow: "0 0 5px rgba(0, 0, 0, 0.2)" , background:"#fff"}} 
                        onClick={() =>loadConsignmentsData()}
                        ></i>
                                                                // </>} */}
                                    
                                    <div style={{ display: "flex", alignItems: "center" }}>

                                        {(tabName.value === "inactive" && selectedRows.length > 0) ? (
                                        <div style={{ marginLeft: "10px" }}>
                                            <button
                                            style={{ marginRight: "20px", backgroundColor: "#20c997", fontSize: "12px", padding:"8px" }}
                                            title="Update LR"
                                            onClick={updateLrs}
                                            className="custom-btn white mr-2"
                                            type="button">
                                            Update LR
                                            </button>
                                        </div>
                                        // <div style={{ marginLeft: "10px" }}>
                                        //     <button
                                        //     style={{ marginRight: "20px", backgroundColor: "#20c997", fontSize: "19px" }}
                                        //     title="Update LR"
                                        //     onClick={updateLrs}
                                        //     className="custom-btn white mr-2"
                                        //     type="button">
                                        //     <i className="icofont icofont-edit"></i>
                                        //     </button>
                                        // </div>
                                        ) : null}
                                        {/* {(tabName.value === "inactive" && selectedRows.length > 0) ? ( */}
                                      
                                        <div style={{ marginLeft: "10px" }}>
                                            <button
                                            style={{ marginRight: "20px", backgroundColor: "#20c997", fontSize: "12px", padding:"8px", borderRadius:"4px" }}
                                            title="Excel Export"
                                            onClick={onExportClick}
                                            className="custom-btn white mr-2"
                                            type="button">
                                            Excel Export
                                            </button>
                                        </div>
                                        {/* // <div style={{ marginLeft: "10px" }}>
                                        //     <button */}
                                        {/* //     style={{ marginRight: "20px", backgroundColor: "#20c997", fontSize: "19px" }}
                                        //     title="Update LR"
                                        //     onClick={updateLrs}
                                        //     className="custom-btn white mr-2"
                                        //     type="button">
                                        //     <i className="icofont icofont-edit"></i>
                                        //     </button>
                                        // </div>
                                        // ) : null} */}
                                        {(tabName.value === "active" && selectedRows.length > 0) ? (
                                        <div style={{ marginLeft: "10px" }}>
                                            <button
                                            style={{ marginRight: "20px", backgroundColor: "#20c997", fontSize: "12px", padding:"8px" }}
                                            title="Update Multiple Status"
                                            onClick={updateBulkPTLStatus}
                                            className={"btn btn-warning float-right action_btn"}
													type="button">
                                            <i className="fa fa-upload"></i>&nbsp;&nbsp;Bulk Status Update
                                            </button>
                                        </div>
                                         ) : null}
                                       <span className='layoutbtns float-right'>
                                      <div className="col-sm-12">
                                        <button
                                        type="button"
                                        title="Save Grid Layout"
                                        name="savegrid"
                                        className="btn btn-success float-right action_btn"
                                        style={{
                                            borderTopRightRadius: "4px", // Adjust this value to your preference
                                            borderBottomRightRadius: "4px" // Adjust this value to your preference
                                        }}
                                        onClick={saveGrid}>
                                        <i className="fa fa-save"></i>
                                        </button>
                                        <button
                                        type="button"
                                        title="Reset Grid Layout"
                                        name="resetgrid"
                                        className="btn btn-info float-right action_btn"
                                        style={{
                                            borderTopLeftRadius: "4px", // Adjust this value to your preference
                                            borderBottomLeftRadius: "4px" // Adjust this value to your preference
                                        }}
                                        // style={{ marginLeft: "10px" }}
                                        onClick={resetGrid}>
                                        <i className="fa fa-reply"></i>
                                        </button>
                                        </div>
                                        </span> 
                                    </div>
                                    </div>
                            </div>
                          
                           <div className="row" style={{padding:"0 30px", paddingTop:"10px"}}>
                           {searchViewType.value ==="LR" && 
                           
                           
                                <div className="col-xl-12 col-lg-12">
                                <span className="float-right legendlist" style={{fontSize: "15px", fontWeight: 400,  fontSize:"13px"}}>
                                    {(tabName.value !== "inactive" && tabName.value !== "cancelled")  &&  <button type="button" className="btn btn-default mybtn" style={{margin:"0px"}}>
                                    <i className="icofont icofont-map-pins" style={{fontSize: "12px", marginLeft:"0px"}}></i>&nbsp;&nbsp;View Route </button> }
                                    {/* <button type="button" className="btn btn-default mybtn">
                                    <i className="icofont icofont-edit" style={{color:"#1cc88a",fontSize: "20px"}}></i>&nbsp;&nbsp;Dispatch Time Update </button>
                                    <button type="button" className="btn btn-default mybtn">
                                    <i className="icofont icofont-edit" style={{color:"#28bad4",fontSize: "20px"}}></i>&nbsp;&nbsp;Status Update </button> */}
                                    {(tabName.value !== "inactive" && tabName.value !== "cancelled") && <button type="button" className="btn btn-default mybtn" style={{margin:"0px"}}>
                                    <i className="icofont icofont-site-map" style={{fontSize: "14px"}}></i>&nbsp;&nbsp;Consignments </button> }
                                    {(tabName.value !=="inactive" && tabName.value !== "cancelled") && <button type='button' className='btn btn-default mybtn' style={{margin:"0px"}}><i className="icofont icofont-fast-delivery" style={{lineHeight:"25px", verticalAlign:"middle", fontSize:"18px"}}></i>&nbsp;&nbsp; Courier Consignments</button>}
                                    {/* {(tabName.value !=="inactive") && <button type="button" className="btn btn-default mybtn" style={{margin:"0px"}}>
                                    <i className="fa fa-cubes" style={{ color: "#cccc"}}></i>&nbsp;&nbsp;KPIs Status </button> } */}
                                    {(tabName.value !=="inactive" && tabName.value !== "cancelled") && <button type="button" className="btn btn-default mybtn" style={{margin:"0px"}}>
                                    <i className="icofont icofont-clock-time" style={{color:"#ffc107", fontSize: "14px"}}></i>&nbsp;&nbsp;Transit Delays </button> }

                                    {/* <button type="button" className="btn btn-default mybtn"><i className="fa fa-th" style={{fontSize: "15px", color:"#FF5370"}}></i>&nbsp;&nbsp;KPI's Triggered</button> */}
                                  
                                    {(tabName.value === "inactive" && tabName.value !== "cancelled") ? null : (
                                        <button 
                                            type="button" 
                                            className="btn btn-default mybtn" 
                                            style={{ marginLeft: "-5px" }}
                                        >
                                            <i className="icofont icofont-social-google-map txt-danger" style={{ fontSize: "14px" }}></i>
                                            &nbsp;&nbsp;Tracking N/A 
                                        </button>
                                    )} 
                                    {(tabName.value === "active" || tabName.value === "all") ?  (
                                        <button 
                                            type="button" 
                                            className="btn btn-default mybtn" 
                                            style={{ marginLeft: "-5px" }}
                                        >
                                            <i className="icofont icofont-social-google-map " style={{ color:"#26c6da",fontSize: "14px" }}></i>
                                            &nbsp;&nbsp;Tracking not adequate 
                                        </button>
                                    ): null }  
                                       {(tabName.value !== "inactive" && tabName.value !== "cancelled") && <button type="button" className="btn btn-default mybtn rm-br" style={{margin:"0px"}}>
                                       <i className="icofont icofont-pause maroon" style={{fontSize: "14px"}}></i>&nbsp;&nbsp;Stoppages </button> }
                                                                        {(tabName.value ==="active" || tabName.value === "all") && (<><img
                                        src={require("../../assets/images/Update.png")} 
                                        style={{marginLeft:"8px", height:"12px"}}
                                        alt="Update" // Add alt for accessibility
                                        title='Update'
                                    /> <span style={{fontSize:"12px", borderRight: "1px solid #ccc", paddingRight:"5px",marginLeft:"2px", display:"inline-block", height:"20px"}}>Edit</span> </>)}

                                    {(tabName.value ==="active" || tabName.value === "all") && (<><img
                                        src={require("../../assets/images/edit_location.png")} 
                                        style={{marginLeft:"5px", width:"14px"}}
                                        alt="Update Tracking Status " // Add alt for accessibility
                                        title='Update Tracking Status'
                                    /> <span style={{fontSize:"12px", borderRight: "1px solid #ccc", paddingRight:"5px", display:"inline-block", height:"20px"}}>Update Tracking Status</span> </>)}
                                                                        {(tabName.value ==="active" || tabName.value === "all") && (<>
                                       
                                        <i className="icofont icofont-upload-alt f15" style={{ fontSize:"12px",color: "#3a3fa6",marginLeft:"5px", marginRight:"5px", width:"14px" }} title='Upload Documents'></i>
                                    <span style={{fontSize:"12px", borderRight: "1px solid #ccc", paddingRight:"5px", display:"inline-block", height:"20px"}}>Upload Documents</span> </>)}
                                    {(tabName.value ==="active" || tabName.value === "all") && (<>
                                       
                                       <i className="fa fa-eye f15" style={{ fontSize:"12px",marginLeft:"5px", marginRight:"5px", width:"14px" }} title='View Documents'></i>
                                   <span style={{fontSize:"12px", borderRight: "1px solid #ccc", paddingRight:"5px", display:"inline-block", height:"20px"}}>View Documents</span> </>)}
                                   {(tabName.value ==="completed" || tabName.value === "all") && (<>
                                       
                                       <i className="icofont icofont-upload f15" style={{ fontSize:"12px",color: "green",marginLeft:"5px", marginRight:"5px", width:"14px" }} title='Upload POD'></i>
                                   <span style={{fontSize:"12px", borderRight: "1px solid #ccc", paddingRight:"5px", display:"inline-block", height:"20px"}}>Upload POD</span> </>)}
                                   {(tabName.value ==="completed" || tabName.value === "all") && (<>
                                      
                                      <i className="fa fa-file f15" style={{ fontSize:"12px",marginLeft:"5px", marginRight:"5px", width:"14px" }} title='View POD'></i>
                                  <span style={{fontSize:"12px", borderRight: "1px solid #ccc", paddingRight:"5px", display:"inline-block", height:"20px"}}>View POD</span> </>)}

                                   {(tabName.value ==="active") && (<>
                                       
                                       <i className="icofont icofont-ban f15" style={{ fontSize:"12px",marginLeft:"5px", marginRight:"5px", width:"14px" }} title='Force Close'></i>
                                   <span style={{fontSize:"12px", borderRight: "1px solid #ccc", paddingRight:"5px", display:"inline-block", height:"20px"}}>Force Close</span> </>)}
                                    {/* {(tabName.value === "all") && <br/>} */}
                                    
                                    {(tabName.value === "all") && (<>

                                       <i className="icofont icofont-ban f15" style={{ fontSize:"12px",marginLeft:"5px", marginRight:"5px", width:"14px" }} title='Force Close'></i>
                                   <span style={{fontSize:"12px", borderRight: "1px solid #ccc", paddingRight:"5px", display:"inline-block", height:"20px"}}>Force Close</span> </>)}

                                   {(tabName.value ==="active" || tabName.value === "all") && (<>
                                       
                                       <img src={require("../../assets/images/share_icon.png")} style={{ fontSize:"12px",marginLeft:"5px", marginRight:"5px", width:"14px" }} title='Share Link'/>
                                   <span style={{fontSize:"12px", borderRight: "1px solid #ccc", paddingRight:"5px", display:"inline-block", height:"20px"}}>Share Link</span> </>)}


                                                                      {/* <button type="button" className="btn btn-default mybtn">
                                    <i className="icofont icofont-social-google-map txt-secondary" style="font-size: 20px;"></i>&nbsp;GPS Data Not Adequate </button>
                                    <button type="button" className="btn btn-default mybtn">
                                    <i className="fa fa-tachometer darkblue" style="font-size: 20px;"></i>&nbsp;&nbsp;Overspeeding </button>
                                    <button type="button" className="btn btn-default mybtn">
                                    <i className="icofont icofont-full-night txt-primary" style="font-size: 20px;"></i>&nbsp;&nbsp;Night Driving </button>
                                    <button type="button" className="btn btn-default mybtn">
                                    <i className="icofont icofont-truck-alt darkorange" style="font-size: 20px;"></i>&nbsp;&nbsp;Loading Delay </button>
                                    <button type="button" className="btn btn-default mybtn">
                                    <i className="icofont icofont-vehicle-delivery-van mildgreen" style="font-size: 20px;"></i>&nbsp;&nbsp;Unloading Delay </button> */}
                                 
                                    {/* <button type="button" className="btn btn-default mybtn">
                                    <i className="icofont icofont-upload-alt " style={{fontSize: "20px", color:"#387ff2"}}></i>&nbsp;&nbsp;Upload Document </button>
                                    <button type="button" className="btn btn-default mybtn">
                                    <i className="icofont icofont-document-folder " style={{fontSize: "20px", color:"#00C292"}}></i>&nbsp;&nbsp;View Document </button> */}
                                </span>

                                </div>}
                                {/* <div className={"col-xl-12 mb-10p "}>
                                    <span className="layoutbtns">
                                        <button className="float-right custom-btn white btn-danger"
                                            // onClick={this.onClickSaveGridState}
                                            style={{fontSize:"12px"}}
                                            onClick={saveGrid}
                                        >
                                            <i className="icofont icofont-save"></i> Save Grid Layout
                                        </button>
                                        <button className="float-right custom-btn white btn-info" style={{ marginRight: "10px",fontSize:"12px" }}
                                            // onClick={this.resetState}
                                            onClick={resetGrid}
                                        >
                                            <i className="icofont icofont-refresh"></i> Reset Default Layout
                                        </button>
                                        
                                    </span>
                                </div> */}
                            </div>
                            
                          
                            <div className="card-body pt-10px" >
                                <div className={"ag-theme-balham mt-8"} style={{ height: '500px', width: '100%', paddingTop: "1rem" }}>
                                    <AgGridReact
                                        ref={agGridRef}
                                        columnDefs={filterForceClose}
                                        rowData={rowData}                                        
                                        defaultColDef={defaultColDef}
                                        // onCellValueChanged={onCellValueChanged}
                                        pagination={true}
                                        paginationPageSize={50}
                                        onGridReady={onGridReadyConsignments}
                                        enableRangeSelection={true}
                                        enableCellContextMenu={true}
                                        masterDetail={true}
                                        detailCellRendererParams={detailCellRendererParams}
                                        // frameworkComponents ={{AddDealer:AddDealerConsignments}}
                                        sideBar={{
                                            toolPanels: [
                                                {
                                                    id: "columns",
                                                    labelDefault: "Columns",
                                                    labelKey: "columns",
                                                    iconKey: "columns",
                                                    toolPanel: "agColumnsToolPanel",
                                                    toolPanelParams: {
                                                        suppressPivotMode: true,
                                                        suppressRowGroups: true,
                                                        suppressValues: true,
                                                    }
                                                },
                                                {
                                                    id: "filters",
                                                    labelDefault: "Filters",
                                                    labelKey: "filters",
                                                    iconKey: "filter",
                                                    toolPanel: "agFiltersToolPanel"
                                                }
                                            ]
                                        }}
                                        statusBar={{
                                            statusPanels: [
                                                {
                                                    statusPanel: "agTotalAndFilteredRowCountComponent",
                                                    align: "left"
                                                },
                                                {
                                                    statusPanel: "agTotalRowCountComponent",
                                                    align: "center"
                                                },
                                                { statusPanel: "agFilteredRowCountComponent" },
                                                { statusPanel: "agSelectedRowCountComponent" },
                                                { statusPanel: "agAggregationComponent" }
                                            ]
                                        }}
                                        rowSelection="multiple"  // Enable multiple row selection
                                        onSelectionChanged={onSelectionChanged}
                                    />
                                </div>
                        {/* Conditionally render timeline when data is available */}
                                     </div>
                           
                        </div>
                    </div>
                </div>
                
                {openMap.sliderRouteTranslate != '' ?
                    <div className={"slide-r " + (openMap.sliderRouteTranslate)} style={{ overflow: "auto" }}>
                        <div className="slide-r-title">
                            <h4 className="slide-r-title">
                                {(openMap.lr_no)}
                                <span className="float-right closebtn" style={{ marginRight: "10px" }} onClick={closeMapModal} >X</span>
                            </h4>
                        </div>
                        <div className="slide-r-body" style={{ position: "relative" }}>
                            <div className="row col-xl-12 col-lg-12 ml-0p n-p-0">
                                <DrawMap
                                    rownode={openMap.rownode}
                                    mapFor={"consignment"}
                                    tolls={openMap.tolls}
                                    googleroutes={openMap.googelRoutes}
                                    truckno={openMap.maptruckno}
                                    dealer={openMap.dealer}
                                    mapinfo={openMap.mapinfo}
                                    deptcode={openMap.deptcode}
                                    defTransitCoords={openMap.defTransitCoords}
                                    baseRouteCoords={openMap.baseRouteCoords}
                                    geofence_coordinates={openMap.geofence_coordinates}
                                    parking_coordinates={openMap.parking_coordinates}
                                />
                                <div className="col-xl-12 col-lg-12 n-p-0">
                                    <div className="crm-numbers pb-0">
                                        <h3 className="subH">{openMap.sidebarSubHeader}</h3>
                                        <div className="col-xl-12 col-lg-12 row">
                                            <div className="col route-block">
                                                <label className="sidebar-label">Truck No</label>
                                                <div>{openMap.routeTruck.truck_no}</div>
                                            </div>
                                            <div className="col route-block">
                                                <label className="sidebar-label">Start Time</label>
                                                <div>{(!isEmpty(openMap.mapinfo.route_details)) ? getHyphenDDMMMYYYYHHMM(openMap.mapinfo.route_details.start_time) : "-"}</div>
                                            </div>
                                            <div className="col route-block">
                                                <label className="sidebar-label">End Time</label>
                                                <div>{(!isEmpty(openMap.mapinfo.route_details)) ? getHyphenDDMMMYYYYHHMM(openMap.mapinfo.route_details.end_time) : "-"}</div>
                                            </div>

                                            <div className="col route-block">
                                                <label className="sidebar-label">Distance</label>
                                                <div>{(!isEmpty(openMap.mapinfo.route_details)) ? Math.round(openMap.mapinfo.route_details.distance_without_google / 1000) : "0"} Kms</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    : ""
                }
                <div className={"slide-r " + (bulkUploadModal.bulkPrioritySlide)} style={{ overflow: "auto" }}>
                    <h3 className="subH">Bulk Upload Consignments
                        <span className="float-right closebtn" style={{ marginRight: "10px" }} onClick={closeBulkUploadModal} >X</span>
                    </h3>

                    <div className="slide-r-body" style={{ position: "relative" }}>

                        <div className="container-fluid">
                            <div className="col-xl-12 col-lg-12" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginLeft:"-30px" }}>
                            <form method="POST" id="upform" className="theme-form" style={{marginBottom:"20px"}}>
                                <div className="col-xl-12 col-lg-12 form-group">
                                    <label className="">Upload File</label>
                                    <input type="file" name="uploadFile" id="bulkUploadCritical" onChange={changeFileHandler} style={{width:"500px"} }className="form-control"  value={file ? undefined : ""} required />
                                </div>
                                <div className="col-xl-3 col-lg-3 form-group">
								    <a className="btn btn-primary" href={require('../../assets/files/Legrand Autometrics Consignments Format.xlsx')} target="_blank">Sample Template</a>
							    </div>
                               {/* {transactionData !=="" &&   */}
                               {/* <div className="col-xl-3 col-lg-3 form-group">
								<button className="btn btn-warning" onClick={invalidFileData}>Invalid File Data</button>
							    </div> */}
                                {/* } */}
                            </form>
                            <div className="form-group1">
                                    <span style={{color:'red'}}>Note:</span>
                                    <div className='d-flex flex-col' style={{color:"#808080"}}>
                                        {/* Invoice No: It must begin with a numerical sequence, followed by  a forward slash (/), and then source identifier. <br/> */}
                                        {/* LR No: It must consist of numerical values only and can be left empty.<br/> */}
                                        Dates must be in the format of DD-MM-YYYY.
                                    </div>
                                    {/* <a className="btn btn-primary" href={require('../../assets/files/Legrand Autometrics Consignments Format.xlsx')} target="_blank">Sample Template</a> */}
                                </div>
                                </div>
                            <div className='col-xl-12 col-lg-12' style={{ display: "flex", alignItems: "center", justifyContent: "end", marginTop:"-50px"}}>
                                
                                <div className='form-group' style={{ marginRight: "8px" }}>
                                    <div style={{marginTop:"-45px", marginRight:"-18px"}}><i className="fa fa-circle" style={{ color: "#c85f62" }}></i>&nbsp; Invalid Field Value</div>
                                    {/* <div><i className="fa fa-circle" style={{ color: "#ffcc00" }}></i>&nbsp; Order Number and FO Number combination already exists</div> */}
                                </div>
                            </div>
                            <div className="ag-theme-balham mt-2" style={{ height: '55vh', width: '100%', overflow:"auto" }}>
                                <AgGridReact
                                    columnDefs={columnDef}
                                    rowData={modalloadData}
                                    defaultColDef={defaultColDef}
                                    // onCellValueChanged={onCellValueChanged} 
                                    onGridReady={onGridReady}
                                    pagination={true}
                                    paginationPageSize={50}
                                    enableRangeSelection={true}
                                    enableCellContextMenu={true}
                                    stopEditingWhenGridLosesFocus={true}
                                    sideBar={{
                                        toolPanels: [
                                            {
                                                id: "columns",
                                                labelDefault: "Columns",
                                                labelKey: "columns",
                                                iconKey: "columns",
                                                toolPanel: "agColumnsToolPanel",
                                                toolPanelParams: {
                                                    suppressPivotMode: true,
                                                    suppressRowGroups: true,
                                                    suppressValues: true,
                                                }
                                            },
                                            {
                                                id: "filters",
                                                labelDefault: "Filters",
                                                labelKey: "filters",
                                                iconKey: "filter",
                                                toolPanel: "agFiltersToolPanel"
                                            }
                                        ]
                                    }}
                                    statusBar={{
                                        statusPanels: [
                                            {
                                                statusPanel: "agTotalAndFilteredRowCountComponent",
                                                align: "left"
                                            },
                                            {
                                                statusPanel: "agTotalRowCountComponent",
                                                align: "center"
                                            },
                                            { statusPanel: "agFilteredRowCountComponent" },
                                            { statusPanel: "agSelectedRowCountComponent" },
                                            { statusPanel: "agAggregationComponent" }
                                        ]
                                    }} />
                            </div>
                            <br />
                            <div className="form-group">
                                <button type="submit" className="btn btn-success" onClick={saveConsignments}>Submit</button>
                                <button type="button" onClick={closeBulkUploadModal} className="btn btn-default">Cancel</button>
                            </div>
                            <br />
                            <br />
                        </div>
                    </div>
                </div>
                <div
                    className={"slide-r " + showAddForm}
                    style={{ overflow: "auto",  }}
                >
                    <div className="slide-r-title">
                        <h4 className="slide-r-title">Update Consignments<span className="float-right closebtn" style={{ marginRight: "10px"}} onClick={onClickHideManualUpload} >X</span></h4>
                    </div>
                    <div className="row" style={{padding:"20px"}}>
                    <div className="col-sm-12">
                        <form onSubmit={onsubmitdata}>
                            <div className="slide-body">
                                <div className="row p-20p">
                                    <div className="form-group col-xl-12 col-lg-12"></div>{" "}
                                <div className="form-group col-xl-12 col-lg-12">
                                    <label className="mb-5p">
                                    Consignee Name<span style={{color:'red'}}>*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="consigner_name"
                                        id="consigner_name"
                                        value={manualUploadDetails1.consignee_name}
                                        className="form-control"
                                        onChange={(e) => setmanualUploadDetails1(prev => ({ ...prev, consignee_name: e.target.value }))}
                                        required
                                    />                             
                                </div>
                                <div className="form-group col-xl-12 col-lg-12">
                                    <label className="mb-5p">
                                    Destination City<span style={{color:'red'}}>*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="consignee_city"
                                        id="consignee_city"
                                        value={manualUploadDetails1.consignee_city}
                                        className="form-control"
                                        onChange={(e) => setmanualUploadDetails1(prev => ({ ...prev, consignee_city: e.target.value }))}
                                        required
                                    /> 
                                </div>
                                <div className="form-group col-xl-12 col-lg-12">
                                    <label className="mb-5p">
                                    Destination State<span style={{color:'red'}}>*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="consignee_state"
                                        id="consignee_state"
                                        value={manualUploadDetails1.consignee_state}
                                        className="form-control"
                                        onChange={(e) => setmanualUploadDetails1(prev => ({ ...prev, consignee_state: e.target.value }))}
                                        required
                                    /> 
                                </div>
                                <div className="form-group col-xl-12 col-lg-12">
                                    <label className="mb-5p">
                                    Destination Pincode<span style={{color:'red'}}>*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="consignee_pincode"
                                        id="consignee_pincode"
                                        value={manualUploadDetails1.consignee_pincode}
                                        className="form-control"
                                        onChange={(e) => setmanualUploadDetails1(prev => ({ ...prev, consignee_pincode: e.target.value }))}
                                        required
                                    /> 
                                
                                </div>
                                <div className="form-group col-xl-12 col-lg-12">
                                    <label className="mb-5p">
                                    Total Weight<span style={{color:'red'}}>*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="total_weight"
                                        id="total_weight"
                                        value={manualUploadDetails1.total_weight}
                                        className="form-control"
                                        // onChange={(e) => setmanualUploadDetails1(prev => ({ ...prev, total_weight: e.target.value }))}
                                        required
                                    />                             
                                </div>                            
                                <div className="form-group col-sm-12 mb-20p text-center">
                                    <button type="submit" className="btn btn-success">
                                    Submit
                                    </button>
                                    
                                </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    </div>
                </div> 
                <div className={"slide-r " + showAddForm2} style={{ overflow: "auto",  }}>
                    <div className="slide-r-title">
                    <h4 className="slide-r-title">Update Details<span className="float-right closebtn" style={{ marginRight: "10px"}} onClick={onClickHideManualUpload2} >X</span></h4>          
                    </div> 
                    {/* { (Dselected_row.status === 1  || Dselected_row.consignment_status === "Dispatched from Source")? */}
                    { (Dselected_row.status === 1 )?

                    <>                          
                        <div className="row" style={{padding:"20px"}}>
                        <div className="col-sm-12">
                            <form 
                            onSubmit={(e) => {
                                e.preventDefault(); // Prevent default submit behavior
                                onClickGateOutUpdate(e); // Your custom submit logic
                            }}    
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    e.preventDefault(); // Prevent form submission on "Enter"
                                }
                            }} 
                            >
                            <div className="slide-body">
                                <div className="row p-20p">                 
                                <div className="form-group col-xl-12 col-lg-12">
                                    <label className="mb-5p">
                                    Dispatch Time<span style={{color:'red'}}>*</span>
                                    </label>
                                <div id="datepicker1">
                                        <DatePicker
                                    selected={manualInTransitStatusUpdate.dispatch_time}
                                    onChange={changeHandleDate}
                                    name="dispatch_time"
                                    className="datepicker-custom-ptl3 form-control"
                                    showTimeSelect
                                    timeFormat="HH:mm:ss"
                                    timeIntervals={15} // Adjust this if you want different time intervals
                                    timeCaption="Time"
                                    dateFormat="dd-MM-yyyy HH:mm:ss" // Adjusted format to match the original format
                                    // placeholderText="Date" // Equivalent to placeholder in the original
                                    id="dispatch_time"
                                    autoComplete='off'
                                    style={{width:"96%"}}
                                    required
                                    />
                                </div>
                                
                                </div>
                                
                                {/* <h6 style={{ color: "red", fontSize: "14px", marginTop: "2%" }}>Note: All date fields should be greater than production date</h6> */}
                                <div className="form-group col-sm-12 mb-20p text-center">
                                    <button type="submit" className="btn btn-success" style={{padding:"6px 20px", fontSize:"14px", marginRight:"10px"}}>
                                    Submit
                                    </button>
                                    <button type="button" onClick={onCloseUpdateDetails} className="btn btn-default" style={{}}>Cancel</button>
                                </div>
                                </div>
                            </div>
                            </form>
                        </div>
                        </div>
                    </>
                    : ""}
                    {((Dselected_row.status === 2 || Dselected_row.status === 3) ||  (Dselected_row.consignment_status) || bulkPtlUpdate) ?

                    (<div className="row" style={{padding:"20px"}}>
                        <div className="col-sm-12">
                            <form 
                                onSubmit={(e) => {
                                    e.preventDefault(); // Prevent default submit behavior
                                    onClickDeliveredSubmit(e); // Your custom submit logic
                                }}    
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        e.preventDefault(); // Prevent form submission on "Enter"
                                    }
                                }}                        >
                            <div className="slide-body">
                                <div className="row p-20p">
                                {(Dselected_row.consignment_status || bulkPtlUpdate) && 
                               <div className="form-group col-xl-12 col-lg-12">
                                            <label className="mb-5p">
                                            LR No<span style={{color:'red'}}>*</span>
                                            </label>
                                            <Select placeholder={"All"} closeMenuOnSelect={false}
                                                value={selectedLRStoUpdateLr}
                                                isMulti={true}
                                                className="border-radius-0"
                                                // onChange={e => setInvoiceSelected(e)}
                                                style={{ borderRadius: "0px" }}
                                                styles={{
                                                    control: (provided, state) => ({
                                                    ...provided,
                                                    fontSize: "0.8rem",
                                                    color: "#6e707e",
                                                    width:"100%"
                                                    }),
                                                    singleValue: (provided, state) => ({
                                                    ...provided,
                                                    fontSize: "0.9rem",
                                                    }),
                                                }}
                                                // options={selectedLRStoUpdateLr}
                                                required 
                                            />
                           </div>
                                }
                                <div className="form-group col-xl-12 col-lg-12">
                                    <label className="mb-5p">
                                    Status<span style={{color:'red'}}>*</span>
                                    </label>
                                    <Select
                                        closeMenuOnSelect={true}
                                        value={form2Details.selectedStatus} 
                                        onChange={handleStatusChange}
                                        style={{ borderRadius: "0px" }}
                                        styles={{
                                            control: (provided, state) => ({
                                            ...provided,
                                            fontSize: "0.8rem",
                                            color: "#6e707e",
                                            width:"100%"
                                            }),
                                            singleValue: (provided, state) => ({
                                            ...provided,
                                            fontSize: "0.9rem",
                                            }),
                                        }}
                                        options={form2Details.event_status} 
                                    />
                                      {/* {form2Details.errorMessage && (
                                    <div style={{ color: 'red', fontSize: "10px", margin: "10px 0px 0px 0px" }}>
                                    {form2Details.errorMessage}
                                    </div>
                                )} */}
                                                            </div>
                              
                                <div className="form-group col-xl-12 col-lg-12">
                                    <label className="mb-5p">
                                    Current Location<span style={{color:'red'}}>*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="lr_no"
                                        id="lr_no"
                                        value={form2Details.event_location}
                                        className="form-control1"
                                        onChange={(e) => setForm2Details(prev => ({ ...prev, event_location: e.target.value }))}
                                        autoComplete='off'
                                        required
                                    />                  
                                </div>
                                {ableRemark && 
                                <div className="form-group col-xl-12 col-lg-12">
                                    <label className="mb-5p">
                                    Reason For Undelivered<span style={{color:'red'}}>*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="lr_no"
                                        id="lr_no"
                                        value={form2Details.remark}
                                        className="form-control"
                                        onChange={(e) => setForm2Details(prev => ({ ...prev, remark: e.target.value }))}
                                        autoComplete='off'
                                        required
                                    /> 
                                </div>
                                }
                                 {Dselected_row.ontime_status ===0 && 
                                <div className="form-group col-xl-12 col-lg-12">
                                    <label className="mb-5p">
                                    Reason For Delay<span style={{color:'red'}}>*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="lr_no"
                                        id="lr_no"
                                        value={form2Details.reason_for_delay}
                                        className="form-control"
                                        onChange={(e) => setForm2Details(prev => ({ ...prev, reason_for_delay: e.target.value }))}
                                        autoComplete='off'
                                        required
                                    /> 
                                </div>
                                }
                                 {/* {((Dselected_row.status === 2 || Dselected_row.status === 3) && ((Dselected_row.invoice_list).length>1)) && 
                               <div className="form-group col-xl-12 col-lg-12">
                               <label className="mb-5p">
                               Pincode<span style={{color:'red'}}>*</span>
                               </label>
                               <Select
                                   closeMenuOnSelect={true}
                                   value={form2Details.selectedPincode} 
                                   onChange={(e) =>
                                       setForm2Details({ ...form2Details, selectedPincode: {label:e.value, value: e.value} })
                                   }
                                   style={{ borderRadius: "0px" }}
                                   styles={{
                                       control: (provided, state) => ({
                                       ...provided,
                                       fontSize: "0.8rem",
                                       color: "#6e707e",
                                       width:"100%"
                                       }),
                                       singleValue: (provided, state) => ({
                                       ...provided,
                                       fontSize: "0.9rem",
                                       }),
                                   }}
                                   options={pincodesList} 
                               />
                           </div>
                                } */}
                                <div className="form-group col-xl-12 col-lg-12">
                                    <label className="mb-5p">
                                    {`${form2Details.selectedStatus.label} Datetime`}<span style={{color:'red'}}>*</span>
                                    </label>
                                <div id="datepicker1">
                                <DatePicker
                                    selected={form2Details.delivered_date}
                                    onChange={changeHandleDate1}
                                    name="delivered_date"
                                    className="datepicker-custom-ptl3 form-control"
                                    showTimeSelect
                                    timeFormat="HH:mm:ss"
                                    timeIntervals={15}
                                    timeCaption="Time"
                                    dateFormat="dd-MM-yyyy HH:mm:ss"
                                    id="delivered_date"
                                    autoComplete='off'
                                    required
                                    maxDate={new Date()} // Set maxDate to today's date
                                />
                                </div>
                                
                                </div>
                                {(form2Details.selectedStatus.value === "Reached Destination" || form2Details.selectedStatus.value === "Delivered")  && 
                                 <div className="form-group col-sm-12 mb-20p text-left">
                                 <button type="button" className="btn btn-success" style={{ marginRight: "10px" }} onClick={uploadPODInTracking}>
                                     Upload POD
                                 </button></div>}
                                {uploadPODTracking && (form2Details.selectedStatus.value === "Reached Destination"  || form2Details.selectedStatus.value === "Delivered") && (<div className="row p-20p">
                                {Dselected_row.tracking_type === "FTL" && (
                                            <div className="form-group col-sm-11 mb-20p ml-15p">
                                                {/* <label>Select Invoice<span style={{ color: 'red' }}>*</span></label>
                                                
                                                <Select
                                                    isMulti // Enable multi-select
                                                    closeMenuOnSelect={false} // Keeps dropdown open for multiple selections
                                                    placeholder="Select invoices..."
                                                    value={selectedInvoiceUpload} 
                                                    onChange={(selectedOptions) => setSelectedInvoiceUpload(selectedOptions || [])}
                                                    style={{ borderRadius: "0px" }}
                                                    styles={{
                                                        control: (provided, state) => ({
                                                            ...provided,
                                                            fontSize: "0.8rem",
                                                            color: "#6e707e",
                                                            width: "100%"
                                                        }),
                                                        singleValue: (provided, state) => ({
                                                            ...provided,
                                                            fontSize: "0.9rem",
                                                        }),
                                                    }}
                                                    options={invoicesUploadList}
                                                    // required
                                                /> */}
                                                <label className="f16">LR No.
                                                    {/* <span style={{ color: 'red' }}>*</span> */}
                                                    </label>
                                                
                                                {/* <Select
                                                    isMulti // Enable multi-select
                                                    closeMenuOnSelect={false} // Keeps dropdown open for multiple selections
                                                    placeholder="Select LR No's..."
                                                    value={selectedInvoiceUpload} 
                                                    onChange={(selectedOptions) => setSelectedInvoiceUpload(selectedOptions || [])}
                                                    style={{ borderRadius: "0px" }}
                                                    styles={{
                                                        control: (provided, state) => ({
                                                            ...provided,
                                                            fontSize: "0.8rem",
                                                            color: "#6e707e",
                                                            width: "100%"
                                                        }),
                                                        singleValue: (provided, state) => ({
                                                            ...provided,
                                                            fontSize: "0.9rem",
                                                        }),
                                                    }}
                                                    // options={invoicesUploadList}
                                                    
                                                    // required
                                                /> */}
                                                     <input
                                                        type="text"
                                                        id="selectedLr"
                                                        className="border-radius-0"
                                                        readOnly // Makes the input non-editable

                                                        style={{
                                                            borderRadius: '5px',
                                                            fontSize: '13px',
                                                            padding: '8px',
                                                            width: '103%',
                                                            border: "2px solid lightgrey",
                                                        }}
                                                        value={Dselected_row.lr_no}
                                                        
                                                    />
                                            </div>
                                        )}
                                    <div className="form-group col-sm-11 mb-20p ml-15p">
                                        <label className="f16">Upload POD Document<span style={{color:'red'}}>*</span></label>
                                        
                                        <input type="file" name="epodDoc" id="epodDoc" style={{width:"103%"}} className="form-control" accept=".pdf, image/*" onChange={changeFileHandlerForPod} required />
                                    </div>
                                   


                                    <div className="ml-30p form-group" style={{width:"210px"}}>
                                        <label className="f16">
                                            Damage
                                        </label><br />
                                        <input type='number' value={damage}  onChange={(e) => {
                                            // Allow only numbers 0 and above
                                            const value = e.target.value;
                                            if (value >= 0) {
                                                setDamage(value);
                                            }
                                        }}
                                        className="form-control custom-input"  />
                                     </div>
                                     <div className="form-group ml-30p" style={{width:"208px"}}>
                                        <label className="f16">
                                            Excess
                                        </label><br />
                                        <input type='number' value={excess} onChange={(e) => {
                                            // Allow only numbers 0 and above
                                            const value = e.target.value;
                                            if (value >= 0) {
                                                setExcess(value);
                                            }
                                        }}
                                        className="form-control custom-input"  />
                                     </div>
                                     <div className="form-group ml-30p" style={{width:"210px"}}>
                                        <label className="f16">
                                            Pilferage
                                        </label><br />
                                        <input type='number' value={pilferage} onChange={(e) => {
                                            // Allow only numbers 0 and above
                                            const value = e.target.value;
                                            if (value >= 0) {
                                                setPilferage(value);
                                            }
                                        }} 
                                        className="form-control custom-input" />
                                     </div>
                                    <div className="form-group ml-30p" style={{width:"208px"}}>
                                        <label className="f16">
                                            Short
                                        </label><br />
                                        <input type='number' value={short} onChange={(e) => {
                                            // Allow only numbers 0 and above
                                            const value = e.target.value;
                                            if (value >= 0) {
                                                setShort(value);
                                            }
                                        }} 
                                        className="form-control custom-input" />
                                     </div>
                                    <div className="form-group col-sm-11 mb-20p ml-15p">
                                        <label className="f16">Remarks</label>
                                        <textarea name="podremarks" id="podremarks" rows="3" value={podremarks} onChange={changeHandler1} style={{width:"103%"}} className="form-control" ></textarea>
                                    </div> 
                                    
                                    
                                </div>)}
                                <div className="form-group col-sm-12 mb-20p text-center">
                                    <button type="submit" className="btn btn-success" style={{padding:"6px 20px", fontSize:"14px", marginRight:"10px"}}>
                                    Submit
                                    </button>
                                    <button type="button" onClick={onCloseUpdateDetails} className="btn btn-default" style={{}}>Cancel</button>
                                </div>
                                </div>
                            </div>
                            </form>
                        </div>
                    </div>): ''}
                    
                    
                </div>

                {/* <div className={"slide-r " + showBulkUpdateForm} style={{ overflow: "auto",  }}>
                    <div className="slide-r-title">
                    <h4 className="slide-r-title">Bulk Update Details<span className="float-right closebtn" style={{ marginRight: "10px"}} onClick={onClickHideManualUpload4} >X</span></h4>          
                    </div> 
                    <div className="slide-r-body" style={{ position: "relative" }}>
						<div className="container-fluid">
							<form id="upform" className="theme-form" onSubmit={uploadFormHandler}>
								<div className="form-group mt-20p">
									<label className="">Upload File</label>
									<input type="file" name="uploadBulkFile" onChange={changeBulkStatusFileHandler} className="form-control" required />
								</div>
								<div className="form-group">
									<button type="submit" className="btn btn-success">Submit</button>
									<button type="button" onClick={onClickHideManualUpload4} className="btn btn-default">Cancel</button>
								</div>
							</form>
							{/* <div className="form-group">
								<p style={{ color: "#ff0000" }}>*Note: All fields related to ticket are mandatory</p>
								<p><b>Ticketing bulk update rules:</b></p>
								<p><b>Communication Type:</b> Email/Phone/Other</p>
								<p><b>Status: </b>Open/Closed/Invalid/On Hold/Closed - No response</p>
								<p><b>Satisfactory Response:</b> Yes/No</p>
							</div> */}
							{/* <div className="form-group">
								<a className="btn btn-primary" href={require('../../assets/files/Bulk_update_file.csv')} target="_blank">Sample Template</a>

							</div>

						</div>
					</div>
                    
                    
                </div> */} 
                <div className={"slide-r " + (showBulkUpdateForm)} style={{ overflow: "auto" }}>
                    <h3 className="subH">Bulk Status Update Details
                        <span className="float-right closebtn" style={{ marginRight: "10px" }} onClick={onClickHideManualUpload4} >X</span>
                    </h3>

                    <div className="slide-r-body" style={{ position: "relative" }}>

                        <div className="container-fluid">
                            <div className="col-xl-12 col-lg-12" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginLeft:"-30px" }}>
                            <form method="POST" id="upform" className="theme-form" style={{marginBottom:"20px"}}>
                                <div className="col-xl-12 col-lg-12 form-group">
                                    <label className="">Upload File</label>
                                    <input type="file" name="uploadBulkFile" id="bulkUpdateCritical" onChange={changeBulkStatusFileHandler} style={{width:"500px"} }className="form-control"  value={file1 ? undefined : ""} required />
                                </div>
                                <div className="col-xl-6 col-lg-6 form-group">
								    <a className="btn btn-primary" href={require('../../assets/files/Bulk Update Status.xlsx')} target="_blank">Sample Template</a>
							    </div>
                            </form>
                            <div className="form-group1">
                                    {/* <span style={{color:'red'}}>Note:</span>
                                    <div className='d-flex flex-col' style={{color:"#808080"}}>
                                         Invoice No: It must begin with a numerical sequence, followed by  a forward slash (/), and then source identifier. <br/> 
                                         LR No: It must consist of numerical values only and can be left empty.<br/> 
                                         Dates must be in the format of DD-MM-YYYY.
                                    </div> 
                                      <a className="btn btn-primary" href={require('../../assets/files/Legrand Autometrics Consignments Format.xlsx')} target="_blank">Sample Template</a>   */}
                                 </div>
                                </div> 
                             <div className='col-xl-12 col-lg-12' style={{ display: "flex", alignItems: "center", justifyContent: "end", marginTop:"-50px"}}>
                                
                                <div className='form-group' style={{ marginRight: "8px" }}>
                                    <div style={{marginTop:"-45px", marginRight:"-18px"}}><i className="fa fa-circle" style={{ color: "#c85f62" }}></i>&nbsp; Invalid Field Value</div>
                                    {/* <div><i className="fa fa-circle" style={{ color: "#ffcc00" }}></i>&nbsp; Order Number and FO Number combination already exists</div>  */}
                                 </div>
                            </div> 
                            <div className="ag-theme-balham mt-2" style={{ height: '55vh', width: '100%', overflow:"auto" }}>
                                <AgGridReact
                                    columnDefs={columnBulkUpdateDef}
                                    rowData={modalBulkUpdateData}
                                    defaultColDef={defaultColDef}
                                    // onCellValueChanged={onCellValueChanged} 
                                    onGridReady={onGridReadyBulkUpdate}
                                    pagination={true}
                                    paginationPageSize={50}
                                    enableRangeSelection={true}
                                    enableCellContextMenu={true}
                                    stopEditingWhenGridLosesFocus={true}
                                    sideBar={{
                                        toolPanels: [
                                            {
                                                id: "columns",
                                                labelDefault: "Columns",
                                                labelKey: "columns",
                                                iconKey: "columns",
                                                toolPanel: "agColumnsToolPanel",
                                                toolPanelParams: {
                                                    suppressPivotMode: true,
                                                    suppressRowGroups: true,
                                                    suppressValues: true,
                                                }
                                            },
                                            {
                                                id: "filters",
                                                labelDefault: "Filters",
                                                labelKey: "filters",
                                                iconKey: "filter",
                                                toolPanel: "agFiltersToolPanel"
                                            }
                                        ]
                                    }}
                                    statusBar={{
                                        statusPanels: [
                                            {
                                                statusPanel: "agTotalAndFilteredRowCountComponent",
                                                align: "left"
                                            },
                                            {
                                                statusPanel: "agTotalRowCountComponent",
                                                align: "center"
                                            },
                                            { statusPanel: "agFilteredRowCountComponent" },
                                            { statusPanel: "agSelectedRowCountComponent" },
                                            { statusPanel: "agAggregationComponent" }
                                        ]
                                    }} />
                            </div>
                            <br />
                            <div className="form-group"> 
                                <button type="submit" className="btn btn-success" onClick={uploadFormHandler}>Submit</button> 
                                 <button type="button" onClick={onClickHideManualUpload4} className="btn btn-default">Cancel</button>
                            </div>
                            <br />
                            <br />
                        </div> 
                    </div> 
                 </div>    
 
                <div className={"slide-r " + showAddForm3} style={{ overflow: "auto",  }}>
                    <div className="slide-r-title">
                        <h4 className="slide-r-title">Update Trip Details<span className="float-right closebtn" style={{ marginRight: "10px"}} onClick={onClickHideManualUpload3} >X</span></h4>                    
                    </div>
                    <div className="row" style={{padding:"20px"}}>
                        <div className="col-sm-12">
                            <form onSubmit={onClickUpdateConsignment}>
                                <div className="slide-body">
                                    <div className="row p-20p">   
                                        {/* Lr no */}
                                        <div className="form-group col-xl-12 col-lg-12">
                                            <label className="mb-5p">
                                                LR No.
                                                <span style={{color:'red'}}>*</span>
                                            </label>
                                            <input
                                                type="text"
                                                name="lr_no"
                                                id="lr_no"
                                                value={manualUpdateConsignment.lr_no}
                                                className="form-control"
                                                // onChange={(e) => {
                                                //     // Only update state if the input is a valid number
                                                //     const value = e.target.value;
                                                //     if (/^\d*$/.test(value)) {  // This regex allows only numeric values
                                                //         setManualUpdateConsignment(prev => ({ ...prev, lr_no: value }));
                                                //     }
                                                // }}
                                                isDisabled={true}

                                                required
                                            />                                     
                                        </div>
                                         {/* invoice no */}
                                         <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">Invoice No<span style={{color:'red'}}>*</span>  </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                // onChange={(e)=> setManualUpdateConsignment(prev => ({...prev, invoice_no:e.target.value.toUpperCase() }))}
                                                value={manualUpdateConsignment.invoice_no}
                                                name="invoice_no"
                                                autoComplete='off'
                                                // pattern="\d+/[a-zA-Z]{3}"
                                                isDisabled={true}

                                                // onInvalid={(e) => {
                                                // e.target.setCustomValidity("Invalid invoice no format. Please enter 6 digits/ABC format.");
                                                // }}
                                                // onInput={(e) => {
                                                // e.target.setCustomValidity("");
                                                // }}
                                            />
                                            {/* {manualUpdateConsignment.invoice_no && !/^\d+\/[A-Z]{3}$/.test(manualUpdateConsignment.invoice_no) && (
                                                <div style={{ color: "red", fontSize: "12px", paddingLeft: "20px",paddingTop:"5px" }}>
                                                    Invalid invoice no format. Please enter digits followed by /ABC format (e.g., 300000/ACM).
                                                </div>
                                            )} */}

                                            </div>
                                        {/* driver mobile no */}
                                        {(selected_row.tracking_type ==="FTL") && 
                                        <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">Driver Mobile No.<span style={{color:'red'}}>*</span> </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                // onChange ={(e)=>  setManualUpdateConsignment((prev) => ({ ...prev, driver_mobile_no: e.target.value }))}
                                                onChange={(e) => {
                                                    const { name } = e.target;
                                                    const numericValue = e.target.value.replace(/\D/g, '').slice(0, 10);
                                                    
                                                    // Validate the input length and content
                                                    if (numericValue.length < 10) {
                                                        setError2('Mobile number must be 10 digits long');
                                                    } else if (!/^[6-9]\d{9}$/.test(numericValue)) {
                                                        setError2('Mobile number must start with a digit between 6 and 9 and be 10 digits long');
                                                    } else {
                                                        setError2(''); // Clear error if the number is valid
                                                    }

                                                    // Update the state with the new value (allow only 10 digits max)
                                                    if (numericValue.length <= 10) {
                                                       
                                                            setManualUpdateConsignment((prev) => ({ ...prev, driver_mobile_no: numericValue }));
                                                       
                                                    }
                                                }}                                               
                                                name="driver_mobile_no"
                                                autoComplete='off'
                                                value = {manualUpdateConsignment.driver_mobile_no}
                                            />
                                            {error2 && <span style={{ color: 'red', fontSize: "10px", margin: "10px 0px 0px 20px" }}>{error2}</span>}                    
               
                                        </div>}
                                        {/* Source */}
                                        {
                                            <div className="form-group col-xl-12 col-lg-12">
                                                <label className="mb-5p">Source<span style={{color:'red'}}>*</span></label>
                                                <Select
                                                    closeMenuOnSelect={true}
                                                    value={manualUpdateConsignment.source}
                                                    style={{ borderRadius: '0px' }}
                                                    styles={{
                                                    control: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: '0.8rem',
                                                        color: '#6e707e',
                                                        width:"100%"
                                                    }),
                                                    singleValue: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: '0.9rem',
                                                    }),
                                                    }}
                                                    // options={sourceOptions} 
                                                    isDisabled={true}
                                                    // onChange={(option) => {
                                                    // setManualUpdateConsignment((prev) => ({ ...prev, source: option }));
                                                    // }}
                                                />
                                            </div>
                                        }                                        
                                        {manualUpdateConsignment.other_source && (
                                            <>
                                                {/* Other Source Field */}
                                                <div className="col-xl-12 col-lg-12 form-group">
                                                <label className="mb-5p">
                                                    Other Source<span style={{ color: 'red' }}>*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    onChange={(e) => {
                                                    const text = e.target.value;
                                                    if (/^[A-Za-z\s]*$/.test(text)) { // Allow only text and spaces
                                                        setManualUpdateConsignment((prev) => ({ ...prev, other_source: text }));
                                                    }
                                                    }}
                                                    value={manualUpdateConsignment.other_source}
                                                    name="other_source"
                                                    autoComplete="off"
                                                />
                                                {manualUpdateConsignment.other_source && !/^[A-Za-z\s]+$/.test(manualUpdateConsignment.other_source) && (
                                                    <div style={{ color: "red", fontSize: "12px", paddingTop:"5px", paddingLeft:"20px" }}>Invalid input. Only text is allowed.</div>
                                                )}
                                                </div>

                                                {/* Other Pincode Field */}
                                                <div className="col-xl-12 col-lg-12 form-group">
                                                <label className="mb-5p">
                                                    Other Pincode<span style={{ color: 'red' }}>*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    maxLength={6}
                                                    onChange={(e) => {
                                                    const digits = e.target.value;
                                                    if (/^\d{0,6}$/.test(digits)) { // Allow only digits
                                                        setManualUpdateConsignment((prev) => ({ ...prev, other_pincode: digits }));
                                                    }
                                                    }}
                                                    value={manualUpdateConsignment.other_pincode}
                                                    name="other_pincode"
                                                    autoComplete="off"
                                                />
                                                {manualUpdateConsignment.other_pincode && !/^\d{0,6}$/.test(manualUpdateConsignment.other_pincode) && (
                                                    <div style={{ color: "red", fontSize: "12px", paddingTop:"5px", paddingLeft:"20px" }}>Invalid input. Only digits are allowed.</div>
                                                )}
                                                </div>
                                            </>
                                        )}
                                        {/* Truck No */}
                                        {(selected_row.tracking_type==="FTL") && 
                                        <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">
                                                Truck No<span style={{ color: 'red' }}>*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                // onChange={(e) => {
                                                // const value = e.target.value.toUpperCase(); 
                                                // if (/^[A-Z0-9]{0,10}$/.test(value)) {
                                                //     setManualUpdateConsignment((prev) => ({ ...prev, truck_no: value }));
                                                // }
                                                // }}
                                                onChange ={(e) => {
                                                    setManualUpdateConsignment((prev) => ({ ...prev, truck_no: e.target.value }))
                                                }}
                                                value={manualUpdateConsignment.truck_no}
                                                name="truck_no"
                                                autoComplete="off"
                                                maxLength={10} 
                                            />
                                            {/* {manualUpdateConsignment.truck_no && !/^[A-Z]{2}[0-9]{2}[A-Z0-9]{1,6}$/.test(manualUpdateConsignment.truck_no) && (
                                                <div style={{ color: 'red', fontSize: '12px', paddingTop: '5px', paddingLeft:"20px" }}>
                                                Invalid truck number format. Please enter a valid format (e.g., AB12CD3456).
                                                </div>
                                            )} */}
                                        </div>}
                                        {/* truck seal no */}
                                        <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">Truck Seal No<span style={{color:'red'}}>*</span>  </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                onChange={(e)=> setManualUpdateConsignment(prev =>({...prev, truck_seal_no:e.target.value}))}
                                                value={manualUpdateConsignment.truck_seal_no}
                                                name="truck_seal_no"
                                                autoComplete='off'
                                            />
                                        </div>
                                        {/* Entity */}
                                        <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">Entity</label>
                                            <Select
                                                closeMenuOnSelect={true}
                                                value={manualUpdateConsignment.entity}
                                                onChange={(e)=> setManualUpdateConsignment((prev)=>({
                                                    ...prev, 
                                                    entity:{label:e.label, value: e.value}
                                                }))}
                                                style={{ borderRadius: "0px" }}
                                                styles={{
                                                    control: (provided, state) => ({
                                                    ...provided,
                                                    fontSize: "0.8rem",
                                                    color: "#6e707e",
                                                    width:"100%"
                                                    }),
                                                    singleValue: (provided, state) => ({
                                                    ...provided,
                                                    fontSize: "0.9rem",
                                                    }),
                                                }}
                                                options={entityList}
                                            />
                                        </div>
                                        {/* Vehicle Type */}
                                        {
                                            <div className="form-group col-xl-12 col-lg-12">
                                                <label className="mb-5p">
                                                    Vehicle Type<span style={{color:'red'}}>*</span>
                                                </label>
                                                <Select
                                                    closeMenuOnSelect={true}
                                                    value={manualUpdateConsignment.vehicle_type}
                                                    onChange={(e) =>{
                                                    setManualUpdateConsignment((prev) => ({
                                                        ...prev,
                                                        vehicle_type: { label: e.label, value: e.value },
                                                    }))
                                                    if (e.value === "Others") {
                                                        setEnableVehicelType1(true);
                                                        setManualUpdateConsignment((prev) => ({ ...prev, other_vehicle_type: "" , other_vehicle_capacity:''}));

                                                    } else {
                                                        setEnableVehicelType1(false);
                                                        fetchVehicleDetails1(e.label, e.value)
                                                        
                                                    }
                                                }
                                                    }
                                                    style={{ borderRadius: "0px", maxWidth: "415px" }}
                                                    styles={{
                                                    control: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.8rem",
                                                        color: "#6e707e",
                                                        width:"100%"
                                                    }),
                                                    singleValue: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.9rem",
                                                    }),
                                                    }}
                                                    options={
                                                        (orginalDetailsForEdit.tracking_type) === "FTL"
                                                            ? vehicleTypeList.filter((vehicle) => vehicle.value !== "PTL/Courier")
                                                            : vehicleTypeList
                                                    }
                                                />
                                            </div>  
                                        }
                                        {/* {!manualUpdateConsignment.other_vehicle_type && 
                                            <div className="form-group col-xl-12 col-lg-12">
                                                <label className="mb-5p">
                                                    Vehicle Type<span style={{color:'red'}}>*</span>
                                                </label>
                                                <Select
                                                    closeMenuOnSelect={true}
                                                    value={manualUpdateConsignment.vehicle_type}
                                                    onChange={(e) =>
                                                    setManualUpdateConsignment((prev) => ({
                                                        ...prev,
                                                        vehicle_type: { label: e.label, value: e.value },
                                                    }))
                                                    }
                                                    className='custom-field-width'
                                                    style={{ borderRadius: "0px", maxWidth: "415px" }}
                                                    styles={{
                                                    control: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.8rem",
                                                        color: "#6e707e",
                                                    }),
                                                    singleValue: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.9rem",
                                                    }),
                                                    }}
                                                    options={vehicleTypeList}
                                                />
                                            </div>  
                                        }                                       */}
                                        {manualUpdateConsignment.vehicle_type && manualUpdateConsignment.vehicle_type.value === "Others" && (
                                                <div className="col-xl-12 col-lg-12 form-group">
                                                <label className="mb-5p">
                                                    Other Vehicle Type<span style={{ color: 'red' }}>*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    maxLength={6}
                                                    onChange={(e) => { setManualUpdateConsignment((prev) => ({ ...prev, other_vehicle_type: e.target.value }))}}
                                                    value={manualUpdateConsignment.other_vehicle_type}
                                                    name="other_vehicle_type"
                                                    autoComplete="off"
                                                />
                                                {/* {manualUpdateConsignment.other_vehicle_type && (
                                                    <div style={{ color: "red", fontSize: "12px", paddingTop:"5px", paddingLeft:"20px" }}>Please Enter the Vehicle Type</div>
                                                )} */}
                                                </div>
                                        )}
                                        {/* Transporter - Courier Partner */}
                                        {manualUpdateConsignment.other_transporter &&
                                            <div className="form-group col-xl-12 col-lg-12">
                                                <label className="mb-5p">
                                                Transporter<span style={{color:'red'}}>*</span>
                                                </label>
                                                <Select
                                                    closeMenuOnSelect={true}
                                                    value={{value:"Other", label:"Other"}}
                                                    onChange={(e)=>
                                                        setManualUpdateConsignment((prev)=>({
                                                            ...prev, 
                                                            courier_partner:{label:e.label, value: e.value}
                                                        }))
                                                    }
                                                    className='custom-field-width'
                                                    style={{ borderRadius: "0px" }}
                                                    styles={{
                                                        control: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.8rem",
                                                        color: "#6e707e",
                                                        width:"100%"
                                                        }),
                                                        singleValue: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.9rem",
                                                        }),
                                                    }}
                                                    options={courierPartnerList}
                                                    
                                                />
                                            </div>
                                        }
                                        {!manualUpdateConsignment.other_transporter &&
                                            <div className="form-group col-xl-12 col-lg-12">
                                                <label className="mb-5p">
                                                Transporter<span style={{color:'red'}}>*</span>
                                                </label>
                                                <Select
                                                    closeMenuOnSelect={true}
                                                    value={manualUpdateConsignment.courier_partner}
                                                    onChange={(e)=>
                                                        setManualUpdateConsignment((prev)=>({
                                                            ...prev, 
                                                            courier_partner:{label:e.label, value: e.value}
                                                        }))
                                                    }
                                                    style={{ borderRadius: "0px" }}
                                                    styles={{
                                                        control: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.8rem",
                                                        color: "#6e707e",
                                                        width:"100%"
                                                        }),
                                                        singleValue: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.9rem",
                                                        }),
                                                    }}
                                                    options={courierPartnerList}
                                                    isDisabled={true}

                                                />
                                            </div>
                                        }
                                        {manualUpdateConsignment.courier_partner && manualUpdateConsignment.courier_partner.value === "Others"  && <div className="col-xl-12 col-lg-12 row form-group">
                                            <label className="col-xl-12 col-lg-12">Other Transporter<span style={{color:'red'}}>*</span>  </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                onChange={(e)=> setManualUpdateConsignment(prev =>({...prev, other_transporter:e.target.value}))}
                                                value={manualUpdateConsignment.other_transporter}
                                                name="truck_no"
                                                autoComplete='off'
                                            />
                                        </div>}  
                                        {/* vehicle - capacity */}
                                    
                                      {  !enableVehicleType1 &&    <div className="form-group col-xl-12 col-lg-12">
                                                <label className="mb-5p"> Vehicle Capacity<span style={{color:'red'}}>*</span></label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    // onChange={(e)=> setFormData(prev => ({...prev, destination_pincode:e.target.value }))}
                                                    value={manualUpdateConsignment.vehicle_capacity}
                                                    name="vehicle_capacity"
                                                    autoComplete='off'
                                                    // onFocus={checkConsignee}
                                                    disabled={true}
                                                />
                                                {/* <Select
                                                    closeMenuOnSelect={true}
                                                    value={ manualUpdateConsignment.vehicle_capacity}
                                                    onChange={(e) => {
                                                    setManualUpdateConsignment((prev) => ({ ...prev, vehicle_capacity: { label: e.label, value: e.value } }));
                                                    }}
                                                    className='custom-field-width'
                                                    style={{ borderRadius: "0px" }}
                                                    styles={{
                                                    control: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.8rem",
                                                        color: "#6e707e",
                                                    }),
                                                    singleValue: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.9rem",
                                                    }),
                                                    }}
                                                    options={vehicleCapacityList}
                                                /> */}
                                            </div>}
                                        
                                        {/* {manualUpdateConsignment.other_vehicle_capacity && 
                                            <div className="form-group col-xl-12 col-lg-12">
                                                <label className="mb-5p"> Vehicle Capacity<span style={{color:'red'}}>*</span></label>
                                                <Select
                                                    closeMenuOnSelect={true}
                                                    value={ {value: "Other", label: "Other" }}
                                                    onChange={(e) => {
                                                    setManualUpdateConsignment((prev) => ({ ...prev, vehicle_capacity: { label: e.label, value: e.value } }));
                                                    }}
                                                    className='custom-field-width'
                                                    style={{ borderRadius: "0px" }}
                                                    styles={{
                                                    control: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.8rem",
                                                        color: "#6e707e",
                                                    }),
                                                    singleValue: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.9rem",
                                                    }),
                                                    }}
                                                    options={vehicleCapacityList}
                                                />
                                            </div>
                                        }                                         */}
                                        {enableVehicleType1 && (
                                            <div className="col-xl-12 col-lg-12 form-group">
                                                <label className="mb-5p">Other Vehicle Capacity<span style={{color:'red'}}>*</span>  </label>
                                                <input
                                                type="text"
                                                className="form-control"
                                                onChange={(e) => setManualUpdateConsignment((prev) => ({ ...prev, other_vehicle_capacity: e.target.value }))}
                                                value={manualUpdateConsignment.other_vehicle_capacity}
                                                name="truck_no"
                                                autoComplete='off'
                                                
                                                />
                                            </div>
                                        )}
                                        {/* E-Way Bill */}
                                        <div className="form-group col-xl-12 col-lg-12">
                                            <label className="mb-5p">E-Way Bill Expiry Date</label>
                                            <div id="datepicker1">
                                                <DatePicker
                                                    selected={manualUpdateConsignment.eway_bill_expiry_date}
                                                    onChange={handleEwayDate}
                                                    name="eway_bill_expiry_date"
                                                    className="datepicker-custom-ptl1 form-control3"
                                                    showTimeSelect
                                                    timeFormat="HH:mm:ss"
                                                    timeIntervals={15} 
                                                    timeCaption="Time"
                                                    dateFormat="dd-MM-yyyy HH:mm:ss" 
                                                    minDate={new Date()} 
                                                    id="eway_bill_expiry_date"
                                                    autoComplete="off"
                                                    onKeyDown={(e) => e.preventDefault()}
                                                />
                                            </div>
                                        </div>
                                        {/* Consignee Name */}
                                        
                                            <div className="col-xl-12 col-lg-12 form-group">
                                                <label className="mb-5p">Consignee Name<span style={{color:'red'}}>*</span>  </label>
                                                <Select
                                                closeMenuOnSelect={true}
                                                value={manualUpdateConsignment.consignee_name}
                                                onChange={(e) => {
                                                    setManualUpdateConsignment((prev) => ({ ...prev, consignee_name: { label: e.label, value: e.value } }));
                                                    fetchConsigneeDetails2(e.label, e.value)
                                                }}
                                                style={{ borderRadius: "0px" }}
                                                styles={{
                                                    control: (provided, state) => ({
                                                    ...provided,
                                                    fontSize: "0.8rem",
                                                    color: "#6e707e",
                                                    width:"100%"
                                                    }),
                                                    singleValue: (provided, state) => ({
                                                    ...provided,
                                                    fontSize: "0.9rem",
                                                    })
                                                }}
                                                options={consignees}
                                                />
                                            </div>
                                        
                                        {/* {!manualUpdateConsignment.other_consignee_name && (
                                        <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">Consignee Name<span style={{color:'red'}}>*</span>  </label>
                                            <Select
                                            closeMenuOnSelect={true}
                                            value={manualUpdateConsignment.consignee_name}
                                            onChange={(e) => {
                                                setManualUpdateConsignment((prev) => ({ ...prev, consignee_name: { label: e.label, value: e.value } }));
                                            }}
                                            className='custom-field-width'
                                            style={{ borderRadius: "0px" }}
                                            styles={{
                                                control: (provided, state) => ({
                                                ...provided,
                                                fontSize: "0.8rem",
                                                color: "#6e707e",
                                                }),
                                                singleValue: (provided, state) => ({
                                                ...provided,
                                                fontSize: "0.9rem",
                                                })
                                            }}
                                            options={consignees}
                                            />
                                        </div>
                                        )} */}
                                        {manualUpdateConsignment.consignee_name && manualUpdateConsignment.consignee_name.value === "Others" && 
                                            (
                                                <>
                                                    <div className="col-xl-12 col-lg-12 form-group">
                                                        <label className="mb-5p">Other Consignee Name<span style={{color:'red'}}>*</span>  </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            onChange={(e)=> setManualUpdateConsignment(prev =>({...prev, other_consignee_name:e.target.value}))}
                                                            value={manualUpdateConsignment.other_consignee_name}
                                                            name="truck_no"
                                                            autoComplete='off'
                                                        />
                                                    </div>
                                                    <div className="col-xl-12 col-lg-12 form-group">
                                                        <label className="mb-5p">Other Destination City<span style={{color:'red'}}>*</span>  </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            onChange={(e)=> setManualUpdateConsignment(prev =>({...prev, other_destination_city:e.target.value}))}
                                                            value={manualUpdateConsignment.other_destination_city}
                                                            name="truck_no"
                                                            autoComplete='off'
                                                        />
                                                    </div>
                                                    <div className="col-xl-12 col-lg-12 form-group">
                                                        <label className="mb-5p">Other Destination Pincode<span style={{color:'red'}}>*</span>  </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            onChange={(e) => {
                                                            const pincode = e.target.value;
                                                            const isValid = validatePincode(pincode);
                                                            setManualUpdateConsignment((prev) => ({ ...prev, other_destination_pincode: pincode, isPincodeValid: isValid }));
                                                            }}
                                                            value={manualUpdateConsignment.other_destination_pincode}
                                                            name="truck_no"
                                                            autoComplete='off'
                                                        />
                                                        {manualUpdateConsignment.other_destination_pincode && !manualUpdateConsignment.isPincodeValid && (
                                                            <div style={{ color: 'red', fontSize:"12px", paddingTop:"5px", paddingLeft:"20px" }}>Invalid pincode</div>
                                                        )}
                                                    </div>
                                                </>
                                            )
                                        }
                                        {manualUpdateConsignment.consignee_name && manualUpdateConsignment.consignee_name.value!=="Others" && 
                                            <>                                             
                                                <div className="col-xl-12 col-lg-12 form-group">
                                                    <label className="mb-5p">Destination City<span style={{color:'red'}}>*</span>  </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        onChange={(e)=> setManualUpdateConsignment(prev => ({...prev, destination_city:e.target.value }))}
                                                        value={manualUpdateConsignment.destination_city}
                                                        name="destination_city"
                                                        autoComplete='off'
                                                    />
                                                </div>                                     
                                                <div className="col-xl-12 col-lg-12 form-group">
                                                    <label className="mb-5p">Destination Pincode<span style={{color:'red'}}>*</span>  </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        onChange={(e) => {
                                                        const pincode = e.target.value;
                                                        const isValid = validatePincode(pincode);
                                                        setManualUpdateConsignment((prev) => ({ ...prev, destination_pincode: pincode, isPincodeValid: isValid }));
                                                        }}
                                                        value={manualUpdateConsignment.destination_pincode}
                                                        name="destination_pincode"
                                                        autoComplete='off'
                                                    />
                                                    {manualUpdateConsignment.destination_pincode && !validatePincode(manualUpdateConsignment.destination_pincode)  && (
                                                        <div style={{ color: 'red', fontSize:"12px", paddingTop:"5px", paddingLeft:"20px" }}>Invalid pincode</div>
                                                    )}
                                                </div>
                                            </>
                                        }
                                        {/* Movement Type */}
                                        <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">Movement Type<span style={{color:'red'}}>*</span>  </label>
                                            <Select
                                                closeMenuOnSelect={true}
                                                value={manualUpdateConsignment.movement_type}
                                                onChange={(e)=> setManualUpdateConsignment((prev)=>({
                                                    ...prev, 
                                                    movement_type:{label:e.label, value: e.value}
                                                }))}
                                                style={{ borderRadius: "0px" }}
                                                styles={{
                                                    control: (provided, state) => ({
                                                    ...provided,
                                                    fontSize: "0.8rem",
                                                    color: "#6e707e",
                                                    width:"100%"
                                                    }),
                                                    singleValue: (provided, state) => ({
                                                    ...provided,
                                                    fontSize: "0.9rem",
                                                    }),
                                                }}
                                                options={movementType}
                                            />                                            
                                        </div>
                                        {/* No Of Boxes */}
                                        <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">Number of Boxes  </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                onChange={(e)=> setManualUpdateConsignment(prev => ({...prev, no_of_boxes:e.target.value }))}
                                                value={manualUpdateConsignment.no_of_boxes}
                                                name="number_of_boxes"
                                                autoComplete='off'
                                            />
                                        </div>
                                        
                                        <div style={{padding:"5px"}}>
                                        {manualTripUploadDetails.map((point, index) => {
                                            
                                            const isOtherConsignee = (!point.destination_pincode || !point.destination_city) && (!point.consignee_name || point.consignee_name.value === 'Other');
                                            
                                            // const filteredConsigneeOptions = consignees.filter(
                                            //     (consignee) =>
                                            //         !consigneesForTrip.some(
                                            //             (detail) =>
                                            //                 detail.consignee_name === consignee.label || 
                                            //                 detail.destination_pincode === point.destination_pincode || 
                                            //                 detail.destination_city === point.destination_city
                                            //                 // detail.other_destination_pincode === point.other_consignee_pincode || 
                                            //                 // detail.other_destination_city === point.other_consignee_city
                                            //         )
                                            // );
                                            const filteredConsigneeOptions = consignees.filter(
                                                (consignee) =>
                                                    !consigneesForTrip.some((detail) => {
                                                        const consigneePincode = Array.isArray(detail.destination_pincode)
                                                            ? detail.destination_pincode[0]
                                                            : detail.destination_pincode;
                                                        return (
                                                            detail.consignee_name === consignee.label || 
                                                            consigneePincode === consignee.value || 
                                                            detail.destination_city === consignee.label
                                                        );
                                                    })
                                            );
                                            
                                            return (
                                                <div key={point._id} style={{ padding: '20px', border: '1px solid #ccc', marginBottom: '20px' }}>
                                                    <div className="slide-body">
                                                        <div className="row p-20p">
                                                            <div className="col-xl-12 col-lg-12 d-flex justify-content-between align-items-center">
                                                            <h3>Drop Point {index + 1}</h3>
                                                            {/* <button
                                                            type="button"
                                                            className="btn btn-danger"
                                                            onClick={() => handleRemoveDropPoint(point.consignment_uid)}
                                                        >
                                                            Delete
                                                        </button> */}
                                                        </div>
                                                            {/* LR No */}
                                                            <div className="form-group col-xl-12 col-lg-12">
                                                                <label className="mb-5p">LR No.<span style={{ color: 'red' }}>*</span></label>
                                                                <input
                                                                    type="text"
                                                                    name="lr_no"
                                                                    value={manualUpdateConsignment.lr_no}
                                                                    className="form-control"
                                                                    // onChange={(e) => handleInputChange(point._id, 'lr_no', e.target.value)}
                                                                    required
                                                                />
                                                            </div>

                                                            {/* Invoice No */}
                                                            <div className="form-group col-xl-12 col-lg-12">
                                                                <label className="mb-5p">Invoice No<span style={{ color: 'red' }}>*</span></label>
                                                                <input
                                                                    // type="text"
                                                                    // name="invoice_no"
                                                                    // value={point.invoice_no}
                                                                    // className="form-control"
                                                                    // onChange={(e) => {
                                                                    //     const value = e.target.value;
                                                                    //     const invoicePattern = /^\d+\/[a-zA-Z]{3}$/;
                                                                    //     if (!invoicePattern.test(value)) {
                                                                    //         e.target.setCustomValidity('Invoice number must be in digits/ABC format (e.g., 123456/XYZ)');
                                                                    //     } else {
                                                                    //         e.target.setCustomValidity('');
                                                                    //     }
                                                                    //     handleInputChange(index, 'invoice_no', value);
                                                                    // }}
                                                                    // required
                                                                    type="text"
                                                                    className="form-control"
                                                                    // onChange={(e)=> setManualUpdateConsignment(prev => ({...prev, invoice_no:e.target.value.toUpperCase() }))}
                                                                    value={point.invoice_no}
                                                                    name="invoice_no"
                                                                    autoComplete='off'
                                                                    // pattern="\d+/[a-zA-Z]{3}"
                                                                    isDisabled={true}
                                                                />
                                                            </div>
                                                            {/* Other Consignee Name* */}
                                                            {/* Consignee Name */}
                                                            <div className="form-group col-xl-12 col-lg-12">
                                                                <label className="mb-5p">Consignee Name<span style={{ color: 'red' }}>*</span></label>
                                                                <Select
                                                                    closeMenuOnSelect={true}
                                                                    value={point.consignee_name ? { label: point.consignee_name, value: point.consignee_name } : null}                                                                    
                                                                    onChange={(e) => {handleInputChange(index, 'consignee_name', e.label)
                                                                        if (e.label !=="Others"){
                                                                            fetchConsigneeDetails1(index, e.value, e.label);
                                                                        }
                                                                }}
                                                                    options={[...filteredConsigneeOptions]}
                                                                    className="custom-field-width1"
                                                                />
                                                                
                                                            </div>

                                                            {/* Destination Pincode */}
                                                            {!showOthersConsignee[index] && (
                                                                <div className="form-group col-xl-12 col-lg-12">
                                                                    <label className="mb-5p">Destination Pincode<span style={{ color: 'red' }}>*</span></label>
                                                                    <input
                                                                        type="text"
                                                                        name="destination_pincode"
                                                                        value={point.destination_pincode}
                                                                        className="form-control"
                                                                        onChange={(e) => {
                                                                            const value = e.target.value;
                                                                            const pincodePattern = /^\d{6}$/;

                                                                            if (!pincodePattern.test(value)) {
                                                                                e.target.setCustomValidity('Pincode must be exactly 6 digits.');
                                                                            } else {
                                                                                e.target.setCustomValidity('');  // Clear error
                                                                            }

                                                                            handleInputChange(index, 'destination_pincode', value);
                                                                        }}
                                                                        required
                                                                    />
                                                                </div>
                                                            )}

                                                            {/* Destination City */}
                                                            {!showOthersConsignee[index] && (
                                                                <div className="form-group col-xl-12 col-lg-12">
                                                                    <label className="mb-5p">Destination City<span style={{ color: 'red' }}>*</span></label>
                                                                    <input
                                                                        type="text"
                                                                        name="destination_city"
                                                                        value={point.destination_city}
                                                                        className="form-control"
                                                                        onChange={(e) => handleInputChange(index, 'destination_city', e.target.value)}
                                                                        required
                                                                    />
                                                                </div>
                                                            )}

                                                            {/* Other Consignee Name */}
                                                            
                                                            {showOthersConsignee[index] && (
                                                                <>
                                                                    <div className="form-group col-xl-12 col-lg-12">
                                                                        <label className="mb-5p">Other Consignee Name<span style={{ color: 'red' }}>*</span></label>
                                                                        <input
                                                                            type="text"
                                                                            name="other_consignee_name"
                                                                            value={point.other_consignee_name}
                                                                            className="form-control"
                                                                            onChange={(e) => handleInputChange(index, 'other_consignee_name', e.target.value)}
                                                                            autoComplete='off'
                                                                            // required
                                                                        />
                                                                    </div>

                                                                    {/* Other Destination Pincode */}
                                                                    <div className="form-group col-xl-12 col-lg-12">
                                                                        <label className="mb-5p">Other Destination Pincode<span style={{ color: 'red' }}>*</span></label>
                                                                        <input
                                                                            type="text"
                                                                            name="other_consignee_pincode"
                                                                            value={point.other_consignee_pincode}
                                                                            className="form-control"
                                                                            onChange={(e) => {
                                                                                const value = e.target.value;
                                                                                const pincodePattern = /^\d{6}$/;

                                                                                if (!pincodePattern.test(value)) {
                                                                                    e.target.setCustomValidity('Pincode must be exactly 6 digits.');
                                                                                } else {
                                                                                    e.target.setCustomValidity('');  // Clear error
                                                                                }

                                                                                handleInputChange(index, 'other_consignee_pincode', value);
                                                                            }}
                                                                            autoComplete='off'

                                                                            // required
                                                                        />
                                                                    </div>

                                                                    {/* Other Destination City */}
                                                                    <div className="form-group col-xl-12 col-lg-12">
                                                                        <label className="mb-5p">Other Destination City<span style={{ color: 'red' }}>*</span></label>
                                                                        <input
                                                                            type="text"
                                                                            name="other_consignee_city"
                                                                            value={point.other_consignee_city}
                                                                            className="form-control"
                                                                            onChange={(e) => handleInputChange(index, 'other_consignee_city', e.target.value)}
                                                                            autoComplete='off'

                                                                            // required
                                                                        />
                                                                    </div>
                                                                </>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })}


                                        </div>
                                        {/* //Edit */}
                                        <div className="form-group col-sm-12 mb-20p text-center">
                                            {/* <button
                                                type="button"
                                                className="btn btn-primary customAddBtn" // You can customize the button style
                                                onClick={handleButtonClick}
                                                style={{ padding: '9px 10px', fontSize: '12px', cursor: 'pointer', borderRadius:"none",marginRight:"20px" }} // Adjust the button style if needed
                                            >
                                                Add Drop Point
                                            </button> */}
                                            <button type="submit" className="btn btn-success">
                                                Submit
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div> 
                
                <div className={"slide-r " + (sliderCreateConsignmentTranslate)} style={{ overflowX: "hidden", overflowY: "auto", maxHeight:"100vh" }}>
					<div className="slide-r-title">
						<h4 className="slide-r-title"> Add Consignment <span className="float-right closebtn" style={{ marginRight: "10px" }} onClick={onClickHideAll} >X</span></h4>
					</div>
                    <div className="row" style={{padding:"20px"}}>
                        <div className="col-sm-12"></div>
							<form method="POST" className="theme-form col-xl-12 col-lg-12" onSubmit={saveConsignmentData}>
                                <div className="slide-body">
                                    <div className='row'>                                        
                                        {/* lr no */}
                                        <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">LR No
                                                <span style={{color:'red'}}>*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                onChange={(e) => {
                                                    // Only update state if the input is a valid number
                                                    const value = e.target.value;
                                                    // if ((/^[a-zA-Z0-9]*$/.test(value))) {  // This regex allows only numeric values /* PMS ID - 10259 */
                                                    if (/^[^\s]*$/.test(value)) {
                                                        setFormData(prev => ({ ...prev, lr_no: value }));
                                                    }
                                                }}
                                               
                                                value={formData.lr_no}
                                                name="lr_no"
                                                autoComplete="off"
                                                // placeholder="Enter LR No"
                                            />
                                        </div>
                                        <div className="form-group col-xl-12 col-lg-12">
                                            <label className="mb-5p">
                                                Transporter<span style={{color: 'red'}}>*</span>
                                            </label>
                                            <Select
                                                closeMenuOnSelect={true}
                                                value={formData.courier_partner}
                                                onChange={(e) => {
                                                    setFormData((prev) => ({
                                                        ...prev,
                                                        courier_partner: { label: e.label, value: e.value }
                                                    }));

                                                    // Enable Other Transporter field when "Other" is selected
                                                    if (e.value === "Others") {
                                                        setEnableCourierType(true);
                                                    } else {
                                                        setFormData((prev) => ({ ...prev, other_transporter: "" }));
                                                        setEnableCourierType(false);
                                                    }
                                                }}
                                                style={{ borderRadius: "0px" }}
                                                styles={{
                                                    control: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.8rem",
                                                        color: "#6e707e",
                                                        width:"100%"

                                                    }),
                                                    singleValue: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.9rem",
                                                    }),
                                                }}
                                                options={courierPartnerList}
                                            />
                                        </div>
                                        {enableCourierType && <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">Other Transporter<span style={{color:'red'}}>*</span>  </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                onChange={(e)=> setFormData(prev =>({...prev, other_transporter:e.target.value}))}
                                                value={formData.other_transporter}
                                                name="truck_no"
                                                autoComplete='off'
                                                required
                                            />
                                        </div>}
                                          {/* driver mobile no */}
                                          <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">Driver Mobile No.<span style={{color:'red'}}>*</span> </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                onChange={(e) => {
                                                    const { name } = e.target;
                                                    const numericValue = e.target.value.replace(/\D/g, '').slice(0, 10);
                                                    
                                                    // Validate the input length and content
                                                    if (numericValue.length < 10) {
                                                        setError1('Mobile number must be 10 digits long');
                                                    } else if (!/^[6-9]\d{9}$/.test(numericValue)) {
                                                        setError1('Mobile number must start with a digit between 6 and 9 and be 10 digits long');
                                                    } else {
                                                        setError1(''); // Clear error if the number is valid
                                                    }

                                                    // Update the state with the new value (allow only 10 digits max)
                                                    if (numericValue.length <= 10) {
                                                        if (name === 'driver_number_update') {
                                                            setManualUpdateConsignment((prev) => ({ ...prev, driver_number: numericValue }));
                                                        } else if (name === 'driver_mobile_no') {
                                                            setFormData((prev) => ({ ...prev, driver_mobile_no: numericValue }));
                                                        }
                                                    }
                                                }}
                                                value={formData.driver_mobile_no}
                                                name="driver_mobile_no"
                                                autoComplete='off'
                                            />
                                            {error1 && <span style={{ color: 'red', fontSize: "10px", margin: "10px 0px 0px 0px" }}>{error1}</span>}                    
                                        </div>
                                           {/* source name */}
                                           <div className="form-group col-xl-12 col-lg-12">
                                            <label className="mb-5p">Source<span style={{color:'red'}}>*</span></label>
                                            <Select
                                                closeMenuOnSelect={true}
                                                value={formData.source}
                                                isDisabled={sourceValidation}
                                                onChange={(e) => {
                                                        setFormData((prev) => ({
                                                            ...prev,
                                                            source: { label: e.label, value: e.value }
                                                        }));
                                                        if (e.value === "Others") {
                                                            setEnableSourceField(true);
                                                        } else {
                                                            setFormData((prev) => ({ ...prev, other_source: "" }));
                                                            setEnableSourceField(false);
                                                        }
                                                    // else {
                                                    //     setErrorMssge("Please fill in the invoice_no field first");
                                                    // }
                                                }}
                                                style={{ borderRadius: "0px" }}
                                                styles={{
                                                    control: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.8rem",
                                                        color: "#6e707e",
                                                        width:"100%"
                                                    }),
                                                    singleValue: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.9rem",
                                                    }),
                                                }}
                                                options={sourceList}
                                            />
                                             {sourceValidation && <span style={{color:"red", fontSize:"12px", marginTop:"5px"}}>
                                             Please enter valid Invoice Numbers. The source will be auto-filled accordingly.                                            </span>}
                                        </div>
                                        {enableSourceField && <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">
                                                Other Source<span style={{color:'red'}}>*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                onChange={handleOtherSourceChange}
                                                value={formData.other_source}
                                                name="truck_no"
                                                autoComplete="off"
                                            />
                                            {validOtherSource === false && (
                                                <span style={{color:"red", fontSize:"12px", marginTop:"5px", marginLeft:"16px"}}>
                                                    Enter Valid Source Name
                                                </span>
                                            )}
                                        </div>}
                                         {/* truck no */}
                                         <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">
                                                Truck No<span style={{color:'red'}}>*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                onChange={handleTruckNoChange}  
                                                value={formData.truck_no}
                                                name="truck_no"
                                                autoComplete='off'
                                            />
                                            {validateTruckNo === false && (
                                                <span style={{color:"red", fontSize:"12px", marginTop:"5px", marginLeft:"0px"}}>
                                                    Enter Valid Truck Number
                                                </span>
                                            )}
                                        </div>
                                         {/* truck seal no */}
                                         <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">Truck Seal No </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                onChange={(e)=> setFormData(prev =>({...prev, truck_seal_no:e.target.value}))}
                                                value={formData.truck_seal_no}
                                                name="truck_seal_no"
                                                autoComplete='off'
                                            />
                                        </div>
                                          {/* entity */}
                                          <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">Entity<span style={{color: 'red'}}>*</span></label>
                                            <Select
                                                closeMenuOnSelect={true}
                                                value={formData.entity}
                                                onChange={(e)=> setFormData((prev)=>({
                                                    ...prev, 
                                                    entity:{label:e.label, value: e.value}
                                                }))}
                                                style={{ borderRadius: "0px" }}
                                                styles={{
                                                    control: (provided, state) => ({
                                                    ...provided,
                                                    fontSize: "0.8rem",
                                                    color: "#6e707e",
                                                    width:"100%"
                                                    }),
                                                    singleValue: (provided, state) => ({
                                                    ...provided,
                                                    fontSize: "0.9rem",
                                                    }),
                                                }}
                                                options={entityList}
                                            />
                                        </div>
                                         {/* vehicle type */}
                                         <div className="form-group col-xl-12 col-lg-12">
                                            <label className="mb-5p">
                                                Vehicle Type<span style={{color: 'red'}}>*</span>
                                            </label>
                                            <Select
                                                closeMenuOnSelect={true}
                                                value={formData.vehicle_type}
                                                onChange={(e) => {
                                                    setFormData((prev) => ({
                                                        ...prev,
                                                        vehicle_type: { label: e.label, value: e.value }
                                                    }));
                                                    if (e.value === "Others") {
                                                        setEnableVehicelType(true);
                                                        setFormData((prev) => ({ ...prev, other_vehicle_type: "" , other_vehicle_capacity:''}));

                                                    } else {
                                                        setEnableVehicelType(false);
                                                        fetchVehicleDetails(e.label, e.value)
                                                        
                                                    }
                                                }}
                                                style={{ borderRadius: "0px", maxWidth: "415px" }}
                                                styles={{
                                                    control: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.8rem",
                                                        color: "#6e707e",
                                                        width:"100%"

                                                    }),
                                                    singleValue: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.9rem",
                                                    }),
                                                }}
                                                options={vehicleTypeList.filter(
                                                    (vehicle) => vehicle.value !== "PTL/Courier" 
                                                )}                                            />
                                        </div>
                                        {enableVehicleType && <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">Other Vehicle Type<span style={{color:'red'}}>*</span>  </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                onChange={(e)=> setFormData(prev =>({...prev, other_vehicle_type:e.target.value}))}
                                                value={formData.other_vehicle_type}
                                                name="truck_no"
                                                autoComplete='off'
                                                required
                                            />
                                        </div>}
                                        {/* invoice no */}
                                        <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">
                                                Invoice No<span style={{color:'red'}}>*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                onChange={(e) => handleInvoiceChange(e)}
                                                onBlur={() => {
                                                    const isValid = validateInput(formData.invoice_no);
                                                    setIsValid(isValid);
                                                    if (!isValid) {
                                                        setSourceValidation(true)
                                                        setErrorMsg1(true)
                                                        setInvoiceValid(true)
                                                        console.error("Validation failed for invoice input.");
                                                    }else{
                                                        setSourceValidation(false)
                                                    }
                                                }}
                                                value={formData.invoice_no_str}
                                                name="invoice_no"
                                                autoComplete="off"
                                            />
                                            {invoiceValid && <span style={{color:"red", fontSize:"12px", marginTop:"5px"}}>
                                                Enter the Valid Invoice No's
                                            </span>}
                                        </div>
                                           {/* Consignee Name */}
                                           <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">Consignee Name<span style={{color:'red'}}>*</span>  </label>
                                            <Select
                                                closeMenuOnSelect={true}
                                                value={formData.consignee_name}
                                                onChange={(e) => {                                                    
                                                    setFormData((prev) => ({
                                                        ...prev, 
                                                        consignee_name: {label: e.label, value: e.value}
                                                    }));

                                                    // Check if the selected option is "Other"
                                                    if (e.label !== "Others") {
                                                        fetchConsigneeDetails(e.value, e.label);
                                                        setEnableConsigee(false)
                                                    } else {
                                                        setEnableConsigee(true)
                                                        setFormData(prev => ({...prev, destination_pincode: "", destination_city: ""}));
                                                    }

                                                    // Validate after updating the selection
                                                    validateOption("consigneeName");
                                                }}
                                                style={{ borderRadius: "0px" }}
                                                styles={{
                                                    control: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.8rem",
                                                        color: "#6e707e",
                                                        width:"100%"

                                                    }),
                                                    singleValue: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.9rem",
                                                    }),
                                                }}
                                                options={consignees}
                                            />
                                            {formData.consignee_name.value ==="Others" && <>
                                                <div className="col-xl-12 col-lg-12 form-group" style={{marginTop:"20px", padding:"0px"}}>
                                                    <label className="mb-5p">Other Consignee Name<span style={{color:'red'}}>*</span></label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        onChange={(e) => {
                                                            const { value } = e.target;
                                                            setFormData(prev => ({...prev, other_consignee_name: value}));
                                                            validateOtherConsignee(value);
                                                        }}
                                                        value={formData.other_consignee_name}
                                                        name="other_consignee_name"
                                                        autoComplete='off'
                                                        required
                                                    />
                                                    {validOtherConsigneeName === false && <span style={{color:"red", fontSize:"12px", marginTop:"5px"}}>Enter Valid Consignee Name</span>}
                                                </div>

                                                <div className="col-xl-12 col-lg-12 form-group" style={{ marginTop: "20px", padding: "0px" }}>
                                                    <label className="mb-5p">Other Destination City<span style={{ color: 'red' }}>*</span></label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        onChange={(e) => {
                                                            const {value} = e.target

                                                            setFormData(prev => ({ ...prev, other_destination_city: value }));
                                                            checkOtherConsigneeName(e.target.name, value); // Call validation here
                                                        }}
                                                        value={formData.other_destination_city}
                                                        name="other_destination_city"
                                                        autoComplete='off'
                                                        required
                                                    />
                                                    {validCity === false && <span style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>Enter Valid City Name</span>}
                                                </div>
                                                <div className="col-xl-12 col-lg-12 form-group" style={{ marginTop: "20px", padding: "0px" }}>
                                                    <label className="mb-5p">Other Destination Pincode<span style={{ color: 'red' }}>*</span></label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        onChange={(e) => {
                                                            const {value} = e.target
                                                            setFormData(prev => ({ ...prev, other_destination_pincode: value }));
                                                            checkOtherConsigneeName(e.target.name, value); // Call validation here
                                                        }}
                                                        value={formData.other_destination_pincode}
                                                        name="other_destination_pincode"
                                                        autoComplete='off'
                                                        required
                                                    />
                                                    {validPincode === false && <span style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>Enter Valid Pincode</span>}
                                                </div>

                                            </>
                                            }

                                       
                                            
                                        </div>
                                      
                                     
                                       
                                       
                                      
                                       
                                        {/* courier partner - transporter */}
                                                                                
                                        {/* vehicle capacity */}
                                        {!enableVehicleType && <div className="form-group col-xl-12 col-lg-12">
                                            <label className="mb-5p">
                                                Vehicle Capacity<span style={{color: 'red'}}>*</span>
                                            </label>
                                            <input
                                                    type="text"
                                                    className="form-control"
                                                    // onChange={(e)=> setFormData(prev => ({...prev, destination_pincode:e.target.value }))}
                                                    value={formData.vehicle_capacity}
                                                    name="vehicle_capacity"
                                                    autoComplete='off'
                                                    // onFocus={checkConsignee}
                                                    disabled={true}
                                                />
                                            {/* <Select
                                                closeMenuOnSelect={true}
                                                value={formData.vehicle_capacity}
                                                className="custom-field-width"
                                                onChange={(e) => {
                                                    setFormData((prev) => ({
                                                        ...prev,
                                                        vehicle_capacity: { label: e.label, value: e.value }
                                                    }));

                                                    // Enable Other Vehicle Capacity field when "Other" is selected
                                                    // if (e.value === "Others") {
                                                    //     setEnableVehicleCapacity(true);
                                                    // } else {
                                                    //     setFormData((prev) => ({ ...prev, other_vehicle_capacity: "" }));
                                                    //     setEnableVehicleCapacity(false);
                                                    // }
                                                }}
                                                style={{ borderRadius: "0px" }}
                                                styles={{
                                                    control: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.8rem",
                                                        color: "#6e707e",
                                                    }),
                                                    singleValue: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.9rem",
                                                    }),
                                                }}
                                                // options={vehicleCapacityList}
                                            /> */}
                                        </div>}
                                        {enableVehicleType && <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">
                                                Other Vehicle Capacity<span style={{color:'red'}}>*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                onChange={handleVehicleCapacityChange} 
                                                value={formData.other_vehicle_capacity}
                                                name="other_vehicle_capacity"
                                                autoComplete='off'
                                                required
                                            />
                                            {validVehicleCapacity === false && (
                                                <span style={{color:"red", fontSize:"12px", marginTop:"5px", marginLeft:"16px"}}>
                                                    Enter Valid Vehicle Capacity
                                                </span>
                                            )}
                                        </div>}
                                            {/* No Of Boxes */}
                                            <div className="col-xl-12 col-lg-12 form-group">
                                                <label className="mb-5p">Number of Boxes</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    onChange={(e) =>
                                                        setFormData((prev) => ({ ...prev, number_of_boxes: e.target.value }))
                                                    }
                                                    onInput={(e) => {
                                                        // Remove non-numeric characters
                                                        e.target.value = e.target.value.replace(/[^0-9]/g, '');
                                                    }}
                                                    value={formData.number_of_boxes}
                                                    name="number_of_boxes"
                                                    autoComplete="off"
                                                />
                                            </div>

                                        {formData.consignee_name.value !=="Others" && 
                                        <>                                         
                                            <div className="col-xl-12 col-lg-12 form-group">
                                                <label className="mb-5p">Destination City<span style={{color:'red'}}>*</span>  </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    onChange={(e)=> setFormData(prev => ({...prev, destination_city:e.target.value }))}
                                                    value={formData.destination_city}
                                                    name="destination_city"
                                                    autoComplete='off'
                                                    onFocus={checkConsignee}
                                                    disabled={!enableEdit}
                                                />
                                            </div>                                    
                                            <div className="col-xl-12 col-lg-12 form-group">
                                                <label className="mb-5p">Destination Pincode<span style={{color:'red'}}>*</span>  </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    onChange={(e)=> setFormData(prev => ({...prev, destination_pincode:e.target.value }))}
                                                    value={formData.destination_pincode}
                                                    name="destination_pincode"
                                                    autoComplete='off'
                                                    onFocus={checkConsignee}
                                                    disabled={!enableEdit}
                                                />
                                            </div>
                                        </>
                                    }
                                        {/* Eway bill */}
                                        <div className="form-group col-xl-12 col-lg-12">
                                            <label className="mb-5p">E-Way Bill Expiry Date</label>
                                            <div id="datepicker1">
                                                <DatePicker
                                                selected={formData.eway_bill_expiry_date}
                                                onChange={handleEwayDate}
                                                name="eway_bill_expiry_date"
                                                className="datepicker-custom-ptl4 form-control1"
                                                showTimeSelect
                                                timeFormat="HH:mm:ss"
                                                timeIntervals={15} // Adjust this if you want different time intervals
                                                timeCaption="Time"
                                                dateFormat="dd-MM-yyyy HH:mm:ss" // Adjusted format to match the original format
                                                minDate={new Date()} // Prevents past date selection
                                                id="eway_bill_expiry_date"
                                                autoComplete="off"
                                                onKeyDown={(e) => e.preventDefault()}
                                                />
                                            </div>
                                        </div> 
                                     
                                        {/* Movement Type */}
                                        <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">Movement Type<span style={{color:'red'}}>*</span>  </label>
                                            <Select
                                                closeMenuOnSelect={true}
                                                value={formData.movement_type}
                                                onChange={(e)=> setFormData((prev)=>({
                                                    ...prev, 
                                                    movement_type:{label:e.label, value: e.value}
                                                }))}
                                                style={{ borderRadius: "0px" }}
                                                styles={{
                                                    control: (provided, state) => ({
                                                    ...provided,
                                                    fontSize: "0.8rem",
                                                    color: "#6e707e",
                                                    width:"100%"

                                                    }),
                                                    singleValue: (provided, state) => ({
                                                    ...provided,
                                                    fontSize: "0.9rem",
                                                    }),
                                                }}
                                                options={movementType}
                                            />                                        
                                        </div>
                                    
                                     
                                   
                                    <div style={{padding:"5px"}}>
                                    {manualTripUploadDetails.map((point, index) => (
                                        <div key={point.id} style={{ padding: '20px', border: '1px solid #ccc', marginBottom: '20px' }}>
                                            <div className="slide-body">
                                                <div className="row p-20p">
                                                    <div className="col-xl-12 col-lg-12 d-flex justify-content-between align-items-center">
                                                        <h3>Drop Point {index + 1}</h3>
                                                        <button
                                                            type="button"
                                                            className="btn btn-danger"
                                                            onClick={() => handleRemoveDropPoint(point.id)}
                                                        >
                                                            Delete
                                                        </button>
                                                    </div>

                                                    {/* LR No Field */}
                                                    <div className="form-group col-xl-12 col-lg-12">
                                                        <label className="mb-5p">
                                                            LR No
                                                            {/* <span style={{ color: 'red' }}>*</span> */}
                                                        </label>
                                                        <input
                                                            type="text"
                                                            name="lr_no"
                                                            value={formData.lr_no}
                                                            className="form-control"
                                                            // onChange={(e) =>
                                                            //     handleInputChange(point.id, 'lr_no', e.target.value)
                                                            // }
                                                            // required
                                                        />
                                                        {/* {validationErrors[point.id]?.lr_no && (
                                                            <span className="text-danger">{validationErrors[point.id].lr_no}</span>
                                                        )} */}
                                                    </div>

                                                    {/* Invoice No Field */}
                                                    <div className="form-group col-xl-12 col-lg-12">
                                                        <label className="mb-5p">
                                                            Invoice No<span style={{ color: 'red' }}>*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            name="invoice_no"
                                                            value={point.invoice_no}
                                                            className="form-control"
                                                            onChange={(e) =>
                                                                handleInputChange(index, 'invoice_no', e.target.value.toUpperCase())
                                                            }
                                                            autoComplete='off'
                                                            required
                                                        />
                                                        {validationErrors[index]?.invoice_no && (
                                                            <span style={{color:"red", fontSize:"12px",marginTop:"5px"}}>{validationErrors[index].invoice_no}</span>
                                                        )}
                                                    </div>
                                                    {/* Consignee Name Field */}
                                                    <div className="form-group col-xl-12 col-lg-12">
                                                        <label className="mb-5p">
                                                            Consignee Name<span style={{ color: 'red' }}>*</span>
                                                        </label>
                                                        <Select
                                                            closeMenuOnSelect={true}
                                                            value={dropPointConsignee.find(option => option.value === point.consignee_name) || null}
                                                            options={dropPointConsignee.filter((option, optIndex) => {
                                                                // Filter out consignees that were selected in any previous blocks
                                                                const selectedInPreviousBlocks = manualTripUploadDetails
                                                                    .slice(0, index)
                                                                    .some(prevPoint => prevPoint.consignee_name === option.value);

                                                                return !selectedInPreviousBlocks;
                                                            })}
                                                            onChange={(selectedOption) => {
                                                                handleConsigneeChange(point.id, selectedOption.value);
                                                                if (selectedOption.value && selectedOption.value !== "Others") {
                                                                    fetchDestinationDetails(selectedOption.value, point.id);
                                                                }
                                                            }}
                                                            required
                                                        />
                                                        {validationErrors[point.id]?.consignee_name && (
                                                            <span style={{color:"red", fontSize:"12px",marginTop:"5px"}}>{validationErrors[point.id].consignee_name}</span>
                                                        )}

                                                        {showCustomConsigneeInput[point.id] && (
                                                        <>
                                                            <div className="form-group col-xl-12 col-lg-12" style={{ marginTop: "20px", padding: "0px" }}>
                                                                <label className="mb-5p">Other Consignee Name<span style={{ color: 'red' }}>*</span></label>
                                                                <input
                                                                    type="text"
                                                                    name="other_consignee_name"
                                                                    className="form-control"
                                                                    onChange={(e) => handleInputChange(index, 'other_consignee_name', e.target.value)}
                                                                    value={point.other_consignee_name || ""}
                                                                    autoComplete='off'
                                                                    required
                                                                />
                                                            </div>
                                                            <div className="form-group col-xl-12 col-lg-12" style={{ marginTop: "20px", padding: "0px" }}>
                                                                <label className="mb-5p">Other Destination City<span style={{ color: 'red' }}>*</span></label>
                                                                <input
                                                                    type="text"
                                                                    name="other_consignee_city"
                                                                    className="form-control"
                                                                    onChange={(e) => {
                                                                        const {value} = e.target
                                                                        handleInputChange(index, 'other_consignee_city', value)
                                                                        checkOtherConsigneeName("other_consignee_city1", value)
                                                                    }}
                                                                    value={point.other_consignee_city || ""}
                                                                    autoComplete='off'
                                                                    required
                                                                />
                                                            {validCity1 === false && <span style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>Enter Valid City Name</span>}

                                                            </div>
                                                            <div className="form-group col-xl-12 col-lg-12" style={{ marginTop: "20px", padding: "0px" }}>
                                                                <label className="mb-5p">Other Destination Pincode<span style={{ color: 'red' }}>*</span></label>
                                                                <input
                                                                    type="text"
                                                                    name="other_consignee_pincode"
                                                                    className="form-control"
                                                                    onChange={(e) => {
                                                                        const {value} = e.target
                                                                        handleInputChange(index, 'other_consignee_pincode', value)
                                                                        checkOtherConsigneeName("other_consignee_pincode1", value)
                                                                    }}
                                                                    value={point.other_consignee_pincode || ""}
                                                                    autoComplete='off'
                                                                    required
                                                                />
                                                    {validPincode1 === false && <span style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>Enter Valid Pincode</span>}
                                                    </div>
                                                        </>
                                                        )}
                                                    </div>
                                                    {!showCustomConsigneeInput[point.id] && (
                                                        <>                                                        
                                                            {/* Destination City Field */}
                                                            <div className="form-group col-xl-12 col-lg-12">
                                                                <label className="mb-5p">
                                                                    Destination City<span style={{ color: 'red' }}>*</span>
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    name="destination_city"
                                                                    value={point.destination_city}
                                                                    className="form-control"
                                                                    onChange={(e) =>
                                                                        handleInputChange(index, 'destination_city', e.target.value)
                                                                    }
                                                                    autoComplete='off'
                                                                    required
                                                                />
                                                                {validationErrors[point.id]?.destination_city && (
                                                                    <span style={{color:"red", fontSize:"12px",marginTop:"5px"}}>{validationErrors[point.id].destination_city}</span>
                                                                )}
                                                            </div>
                                                            {/* Destination Pincode Field */}
                                                            <div className="form-group col-xl-12 col-lg-12">
                                                                <label className="mb-5p">
                                                                    Destination Pincode<span style={{ color: 'red' }}>*</span>
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    name="destination_pincode"
                                                                    value={point.destination_pincode}
                                                                    className="form-control"
                                                                    onChange={(e) =>
                                                                        handleInputChange(index, 'destination_pincode', e.target.value)
                                                                    }
                                                                    autoComplete='off'
                                                                    required
                                                                />
                                                                {validationErrors[point.id]?.destination_pincode && (
                                                                    <span style={{color:"red", fontSize:"12px",marginTop:"5px"}}>{validationErrors[point.id].destination_pincode}</span>
                                                                )}
                                                            </div>
                                                        </>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    ))}


                                    </div>
                                    <div className="form-group col-sm-12 mb-20p text-center">
                                        <button
                                            type="button"
                                            className={`btn customAddBtn${isFormValid() && isManualTripUploadDetailsValid() && !invoiceValid? 'btn-primary' : 'btn-disabled'}`}
                                            onClick={handleButtonClick}
                                            style={{ padding: '9px 10px', fontSize: '12px', cursor: 'pointer',borderRadius:"none" ,marginRight:"20px" }}
                                            disabled={!isFormValid() || !isManualTripUploadDetailsValid() && invoiceValid}
                                            >
                                            Add Drop Point
                                        </button>
                                        <button
                                            type="submit"
                                            className={`btn ${((isFormValid() && isManualTripUploadDetailsValid() && !invoiceValid ) || !isValid1)? 'btn-success' : 'btn-disabled'}`}
                                            disabled={(!isFormValid() && !isManualTripUploadDetailsValid() && invoiceValid) || isValid1}
                                            >
                                            Submit
                                        </button>
                                    </div>

                                    
                                    </div>
                                </div>
							</form>
						</div>
				    </div>
                {/* <div className={"slide-r " + (sliderShow1)}>
                    <div className="slide-r-title">
                        <h4 className="slide-r-title">Upload Document
                            <span
                                  className="float-right closebtn"
                                  style={{ marginRight: "10px" }}
                                  onClick={onCloseSliderDiv1}          
                                        >
                                 X
                            </span>
                        </h4>
                    </div> */}
                    
                    <div className={"slide-r " + (sliderShow1)}>
            <div className="slide-r-title">
                <h4 className="slide-r-title">Upload Document
                    <span
                        className="float-right closebtn"
                        style={{ marginRight: "10px" }}
                        onClick={onCloseSliderDiv1}
                    >
                        X
                    </span>
                </h4>
            </div>

            <div className="col-sm-12">
                <div className="slide-r-body">
                    <div className="tabs1">
                        {/* Tab Navigation */}

                        {(rownode.length> 0 && rownode[0].tracking_type === "FTL") ?(
                            <>
                            <div className="tab-buttons">
                                {/* <button
                                    className={`tab-button ${(rownode[0].loading_doc !==1) ? "active" : ""}`}
                                    onClick={() => handleDocTab("loading")}
                                    disabled={rownode[0].loading_doc ===1} // Disable if loading_doc == 1
                                >
                                    Loading
                                </button> */}
                                <button 
                        className={selectedTab === "loading" ? "loading-button1 mr-10p" : "loading-button mr-10p" }
                        onClick={() => handleDocTab("loading")}
                        // disabled={rownode[0].loading_doc === 1}
                        >
                        Loading
                        {/* Only show dots if loading and button is not disabled */}
                        {/* {!rownode[0].loading_doc === 1 && ( */}
                        {/* { (
                            <div className="loading-dots">
                            <div className="dot"></div>
                            <div className="dot"></div>
                            <div className="dot"></div>
                            </div>
                        )} */}
                        </button>

                        <button 
                        className={selectedTab === "unloading" ? "loading-button1" : "loading-button" }
                        onClick={() => handleDocTab("unloading")}
                        disabled={rownode[0].consignment_status ? rownode[0].consignment_status !=="Arrived At Destination" : rownode[0].status !==3}
                        >
                        Unloading
                        {/* Only show dots if unloading and button is not disabled */}
                        {/* {(rownode[0].consignment_status ? (rownode[0].consignment_status !=="Arrived At Destination") : (rownode[0].status !==4)) ? "": (
                            <div className="loading-dots">
                            <div className="dot"></div>
                            <div className="dot"></div>
                            <div className="dot"></div>
                            </div>
                        )} */}
                        </button>

                                                    </div>
                        

                        {/* Tab Content */}
                        <form className="theme-form" method="POST" id="formDocument" encType="multipart/form-data" onSubmit={uploadDocument1}>
                            <div className="row p-20p">
                                {/* {(!rownode[0].loading_doc && rownode[0].loading_doc !== 1) && ( */}
                                { (selectedTab ==="loading") && (

                                    <>
                                        <div className="form-group col-sm-12 mb-20p">
                                            <label className="f16">Upload Loading Document <span style={{ color: 'red' }}>*</span></label>
                                            <input
                                                type="file"
                                                name="loading"
                                                id="uploadDoc"
                                                className="form-control"
                                                accept=".pdf, image/*"
                                                multiple
                                                onChange={changeFileHandlerForUploadDoc}
                                                required
                                            />
                                        </div>
                                        <div className="form-group col-sm-12 mb-20p">
                                            <label className="f16">Remarks <span style={{ color: 'red' }}>*</span></label>
                                            <textarea
                                                name="loadingdocremarks"
                                                id="docremarks"
                                                rows="3"
                                                value={loadingdocremarks}
                                                onChange={changeHandler1}
                                                className="form-control"
                                            ></textarea>
                                        </div>
                                    </>
                                )}

                                {((rownode[0].consignment_status !=="Arrived At Destination" || rownode[0].status !==3)  && selectedTab === "unloading" )&& (
                                    <>
                                        <div className="form-group col-sm-12 mb-20p">
                                            <label className="f16">Upload Unloading Document <span style={{ color: 'red' }}>*</span></label>
                                            <input
                                                type="file"
                                                name="unloading"
                                                id="uploadDoc"
                                                className="form-control"
                                                accept=".pdf, image/*"
                                                multiple
                                                onChange={changeFileHandlerForUploadDoc}
                                                required
                                            />
                                        </div>
                                        <div className="form-group col-sm-12 mb-20p">
                                            <label className="f16">Remarks <span style={{ color: 'red' }}>*</span></label>
                                            <textarea
                                                name="unloadingdocremarks"
                                                id="docremarks"
                                                rows="3"
                                                value={unloadingdocremarks}
                                                onChange={changeHandler1}
                                                className="form-control"
                                            ></textarea>
                                        </div>
                                    </>
                                )}

                                <div className="form-group col-sm-12 mb-20p text-center">
                                    <button type="submit" className="btn btn-success" style={{ marginRight: "10px" }}>
                                        Upload
                                    </button>
                                    <button type="button" className="btn btn-default" onClick={hideSlideBlockForDocument}>
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </form>
                        </>): <> 
                        <form className="theme-form" method="POST" id="formDocument" encType="multipart/form-data" onSubmit={uploadDocument1}>
                        <div className="row p-20p">
                                <div className="form-group col-sm-12 mb-20p">
                                        <label className="f16">Upload Document<span style={{color:'red'}}>*</span></label>
                                        <input type="file" name="uploadDoc" id="uploadDoc" className="form-control"  accept = ".pdf, image/*" multiple onChange={changeFileHandlerForUploadDoc} required />
                                    </div>
                                  
                                    <div className="form-group col-sm-12 mb-20p">
                                        <label className="f16">Remarks<span style={{color:'red'}}>*</span></label>
                                        <textarea name="docremarks" id="docremarks" rows="3" value={docremarks} onChange={changeHandler1} className="form-control" ></textarea>
                                    </div> 
                                    
                                    <div className="form-group col-sm-12 mb-20p text-center">
                                        <button type="submit" className="btn btn-success" style={{marginRight:"10px"}}>Upload</button>
                                        <button type="button" className="btn btn-default" onClick={hideSlideBlockForDocument}>Cancel</button>
                                    </div>
                                    </div>
                        </form></>}
                    </div>
                </div>
            </div>
        </div>
                    {/* previousss */}
                    {/* <div className="col-sm-12">
                        <div className="slide-r-body">
                            <form className="theme-form" method="POST" id="formDocument" enctype="multipart/form-data" onSubmit={uploadDocument1}>
                                <div className="row p-20p">
                                    {/* <div className="form-group col-sm-12 mb-20p">
                                        <label>Delivered Date<span cl
                                        assName="rclr fbold">*</span></label>
                                        <input type="text" name="startDate" className="form-control" value={this.state.delivered_date} required />

                                    </div> */}
                                    {/* <div className="form-group col-sm-12 mb-20p">
                                        <label>Upload Document<span style={{color:'red'}}>*</span></label>
                                        <input type="file" name="uploadDoc" id="uploadDoc" className="form-control"  accept = ".pdf, image/*" multiple onChange={changeFileHandlerForUploadDoc} required />
                                    </div>
                                  
                                    <div className="form-group col-sm-12 mb-20p">
                                        <label>Remarks<span style={{color:'red'}}>*</span></label>
                                        <textarea name="docremarks" id="docremarks" rows="3" value={docremarks} onChange={changeHandler1} className="form-control" ></textarea>
                                    </div> 
                                    
                                    <div className="form-group col-sm-12 mb-20p text-center">
                                        <button type="submit" className="btn btn-success" style={{marginRight:"10px"}}>Upload</button>
                                        <button type="button" className="btn btn-default" onClick={hideSlideBlockForDocument}>Cancel</button>
                                    </div> */}
                                {/* </div> */}
                            {/* </form> */}
                        {/* </div> */}
                    {/* // </div> */} 
                {/* </div>   */}
                {gateOutSlide
                 && 
                 <div className={"sliderBlock3 " + (gateOutSlide)} >
                <span className="float-right ffclosebtn1" style={{ marginRight: "25px", fontSize: '20px' }} onClick={hideGateoutSubmit} >
                    <img src={require('../../assets/images/closeIcon.png')} className='closeIcon mt-5p' style={{ marginTop: "-40px" }} />
                </span>
                <div className='d-flex mt-60p' style={{marginLeft:"42px"}}>
                            <div className='d-flex flex-column ml-20p'>
                                <h1 className='confirm-heading'>Are you sure you want to submit ?</h1>
                            </div>
                </div>                
                <div className='d-flex flex-row ml-30p mt-20p'>
                    <button className='btn_confirm_cancel' style={{ marginRight: "36px", marginLeft: "15px" }} onClick={hideGateoutSubmit} >Cancel</button>
                    <button className='btn_hover7' onClick={onsubmitdata1}>Submit</button>
                </div>

                </div>} 
                {tabName.value == 'inactive' && (
                    <div
                    className={"slide-r " + showAddForm}
                    style={{ overflow: "auto",  }}
                >
                    <div className="slide-r-title">
                    <h4 className="slide-r-title">Single Update LR<span className="float-right closebtn" style={{ marginRight: "10px"}} onClick={onClickHideManualUpload1} >X</span></h4>
                    

                    </div>
                    <div className="row" style={{padding:"20px"}}>
                    <div className="col-sm-12">
                        <form 
                        onSubmit={onSubmitLrUpdateForm}
                        >
                        <div className="slide-body">
                            <div className="row p-20p">
                            <div className="form-group col-xl-12 col-lg-12">
                            </div>{" "}
                            <div className="form-group col-xl-12 col-lg-12">
                                <label className="mb-5p">
                                Invoice No<span style={{color:'red'}}>*</span>
                                </label>
                                <input
                                                        type="text"
                                                        name="lr_no"
                                                        id="lr_no"
                                                        value={manualUploadDetails.invoice_no}
                                                        className="form-control"
                                                        // onChange={(e) => setmanualUploadDetails1(prev => ({ ...prev, invoice_no: e.target.value }))}
                                                        required
                                                    /> 
                            
                            </div>
                            <div className="form-group col-xl-12 col-lg-12">
                                <label className="mb-5p">
                                LR No<span style={{color:'red'}}>*</span>
                                </label>
                                <input
                                                        type="text"
                                                        name="lr_no"
                                                        id="lr_no"
                                                        value={manualUploadDetails.lr_no}
                                                        className="form-control"
                                                        onChange={handleLRChange}
                                                        required
                                                    /> 
                            
                            </div>                
                            <div className="form-group col-sm-12 mb-20p text-center">
                                <button type="submit" className="btn btn-success">
                                Submit
                                </button>
                            </div>
                            </div>
                        </div>
                        </form>
                    </div>
                    </div>
                </div> 
                )} 
                {tabName.value == 'inactive' && (
                    <div
                    className={"slide-r " + showUpdateLrForm}
                    style={{ overflow: "auto",  }}
                >
                    <div className="slide-r-title">
                        <h4 className="slide-r-title">Update LR<span className="float-right closebtn" style={{ marginRight: "10px"}} onClick={onClickHideLrUpdateForm} >X</span></h4>                  
                    </div>
                    <div className="row" style={{padding:"20px"}}>
                        <div className="col-sm-12">
                            <form onSubmit={onSubmitLrUpdateForm}>
                                <div className="slide-body">
                                    <div className="row p-20p">
                                        <div className="form-group col-xl-12 col-lg-12">
                                            <label className="mb-5p">
                                            Invoice No<span style={{color:'red'}}>*</span>
                                            </label>
                                            <Select placeholder={"All"} closeMenuOnSelect={false}
                                                value={selectedInvoicetoUpdateLr}
                                                isMulti={true}
                                                className="border-radius-0"
                                                // onChange={e => setInvoiceSelected(e)}
                                                style={{ borderRadius: "0px" }}
                                                styles={{
                                                    control: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.8rem",
                                                        color: "#6e707e",
                                                        width:"100%"

                                                    }),
                                                    singleValue: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.9rem",
                                                    }),
                                                }}
                                                options={selectedInvoicetoUpdateLr}
                                                required 
                                            />
                                        </div>
                                        <div className="form-group col-xl-12 col-lg-12">
                                            <label className="mb-5p">
                                            LR No<span style={{color:'red'}}>*</span>
                                            </label>
                                            <input
                                                type="text"
                                                name="lr_no2"
                                                value={updatelrNo}
                                                className="form-control1"
                                                onChange={handleLRChange}
                                                autoComplete='off'
                                                // required
                                            />                        
                                        </div>
                                        {/* {transporterValidation  &&  */}
                                        <div className="form-group col-xl-12 col-lg-12">
                                            <label className="mb-5p">
                                                Transporter<span style={{color: 'red'}}>*</span>
                                            </label>
                                            <Select
                                                closeMenuOnSelect={true}
                                                value={manualUpdateLRConsignment.courier_partner}
                                                onChange={(e) => {
                                                    setManualUpdateLRConsignment((prev) => ({
                                                        ...prev,
                                                        courier_partner: { label: e.label, value: e.value }
                                                    }));

                                                    // Enable Other Transporter field when "Other" is selected
                                                    if (e.value === "Others") {
                                                        setEnableCourierType(true);
                                                    } else {
                                                        setManualUpdateLRConsignment((prev) => ({ ...prev, other_transporter: "" }));
                                                        setEnableCourierType(false);
                                                    }
                                                }}
                                                isDisabled = {true}
                                                style={{ borderRadius: "0px" }}
                                                styles={{
                                                    control: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.8rem",
                                                        color: "#6e707e",
                                                        width:"100%"

                                                    }),
                                                    singleValue: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.9rem",
                                                    }),
                                                }}
                                                options={courierPartnerList1}
                                            />
                                        </div>
                                        {/* } */}
                                        {console.log(typeof(truckNoValidation), "trucknovalidation888888")}
                                        {/* {((lRTrackingType==="FTL" && truckNoValidation) || ((selectedRows[0]?.transporter_name ==="" || selectedRows[0]?.transporter_name ===undefined || selectedRows[0]?.transporter_name ===null) && (lRTrackingType ==="" || lRTrackingType ===undefined || lRTrackingType ===null) && truckNoValidation)) &&  */}
                                        {(lRTrackingType==="FTL") &&

                                        <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">
                                                Truck No<span style={{color:'red'}}>*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control1"
                                                onChange={handleTruckNoChange}  
                                                value={manualUpdateLRConsignment.truck_no}
                                                name="lr_truck_no"
                                                autoComplete='off'
                                                disabled={!truckNoValidation}
                                            />
                                            {validateTruckNo === false && (
                                                <span style={{color:"red", fontSize:"12px", marginTop:"5px", marginLeft:"0px"}}>
                                                    Enter Valid Truck Number
                                                </span>
                                            )}
                                        </div>}
                                        <div className="form-group col-xl-12 col-lg-12">
                                            <label className="mb-5p">
                                            Dispatch Time<span style={{color:'red'}}>*</span>
                                            </label>
                                        <div id="datepicker1">
                                                <DatePicker
                                            selected={manualUpdateLRConsignment.dispatch_time}
                                            onChange={changeHandleDate2}
                                            name="dispatch_time"
                                            className="datepicker-custom-ptl6 form-control"
                                            showTimeSelect
                                            timeFormat="HH:mm:ss"
                                            timeIntervals={15} // Adjust this if you want different time intervals
                                            timeCaption="Time"
                                            dateFormat="dd-MM-yyyy HH:mm:ss" // Adjusted format to match the original format
                                            // placeholderText="Date" // Equivalent to placeholder in the original
                                            id="dispatch_time"
                                            autoComplete='off'
                                            // style={{width:"100%"}}
                                            required
                                            disabled
                                            />
                                        </div>
                                        
                                        </div>
                 
                                        {/* } */}
                                        {/* {((lRTrackingType==="FTL" && driverNoValidation) || ((selectedRows[0]?.transporter_name ==="" || selectedRows[0]?.transporter_name ===undefined || selectedRows[0]?.transporter_name ===null) && (lRTrackingType ==="" || lRTrackingType ===undefined || lRTrackingType ===null) && driverNoValidation) )&& */}
                                        {(lRTrackingType==="FTL") &&
                                        <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">Driver Mobile No.
                                                {/* <span style={{color:'red'}}>*</span>  */}
                                                </label>
                                            <input
                                                type="text"
                                                className="form-control1"
                                                onChange={(e) => {
                                                    const { name } = e.target;
                                                    const numericValue = e.target.value.replace(/\D/g, '').slice(0, 10);
                                                    
                                                    // Validate the input length and content
                                                    if (numericValue.length < 10) {
                                                        setError1('Mobile number must be 10 digits long');
                                                    } else if (!/^[6-9]\d{9}$/.test(numericValue)) {
                                                        setError1('Mobile number must start with a digit between 6 and 9 and be 10 digits long');
                                                    } else {
                                                        setError1(''); // Clear error if the number is valid
                                                    }

                                                    // Update the state with the new value (allow only 10 digits max)
                                                    if (numericValue.length <= 10) {
                                                        setManualUpdateLRConsignment((prev) => ({ ...prev, driver_mobile_no: numericValue }));

                                                        // if (name === 'driver_number_update') {
                                                        //     setManualUpdateConsignment((prev) => ({ ...prev, driver_number: numericValue }));
                                                        // } else if (name === 'driver_mobile_no') {
                                                        //     setFormData((prev) => ({ ...prev, driver_mobile_no: numericValue }));
                                                        // }
                                                    }
                                                }}
                                                disabled={!driverNoValidation}
                                                value={manualUpdateLRConsignment.driver_mobile_no}
                                                name="driver_mobile_no"
                                                autoComplete='off'
                                            />
                                            {error1 && <span style={{ color: 'red', fontSize: "10px", margin: "10px 0px 0px 20px" }}>{error1}</span>}                    
                                        </div>}
                                        {/* } */}

                                        

                                        {/* {((lRTrackingType==="PTL" && entityValidation) || ((selectedRows[0]?.transporter_name ==="" || selectedRows[0]?.transporter_name ===undefined || selectedRows[0]?.transporter_name ===null) && (lRTrackingType ==="" || lRTrackingType ===undefined || lRTrackingType ===null)  && entityValidation)) &&  */}
                                        <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">Entity <span style={{color:'red'}}>*</span> </label>
                                            <Select
                                                closeMenuOnSelect={true}
                                                value={manualUpdateLRConsignment.entity}
                                                onChange={(e)=> setManualUpdateLRConsignment((prev)=>({
                                                    ...prev, 
                                                    entity:{label:e.label, value: e.value}
                                                }))}
                                                style={{ borderRadius: "0px" }}
                                                styles={{
                                                    control: (provided, state) => ({
                                                    ...provided,
                                                    fontSize: "0.8rem",
                                                    color: "#6e707e",
                                                    width:"100%"
                                                    }),
                                                    singleValue: (provided, state) => ({
                                                    ...provided,
                                                    fontSize: "0.9rem",
                                                    }),
                                                }}
                                                options={entityList}
                                                isDisabled={!entityValidation}
                                            />
                                        </div>
                                        {/* } */}

                                        {/* {((lRTrackingType==="FTL" && vehicleTypeValidation) || ((selectedRows[0]?.transporter_name ==="" || selectedRows[0]?.transporter_name ===undefined || selectedRows[0]?.transporter_name ===null) && (lRTrackingType ==="" || lRTrackingType ===undefined || lRTrackingType ===null) &&(vehicleTypeValidation))) &&  */}
                                        <div className="form-group col-xl-12 col-lg-12">
                                            <label className="mb-5p">
                                                Vehicle Type
                                                
                                            </label>
                                            <Select
                                                closeMenuOnSelect={true}
                                                value={manualUpdateLRConsignment.vehicle_type}
                                                onChange={(e) => {
                                                    setManualUpdateLRConsignment((prev) => ({
                                                        ...prev,
                                                        vehicle_type: { label: e.label, value: e.value }
                                                    }));
                                                    if (e.value === "Others") {
                                                        setEnableVehicelType(true);
                                                        setManualUpdateLRConsignment((prev) => ({ ...prev, other_vehicle_type: "" , other_vehicle_capacity:''}));

                                                    } else {
                                                        setEnableVehicelType(false);
                                                        fetchVehicleDetails(e.label, e.value)
                                                        
                                                    }
                                                }}
                                                style={{ borderRadius: "0px", maxWidth: "415px" }}
                                                styles={{
                                                    control: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.8rem",
                                                        color: "#6e707e",
                                                        width:"100%"

                                                    }),
                                                    singleValue: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.9rem",
                                                    }),
                                                }}
                                                options={vehicleTypeList}
                                                isDisabled={!vehicleTypeValidation}
                                            />
                                        </div>
                                        {/* } */}
                                        {enableVehicleType && <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">Other Vehicle Type</label>
                                            <input
                                                type="text"
                                                className="form-control1"
                                                onChange={(e)=> setManualUpdateLRConsignment(prev =>({...prev, other_vehicle_type:e.target.value}))}
                                                value={manualUpdateLRConsignment.other_vehicle_type}
                                                name="truck_no"
                                                autoComplete='off'
                                                required
                                            />
                                        </div>}

                                       

                                        {/* {noOfBoxesValidation &&  */}
                                        <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">Number of Boxes  </label>
                                            <input
                                                type="text"
                                                className="form-control1"
                                                onChange={(e)=> setManualUpdateLRConsignment(prev => ({...prev, no_of_boxes:e.target.value }))}
                                                value={manualUpdateLRConsignment.no_of_boxes}
                                                name="no_of_boxes"
                                                autoComplete='off'
                                                disabled={!noOfBoxesValidation}
                                            />
                                        </div>
                                        {/* } */}

                                      
                                {/* {totalCBMValidation &&  */}
                                        {/* <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">Total CBM </label>
                                            <input
                                                type="text"
                                                className="form-control1"
                                                onChange={(e)=> setManualUpdateLRConsignment(prev => ({...prev, total_cbm:e.target.value }))}
                                                value={manualUpdateLRConsignment.total_cbm}
                                                name="total_cbm"
                                                autoComplete='off'
                                                disabled={!totalCBMValidation}
                                            />
                                        </div>
                                        {/* } */}
                                        {/* {totalWeightValidation &&  */}
                                        {/* <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">Total Weight </label>
                                            <input
                                                type="text"
                                                className="form-control1"
                                                onChange={(e)=> setManualUpdateLRConsignment(prev => ({...prev, total_weight:e.target.value }))}
                                                value={manualUpdateLRConsignment.total_weight}
                                                name="total_weight"
                                                autoComplete='off'
                                                disabled={!totalWeightValidation}
                                            />
                                        </div>  */}
                                        {/* } */}
                                        {/* {dispacthdateValidation && 
                                    <div className="form-group col-xl-12 col-lg-12">
                                    <label className="mb-5p">
                                    Dispatch Time<span style={{color:'red'}}>*</span>
                                    </label>
                                    <div id="datepicker1">
                                        <DatePicker
                                    selected={manualUpdateLRConsignment.dispatch_time}
                                    onChange={changeHandleDate2}
                                    name="lr_dispatch_time"
                                    className="datepicker-custom-ptl3 form-control"
                                    showTimeSelect
                                    timeFormat="HH:mm:ss"
                                    timeIntervals={15} // Adjust this if you want different time intervals
                                    timeCaption="Time"
                                    dateFormat="dd-MM-yyyy HH:mm:ss" // Adjusted format to match the original format
                                    // placeholderText="Date" // Equivalent to placeholder in the original
                                    id="dispatch_time"
                                    autoComplete='off'
                                    style={{width:"96%"}}
                                    // required
                                    />
                                </div>
                                
                                </div>} */}
                                {/* {modeValidation &&  */}
                                        <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">Mode<span style={{color:'red'}}>*</span></label>
                                            <input
                                                type="text"
                                                className="form-control1"
                                                onChange={(e)=> setManualUpdateLRConsignment(prev => ({...prev, tracking_type:e.target.value }))}
                                                value={manualUpdateLRConsignment.tracking_type}
                                                name="tracking_type"
                                                autoComplete='off'
                                                disabled={!modeValidation}
                                            />
                                        {Array.isArray(manualUpdateLRConsignment.tracking_type) &&
                                        manualUpdateLRConsignment.tracking_type.length > 1 && (
                                            <Select
                                            closeMenuOnSelect={true}
                                            value={manualUpdateLRConsignment.tracking_type_mutliple}
                                            onChange={(e) =>
                                                setManualUpdateLRConsignment((prev) => ({
                                                ...prev,
                                                tracking_type_mutliple: { label: e.label, value: e.value },
                                                }))
                                            }
                                            style={{ borderRadius: "0px" }}
                                            styles={{
                                                control: (provided) => ({
                                                ...provided,
                                                fontSize: "0.8rem",
                                                color: "#6e707e",
                                                width: "100%",
                                                }),
                                                singleValue: (provided) => ({
                                                ...provided,
                                                fontSize: "0.9rem",
                                                }),
                                            }}
                                            options={TrackingTypeList}
                                            />
                                        )}

                                        </div>

                                        {/* } */}
                                        {/* {fuelValidation &&  */}
                                        <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">Fuel Type<span style={{color:'red'}}>*</span></label>
                                            <Select
                                                closeMenuOnSelect={true}
                                                value={manualUpdateLRConsignment.fuel_type}
                                                onChange={(e)=> setManualUpdateLRConsignment((prev)=>({
                                                    ...prev, 
                                                    fuel_type:{label:e.label, value: e.value}
                                                }))}
                                                style={{ borderRadius: "0px" }}
                                                styles={{
                                                    control: (provided, state) => ({
                                                    ...provided,
                                                    fontSize: "0.8rem",
                                                    color: "#6e707e",
                                                    width:"100%"
                                                    }),
                                                    singleValue: (provided, state) => ({
                                                    ...provided,
                                                    fontSize: "0.9rem",
                                                    }),
                                                }}
                                                options={fuelTypeList}
                                                isDisabled={!fuelValidation}
                                            />
                                        </div>
                                        {/* }                                        */}
                                         {/* {invoiceTypeValidation && 
                                        <div className="form-group col-xl-12 col-lg-12">
                                            <label className="mb-5p">
                                                Invoice Type<span style={{color: 'red'}}>*</span>
                                            </label>
                                            <Select
                                                closeMenuOnSelect={true}
                                                value={manualUpdateLRConsignment.invoice_type}
                                                onChange={(e) => {
                                                    setManualUpdateLRConsignment((prev) => ({
                                                        ...prev,
                                                        invoice_type: { label: e.label, value: e.value }
                                                    }));
                                                }}
                                                className="custom-field-width"
                                                style={{ borderRadius: "0px" }}
                                                styles={{
                                                    control: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.8rem",
                                                        color: "#6e707e",
                                                        width:"445px"

                                                    }),
                                                    singleValue: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.9rem",
                                                    }),
                                                }}
                                                options={courierPartnerList}
                                            />
                                        </div>} */}
                                        <div className="form-group col-sm-12 mb-20p text-center">
                                            <button type="submit" className="btn btn-success" style={{marginRight:"10px"}}>Submit</button>
                                            <button type="button" onClick={cancelUpdateLrNo} className="btn btn-default">Cancel</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div> 
                )} 
                
      <div
        className={"slide-r " + showAddForm1}
        style={{ overflow: "auto",  }}
      >
        <div className="slide-r-title">
          <h4 className="slide-r-title">Update Details<span className="float-right closebtn" style={{ marginRight: "10px"}} onClick={onClickHideManualUpload1} >X</span></h4>
          

        </div>
        <div className="row" style={{padding:"20px"}}>
          <div className="col-sm-12">
            <form 
            onSubmit={onClickGateOutUpdate}
            >
              <div className="slide-body">
                <div className="row p-20p">
                  <div className="form-group col-xl-12 col-lg-12">
                    {/* <p className="mb-5p">
                      LR No: {selected_row.lr_no}
                    </p> */}
                  </div>{" "}
                 
                  <div className="form-group col-xl-12 col-lg-12">
                    <label className="mb-5p">
                      Dispatch Time<span style={{color:'red'}}>*</span>
                    </label>
                  <div id="datepicker1">
                        <DatePicker
                    selected={manualUploadDetails14.dispatch_time}
                    onChange={changeHandleDate}
                    name="dispatch_time"
                    className="datepicker-custom-ptl1 form-control"
                    showTimeSelect
                    timeFormat="HH:mm:ss"
                    timeIntervals={15} // Adjust this if you want different time intervals
                    timeCaption="Time"
                    dateFormat="dd-MM-yyyy HH:mm:ss" // Adjusted format to match the original format
                    // placeholderText="Date" // Equivalent to placeholder in the original
                    id="dispatch_time"
                    autoComplete='off'
                    // style={{width:"100%"}}
                    required
                    />
                  </div>
                  
                  </div>
                 
                  {/* <h6 style={{ color: "red", fontSize: "14px", marginTop: "2%" }}>Note: All date fields should be greater than production date</h6> */}
                  <div className="form-group col-sm-12 mb-20p text-center">
                    <button type="submit" className="btn btn-success">
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
                <div className={"overlay-part " + (overly)} style={{ zIndex: "10" }}
                    onClick={onClickHideAll}
                ></div>
                <div className={"dataLoadpage " + (loadshow)}></div>
                <div className={"dataLoadpageimg " + (loadshow)} style={{ top: "21em" }}>
                    <div className="loader-box"><div className="loader-box"><div className="rotate dashed colored"></div></div></div>
                </div>
            </>
        </div>

    );
}
function DateEditor() { }
DateEditor.prototype.init = function (params) {
    this.eInput = document.createElement('input');
    this.eInput.style.width = "180px";
    const currentDate = new Date();

    let maxDate;
    if (params.column.getColId() === "current_event_date_time") {
        maxDate = new Date(currentDate.getTime() + 8 * 60 * 60 * 1000); // Current date + 8 hours
    } else if (params.column.getColId() === "recent_dealer_reported") {
        maxDate = currentDate; // Current date only
    }
    this.eInput.value = params.value ? params.value : "";
        $(this.eInput).datetimepicker({
            dateFormat: "yy-mm-dd",       // Date format
            timeFormat: "HH:mm",          // Time format (24-hour)
            changeMonth: true,
            changeYear: true,
            showSecond: true,             // Show seconds
            showTime: true,   
            maxDate: maxDate,            // Enable time
            hour: 12,                     // Default hour (12 PM)
            minute: 0,                    // Default minute
            second: 0,                    // Default second
    });
};
DateEditor.prototype.getGui = function () {
    return this.eInput;
};
DateEditor.prototype.afterGuiAttached = function () {
    this.eInput.focus();
    this.eInput.select();
};
DateEditor.prototype.getValue = function () {
    return this.eInput.value;
    const selectedDate = new Date(inputValue);

    // Validate and return as ISO string in UTC
    if (!isNaN(selectedDate)) {
        const isoDate = selectedDate.toISOString(); // Convert to ISODate (UTC)
        console.log("ISODate returned:", isoDate); // Debugging
        return isoDate;
    }

    console.error("Invalid date selected:", inputValue);
    return null; 
};
DateEditor.prototype.destroy = function () {
};
DateEditor.prototype.isPopup = function () {
    return false;
};

export default Consignments;

function loadScript(url) {
    var index = window.document.getElementsByTagName("script")[0]
    var script = window.document.createElement("script")
    script.src = url
    script.async = true
    script.defer = true
    index.parentNode.insertBefore(script, index)
}
function secondsToString(seconds) {
    var numdays = Math.floor(seconds / 86400);
    var numhours = Math.floor((seconds % 86400) / 3600);
    var numminutes = Math.floor(((seconds % 86400) % 3600) / 60);
    var numseconds = ((seconds % 86400) % 3600) % 60;
    return numdays + " days " + numhours + " hours " + numminutes + " minutes ";
}

function secondsToDays(seconds) {
    var numdays = Math.floor(seconds / 86400);
    var numhours = Math.floor((seconds % 86400) / 3600);
    var numminutes = Math.floor(((seconds % 86400) % 3600) / 60);
    var numseconds = ((seconds % 86400) % 3600) % 60;
    return numdays;
}

function isEmpty(obj) {
    for (var key in obj) {
        if (obj.hasOwnProperty(key))
            return false;
    }
    return true;
} 
function dateComparator(date1, date2) {
	if (date1 != "" && date2 != "" && date1 != undefined && date2 != undefined) {
		var date_1 = getMonthNumber(date1.split(" ")[0].split("-")[1]);
		date1 = date1.replace(date1.split(" ")[0].split("-")[1], date_1);
		var date_2 = getMonthNumber(date2.split(" ")[0].split("-")[1]);
		date2 = date2.replace(date2.split(" ")[0].split("-")[1], date_2);
		var date1Number = monthToComparableNumber(date1);
		var date2Number = monthToComparableNumber(date2);
		if (date1Number === null && date2Number === null) {
			return 0;
		}
		if (date1Number === null) {
			return -1;
		}
		if (date2Number === null) {
			return 1;
		}
		return date1Number - date2Number;
	}
}
function getMonthNumber(monthName) {
	var months = [
		'Jan', 'Feb', 'Mar', 'Apr', 'May',
		'Jun', 'Jul', 'Aug', 'Sep',
		'Oct', 'Nov', 'Dec'
	];
	var monthNum = months.indexOf(monthName) + 1;
	if (monthNum < 10) {
		monthNum = "0" + monthNum.toString();
	}
	return monthNum;
}
function monthToComparableNumber(date) {
	if (date === undefined || date === null || date.length !== 16) {
		return null;
	}
	var yearNumber = date.substring(6, 10);
	var monthNumber = date.substring(3, 5);
	var dayNumber = date.substring(0, 2);
	var result = yearNumber * 10000 + monthNumber * 100 + dayNumber;
	return result;
}
 // Helper function to validate invoice number
 function validateInvoice(invoiceNo, sourceRecords) {
    // Regular expression to match the first 6 digits followed by a '/'
    const invoicePattern = /^[A-Za-z0-9]+\/.*/;

    // Validate the invoice number and return formatted result
    if (invoicePattern.test(invoiceNo)) {
        const invoiceSeries = invoiceNo.split("/")[1]
        const arr = Array.from(sourceRecords);
        const isValid = arr.includes(invoiceSeries.toUpperCase())
        if(isValid){
            return invoiceNo; // Valid format, return the invoice number
        }else{
            return ""
        }

    } else {
        return ""; // Invalid format, return error message
    }
}
const formatDateTime = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    
    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
};

function validateLRNo(lrNo) {
    // If the value is empty, allow it
    if (lrNo === "") {
        return lrNo; // Allow empty value
    }

    // Define the pattern for a valid LR No (only digits allowed)
    const pattern = /^\d+$/;

    if (!pattern.test(lrNo)) {
        return "Invalid LR No"; // Return invalid if LR No doesn't consist of only digits
    }
    return lrNo; // Return valid LR No if validation passes
}
function formatAdjustedDate(inputDate) {
    if (!inputDate) return ""; // Return an empty string if inputDate is falsy

    // Parse the input date with moment
    const date1 = moment(inputDate);

    // Subtract 5 hours and 30 minutes
    const adjustedDate = date1.subtract(5, "hours").subtract(30, "minutes");

    // Convert to a native Date object
    const adjustedTime = adjustedDate.toDate();
    var timeString = adjustedTime.toDateString()
    const date = new Date(timeString);

    // Format date as "DD-MM-YYYY HH:mm:ss"
    const formattedDate = `${adjustedTime.getDate().toString().padStart(2, '0')}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getFullYear()} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}`;
    
    return formattedDate;
}

